'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactRouterDom = require('react-router-dom');
var data = require('@grafana/data');
var runtime = require('@grafana/runtime');
var React = require('react');
var rxjs = require('rxjs');
var uuid = require('uuid');
var lodash = require('lodash');
var schema = require('@grafana/schema');
var i18n = require('@grafana/i18n');
var ui = require('@grafana/ui');
var e2eSelectors = require('@grafana/e2e-selectors');
var css = require('@emotion/css');
var uFuzzy = require('@leeoniya/ufuzzy');
var reactUse = require('react-use');
var react$1 = require('@floating-ui/react');
var reactVirtual = require('@tanstack/react-virtual');
var react = require('@emotion/react');
require('react-dom');
var operators = require('rxjs/operators');
var ReactGridLayout = require('react-grid-layout');
var BarChartPanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/barchart/panelcfg/x/BarChartPanelCfg_types.gen');
var BarGaugePanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/bargauge/panelcfg/x/BarGaugePanelCfg_types.gen');
var DatagridPanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/datagrid/panelcfg/x/DatagridPanelCfg_types.gen');
var GaugePanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/gauge/panelcfg/x/GaugePanelCfg_types.gen');
var GeomapPanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/geomap/panelcfg/x/GeomapPanelCfg_types.gen');
var HeatmapPanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/heatmap/panelcfg/x/HeatmapPanelCfg_types.gen');
var HistogramPanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/histogram/panelcfg/x/HistogramPanelCfg_types.gen');
var NewsPanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/news/panelcfg/x/NewsPanelCfg_types.gen');
var PieChartPanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/piechart/panelcfg/x/PieChartPanelCfg_types.gen');
var StatPanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/stat/panelcfg/x/StatPanelCfg_types.gen');
var StateTimelinePanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/statetimeline/panelcfg/x/StateTimelinePanelCfg_types.gen');
var StatusHistoryPanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/statushistory/panelcfg/x/StatusHistoryPanelCfg_types.gen');
var TablePanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/table/panelcfg/x/TablePanelCfg_types.gen');
var TextPanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/text/panelcfg/x/TextPanelCfg_types.gen');
var XYChartPanelCfg_types_gen = require('@grafana/schema/dist/esm/raw/composable/xychart/panelcfg/x/XYChartPanelCfg_types.gen');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var uFuzzy__default = /*#__PURE__*/_interopDefaultCompat(uFuzzy);
var ReactGridLayout__default = /*#__PURE__*/_interopDefaultCompat(ReactGridLayout);

function useAppQueryParams() {
  const location = reactRouterDom.useLocation();
  return runtime.locationSearchToObject(location.search || "");
}
function getUrlWithAppState(path, searchObject, preserveParams) {
  const paramsCopy = { ...searchObject };
  if (preserveParams) {
    for (const key of Object.keys(paramsCopy)) {
      if (!preserveParams.includes(key)) {
        delete paramsCopy[key];
      }
    }
  }
  return data.urlUtil.renderUrl(data.locationUtil.assureBaseUrl(path), paramsCopy);
}
function useSceneRouteMatch(path) {
  const params = reactRouterDom.useParams();
  const location = reactRouterDom.useLocation();
  const isExact = reactRouterDom.matchPath(
    {
      path,
      caseSensitive: false,
      end: true
    },
    location.pathname
  );
  const match = {
    params,
    isExact: isExact !== null,
    path: location.pathname,
    url: location.pathname
  };
  return match;
}

const runtimePanelPlugins = /* @__PURE__ */ new Map();
function registerRuntimePanelPlugin({ pluginId, plugin }) {
  if (runtimePanelPlugins.has(pluginId)) {
    throw new Error(`A runtime panel plugin with id ${pluginId} has already been registered`);
  }
  plugin.meta = {
    ...plugin.meta,
    id: pluginId,
    name: pluginId,
    module: "runtime plugin",
    baseUrl: "runtime plugin",
    info: {
      author: {
        name: "Runtime plugin " + pluginId
      },
      description: "",
      links: [],
      logos: {
        large: "",
        small: ""
      },
      screenshots: [],
      updated: "",
      version: ""
    }
  };
  runtimePanelPlugins.set(pluginId, plugin);
}
function loadPanelPluginSync(pluginId) {
  var _a;
  const { getPanelPluginFromCache } = runtime.getPluginImportUtils();
  return (_a = getPanelPluginFromCache(pluginId)) != null ? _a : runtimePanelPlugins.get(pluginId);
}

function SceneComponentWrapperWithoutMemo({ model, ...otherProps }) {
  var _a;
  const Component = (_a = model.constructor["Component"]) != null ? _a : EmptyRenderer;
  const [_, setValue] = React.useState(0);
  React.useEffect(() => {
    const unsub = model.activate();
    setValue((prevState) => prevState + 1);
    return unsub;
  }, [model]);
  if (!model.isActive && !model.renderBeforeActivation) {
    return null;
  }
  return /* @__PURE__ */ React__default.default.createElement(Component, { ...otherProps, model });
}
const SceneComponentWrapper = React__default.default.memo(SceneComponentWrapperWithoutMemo);
function EmptyRenderer(_) {
  return null;
}

class SceneObjectStateChangedEvent extends data.BusEventWithPayload {
}
SceneObjectStateChangedEvent.type = "scene-object-state-change";
class UserActionEvent extends data.BusEventWithPayload {
}
UserActionEvent.type = "scene-object-user-action";

var __typeError$5 = (msg) => {
  throw TypeError(msg);
};
var __accessCheck$5 = (obj, member, msg) => member.has(obj) || __typeError$5("Cannot " + msg);
var __privateGet$5 = (obj, member, getter) => (__accessCheck$5(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$5 = (obj, member, value) => member.has(obj) ? __typeError$5("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$5 = (obj, member, value, setter) => (__accessCheck$5(obj, member, "write to private field"), member.set(obj, value), value);
var _ref;
class SceneObjectRef {
  constructor(ref) {
    __privateAdd$5(this, _ref);
    __privateSet$5(this, _ref, ref);
  }
  resolve() {
    return __privateGet$5(this, _ref);
  }
}
_ref = new WeakMap();

class SceneObjectBase {
  constructor(state) {
    this._isActive = false;
    this._activationHandlers = [];
    this._deactivationHandlers = /* @__PURE__ */ new Map();
    this._subs = new rxjs.Subscription();
    this._refCount = 0;
    this._renderBeforeActivation = false;
    if (!state.key) {
      state.key = uuid.v4();
    }
    this._events = new data.EventBusSrv();
    this._state = Object.freeze(state);
    this._setParent(this._state);
  }
  /** Current state */
  get state() {
    return this._state;
  }
  /** True if currently being active (ie displayed for visual objects) */
  get isActive() {
    return this._isActive;
  }
  get renderBeforeActivation() {
    return this._renderBeforeActivation;
  }
  /** Returns the parent, undefined for root object */
  get parent() {
    return this._parent;
  }
  /** Returns variable dependency config */
  get variableDependency() {
    return this._variableDependency;
  }
  /** Returns url sync config */
  get urlSync() {
    return this._urlSync;
  }
  /**
   * Used in render functions when rendering a SceneObject.
   * Wraps the component in an EditWrapper that handles edit mode
   */
  get Component() {
    return SceneComponentWrapper;
  }
  _setParent(state) {
    forEachChild(state, (child) => {
      if (child._parent && child._parent !== this) {
        console.warn(
          "SceneObject already has a parent set that is different from the new parent. You cannot share the same SceneObject instance in multiple scenes or in multiple different places of the same scene graph. Use SceneObject.clone() to duplicate a SceneObject or store a state key reference and use sceneGraph.findObject to locate it.",
          child,
          this
        );
      }
      child._parent = this;
    });
  }
  /**
   * Sometimes you want to move one instance to another parent.
   * This is a way to do that without getting the console warning.
   */
  clearParent() {
    this._parent = void 0;
  }
  /**
   * Subscribe to the scene state subject
   **/
  subscribeToState(handler) {
    return this._events.subscribe(SceneObjectStateChangedEvent, (event) => {
      if (event.payload.changedObject === this) {
        handler(event.payload.newState, event.payload.prevState);
      }
    });
  }
  /**
   * Subscribe to the scene event
   **/
  subscribeToEvent(eventType, handler) {
    return this._events.subscribe(eventType, handler);
  }
  setState(update) {
    const prevState = this._state;
    const newState = {
      ...this._state,
      ...update
    };
    this._state = Object.freeze(newState);
    this._setParent(update);
    this._handleActivationOfChangedStateProps(prevState, newState);
    this.publishEvent(
      new SceneObjectStateChangedEvent({
        prevState,
        newState,
        partialUpdate: update,
        changedObject: this
      }),
      true
    );
  }
  /**
   * This handles activation and deactivation of $data, $timeRange and $variables when they change
   * during the active phase of the scene object.
   */
  _handleActivationOfChangedStateProps(prevState, newState) {
    if (!this.isActive) {
      return;
    }
    if (prevState.$behaviors !== newState.$behaviors) {
      this._handleChangedBehaviors(prevState.$behaviors, newState.$behaviors);
    }
    if (prevState.$data !== newState.$data) {
      this._handleChangedStateActivation(prevState.$data, newState.$data);
    }
    if (prevState.$variables !== newState.$variables) {
      this._handleChangedStateActivation(prevState.$variables, newState.$variables);
    }
    if (prevState.$timeRange !== newState.$timeRange) {
      this._handleChangedStateActivation(prevState.$timeRange, newState.$timeRange);
    }
  }
  _handleChangedStateActivation(oldValue, newValue) {
    if (oldValue) {
      const deactivationHandler = this._deactivationHandlers.get(oldValue);
      if (deactivationHandler) {
        deactivationHandler();
        this._deactivationHandlers.delete(oldValue);
      }
    }
    if (newValue) {
      this._deactivationHandlers.set(newValue, newValue.activate());
    }
  }
  _handleChangedBehaviors(oldValue, newValue) {
    if (oldValue) {
      for (const oldBehavior of oldValue) {
        if (!newValue || !newValue.includes(oldBehavior)) {
          const deactivationHandler = this._deactivationHandlers.get(oldBehavior);
          if (deactivationHandler) {
            deactivationHandler();
            this._deactivationHandlers.delete(oldBehavior);
          }
        }
      }
    }
    if (newValue) {
      for (const newBehavior of newValue) {
        if (!oldValue || !oldValue.includes(newBehavior)) {
          this._activateBehavior(newBehavior);
        }
      }
    }
  }
  /*
   * Publish an event and optionally bubble it up the scene
   **/
  publishEvent(event, bubble) {
    this._events.publish(event);
    if (bubble && this.parent) {
      this.parent.publishEvent(event, bubble);
    }
  }
  getRoot() {
    return !this._parent ? this : this._parent.getRoot();
  }
  _internalActivate() {
    this._isActive = true;
    const { $data, $variables, $timeRange, $behaviors } = this.state;
    this._activationHandlers.forEach((handler) => {
      const result = handler();
      if (result) {
        this._deactivationHandlers.set(result, result);
      }
    });
    if ($timeRange && !$timeRange.isActive) {
      this._deactivationHandlers.set($timeRange, $timeRange.activate());
    }
    if ($variables && !$variables.isActive) {
      this._deactivationHandlers.set($variables, $variables.activate());
    }
    if ($data && !$data.isActive) {
      this._deactivationHandlers.set($data, $data.activate());
    }
    if ($behaviors) {
      for (const behavior of $behaviors) {
        this._activateBehavior(behavior);
      }
    }
  }
  _activateBehavior(behavior) {
    if (behavior instanceof SceneObjectBase) {
      this._deactivationHandlers.set(behavior, behavior.activate());
    } else if (typeof behavior === "function") {
      const deactivate = behavior(this);
      if (deactivate) {
        this._deactivationHandlers.set(behavior, deactivate);
      }
    }
  }
  /**
   * This is primarily called from SceneComponentWrapper when the SceneObject's Component is mounted.
   * But in some scenarios this can also be called directly from another scene object. When called manually from another scene object
   * make sure to call the returned function when the source scene object is deactivated.
   */
  activate() {
    if (!this.isActive) {
      this._internalActivate();
    }
    this._refCount++;
    let called = false;
    return () => {
      this._refCount--;
      if (called) {
        const msg = `SceneObject cancelation handler returned by activate() called a second time`;
        throw new Error(msg);
      }
      called = true;
      if (this._refCount === 0) {
        this._internalDeactivate();
      }
    };
  }
  /**
   * Called by the SceneComponentWrapper when the react component is unmounted.
   * Don't override this, instead use addActivationHandler. The activation handler can return a deactivation handler.
   */
  _internalDeactivate() {
    this._isActive = false;
    for (let handler of this._deactivationHandlers.values()) {
      handler();
    }
    this._deactivationHandlers.clear();
    this._events.removeAllListeners();
    this._subs.unsubscribe();
    this._subs = new rxjs.Subscription();
  }
  /**
   * Utility hook to get and subscribe to state
   */
  useState() {
    return useSceneObjectState(this);
  }
  /** Force a re-render, should only be needed when variable values change */
  forceRender() {
    this.setState({});
  }
  /**
   * Will create new SceneObject with shallow-cloned state, but all state items of type SceneObject are deep cloned
   */
  clone(withState) {
    return cloneSceneObject(this, withState);
  }
  /**
   * Allows external code to register code that is executed on activate and deactivate. This allow you
   * to wire up scene objects that need to respond to state changes in other objects from the outside.
   **/
  addActivationHandler(handler) {
    this._activationHandlers.push(handler);
  }
  /**
   * Loop through state and call callback for each direct child scene object.
   * Checks 1 level deep properties and arrays. So a scene object hidden in a nested plain object will not be detected.
   * Return false to exit loop early.
   */
  forEachChild(callback) {
    forEachChild(this.state, callback);
  }
  /** Returns a SceneObjectRef that will resolve to this object */
  getRef() {
    if (!this._ref) {
      this._ref = new SceneObjectRef(this);
    }
    return this._ref;
  }
  toJSON() {
    return {
      type: Object.getPrototypeOf(this).constructor.name,
      isActive: this.isActive,
      state: this.state
    };
  }
}
function useSceneObjectState(model, options) {
  var _a;
  const [_, setState] = React.useState(model.state);
  const stateAtFirstRender = model.state;
  const shouldActivateOrKeepAlive = (_a = options == null ? void 0 : options.shouldActivateOrKeepAlive) != null ? _a : false;
  React.useEffect(() => {
    let unactivate;
    if (shouldActivateOrKeepAlive) {
      unactivate = model.activate();
    }
    const s = model.subscribeToState((state) => {
      setState(state);
    });
    if (model.state !== stateAtFirstRender) {
      setState(model.state);
    }
    return () => {
      s.unsubscribe();
      if (unactivate) {
        unactivate();
      }
    };
  }, [model, shouldActivateOrKeepAlive]);
  return model.state;
}
function forEachChild(state, callback) {
  for (const propValue of Object.values(state)) {
    if (propValue instanceof SceneObjectBase) {
      const result = callback(propValue);
      if (result === false) {
        break;
      }
    }
    if (Array.isArray(propValue)) {
      let exitEarly = false;
      for (const child of propValue) {
        if (child instanceof SceneObjectBase) {
          const result = callback(child);
          if (result === false) {
            exitEarly = true;
            break;
          }
        }
      }
      if (exitEarly) {
        break;
      }
    }
  }
}

function cloneSceneObject(sceneObject, withState) {
  const clonedState = cloneSceneObjectState(sceneObject.state, withState);
  return new sceneObject.constructor(clonedState);
}
function cloneSceneObjectState(sceneState, withState) {
  const clonedState = { ...sceneState };
  Object.assign(clonedState, withState);
  for (const key in clonedState) {
    if (withState && withState[key] !== void 0) {
      continue;
    }
    const propValue = clonedState[key];
    if (propValue instanceof SceneObjectRef) {
      console.warn("Cloning object with SceneObjectRef");
      continue;
    }
    if (propValue instanceof SceneObjectBase) {
      clonedState[key] = propValue.clone();
    } else if (Array.isArray(propValue)) {
      const newArray = [];
      for (const child of propValue) {
        if (child instanceof SceneObjectBase) {
          newArray.push(child.clone());
        } else if (typeof child === "object") {
          newArray.push(lodash.cloneDeep(child));
        } else {
          newArray.push(child);
        }
      }
      clonedState[key] = newArray;
    } else if (typeof propValue === "object") {
      clonedState[key] = lodash.cloneDeep(propValue);
    } else {
      clonedState[key] = propValue;
    }
  }
  return clonedState;
}

class RuntimeDataSource extends data.DataSourceApi {
  constructor(pluginId, uid) {
    super({
      name: "RuntimeDataSource-" + pluginId,
      uid,
      type: pluginId,
      id: 1,
      readOnly: true,
      jsonData: {},
      access: "direct",
      meta: {
        id: pluginId,
        name: "RuntimeDataSource-" + pluginId,
        type: data.PluginType.datasource,
        info: {
          author: {
            name: ""
          },
          description: "",
          links: [],
          logos: {
            large: "",
            small: ""
          },
          screenshots: [],
          updated: "",
          version: ""
        },
        module: "",
        baseUrl: ""
      }
    });
  }
  testDatasource() {
    return Promise.resolve({});
  }
}
const runtimeDataSources = /* @__PURE__ */ new Map();
function registerRuntimeDataSource({ dataSource }) {
  if (runtimeDataSources.has(dataSource.uid)) {
    throw new Error(`A runtime data source with uid ${dataSource.uid} has already been registered`);
  }
  runtimeDataSources.set(dataSource.uid, dataSource);
}

const DEFAULT_NAMESPACE = "";
const DEFAULT_EXCLUDE_FROM_NAMESPACE = ["from", "to", "timezone"];
class UniqueUrlKeyMapper {
  constructor(options) {
    this.index = /* @__PURE__ */ new Map();
    this.options = {
      namespace: (options == null ? void 0 : options.namespace) || DEFAULT_NAMESPACE,
      excludeFromNamespace: (options == null ? void 0 : options.excludeFromNamespace) || DEFAULT_EXCLUDE_FROM_NAMESPACE
    };
  }
  getOptions() {
    return this.options;
  }
  getNamespacedKey(keyWithoutNamespace) {
    if (this.options.namespace && !this.options.excludeFromNamespace.includes(keyWithoutNamespace)) {
      return `${this.options.namespace}-${keyWithoutNamespace}`;
    }
    return keyWithoutNamespace;
  }
  getUniqueKey(keyWithoutNamespace, obj) {
    const key = this.getNamespacedKey(keyWithoutNamespace);
    const objectsWithKey = this.index.get(key);
    if (!objectsWithKey) {
      this.index.set(key, [obj]);
      return key;
    }
    let address = objectsWithKey.findIndex((o) => o === obj);
    if (address === -1) {
      filterOutOrphanedObjects(objectsWithKey, obj.getRoot());
      objectsWithKey.push(obj);
      address = objectsWithKey.length - 1;
    }
    if (address > 0) {
      return `${key}-${address + 1}`;
    }
    return key;
  }
  clear() {
    this.index.clear();
  }
}
function filterOutOrphanedObjects(sceneObjects, root) {
  for (let i = 0; i < sceneObjects.length; i++) {
    const obj = sceneObjects[i];
    if (isOrphan(obj)) {
      sceneObjects.splice(i, 1);
      i--;
    }
  }
}
function isOrphan(obj, root) {
  if (!obj.parent) {
    return false;
  }
  let found = false;
  obj.parent.forEachChild((child) => {
    if (child === obj) {
      found = true;
      return false;
    }
    return;
  });
  if (!found) {
    return true;
  }
  return isOrphan(obj.parent);
}

function getUrlState(root, uniqueUrlKeyMapperOptions) {
  const urlKeyMapper = new UniqueUrlKeyMapper(uniqueUrlKeyMapperOptions);
  const result = {};
  const visitNode = (obj) => {
    if (obj.urlSync) {
      const newUrlState = obj.urlSync.getUrlState();
      for (const [key, value] of Object.entries(newUrlState)) {
        if (value != null) {
          const uniqueKey = urlKeyMapper.getUniqueKey(key, obj);
          result[uniqueKey] = value;
        }
      }
    }
    obj.forEachChild(visitNode);
  };
  visitNode(root);
  return result;
}
function syncStateFromSearchParams(root, urlParams, uniqueUrlKeyMapperOptions) {
  const urlKeyMapper = new UniqueUrlKeyMapper(uniqueUrlKeyMapperOptions);
  syncStateFromUrl(root, urlParams, urlKeyMapper);
}
function syncStateFromUrl(root, urlParams, urlKeyMapper, onlyChildren) {
  if (!onlyChildren) {
    syncUrlStateToObject(root, urlParams, urlKeyMapper);
  }
  root.forEachChild((child) => {
    syncUrlStateToObject(child, urlParams, urlKeyMapper);
  });
  root.forEachChild((child) => syncStateFromUrl(child, urlParams, urlKeyMapper, true));
}
function syncUrlStateToObject(sceneObject, urlParams, urlKeyMapper) {
  if (sceneObject.urlSync) {
    const urlState = {};
    const currentState = sceneObject.urlSync.getUrlState();
    for (const key of sceneObject.urlSync.getKeys()) {
      const uniqueKey = urlKeyMapper.getUniqueKey(key, sceneObject);
      const newValue = urlParams.getAll(uniqueKey);
      const currentValue = currentState[key];
      if (isUrlValueEqual(newValue, currentValue)) {
        continue;
      }
      if (newValue.length > 0) {
        if (Array.isArray(currentValue)) {
          urlState[key] = newValue;
        } else {
          urlState[key] = newValue[0];
        }
      } else {
        urlState[key] = null;
      }
    }
    if (Object.keys(urlState).length > 0) {
      sceneObject.urlSync.updateFromUrl(urlState);
    }
  }
}
function isUrlValueEqual(currentUrlValue, newUrlValue) {
  if (currentUrlValue.length === 0 && newUrlValue == null) {
    return true;
  }
  if (!Array.isArray(newUrlValue) && (currentUrlValue == null ? void 0 : currentUrlValue.length) === 1) {
    return newUrlValue === currentUrlValue[0];
  }
  if ((newUrlValue == null ? void 0 : newUrlValue.length) === 0 && currentUrlValue === null) {
    return true;
  }
  return lodash.isEqual(currentUrlValue, newUrlValue);
}

function lookupVariable(name, sceneObject) {
  const variables = sceneObject.state.$variables;
  if (!variables) {
    if (sceneObject.parent) {
      return lookupVariable(name, sceneObject.parent);
    } else {
      return null;
    }
  }
  const found = variables.getByName(name);
  if (found) {
    return found;
  } else if (sceneObject.parent) {
    return lookupVariable(name, sceneObject.parent);
  }
  return null;
}

function writeSceneLog(logger, message, ...rest) {
  let loggingEnabled = false;
  if (typeof window !== "undefined") {
    loggingEnabled = localStorage.getItem("grafana.debug.scenes") === "true";
  }
  if (loggingEnabled) {
    console.log(`${logger}: `, message, ...rest);
  }
}

var __typeError$4 = (msg) => {
  throw TypeError(msg);
};
var __accessCheck$4 = (obj, member, msg) => member.has(obj) || __typeError$4("Cannot " + msg);
var __privateGet$4 = (obj, member, getter) => (__accessCheck$4(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$4 = (obj, member, value) => member.has(obj) ? __typeError$4("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$4 = (obj, member, value, setter) => (__accessCheck$4(obj, member, "write to private field"), member.set(obj, value), value);
var _running, _tryCompleteProfileFrameId;
function isQueryController(s) {
  return "isQueryController" in s;
}
class SceneQueryController extends SceneObjectBase {
  constructor(state = {}, profiler) {
    super({ ...state, isRunning: false });
    this.profiler = profiler;
    this.isQueryController = true;
    __privateAdd$4(this, _running, /* @__PURE__ */ new Set());
    __privateAdd$4(this, _tryCompleteProfileFrameId, null);
    this.runningQueriesCount = () => {
      return __privateGet$4(this, _running).size;
    };
    if (profiler) {
      this.profiler = profiler;
      profiler.setQueryController(this);
    }
    this.addActivationHandler(() => {
      var _a;
      (_a = this.profiler) == null ? void 0 : _a.setQueryController(this);
      return () => __privateGet$4(this, _running).clear();
    });
  }
  startProfile(name) {
    var _a;
    if (!this.state.enableProfiling) {
      return;
    }
    (_a = this.profiler) == null ? void 0 : _a.startProfile(name);
  }
  cancelProfile() {
    var _a;
    (_a = this.profiler) == null ? void 0 : _a.cancelProfile();
  }
  queryStarted(entry) {
    __privateGet$4(this, _running).add(entry);
    this.changeRunningQueryCount(1, entry);
    if (!this.state.isRunning) {
      this.setState({ isRunning: true });
    }
  }
  queryCompleted(entry) {
    if (!__privateGet$4(this, _running).has(entry)) {
      return;
    }
    __privateGet$4(this, _running).delete(entry);
    this.changeRunningQueryCount(-1);
    if (__privateGet$4(this, _running).size === 0) {
      this.setState({ isRunning: false });
    }
  }
  changeRunningQueryCount(dir, entry) {
    var _a, _b, _c, _d;
    window.__grafanaRunningQueryCount = ((_a = window.__grafanaRunningQueryCount) != null ? _a : 0) + dir;
    if (dir === 1 && this.state.enableProfiling) {
      if (entry) {
        (_b = this.profiler) == null ? void 0 : _b.addCrumb(`${entry.type}`);
      }
      if ((_c = this.profiler) == null ? void 0 : _c.isTailRecording()) {
        writeSceneLog("SceneQueryController", "New query started, cancelling tail recording");
        (_d = this.profiler) == null ? void 0 : _d.cancelTailRecording();
      }
    }
    if (this.state.enableProfiling) {
      if (__privateGet$4(this, _tryCompleteProfileFrameId)) {
        cancelAnimationFrame(__privateGet$4(this, _tryCompleteProfileFrameId));
      }
      __privateSet$4(this, _tryCompleteProfileFrameId, requestAnimationFrame(() => {
        var _a2;
        (_a2 = this.profiler) == null ? void 0 : _a2.tryCompletingProfile();
      }));
    }
  }
  cancelAll() {
    var _a;
    for (const entry of __privateGet$4(this, _running).values()) {
      (_a = entry.cancel) == null ? void 0 : _a.call(entry);
    }
  }
}
_running = new WeakMap();
_tryCompleteProfileFrameId = new WeakMap();

function getQueryController(sceneObject) {
  let parent = sceneObject;
  while (parent) {
    if (parent.state.$behaviors) {
      for (const behavior of parent.state.$behaviors) {
        if (isQueryController(behavior)) {
          return behavior;
        }
      }
    }
    parent = parent.parent;
  }
  return void 0;
}

class SceneDataNode extends SceneObjectBase {
  constructor(state) {
    super({
      data: emptyPanelData,
      ...state
    });
  }
  getResultsStream() {
    const result = {
      origin: this,
      data: this.state.data
    };
    return rxjs.of(result);
  }
}
const emptyPanelData = {
  state: schema.LoadingState.Done,
  series: [],
  timeRange: data.getDefaultTimeRange()
};

class SceneObjectUrlSyncConfig {
  constructor(_sceneObject, _options) {
    this._sceneObject = _sceneObject;
    this._nextChangeShouldAddHistoryStep = false;
    this._keys = _options.keys;
  }
  getKeys() {
    if (typeof this._keys === "function") {
      return this._keys();
    }
    return this._keys;
  }
  getUrlState() {
    return this._sceneObject.getUrlState();
  }
  updateFromUrl(values) {
    this._sceneObject.updateFromUrl(values);
  }
  shouldCreateHistoryStep(values) {
    return this._nextChangeShouldAddHistoryStep;
  }
  performBrowserHistoryAction(callback) {
    this._nextChangeShouldAddHistoryStep = true;
    callback();
    this._nextChangeShouldAddHistoryStep = false;
  }
}

function getClosest(sceneObject, extract) {
  let curSceneObject = sceneObject;
  let extracted = void 0;
  while (curSceneObject && !extracted) {
    extracted = extract(curSceneObject);
    curSceneObject = curSceneObject.parent;
  }
  return extracted;
}

const INTERVAL_STRING_REGEX = /^\d+[yYmMsSwWhHdD]$/;
function parseUrlParam(value) {
  if (typeof value !== "string") {
    return null;
  }
  if (value.indexOf("now") !== -1) {
    return value;
  }
  if (INTERVAL_STRING_REGEX.test(value)) {
    return value;
  }
  if (value.length === 8) {
    const utcValue = data.toUtc(value, "YYYYMMDD");
    if (utcValue.isValid()) {
      return utcValue.toISOString();
    }
  } else if (value.length === 15) {
    const utcValue = data.toUtc(value, "YYYYMMDDTHHmmss");
    if (utcValue.isValid()) {
      return utcValue.toISOString();
    }
  } else if (value.length === 19) {
    const utcValue = data.toUtc(value, "YYYY-MM-DD HH:mm:ss");
    if (utcValue.isValid()) {
      return utcValue.toISOString();
    }
  } else if (value.length === 24) {
    const utcValue = data.toUtc(value);
    return utcValue.toISOString();
  }
  const epoch = parseInt(value, 10);
  if (!isNaN(epoch)) {
    return data.toUtc(epoch).toISOString();
  }
  return null;
}

function evaluateTimeRange(from, to, timeZone, fiscalYearStartMonth, delay, weekStart) {
  const hasDelay = delay && to === "now";
  const now = Date.now();
  if (weekStart) {
    setWeekStartIfDifferent(weekStart);
  }
  const parseOrToDateTime = (val, options) => {
    if (data.dateMath.toDateTime) {
      return data.dateMath.toDateTime(val, options);
    } else {
      return data.dateMath.parse(val, options.roundUp, options.timezone, options.fiscalYearStartMonth);
    }
  };
  return {
    to: parseOrToDateTime(hasDelay ? "now-" + delay : to, {
      roundUp: true,
      timezone: timeZone,
      fiscalYearStartMonth,
      now
    }),
    from: parseOrToDateTime(from, {
      roundUp: false,
      timezone: timeZone,
      fiscalYearStartMonth,
      now
    }),
    raw: {
      from,
      to
    }
  };
}
let prevWeekStart;
function setWeekStartIfDifferent(weekStart) {
  if (weekStart !== prevWeekStart) {
    prevWeekStart = weekStart;
    data.setWeekStart(weekStart);
  }
}

function isValid$1(value, roundUp, timeZone) {
  if (data.isDateTime(value)) {
    return value.isValid();
  }
  if (data.dateMath.isMathString(value)) {
    return data.dateMath.isValid(value);
  }
  const parsed = data.dateTimeParse(value, { roundUp, timeZone });
  return parsed.isValid();
}

const REFRESH_INTERACTION = "refresh";
const TIME_RANGE_CHANGE_INTERACTION = "time_range_change";
const FILTER_REMOVED_INTERACTION = "filter_removed";
const FILTER_CHANGED_INTERACTION = "filter_changed";
const FILTER_RESTORED_INTERACTION = "filter_restored";
const VARIABLE_VALUE_CHANGED_INTERACTION = "variable_value_changed";
const SCOPES_CHANGED_INTERACTION = "scopes_changed";
const ADHOC_KEYS_DROPDOWN_INTERACTION = "adhoc_keys_dropdown";
const ADHOC_VALUES_DROPDOWN_INTERACTION = "adhoc_values_dropdown";
const GROUPBY_DIMENSIONS_INTERACTION = "groupby_dimensions";

class SceneTimeRange extends SceneObjectBase {
  constructor(state = {}) {
    var _a;
    const from = state.from && isValid$1(state.from) ? state.from : "now-6h";
    const to = state.to && isValid$1(state.to) ? state.to : "now";
    const timeZone = getValidTimeZone(state.timeZone);
    const value = evaluateTimeRange(
      from,
      to,
      timeZone || data.getTimeZone(),
      state.fiscalYearStartMonth,
      state.UNSAFE_nowDelay,
      state.weekStart
    );
    const refreshOnActivate = (_a = state.refreshOnActivate) != null ? _a : { percent: 10 };
    super({ from, to, timeZone, value, refreshOnActivate, ...state });
    this._urlSync = new SceneObjectUrlSyncConfig(this, { keys: ["from", "to", "timezone", "time", "time.window"] });
    this.onTimeRangeChange = (timeRange) => {
      const update = {};
      if (typeof timeRange.raw.from === "string") {
        update.from = timeRange.raw.from;
      } else {
        update.from = timeRange.raw.from.toISOString();
      }
      if (typeof timeRange.raw.to === "string") {
        update.to = timeRange.raw.to;
      } else {
        update.to = timeRange.raw.to.toISOString();
      }
      update.value = evaluateTimeRange(
        update.from,
        update.to,
        this.getTimeZone(),
        this.state.fiscalYearStartMonth,
        this.state.UNSAFE_nowDelay,
        this.state.weekStart
      );
      if (update.from !== this.state.from || update.to !== this.state.to) {
        const queryController = getQueryController(this);
        queryController == null ? void 0 : queryController.startProfile(TIME_RANGE_CHANGE_INTERACTION);
        this._urlSync.performBrowserHistoryAction(() => {
          this.setState(update);
        });
      }
    };
    this.onTimeZoneChange = (timeZone) => {
      this._urlSync.performBrowserHistoryAction(() => {
        var _a;
        const validTimeZone = (_a = getValidTimeZone(timeZone)) != null ? _a : schema.defaultTimeZone;
        const updatedValue = evaluateTimeRange(
          this.state.from,
          this.state.to,
          validTimeZone,
          this.state.fiscalYearStartMonth,
          this.state.UNSAFE_nowDelay,
          this.state.weekStart
        );
        this.setState({ timeZone: validTimeZone, value: updatedValue });
      });
    };
    this.onRefresh = () => {
      this.refreshRange(0);
      this.publishEvent(new runtime.RefreshEvent(), true);
    };
    this.addActivationHandler(this._onActivate.bind(this));
  }
  _onActivate() {
    if (!this.state.timeZone) {
      const timeZoneSource = this.getTimeZoneSource();
      if (timeZoneSource !== this) {
        this._subs.add(
          timeZoneSource.subscribeToState((n, p) => {
            if (n.timeZone !== void 0 && n.timeZone !== p.timeZone) {
              this.refreshRange(0);
            }
          })
        );
      }
    }
    if (data.rangeUtil.isRelativeTimeRange(this.state.value.raw)) {
      this.refreshIfStale();
    }
    return () => {
      if (this.state.weekStart) {
        data.setWeekStart(runtime.config.bootData.user.weekStart);
      }
    };
  }
  refreshIfStale() {
    var _a, _b, _c, _d;
    let ms;
    if (((_b = (_a = this.state) == null ? void 0 : _a.refreshOnActivate) == null ? void 0 : _b.percent) !== void 0) {
      ms = this.calculatePercentOfInterval(this.state.refreshOnActivate.percent);
    }
    if (((_d = (_c = this.state) == null ? void 0 : _c.refreshOnActivate) == null ? void 0 : _d.afterMs) !== void 0) {
      ms = Math.min(this.state.refreshOnActivate.afterMs, ms != null ? ms : Infinity);
    }
    if (ms !== void 0) {
      this.refreshRange(ms);
    }
  }
  /**
   * Will traverse up the scene graph to find the closest SceneTimeRangeLike with time zone set
   */
  getTimeZoneSource() {
    if (!this.parent || !this.parent.parent) {
      return this;
    }
    const source = getClosest(this.parent.parent, (o) => {
      if (o.state.$timeRange && o.state.$timeRange.state.timeZone) {
        return o.state.$timeRange;
      }
      return void 0;
    });
    if (!source) {
      return this;
    }
    return source;
  }
  /**
   * Refreshes time range if it is older than the invalidation interval
   * @param refreshAfterMs invalidation interval (milliseconds)
   * @private
   */
  refreshRange(refreshAfterMs) {
    var _a;
    const value = evaluateTimeRange(
      this.state.from,
      this.state.to,
      (_a = this.state.timeZone) != null ? _a : data.getTimeZone(),
      this.state.fiscalYearStartMonth,
      this.state.UNSAFE_nowDelay,
      this.state.weekStart
    );
    const diff = value.to.diff(this.state.value.to, "milliseconds");
    if (diff >= refreshAfterMs) {
      this.setState({ value });
    }
  }
  calculatePercentOfInterval(percent) {
    const intervalMs = this.state.value.to.diff(this.state.value.from, "milliseconds");
    return Math.ceil(intervalMs / 100 * percent);
  }
  getTimeZone() {
    if (this.state.timeZone && getValidTimeZone(this.state.timeZone)) {
      return this.state.timeZone;
    }
    const timeZoneSource = this.getTimeZoneSource();
    if (timeZoneSource !== this && getValidTimeZone(timeZoneSource.state.timeZone)) {
      return timeZoneSource.state.timeZone;
    }
    return data.getTimeZone();
  }
  getUrlState() {
    const params = runtime.locationService.getSearchObject();
    const urlValues = { from: this.state.from, to: this.state.to, timezone: this.getTimeZone() };
    if (params.time && params["time.window"]) {
      urlValues.time = null;
      urlValues["time.window"] = null;
    }
    return urlValues;
  }
  updateFromUrl(values) {
    var _a, _b, _c;
    const update = {};
    let from = parseUrlParam(values.from);
    let to = parseUrlParam(values.to);
    if (values.time && values["time.window"]) {
      const time = Array.isArray(values.time) ? values.time[0] : values.time;
      const timeWindow = Array.isArray(values["time.window"]) ? values["time.window"][0] : values["time.window"];
      const timeRange = getTimeWindow(time, timeWindow);
      if (timeRange.from && isValid$1(timeRange.from)) {
        from = timeRange.from;
      }
      if (timeRange.to && isValid$1(timeRange.to)) {
        to = timeRange.to;
      }
    }
    if (from && isValid$1(from)) {
      update.from = from;
    }
    if (to && isValid$1(to)) {
      update.to = to;
    }
    if (typeof values.timezone === "string") {
      update.timeZone = values.timezone !== "" ? values.timezone : void 0;
    }
    if (Object.keys(update).length === 0) {
      return;
    }
    update.value = evaluateTimeRange(
      (_a = update.from) != null ? _a : this.state.from,
      (_b = update.to) != null ? _b : this.state.to,
      (_c = update.timeZone) != null ? _c : this.getTimeZone(),
      this.state.fiscalYearStartMonth,
      this.state.UNSAFE_nowDelay,
      this.state.weekStart
    );
    return this.setState(update);
  }
}
function getTimeWindow(time, timeWindow) {
  const valueTime = isNaN(Date.parse(time)) ? parseInt(time, 10) : Date.parse(time);
  let timeWindowMs;
  if (timeWindow.match(/^\d+$/) && parseInt(timeWindow, 10)) {
    timeWindowMs = parseInt(timeWindow, 10);
  } else {
    timeWindowMs = data.rangeUtil.intervalToMs(timeWindow);
  }
  return {
    from: data.toUtc(valueTime - timeWindowMs / 2).toISOString(),
    to: data.toUtc(valueTime + timeWindowMs / 2).toISOString()
  };
}
function getValidTimeZone(timeZone) {
  if (timeZone === void 0) {
    return void 0;
  }
  if (lodash.isEmpty(timeZone)) {
    return runtime.config.bootData.user.timezone;
  }
  if (timeZone === schema.defaultTimeZone) {
    return timeZone;
  }
  if (data.getZone(timeZone)) {
    return timeZone;
  }
  writeSceneLog("SceneTimeRange", `Invalid timeZone "${timeZone}" provided.`);
  return;
}

const EmptyDataNode = new SceneDataNode();
const DefaultTimeRange = new SceneTimeRange();
class EmptyVariableSetImpl extends SceneObjectBase {
  constructor() {
    super({ variables: [] });
  }
  getByName(name) {
    return void 0;
  }
  isVariableLoadingOrWaitingToUpdate(variable) {
    return false;
  }
}
const EmptyVariableSet = new EmptyVariableSetImpl();

function getTimeRange(sceneObject) {
  var _a;
  return (_a = getClosest(sceneObject, (s) => s.state.$timeRange)) != null ? _a : DefaultTimeRange;
}

class SceneVariableValueChangedEvent extends data.BusEventWithPayload {
}
SceneVariableValueChangedEvent.type = "scene-variable-changed-value";
function isCustomVariableValue(value) {
  return typeof value === "object" && "formatter" in value;
}

let fieldAccessorCache = {};
function getFieldAccessor(fieldPath) {
  const accessor = fieldAccessorCache[fieldPath];
  if (accessor) {
    return accessor;
  }
  return fieldAccessorCache[fieldPath] = lodash.property(fieldPath);
}

class ScopedVarsVariable {
  constructor(name, value) {
    this.state = { name, value, type: "scopedvar" };
  }
  getValue(fieldPath) {
    let { value } = this.state;
    let realValue = value.value;
    if (fieldPath) {
      realValue = getFieldAccessor(fieldPath)(value.value);
    } else {
      realValue = value.value;
    }
    if (realValue === "string" || realValue === "number" || realValue === "boolean") {
      return realValue;
    }
    return String(realValue);
  }
  getValueText() {
    const { value } = this.state;
    if (value.text != null) {
      return String(value.text);
    }
    return String(value);
  }
}
let scopedVarsVariable;
function getSceneVariableForScopedVar(name, value) {
  if (!scopedVarsVariable) {
    scopedVarsVariable = new ScopedVarsVariable(name, value);
  } else {
    scopedVarsVariable.state.name = name;
    scopedVarsVariable.state.value = value;
  }
  return scopedVarsVariable;
}

const ALL_VARIABLE_TEXT = "All";
const ALL_VARIABLE_VALUE = "$__all";
const AUTO_VARIABLE_TEXT = "Auto";
const AUTO_VARIABLE_VALUE = "$__auto";
const VARIABLE_REGEX = /\$(\w+)|\[\[(\w+?)(?::(\w+))?\]\]|\${(\w+)(?:\.([^:^\}]+))?(?::([^\}]+))?}/g;
const SEARCH_FILTER_VARIABLE = "__searchFilter";
const SCOPES_VARIABLE_NAME = "__scopes";

const formatRegistry = new data.Registry(() => {
  const formats = [
    {
      id: schema.VariableFormatID.Lucene,
      name: "Lucene",
      description: "Values are lucene escaped and multi-valued variables generate an OR expression",
      formatter: (value) => {
        if (typeof value === "string") {
          return luceneEscape(value);
        }
        if (Array.isArray(value)) {
          if (value.length === 0) {
            return "__empty__";
          }
          const quotedValues = lodash.map(value, (val) => {
            return '"' + luceneEscape(val) + '"';
          });
          return "(" + quotedValues.join(" OR ") + ")";
        } else {
          return luceneEscape(`${value}`);
        }
      }
    },
    {
      id: schema.VariableFormatID.Raw,
      name: "raw",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.keep-value-as-is",
        "Keep value as is"
      ),
      formatter: (value) => String(value)
    },
    {
      id: schema.VariableFormatID.Regex,
      name: "Regex",
      description: "Values are regex escaped and multi-valued variables generate a (<value>|<value>) expression",
      formatter: (value) => {
        if (typeof value === "string") {
          return data.escapeRegex(value);
        }
        if (Array.isArray(value)) {
          const escapedValues = value.map((item) => {
            if (typeof item === "string") {
              return data.escapeRegex(item);
            } else {
              return data.escapeRegex(String(item));
            }
          });
          if (escapedValues.length === 1) {
            return escapedValues[0];
          }
          return "(" + escapedValues.join("|") + ")";
        }
        return data.escapeRegex(`${value}`);
      }
    },
    {
      id: schema.VariableFormatID.Pipe,
      name: "Pipe",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.values-are-separated-by-character",
        "Values are separated by | character"
      ),
      formatter: (value) => {
        if (typeof value === "string") {
          return value;
        }
        if (Array.isArray(value)) {
          return value.join("|");
        }
        return `${value}`;
      }
    },
    {
      id: schema.VariableFormatID.Distributed,
      name: "Distributed",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.multiple-values-are-formatted-like-variablevalue",
        "Multiple values are formatted like variable=value"
      ),
      formatter: (value, args, variable) => {
        if (typeof value === "string") {
          return value;
        }
        if (Array.isArray(value)) {
          value = lodash.map(value, (val, index) => {
            if (index !== 0) {
              return variable.state.name + "=" + val;
            } else {
              return val;
            }
          });
          return value.join(",");
        }
        return `${value}`;
      }
    },
    {
      id: schema.VariableFormatID.CSV,
      name: "Csv",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.commaseparated-values",
        "Comma-separated values"
      ),
      formatter: (value) => {
        if (typeof value === "string") {
          return value;
        }
        if (lodash.isArray(value)) {
          return value.join(",");
        }
        return String(value);
      }
    },
    {
      id: schema.VariableFormatID.HTML,
      name: "HTML",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.html-escaping-of-values",
        "HTML escaping of values"
      ),
      formatter: (value) => {
        if (typeof value === "string") {
          return data.textUtil.escapeHtml(value);
        }
        if (lodash.isArray(value)) {
          return data.textUtil.escapeHtml(value.join(", "));
        }
        return data.textUtil.escapeHtml(String(value));
      }
    },
    {
      id: schema.VariableFormatID.JSON,
      name: "JSON",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.json-stringify-value",
        "JSON stringify value"
      ),
      formatter: (value) => {
        if (typeof value === "string") {
          return value;
        }
        return JSON.stringify(value);
      }
    },
    {
      id: schema.VariableFormatID.PercentEncode,
      name: "Percent encode",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.useful-for-url-escaping-values",
        "Useful for URL escaping values"
      ),
      formatter: (value) => {
        if (lodash.isArray(value)) {
          return encodeURIComponentStrict("{" + value.join(",") + "}");
        }
        return encodeURIComponentStrict(value);
      }
    },
    {
      id: schema.VariableFormatID.SingleQuote,
      name: "Single quote",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.single-quoted-values",
        "Single quoted values"
      ),
      formatter: (value) => {
        const regExp = new RegExp(`'`, "g");
        if (lodash.isArray(value)) {
          return lodash.map(value, (v) => `'${lodash.replace(v, regExp, `\\'`)}'`).join(",");
        }
        let strVal = typeof value === "string" ? value : String(value);
        return `'${lodash.replace(strVal, regExp, `\\'`)}'`;
      }
    },
    {
      id: schema.VariableFormatID.DoubleQuote,
      name: "Double quote",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.double-quoted-values",
        "Double quoted values"
      ),
      formatter: (value) => {
        const regExp = new RegExp('"', "g");
        if (lodash.isArray(value)) {
          return lodash.map(value, (v) => `"${lodash.replace(v, regExp, '\\"')}"`).join(",");
        }
        let strVal = typeof value === "string" ? value : String(value);
        return `"${lodash.replace(strVal, regExp, '\\"')}"`;
      }
    },
    {
      id: schema.VariableFormatID.SQLString,
      name: "SQL string",
      description: "SQL string quoting and commas for use in IN statements and other scenarios",
      formatter: sqlStringFormatter
    },
    {
      id: "join",
      // join not yet available in depended @grafana/schema version
      name: "Join",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.join-values-with-a-comma",
        "Join values with a comma"
      ),
      formatter: (value, args) => {
        var _a;
        if (lodash.isArray(value)) {
          const separator = (_a = args[0]) != null ? _a : ",";
          return value.join(separator);
        }
        return String(value);
      }
    },
    {
      id: schema.VariableFormatID.Date,
      name: "Date",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.format-date-in-different-ways",
        "Format date in different ways"
      ),
      formatter: (value, args) => {
        var _a;
        let nrValue = NaN;
        if (typeof value === "number") {
          nrValue = value;
        } else if (typeof value === "string") {
          nrValue = parseInt(value, 10);
        }
        if (isNaN(nrValue)) {
          return "NaN";
        }
        const arg = (_a = args[0]) != null ? _a : "iso";
        switch (arg) {
          case "ms":
            return String(value);
          case "seconds":
            return `${Math.round(nrValue / 1e3)}`;
          case "iso":
            return data.dateTime(nrValue).toISOString();
          default:
            if ((args || []).length > 1) {
              return data.dateTime(nrValue).format(args.join(":"));
            }
            return data.dateTime(nrValue).format(arg);
        }
      }
    },
    {
      id: schema.VariableFormatID.Glob,
      name: "Glob",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.format-multivalued-variables-using-syntax-example",
        "Format multi-valued variables using glob syntax, example {value1,value2}"
      ),
      formatter: (value) => {
        if (lodash.isArray(value) && value.length > 1) {
          return "{" + value.join(",") + "}";
        }
        return String(value);
      }
    },
    {
      id: schema.VariableFormatID.Text,
      name: "Text",
      description: "Format variables in their text representation. Example in multi-variable scenario A + B + C.",
      formatter: (value, _args, variable, fieldPath) => {
        if (variable.getValueText) {
          return variable.getValueText(fieldPath);
        }
        return String(value);
      }
    },
    {
      id: schema.VariableFormatID.QueryParam,
      name: "Query parameter",
      description: "Format variables as URL parameters. Example in multi-variable scenario A + B + C => var-foo=A&var-foo=B&var-foo=C.",
      formatter: (value, _args, variable, fieldPath) => {
        if (variable.urlSync && !fieldPath) {
          const urlParam = variable.urlSync.getUrlState();
          return data.urlUtil.toUrlParams(urlParam);
        }
        if (Array.isArray(value)) {
          return value.map((v) => formatQueryParameter(variable.state.name, v)).join("&");
        }
        return formatQueryParameter(variable.state.name, value);
      }
    },
    {
      id: "customqueryparam",
      name: "Custom query parameter",
      description: "Format variables as URL parameters with custom name and value prefix. Example in multi-variable scenario A + B + C => p-foo=x-A&p-foo=x-B&p-foo=x-C.",
      formatter: (value, args, variable) => {
        const name = encodeURIComponentStrict(args[0] || variable.state.name);
        const valuePrefix = encodeURIComponentStrict(args[1] || "");
        if (Array.isArray(value)) {
          return value.map((v) => customFormatQueryParameter(name, v, valuePrefix)).join("&");
        }
        return customFormatQueryParameter(name, value, valuePrefix);
      }
    },
    {
      id: schema.VariableFormatID.UriEncode,
      name: "Percent encode as URI",
      description: i18n.t(
        "grafana-scenes.variables.format-registry.formats.description.useful-escaping-values-taking-syntax-characters",
        "Useful for URL escaping values, taking into URI syntax characters"
      ),
      formatter: (value) => {
        if (lodash.isArray(value)) {
          return encodeURIStrict("{" + value.join(",") + "}");
        }
        return encodeURIStrict(value);
      }
    }
  ];
  return formats;
});
function luceneEscape(value) {
  if (isNaN(+value) === false) {
    return value;
  }
  return value.replace(/([\!\*\+\-\=<>\s\&\|\(\)\[\]\{\}\^\~\?\:\\/"])/g, "\\$1");
}
function encodeURIComponentStrict(str) {
  if (typeof str === "object") {
    str = String(str);
  }
  return replaceSpecialCharactersToASCII(encodeURIComponent(str));
}
const encodeURIStrict = (str) => replaceSpecialCharactersToASCII(encodeURI(String(str)));
const replaceSpecialCharactersToASCII = (value) => value.replace(/[!'()*]/g, (c) => {
  return "%" + c.charCodeAt(0).toString(16).toUpperCase();
});
function formatQueryParameter(name, value) {
  return `var-${name}=${encodeURIComponentStrict(value)}`;
}
function customFormatQueryParameter(name, value, valuePrefix = "") {
  return `${name}=${valuePrefix}${encodeURIComponentStrict(value)}`;
}
const SQL_ESCAPE_MAP = {
  "'": "''",
  '"': '\\"'
};
function sqlStringFormatter(value) {
  const regExp = new RegExp(`'|"`, "g");
  if (lodash.isArray(value)) {
    return lodash.map(value, (v) => `'${lodash.replace(v, regExp, (match) => {
      var _a;
      return (_a = SQL_ESCAPE_MAP[match]) != null ? _a : "";
    })}'`).join(",");
  }
  let strVal = typeof value === "string" ? value : String(value);
  return `'${lodash.replace(strVal, regExp, (match) => {
    var _a;
    return (_a = SQL_ESCAPE_MAP[match]) != null ? _a : "";
  })}'`;
}

class SkipFormattingValue {
  constructor(_value) {
    this._value = _value;
  }
  formatter() {
    return this._value;
  }
}

class UrlTimeRangeMacro {
  constructor(name, sceneObject) {
    this.state = { name, type: "url_variable" };
    this._sceneObject = sceneObject;
  }
  getValue() {
    var _a;
    const timeRange = getTimeRange(this._sceneObject);
    const urlState = (_a = timeRange.urlSync) == null ? void 0 : _a.getUrlState();
    return new SkipFormattingValue(data.urlUtil.toUrlParams(urlState));
  }
  getValueText() {
    return "";
  }
}
class TimeFromAndToMacro {
  constructor(name, sceneObject) {
    this.state = { name, type: "time_macro" };
    this._sceneObject = sceneObject;
  }
  getValue() {
    const timeRange = getTimeRange(this._sceneObject);
    if (this.state.name === "__from") {
      return timeRange.state.value.from.valueOf();
    } else {
      return timeRange.state.value.to.valueOf();
    }
  }
  getValueText() {
    const timeRange = getTimeRange(this._sceneObject);
    if (this.state.name === "__from") {
      return data.dateTimeFormat(timeRange.state.value.from, { timeZone: timeRange.getTimeZone() });
    } else {
      return data.dateTimeFormat(timeRange.state.value.to, { timeZone: timeRange.getTimeZone() });
    }
  }
}
class TimezoneMacro {
  constructor(name, sceneObject) {
    this.state = { name, type: "time_macro" };
    this._sceneObject = sceneObject;
  }
  getValue() {
    const timeRange = getTimeRange(this._sceneObject);
    const timeZone = timeRange.getTimeZone();
    if (timeZone === "browser") {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    return timeZone;
  }
  getValueText() {
    return this.getValue();
  }
}
class IntervalMacro {
  constructor(name, sceneObject, match) {
    this.state = { name, type: "time_macro", match };
    this._sceneObject = sceneObject;
  }
  getValue() {
    var _a;
    const data = getData(this._sceneObject);
    if (data) {
      const request = (_a = data.state.data) == null ? void 0 : _a.request;
      if (!request) {
        return this.state.match;
      }
      if (this.state.name === "__interval_ms") {
        return request.intervalMs;
      }
      return request.interval;
    }
    return this.state.match;
  }
}

function setBaseClassState(sceneObject, newState) {
  sceneObject.setState(newState);
}
function useLocationServiceSafe() {
  return runtime.useLocationService ? runtime.useLocationService() : runtime.locationService;
}
function isRepeatCloneOrChildOf(scene) {
  let obj = scene;
  do {
    if ("repeatSourceKey" in obj.state && obj.state.repeatSourceKey) {
      return true;
    }
    obj = obj.parent;
  } while (obj);
  return false;
}

const _MultiValueVariable = class _MultiValueVariable extends SceneObjectBase {
  constructor() {
    super(...arguments);
    this._urlSync = new MultiValueUrlSyncHandler(this);
  }
  /**
   * This function is called on when SceneVariableSet is activated or when a dependency changes.
   */
  validateAndUpdate() {
    return this.getValueOptions({}).pipe(
      rxjs.map((options) => {
        this.updateValueGivenNewOptions(options);
        return {};
      })
    );
  }
  onCancel() {
    this.setStateHelper({ loading: false });
    const sceneVarSet = this.parent;
    sceneVarSet == null ? void 0 : sceneVarSet.cancel(this);
  }
  /**
   * Check if current value is valid given new options. If not update the value.
   */
  updateValueGivenNewOptions(options) {
    const { value: currentValue, text: currentText, options: oldOptions } = this.state;
    const stateUpdate = this.getStateUpdateGivenNewOptions(options, currentValue, currentText);
    this.interceptStateUpdateAfterValidation(stateUpdate);
    this.setStateHelper(stateUpdate);
    if (stateUpdate.value !== currentValue || stateUpdate.text !== currentText || this.hasAllValue() && !lodash.isEqual(options, oldOptions)) {
      this.publishEvent(new SceneVariableValueChangedEvent(this), true);
    }
  }
  getStateUpdateGivenNewOptions(options, currentValue, currentText) {
    const stateUpdate = {
      options,
      loading: false,
      value: currentValue,
      text: currentText
    };
    if (options.length === 0) {
      if (this.state.defaultToAll || this.state.includeAll) {
        stateUpdate.value = ALL_VARIABLE_VALUE;
        stateUpdate.text = ALL_VARIABLE_TEXT;
      } else if (this.state.isMulti) {
        stateUpdate.value = [];
        stateUpdate.text = [];
      } else {
        stateUpdate.value = "";
        stateUpdate.text = "";
      }
      return stateUpdate;
    }
    if (this.hasAllValue()) {
      if (this.state.includeAll) {
        stateUpdate.text = ALL_VARIABLE_TEXT;
      } else {
        stateUpdate.value = options[0].value;
        stateUpdate.text = options[0].label;
        if (this.state.isMulti) {
          stateUpdate.value = [stateUpdate.value];
          stateUpdate.text = [stateUpdate.text];
        }
      }
      return stateUpdate;
    }
    if (this.state.isMulti) {
      const currentValues = Array.isArray(currentValue) ? currentValue : [currentValue];
      const validValues = currentValues.filter((v) => options.find((o) => o.value === v));
      const validTexts = validValues.map((v) => options.find((o) => o.value === v).label);
      if (validValues.length === 0) {
        const defaultState = this.getDefaultMultiState(options);
        stateUpdate.value = defaultState.value;
        stateUpdate.text = defaultState.text;
      } else {
        if (!lodash.isEqual(validValues, currentValue)) {
          stateUpdate.value = validValues;
        }
        if (!lodash.isEqual(validTexts, currentText)) {
          stateUpdate.text = validTexts;
        }
      }
      return stateUpdate;
    }
    let matchingOption = findOptionMatchingCurrent(currentValue, currentText, options);
    if (matchingOption) {
      stateUpdate.text = matchingOption.label;
      stateUpdate.value = matchingOption.value;
    } else {
      const defaultState = this.getDefaultSingleState(options);
      stateUpdate.value = defaultState.value;
      stateUpdate.text = defaultState.label;
    }
    return stateUpdate;
  }
  /**
   * Values set by initial URL sync needs to survive the next validation and update.
   * This function can intercept and make sure those values are preserved.
   */
  interceptStateUpdateAfterValidation(stateUpdate) {
    const isAllValueFix = stateUpdate.value === ALL_VARIABLE_VALUE && this.state.text === ALL_VARIABLE_TEXT;
    if (this.skipNextValidation && stateUpdate.value !== this.state.value && stateUpdate.text !== this.state.text && !isAllValueFix) {
      stateUpdate.value = this.state.value;
      stateUpdate.text = this.state.text;
    }
    this.skipNextValidation = false;
  }
  getValue(fieldPath) {
    let value = this.state.value;
    if (this.hasAllValue()) {
      if (this.state.allValue) {
        return new CustomAllValue(this.state.allValue, this);
      }
      value = this.state.options.map((o) => o.value);
    }
    if (fieldPath != null) {
      return this.getFieldAtPath(value, fieldPath);
    }
    return value;
  }
  getValueText(fieldPath) {
    if (this.hasAllValue()) {
      return ALL_VARIABLE_TEXT;
    }
    const text = fieldPath != null ? this.getFieldAtPath(this.state.value, fieldPath, true) : this.state.text;
    return Array.isArray(text) ? text.join(" + ") : String(text);
  }
  getFieldAtPath(value, fieldPath, returnText = false) {
    const accesor = this.getFieldAccessor(fieldPath);
    if (Array.isArray(value)) {
      const index = parseInt(fieldPath, 10);
      if (!isNaN(index) && index >= 0 && index < value.length) {
        const v = value[index];
        if (!returnText) {
          return v;
        }
        const o2 = this.state.options.find((o3) => o3.value === v);
        return o2 ? o2.label : String(v);
      }
      return value.map((v) => {
        const o2 = this.state.options.find((o3) => o3.value === v);
        return o2 ? accesor(o2.properties) : v;
      });
    }
    const o = this.state.options.find((o2) => o2.value === value);
    if (o) {
      return accesor(o.properties);
    }
    return returnText ? this.state.text : value;
  }
  getFieldAccessor(fieldPath) {
    const accessor = _MultiValueVariable.fieldAccessorCache[fieldPath];
    if (accessor) {
      return accessor;
    }
    return _MultiValueVariable.fieldAccessorCache[fieldPath] = lodash.property(fieldPath);
  }
  hasAllValue() {
    const value = this.state.value;
    return value === ALL_VARIABLE_VALUE || Array.isArray(value) && value[0] === ALL_VARIABLE_VALUE;
  }
  getDefaultMultiState(options) {
    if (this.state.defaultToAll) {
      return { value: [ALL_VARIABLE_VALUE], text: [ALL_VARIABLE_TEXT] };
    } else if (options.length > 0) {
      return { value: [options[0].value], text: [options[0].label], properties: [options[0].properties] };
    } else {
      return { value: [], text: [] };
    }
  }
  getDefaultSingleState(options) {
    if (this.state.defaultToAll) {
      return { value: ALL_VARIABLE_VALUE, label: ALL_VARIABLE_TEXT };
    } else if (options.length > 0) {
      return { value: options[0].value, label: options[0].label, properties: options[0].properties };
    } else {
      return { value: "", label: "" };
    }
  }
  /**
   * Change the value and publish SceneVariableValueChangedEvent event.
   */
  changeValueTo(value, text, isUserAction = false) {
    var _a, _b;
    if (value === this.state.value && text === this.state.text) {
      return;
    }
    if (!text) {
      if (Array.isArray(value)) {
        text = value.map((v) => this.findLabelTextForValue(v));
      } else {
        text = this.findLabelTextForValue(value);
      }
    }
    if (Array.isArray(value)) {
      if (value.length === 0) {
        const state = this.getDefaultMultiState(this.state.options);
        value = state.value;
        text = state.text;
      }
      if (value[value.length - 1] === ALL_VARIABLE_VALUE) {
        value = [ALL_VARIABLE_VALUE];
        text = [ALL_VARIABLE_TEXT];
      } else if (value[0] === ALL_VARIABLE_VALUE && value.length > 1) {
        value.shift();
        if (Array.isArray(text)) {
          text.shift();
        }
      }
    }
    if (lodash.isEqual(value, this.state.value) && lodash.isEqual(text, this.state.text)) {
      return;
    }
    const stateChangeAction = () => this.setStateHelper({ value, text, loading: false });
    if (isUserAction) {
      const queryController = getQueryController(this);
      queryController == null ? void 0 : queryController.startProfile(VARIABLE_VALUE_CHANGED_INTERACTION);
      (_b = (_a = this._urlSync).performBrowserHistoryAction) == null ? void 0 : _b.call(_a, stateChangeAction);
    } else {
      stateChangeAction();
    }
    this.publishEvent(new SceneVariableValueChangedEvent(this), true);
  }
  findLabelTextForValue(value) {
    if (value === ALL_VARIABLE_VALUE) {
      return ALL_VARIABLE_TEXT;
    }
    const option = this.state.options.find((x) => x.value === value);
    if (option) {
      return option.label;
    }
    const optionByLabel = this.state.options.find((x) => x.label === value);
    if (optionByLabel) {
      return optionByLabel.label;
    }
    return value;
  }
  /**
   * This helper function is to counter the contravariance of setState
   */
  setStateHelper(state) {
    setBaseClassState(this, state);
  }
  getOptionsForSelect(includeCurrentValue = true) {
    let options = this.state.options;
    if (this.state.includeAll) {
      options = [{ value: ALL_VARIABLE_VALUE, label: ALL_VARIABLE_TEXT }, ...options];
    }
    if (includeCurrentValue && !Array.isArray(this.state.value)) {
      const current = options.find((x) => x.value === this.state.value);
      if (!current) {
        options = [{ value: this.state.value, label: String(this.state.text) }, ...options];
      }
    }
    return options;
  }
  refreshOptions() {
    this.getValueOptions({}).subscribe((options) => {
      this.updateValueGivenNewOptions(options);
    });
  }
};
_MultiValueVariable.fieldAccessorCache = {};
let MultiValueVariable = _MultiValueVariable;
function findOptionMatchingCurrent(currentValue, currentText, options) {
  let textMatch;
  for (const o of options) {
    if (o.value === currentValue) {
      return o;
    }
    if (o.label === currentText) {
      textMatch = o;
    }
  }
  return textMatch;
}
class MultiValueUrlSyncHandler {
  constructor(_sceneObject) {
    this._sceneObject = _sceneObject;
    this._nextChangeShouldAddHistoryStep = false;
  }
  getKey() {
    return `var-${this._sceneObject.state.name}`;
  }
  getKeys() {
    if (this._sceneObject.state.skipUrlSync) {
      return [];
    }
    return [this.getKey()];
  }
  getUrlState() {
    if (this._sceneObject.state.skipUrlSync) {
      return {};
    }
    let urlValue = null;
    let value = this._sceneObject.state.value;
    if (Array.isArray(value) && value.length > 1) {
      urlValue = value.map(String);
    } else if (this._sceneObject.state.isMulti) {
      urlValue = [String(value)];
    } else {
      urlValue = String(value);
    }
    return { [this.getKey()]: urlValue };
  }
  updateFromUrl(values) {
    let urlValue = values[this.getKey()];
    if (urlValue != null) {
      if (this._sceneObject.state.includeAll) {
        urlValue = handleLegacyUrlAllValue(urlValue);
      }
      if (this._sceneObject.state.allValue && this._sceneObject.state.allValue === urlValue) {
        urlValue = ALL_VARIABLE_VALUE;
      }
      if (!this._sceneObject.isActive) {
        this._sceneObject.skipNextValidation = true;
      }
      this._sceneObject.changeValueTo(urlValue);
    }
  }
  performBrowserHistoryAction(callback) {
    this._nextChangeShouldAddHistoryStep = true;
    callback();
    this._nextChangeShouldAddHistoryStep = false;
  }
  shouldCreateHistoryStep(values) {
    return this._nextChangeShouldAddHistoryStep;
  }
}
function handleLegacyUrlAllValue(value) {
  if (lodash.isArray(value) && value[0] === ALL_VARIABLE_TEXT) {
    return [ALL_VARIABLE_VALUE];
  } else if (value === ALL_VARIABLE_TEXT) {
    return ALL_VARIABLE_VALUE;
  }
  return value;
}
class CustomAllValue {
  constructor(_value, _variable) {
    this._value = _value;
    this._variable = _variable;
  }
  formatter(formatNameOrFn) {
    if (formatNameOrFn === schema.VariableFormatID.Text) {
      return ALL_VARIABLE_TEXT;
    }
    if (formatNameOrFn === schema.VariableFormatID.PercentEncode) {
      return formatRegistry.get(schema.VariableFormatID.PercentEncode).formatter(this._value, [], this._variable);
    }
    if (formatNameOrFn === schema.VariableFormatID.QueryParam) {
      return formatRegistry.get(schema.VariableFormatID.QueryParam).formatter(ALL_VARIABLE_TEXT, [], this._variable);
    }
    return this._value;
  }
}

class AllVariablesMacro {
  constructor(name, sceneObject) {
    this.state = { name, type: "url_variable" };
    this._sceneObject = sceneObject;
  }
  getValue() {
    const allVars = collectAllVariables(this._sceneObject);
    const format = formatRegistry.get(schema.VariableFormatID.QueryParam);
    const params = [];
    for (const name of Object.keys(allVars)) {
      const variable = allVars[name];
      if (variable instanceof MultiValueVariable && variable.hasAllValue() && !variable.state.allValue) {
        params.push(format.formatter(ALL_VARIABLE_VALUE, [], variable));
        continue;
      }
      const value = variable.getValue();
      if (!value) {
        continue;
      }
      if (isCustomVariableValue(value)) {
        params.push(value.formatter(schema.VariableFormatID.QueryParam));
      } else {
        params.push(format.formatter(value, [], variable));
      }
    }
    return new SkipFormattingValue(params.join("&"));
  }
  getValueText() {
    return "";
  }
}
function collectAllVariables(sceneObject, record = {}) {
  if (sceneObject.state.$variables) {
    for (const variable of sceneObject.state.$variables.state.variables) {
      if (variable.state.skipUrlSync) {
        continue;
      }
      if (!record[variable.state.name]) {
        record[variable.state.name] = variable;
      }
    }
  }
  if (sceneObject.parent) {
    collectAllVariables(sceneObject.parent, record);
  }
  return record;
}

function getTemplateProxyForField(field, frame, frames) {
  return new Proxy(
    {},
    // This object shows up in test snapshots
    {
      get: (obj, key) => {
        if (key === "name") {
          return field.name;
        }
        if (key === "displayName") {
          return data.getFieldDisplayName(field, frame, frames);
        }
        if (key === "labels" || key === "formattedLabels") {
          if (!field.labels) {
            return "";
          }
          return {
            ...field.labels,
            __values: Object.values(field.labels).sort().join(", "),
            toString: () => {
              return data.formatLabels(field.labels, "", true);
            }
          };
        }
        return void 0;
      }
    }
  );
}

class ValueMacro {
  constructor(name, sceneObject, _match, _scopedVars) {
    this._match = _match;
    this._scopedVars = _scopedVars;
    this.state = { name, type: "__value" };
  }
  getValue(fieldPath) {
    var _a, _b;
    const dataContext = (_a = this._scopedVars) == null ? void 0 : _a.__dataContext;
    if (!dataContext) {
      return this._match;
    }
    const { frame, rowIndex, field, calculatedValue } = dataContext.value;
    if (calculatedValue) {
      switch (fieldPath) {
        case "numeric":
          return calculatedValue.numeric;
        case "raw":
          return calculatedValue.numeric;
        case "time":
          return "";
        case "text":
        default:
          return data.formattedValueToString(calculatedValue);
      }
    }
    if (rowIndex == null) {
      return this._match;
    }
    if (fieldPath === "time") {
      const timeField = frame.fields.find((f) => f.type === data.FieldType.time);
      return timeField ? timeField.values[rowIndex] : void 0;
    }
    if (!field) {
      return this._match;
    }
    const value = field.values[rowIndex];
    if (fieldPath === "raw") {
      return value;
    }
    const displayProcessor = (_b = field.display) != null ? _b : fallbackDisplayProcessor;
    const result = displayProcessor(value);
    switch (fieldPath) {
      case "numeric":
        return result.numeric;
      case "text":
      default:
        return data.formattedValueToString(result);
    }
  }
  getValueText() {
    return "";
  }
}
const fallbackDisplayProcessor = data.getDisplayProcessor();
class DataMacro {
  constructor(name, sceneObject, _match, _scopedVars) {
    this._match = _match;
    this._scopedVars = _scopedVars;
    this.state = { name, type: "__data" };
  }
  getValue(fieldPath) {
    var _a, _b;
    const dataContext = (_a = this._scopedVars) == null ? void 0 : _a.__dataContext;
    if (!dataContext || !fieldPath) {
      return this._match;
    }
    const { frame, rowIndex } = dataContext.value;
    if (rowIndex === void 0 || fieldPath === void 0) {
      return this._match;
    }
    const obj = {
      name: frame.name,
      refId: frame.refId,
      fields: data.getFieldDisplayValuesProxy({ frame, rowIndex })
    };
    return (_b = getFieldAccessor(fieldPath)(obj)) != null ? _b : "";
  }
  getValueText() {
    return "";
  }
}
class SeriesMacro {
  constructor(name, sceneObject, _match, _scopedVars) {
    this._match = _match;
    this._scopedVars = _scopedVars;
    this.state = { name, type: "__series" };
  }
  getValue(fieldPath) {
    var _a;
    const dataContext = (_a = this._scopedVars) == null ? void 0 : _a.__dataContext;
    if (!dataContext || !fieldPath) {
      return this._match;
    }
    if (fieldPath !== "name") {
      return this._match;
    }
    const { frame, frameIndex } = dataContext.value;
    return data.getFrameDisplayName(frame, frameIndex);
  }
  getValueText() {
    return "";
  }
}
class FieldMacro {
  constructor(name, sceneObject, _match, _scopedVars) {
    this._match = _match;
    this._scopedVars = _scopedVars;
    this.state = { name, type: "__field" };
  }
  getValue(fieldPath) {
    var _a, _b;
    const dataContext = (_a = this._scopedVars) == null ? void 0 : _a.__dataContext;
    if (!dataContext || !fieldPath) {
      return this._match;
    }
    if (fieldPath === void 0 || fieldPath === "") {
      return this._match;
    }
    const { frame, field, data } = dataContext.value;
    const obj = getTemplateProxyForField(field, frame, data);
    return (_b = getFieldAccessor(fieldPath)(obj)) != null ? _b : "";
  }
  getValueText() {
    return "";
  }
}

class UrlMacro {
  constructor(name, _) {
    this.state = { name, type: "url_macro" };
  }
  getValue(fieldPath) {
    var _a;
    const location = runtime.locationService.getLocation();
    const subUrl = (_a = runtime.config.appSubUrl) != null ? _a : "";
    switch (fieldPath != null ? fieldPath : "") {
      case "params":
        return new UrlStateFormatter(location.search);
      case "path":
        return subUrl + location.pathname;
      case "":
      default:
        return subUrl + location.pathname + location.search;
    }
  }
  getValueText() {
    return "";
  }
}
class UrlStateFormatter {
  constructor(_urlQueryParams) {
    this._urlQueryParams = _urlQueryParams;
  }
  formatter(options) {
    if (!options) {
      return this._urlQueryParams;
    }
    const params = options.split(":");
    if (params[0] === "exclude" && params.length > 1) {
      const allParams = new URLSearchParams(this._urlQueryParams);
      for (const param of params[1].split(",")) {
        allParams.delete(param);
      }
      return `?${allParams}`;
    }
    if (params[0] === "include" && params.length > 1) {
      const allParams = new URLSearchParams(this._urlQueryParams);
      const includeOnly = params[1].split(",");
      for (const param of allParams.keys()) {
        if (!includeOnly.includes(param)) {
          allParams.delete(param);
        }
      }
      return `?${allParams}`;
    }
    return this._urlQueryParams;
  }
}

class UserMacro {
  constructor(name, _) {
    this.state = { name, type: "user_macro" };
  }
  getValue(fieldPath) {
    const user = runtime.config.bootData.user;
    switch (fieldPath) {
      case "login":
        return user.login;
      case "email":
        return user.email;
      case "id":
      default:
        return String(user.id);
    }
  }
}
class OrgMacro {
  constructor(name, _) {
    this.state = { name, type: "org_macro" };
  }
  getValue(fieldPath) {
    const user = runtime.config.bootData.user;
    switch (fieldPath) {
      case "name":
        return user.orgName;
      case "id":
      default:
        return String(user.orgId);
    }
  }
}

const macrosIndex = /* @__PURE__ */ new Map([
  [data.DataLinkBuiltInVars.includeVars, AllVariablesMacro],
  [data.DataLinkBuiltInVars.keepTime, UrlTimeRangeMacro],
  ["__value", ValueMacro],
  ["__data", DataMacro],
  ["__series", SeriesMacro],
  ["__field", FieldMacro],
  ["__url", UrlMacro],
  ["__from", TimeFromAndToMacro],
  ["__to", TimeFromAndToMacro],
  ["__timezone", TimezoneMacro],
  ["__user", UserMacro],
  ["__org", OrgMacro],
  ["__interval", IntervalMacro],
  ["__interval_ms", IntervalMacro]
]);
function registerVariableMacro(name, macro, replace = false) {
  if (!replace && macrosIndex.get(name)) {
    throw new Error(`Macro already registered ${name}`);
  }
  macrosIndex.set(name, macro);
  return () => {
    if (replace) {
      throw new Error(`Replaced macros can not be unregistered. They need to be restored manually.`);
    } else {
      macrosIndex.delete(name);
    }
  };
}

function sceneInterpolator(sceneObject, target, scopedVars, format, interpolations) {
  if (!target || typeof target !== "string") {
    return target != null ? target : "";
  }
  VARIABLE_REGEX.lastIndex = 0;
  return target.replace(VARIABLE_REGEX, (match, var1, var2, fmt2, var3, fieldPath, fmt3) => {
    const variableName = var1 || var2 || var3;
    const fmt = fmt2 || fmt3 || format;
    const variable = lookupFormatVariable(variableName, match, scopedVars, sceneObject);
    if (!variable) {
      if (interpolations) {
        interpolations.push({ match, variableName, fieldPath, format: fmt, value: match, found: false });
      }
      return match;
    }
    const value = formatValue(sceneObject, variable, variable.getValue(fieldPath), fmt, fieldPath);
    if (interpolations) {
      interpolations.push({ match, variableName, fieldPath, format: fmt, value, found: value !== match });
    }
    return value;
  });
}
function lookupFormatVariable(name, match, scopedVars, sceneObject) {
  if (scopedVars && scopedVars.hasOwnProperty(name)) {
    const scopedVar = scopedVars[name];
    if (scopedVar) {
      return getSceneVariableForScopedVar(name, scopedVar);
    }
  }
  const variable = lookupVariable(name, sceneObject);
  if (variable) {
    return variable;
  }
  const Macro = macrosIndex.get(name);
  if (Macro) {
    return new Macro(name, sceneObject, match, scopedVars);
  }
  return null;
}
function formatValue(context, variable, value, formatNameOrFn, fieldPath) {
  if (value === null || value === void 0) {
    return "";
  }
  if (isCustomVariableValue(value)) {
    return sceneInterpolator(context, value.formatter(formatNameOrFn));
  }
  if (!Array.isArray(value) && typeof value === "object") {
    value = `${value}`;
  }
  if (typeof formatNameOrFn === "function") {
    return formatNameOrFn(value, {
      name: variable.state.name,
      type: variable.state.type,
      multi: variable.state.isMulti,
      includeAll: variable.state.includeAll
    });
  }
  let args = [];
  if (!formatNameOrFn) {
    formatNameOrFn = schema.VariableFormatID.Glob;
  } else {
    args = formatNameOrFn.split(":");
    if (args.length > 1) {
      formatNameOrFn = args[0];
      args = args.slice(1);
    } else {
      args = [];
    }
  }
  let formatter = formatRegistry.getIfExists(formatNameOrFn);
  if (!formatter) {
    console.error(`Variable format ${formatNameOrFn} not found. Using glob format as fallback.`);
    formatter = formatRegistry.get(schema.VariableFormatID.Glob);
  }
  return formatter.formatter(value, args, variable, fieldPath);
}

function isSceneObject(obj) {
  return obj.useState !== void 0;
}
function isDataRequestEnricher(obj) {
  return "enrichDataRequest" in obj;
}
function isFiltersRequestEnricher(obj) {
  return "enrichFiltersRequest" in obj;
}
function isDataLayer(obj) {
  return "isDataLayer" in obj;
}

function generateOperationId(prefix = "op") {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    const uuid = crypto.randomUUID();
    return `${prefix}-${uuid}`;
  }
  const randomPart = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  return `${prefix}-${randomPart}`;
}
const _ScenePerformanceTracker = class _ScenePerformanceTracker {
  constructor() {
    this.observers = [];
  }
  static getInstance() {
    if (!_ScenePerformanceTracker.instance) {
      _ScenePerformanceTracker.instance = new _ScenePerformanceTracker();
    }
    return _ScenePerformanceTracker.instance;
  }
  /**
   * Register a performance observer
   */
  addObserver(observer) {
    this.observers.push(observer);
    return () => {
      const index = this.observers.indexOf(observer);
      if (index > -1) {
        this.observers.splice(index, 1);
      }
    };
  }
  /**
   * Remove all observers (for testing)
   */
  clearObservers() {
    this.observers = [];
  }
  /**
   * Get current observer count (for debugging)
   */
  getObserverCount() {
    return this.observers.length;
  }
  notifyObservers(methodName, data, errorContext) {
    this.observers.forEach((observer) => {
      try {
        const method = observer[methodName];
        method == null ? void 0 : method(data);
      } catch (error) {
        console.warn(`Error in ${errorContext} observer:`, error);
      }
    });
  }
  notifyDashboardInteractionStart(data) {
    this.notifyObservers("onDashboardInteractionStart", data, "dashboard interaction start");
  }
  notifyDashboardInteractionMilestone(data) {
    this.notifyObservers("onDashboardInteractionMilestone", data, "dashboard interaction milestone");
  }
  notifyDashboardInteractionComplete(data) {
    this.notifyObservers("onDashboardInteractionComplete", data, "dashboard interaction complete");
  }
  notifyPanelOperationStart(data) {
    this.notifyObservers("onPanelOperationStart", data, "panel operation start");
  }
  notifyPanelOperationComplete(data) {
    this.notifyObservers("onPanelOperationComplete", data, "panel operation complete");
  }
  notifyQueryStart(data) {
    this.notifyObservers("onQueryStart", data, "query start");
  }
  notifyQueryComplete(data) {
    this.notifyObservers("onQueryComplete", data, "query complete");
  }
};
_ScenePerformanceTracker.instance = null;
let ScenePerformanceTracker = _ScenePerformanceTracker;
function getScenePerformanceTracker() {
  return ScenePerformanceTracker.getInstance();
}

function registerQueryWithController(entry, profiler) {
  return (queryStream) => {
    const queryControler = sceneGraph.getQueryController(entry.origin);
    if (!queryControler) {
      return queryStream;
    }
    return new rxjs.Observable((observer) => {
      var _a;
      if (!entry.cancel) {
        entry.cancel = () => observer.complete();
      }
      const queryId = ((_a = entry.request) == null ? void 0 : _a.requestId) || `${entry.type}-${Math.floor(performance.now()).toString(36)}`;
      const startTimestamp = performance.now();
      let endQueryCallback = null;
      if (profiler) {
        endQueryCallback = profiler.onQueryStarted(startTimestamp, entry, queryId);
      } else {
        const operationId = generateOperationId("query");
        getScenePerformanceTracker().notifyQueryStart({
          operationId,
          queryId,
          queryType: entry.type,
          origin: entry.origin.constructor.name,
          timestamp: startTimestamp
        });
        endQueryCallback = (endTimestamp, error) => {
          getScenePerformanceTracker().notifyQueryComplete({
            operationId,
            queryId,
            queryType: entry.type,
            origin: entry.origin.constructor.name,
            timestamp: endTimestamp,
            duration: endTimestamp - startTimestamp,
            error: error ? (error == null ? void 0 : error.message) || String(error) || "Unknown error" : void 0
          });
        };
      }
      queryControler.queryStarted(entry);
      let markedAsCompleted = false;
      const sub = queryStream.subscribe({
        next: (v) => {
          if (!markedAsCompleted && v.state !== schema.LoadingState.Loading) {
            markedAsCompleted = true;
            queryControler.queryCompleted(entry);
            endQueryCallback == null ? void 0 : endQueryCallback(performance.now());
          }
          observer.next(v);
        },
        error: (e) => {
          if (!markedAsCompleted) {
            markedAsCompleted = true;
            queryControler.queryCompleted(entry);
            endQueryCallback == null ? void 0 : endQueryCallback(performance.now(), e);
          }
          observer.error(e);
        },
        complete: () => {
          observer.complete();
        }
      });
      return () => {
        sub.unsubscribe();
        if (!markedAsCompleted) {
          queryControler.queryCompleted(entry);
          endQueryCallback == null ? void 0 : endQueryCallback(performance.now());
        }
      };
    });
  };
}
function wrapPromiseInStateObservable(promise) {
  return new rxjs.Observable((observer) => {
    observer.next({ state: schema.LoadingState.Loading });
    const promiseObservable = rxjs.from(promise);
    promiseObservable.pipe(
      rxjs.map(() => ({ state: schema.LoadingState.Done })),
      rxjs.catchError(() => {
        observer.next({ state: schema.LoadingState.Error });
        return [];
      })
    ).subscribe({
      next: (result) => observer.next(result),
      complete: () => observer.complete()
    });
  });
}

async function getDataSource(datasource, scopedVars) {
  var _a;
  if (datasource == null ? void 0 : datasource.uid) {
    const runtimeDataSource = runtimeDataSources.get(datasource.uid);
    if (runtimeDataSource) {
      return runtimeDataSource;
    }
  }
  if (datasource && datasource.query) {
    return datasource;
  }
  const dsPromise = runtime.getDataSourceSrv().get(datasource, scopedVars);
  if (scopedVars.__sceneObject && scopedVars.__sceneObject.value.valueOf()) {
    const queryControler = sceneGraph.getQueryController(scopedVars.__sceneObject.value.valueOf());
    if (queryControler && queryControler.state.enableProfiling) {
      wrapPromiseInStateObservable(dsPromise).pipe(
        registerQueryWithController({
          type: `getDataSource/${(_a = datasource == null ? void 0 : datasource.type) != null ? _a : "unknown"}`,
          origin: scopedVars.__sceneObject.value.valueOf()
        })
      ).subscribe(() => {
      });
    }
  }
  const result = await dsPromise;
  return result;
}

class VariableValueRecorder {
  constructor() {
    this._values = /* @__PURE__ */ new Map();
  }
  recordCurrentDependencyValuesForSceneObject(sceneObject) {
    this.clearValues();
    if (!sceneObject.variableDependency) {
      return;
    }
    for (const variableName of sceneObject.variableDependency.getNames()) {
      const variable = sceneGraph.lookupVariable(variableName, sceneObject);
      if (variable) {
        this._values.set(variable.state.name, variable.getValue());
      }
    }
  }
  cloneAndRecordCurrentValuesForSceneObject(sceneObject) {
    const clone = new VariableValueRecorder();
    clone.recordCurrentDependencyValuesForSceneObject(sceneObject);
    return clone;
  }
  clearValues() {
    this._values.clear();
  }
  hasValues() {
    return !!this._values;
  }
  recordCurrentValue(variable) {
    this._values.set(variable.state.name, variable.getValue());
  }
  hasRecordedValue(variable) {
    return this._values.has(variable.state.name);
  }
  hasValueChanged(variable) {
    if (this._values.has(variable.state.name)) {
      const value = this._values.get(variable.state.name);
      if (!isVariableValueEqual(value, variable.getValue())) {
        return true;
      }
    }
    return false;
  }
  hasDependenciesChanged(sceneObject) {
    if (!this._values) {
      return false;
    }
    if (!sceneObject.variableDependency) {
      return false;
    }
    for (const variableName of sceneObject.variableDependency.getNames()) {
      const variable = sceneGraph.lookupVariable(variableName, sceneObject);
      if (!variable) {
        continue;
      }
      const name = variable.state.name;
      if (variable && this._values.has(name)) {
        const value = this._values.get(name);
        if (!isVariableValueEqual(value, variable.getValue())) {
          return true;
        }
      }
    }
    return false;
  }
}

function isExtraQueryProvider(obj) {
  return typeof obj === "object" && "getExtraQueries" in obj;
}

const passthroughProcessor = (_, secondary) => rxjs.of(secondary);
const extraQueryProcessingOperator = (processors) => (data) => {
  return data.pipe(
    rxjs.mergeMap(([primary, ...secondaries]) => {
      const processedSecondaries = secondaries.flatMap((s) => {
        var _a, _b;
        return (_b = (_a = processors.get(s.request.requestId)) == null ? void 0 : _a(primary, s)) != null ? _b : rxjs.of(s);
      });
      return rxjs.forkJoin([rxjs.of(primary), ...processedSecondaries]);
    }),
    rxjs.map(([primary, ...processedSecondaries]) => {
      var _a;
      return {
        ...primary,
        series: [...primary.series, ...processedSecondaries.flatMap((s) => s.series)],
        annotations: [...(_a = primary.annotations) != null ? _a : [], ...processedSecondaries.flatMap((s) => {
          var _a2;
          return (_a2 = s.annotations) != null ? _a2 : [];
        })]
      };
    })
  );
};

const GLOBAL_ANNOTATION_ID = 0;
function filterAnnotations(data, filters) {
  var _a;
  if (!Array.isArray(data) || data.length === 0) {
    return data;
  }
  const rows = Array.from({ length: data.length }, () => /* @__PURE__ */ new Set());
  let frameIdx = 0;
  for (const frame of data) {
    for (let index = 0; index < frame.length; index++) {
      if (rows[frameIdx].has(index)) {
        continue;
      }
      let matching = true;
      const panelIdField = frame.fields.find((f) => f.name === "panelId");
      const sourceField = frame.fields.find((f) => f.name === "source");
      if (sourceField) {
        if (panelIdField && sourceField.values[index].type === "dashboard") {
          matching = [filters.panelId, GLOBAL_ANNOTATION_ID].includes(panelIdField.values[index]);
        }
        const sourceFilter = sourceField.values[index].filter;
        if (sourceFilter) {
          const includes = [...(_a = sourceFilter.ids) != null ? _a : [], GLOBAL_ANNOTATION_ID].includes(filters.panelId);
          if (sourceFilter.exclude) {
            if (includes) {
              matching = false;
            }
          } else if (!includes) {
            matching = false;
          }
        }
      }
      if (matching) {
        rows[frameIdx].add(index);
      }
    }
    frameIdx++;
  }
  const processed = [];
  frameIdx = 0;
  for (const frame of data) {
    const frameLength = rows[frameIdx].size;
    const fields = [];
    for (const field of frame.fields) {
      const buffer = [];
      for (let index = 0; index < frame.length; index++) {
        if (rows[frameIdx].has(index)) {
          buffer.push(field.values[index]);
          continue;
        }
      }
      fields.push({
        ...field,
        values: buffer
      });
    }
    processed.push({
      ...frame,
      fields,
      length: frameLength
    });
    frameIdx++;
  }
  return processed;
}

function getEnrichedDataRequest(sourceRunner) {
  const root = sourceRunner.getRoot();
  if (isDataRequestEnricher(root)) {
    return root.enrichDataRequest(sourceRunner);
  }
  return null;
}

const allActiveGroupByVariables = /* @__PURE__ */ new Set();
function findActiveGroupByVariablesByUid(dsUid) {
  var _a;
  for (const groupByVariable of allActiveGroupByVariables.values()) {
    if (interpolate(groupByVariable, (_a = groupByVariable.state.datasource) == null ? void 0 : _a.uid) === dsUid) {
      return groupByVariable;
    }
  }
  return void 0;
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

// ==============================
// NO OP
// ==============================

var noop = function noop() {};

// ==============================
// Get Style Props
// ==============================

var getStyleProps = function getStyleProps(props, name, classNamesState) {
  var cx = props.cx,
    getStyles = props.getStyles,
    getClassNames = props.getClassNames,
    className = props.className;
  return {
    css: getStyles(name, props),
    className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
  };
};
var options = {
  get passive() {
    return true;
  }
};
// check for SSR
var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener('p', noop, options);
  w.removeEventListener('p', noop, false);
}
var Menu = function Menu(props) {
  var children = props.children,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return react.jsx("div", _extends({}, getStyleProps(props, 'menu', {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};
var Menu$1 = Menu;

var _templateObject;

// ==============================
// Dropdown & Clear Icons
// ==============================
process.env.NODE_ENV === "production" ? {
  } : {
  };

// ==============================
// Loading
// ==============================

react.keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
({
  '&:after': _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
});

var components = {
  Menu: Menu$1};

const REGEXP_NON_ASCII = /[^ -~]/m;
const REGEXP_ONLY_SYMBOLS = /^[\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7E]+$/m;
const outOfOrderLimit = 5;
const maxNeedleLength = 25;
const maxFuzzyTerms = 5;
const rankThreshold = 1e4;
const uf = new uFuzzy__default.default({ intraMode: 1 });
function fuzzyFind(options, haystack, needle) {
  let matches = [];
  const terms = uf.split(needle);
  const keptChars = terms.join("").length;
  const inputChars = needle.replace(/\s/g, "").length;
  if (needle === "") {
    matches = options;
  } else if (
    // contains non-ascii
    REGEXP_NON_ASCII.test(needle) || // is only ascii symbols (operators)
    REGEXP_ONLY_SYMBOLS.test(needle) || // too long (often copy-paste from somewhere)
    needle.length > maxNeedleLength || // skip fuzzy searching if too many terms
    terms.length > maxFuzzyTerms || // if these differ then special chars exist in the input
    keptChars !== inputChars
  ) {
    for (let i = 0; i < haystack.length; i++) {
      let item = haystack[i];
      if (item.includes(needle)) {
        matches.push(options[i]);
      }
    }
  } else {
    const [idxs, info, order] = uf.search(haystack, needle, outOfOrderLimit, rankThreshold);
    if (idxs == null ? void 0 : idxs.length) {
      if (info && order) {
        matches = order.map((idx) => options[info.idx[idx]]);
      } else {
        matches = idxs.map((idx) => options[idx]);
      }
    }
  }
  return matches;
}

function getOptionSearcher(options, includeAll = false) {
  let allOptions = options;
  if (includeAll) {
    allOptions = [{ value: ALL_VARIABLE_VALUE, label: ALL_VARIABLE_TEXT }, ...allOptions];
  }
  const haystack = allOptions.map((o) => o.label);
  return (search) => fuzzyFind(allOptions, haystack, search);
}

const filterNoOp$2 = () => true;
const filterAll = (v) => v.value !== "$__all";
const determineToggleAllState = (selectedValues, options) => {
  if (selectedValues.length === options.filter(filterAll).length) {
    return ui.ToggleAllState.allSelected;
  } else if (selectedValues.length === 0 || selectedValues.length === 1 && selectedValues[0] && selectedValues[0].value === "$__all") {
    return ui.ToggleAllState.noneSelected;
  } else {
    return ui.ToggleAllState.indeterminate;
  }
};
function toSelectableValue$2(value, label) {
  return {
    value,
    label: label != null ? label : String(value)
  };
}
function VariableValueSelect({ model, state }) {
  const { value, text, key, options, includeAll, isReadOnly, allowCustomValue = true } = state;
  const [inputValue, setInputValue] = React.useState("");
  const [hasCustomValue, setHasCustomValue] = React.useState(false);
  const selectValue = toSelectableValue$2(value, String(text));
  const queryController = sceneGraph.getQueryController(model);
  const optionSearcher = React.useMemo(() => getOptionSearcher(options, includeAll), [options, includeAll]);
  const onInputChange = (value2, { action }) => {
    if (action === "input-change") {
      setInputValue(value2);
      if (model.onSearchChange) {
        model.onSearchChange(value2);
      }
      return value2;
    }
    return value2;
  };
  const filteredOptions = optionSearcher(inputValue);
  const onOpenMenu = () => {
    if (hasCustomValue) {
      setInputValue(String(text));
    }
  };
  const onCloseMenu = () => {
    setInputValue("");
  };
  return /* @__PURE__ */ React__default.default.createElement(
    ui.Select,
    {
      id: key,
      isValidNewOption: (inputValue2) => inputValue2.trim().length > 0,
      placeholder: i18n.t("grafana-scenes.variables.variable-value-select.placeholder-select-value", "Select value"),
      width: "auto",
      disabled: isReadOnly,
      value: selectValue,
      inputValue,
      allowCustomValue,
      virtualized: true,
      filterOption: filterNoOp$2,
      tabSelectsValue: false,
      onInputChange,
      onOpenMenu,
      onCloseMenu,
      options: filteredOptions,
      "data-testid": e2eSelectors.selectors.pages.Dashboard.SubMenu.submenuItemValueDropDownValueLinkTexts(`${value}`),
      onChange: (newValue) => {
        model.changeValueTo(newValue.value, newValue.label, true);
        queryController == null ? void 0 : queryController.startProfile(VARIABLE_VALUE_CHANGED_INTERACTION);
        if (hasCustomValue !== newValue.__isNew__) {
          setHasCustomValue(newValue.__isNew__);
        }
      }
    }
  );
}
function VariableValueSelectMulti({
  model,
  state
}) {
  const {
    value,
    options,
    key,
    maxVisibleValues,
    noValueOnClear,
    includeAll,
    isReadOnly,
    allowCustomValue = true
  } = state;
  const arrayValue = React.useMemo(() => lodash.isArray(value) ? value : [value], [value]);
  const [uncommittedValue, setUncommittedValue] = React.useState(arrayValue);
  const [inputValue, setInputValue] = React.useState("");
  const optionSearcher = React.useMemo(() => getOptionSearcher(options, includeAll), [options, includeAll]);
  React.useEffect(() => {
    setUncommittedValue(arrayValue);
  }, [arrayValue]);
  const onInputChange = (value2, { action }) => {
    if (action === "input-change") {
      setInputValue(value2);
      if (model.onSearchChange) {
        model.onSearchChange(value2);
      }
      return value2;
    }
    if (action === "input-blur") {
      setInputValue("");
      return "";
    }
    return inputValue;
  };
  const placeholder = options.length > 0 ? "Select value" : "";
  const filteredOptions = optionSearcher(inputValue);
  return /* @__PURE__ */ React__default.default.createElement(
    ui.MultiSelect,
    {
      id: key,
      placeholder,
      width: "auto",
      inputValue,
      disabled: isReadOnly,
      value: uncommittedValue,
      noMultiValueWrap: true,
      maxVisibleValues: maxVisibleValues != null ? maxVisibleValues : 5,
      tabSelectsValue: false,
      virtualized: true,
      allowCustomValue,
      toggleAllOptions: {
        enabled: true,
        optionsFilter: filterAll,
        determineToggleAllState
      },
      options: filteredOptions,
      closeMenuOnSelect: false,
      components: { Option: OptionWithCheckbox },
      isClearable: true,
      hideSelectedOptions: false,
      onInputChange,
      onBlur: () => {
        model.changeValueTo(uncommittedValue, void 0, true);
      },
      filterOption: filterNoOp$2,
      "data-testid": e2eSelectors.selectors.pages.Dashboard.SubMenu.submenuItemValueDropDownValueLinkTexts(`${uncommittedValue}`),
      onChange: (newValue, action) => {
        if (action.action === "clear" && noValueOnClear) {
          model.changeValueTo([], void 0, true);
        }
        setUncommittedValue(newValue.map((x) => x.value));
      }
    }
  );
}
const OptionWithCheckbox = ({
  children,
  data,
  innerProps,
  innerRef,
  isFocused,
  isSelected,
  indeterminate,
  renderOptionLabel
}) => {
  var _a;
  const { onMouseMove, onMouseOver, ...rest } = innerProps;
  const theme = ui.useTheme2();
  const selectStyles = ui.getSelectStyles(theme);
  const optionStyles = ui.useStyles2(getOptionStyles);
  return /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      ref: innerRef,
      className: css.cx(selectStyles.option, isFocused && selectStyles.optionFocused),
      ...rest,
      "data-testid": "data-testid Select option",
      title: data.title
    },
    /* @__PURE__ */ React__default.default.createElement("div", { className: optionStyles.checkbox }, /* @__PURE__ */ React__default.default.createElement(ui.Checkbox, { indeterminate, value: isSelected })),
    /* @__PURE__ */ React__default.default.createElement(
      "div",
      {
        className: selectStyles.optionBody,
        "data-testid": e2eSelectors.selectors.pages.Dashboard.SubMenu.submenuItemValueDropDownOptionTexts(
          (_a = data.label) != null ? _a : String(data.value)
        )
      },
      /* @__PURE__ */ React__default.default.createElement("span", null, children)
    )
  );
};
OptionWithCheckbox.displayName = "SelectMenuOptions";
const getOptionStyles = (theme) => ({
  checkbox: css.css({
    marginRight: theme.spacing(2)
  })
});
function MultiOrSingleValueSelect({ model }) {
  const state = model.useState();
  if (state.isMulti) {
    return /* @__PURE__ */ React__default.default.createElement(VariableValueSelectMulti, { model, state });
  } else {
    return /* @__PURE__ */ React__default.default.createElement(VariableValueSelect, { model, state });
  }
}

class GroupByVariableUrlSyncHandler {
  constructor(_sceneObject) {
    this._sceneObject = _sceneObject;
    this._nextChangeShouldAddHistoryStep = false;
  }
  getRestorableKey() {
    return `restorable-var-${this._sceneObject.state.name}`;
  }
  getKey() {
    return `var-${this._sceneObject.state.name}`;
  }
  getKeys() {
    if (this._sceneObject.state.skipUrlSync) {
      return [];
    }
    return [this.getKey(), this.getRestorableKey()];
  }
  getUrlState() {
    if (this._sceneObject.state.skipUrlSync) {
      return {};
    }
    return {
      [this.getKey()]: this._sceneObject.state.defaultValue && !this._sceneObject.state.restorable ? [""] : toUrlValues(this._sceneObject.state.value, this._sceneObject.state.text),
      [this.getRestorableKey()]: this._sceneObject.state.defaultValue ? this._sceneObject.state.restorable ? "true" : "false" : null
    };
  }
  updateFromUrl(values) {
    let urlValue = values[this.getKey()];
    let restorableValue = values[this.getRestorableKey()];
    if (urlValue != null) {
      if (!this._sceneObject.isActive) {
        this._sceneObject.skipNextValidation = true;
      }
      const { values: values2, texts } = fromUrlValues(urlValue);
      if (this._sceneObject.state.defaultValue && (restorableValue === "false" || restorableValue === void 0)) {
        return;
      }
      if (restorableValue === "false") {
        this._sceneObject.changeValueTo([], [], false);
        return;
      }
      this._sceneObject.changeValueTo(values2, texts);
    }
  }
  performBrowserHistoryAction(callback) {
    this._nextChangeShouldAddHistoryStep = true;
    callback();
    this._nextChangeShouldAddHistoryStep = false;
  }
  shouldCreateHistoryStep(values) {
    return this._nextChangeShouldAddHistoryStep;
  }
}
function toUrlValues(values, texts) {
  values = Array.isArray(values) ? values : [values];
  texts = Array.isArray(texts) ? texts : [texts];
  return values.map((value, idx) => {
    if (value === void 0 || value === null) {
      return "";
    }
    value = String(value);
    let text = texts[idx];
    text = text === void 0 || text === null ? value : String(text);
    return toUrlCommaDelimitedString(value, text);
  });
}
function fromUrlValues(urlValues) {
  urlValues = Array.isArray(urlValues) ? urlValues : [urlValues];
  return urlValues.reduce(
    (acc, urlValue) => {
      const [value, label] = (urlValue != null ? urlValue : "").split(",");
      acc.values.push(unescapeUrlDelimiters(value));
      acc.texts.push(unescapeUrlDelimiters(label != null ? label : value));
      return acc;
    },
    {
      values: [],
      texts: []
    }
  );
}

function getEnrichedFiltersRequest(sourceRunner) {
  const root = sourceRunner.getRoot();
  if (isFiltersRequestEnricher(root)) {
    return root.enrichFiltersRequest(sourceRunner);
  }
  return null;
}

var __typeError$3 = (msg) => {
  throw TypeError(msg);
};
var __accessCheck$3 = (obj, member, msg) => member.has(obj) || __typeError$3("Cannot " + msg);
var __privateGet$3 = (obj, member, getter) => (__accessCheck$3(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$3 = (obj, member, value) => member.has(obj) ? __typeError$3("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$3 = (obj, member, value, setter) => (__accessCheck$3(obj, member, "write to private field"), member.set(obj, value), value);
var _value;
class SafeSerializableSceneObject {
  constructor(value) {
    __privateAdd$3(this, _value);
    this.text = "__sceneObject";
    this.valueOf = () => {
      return __privateGet$3(this, _value);
    };
    __privateSet$3(this, _value, value);
  }
  toString() {
    return void 0;
  }
  get value() {
    return this;
  }
}
_value = new WeakMap();

function shouldWrapInSafeSerializableSceneObject(grafanaVersion) {
  const pattern = /^(\d+)\.(\d+)\.(\d+)/;
  const match = grafanaVersion.match(pattern);
  if (!match) {
    return false;
  }
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  if (major === 11) {
    return minor === 0 && patch >= 4 || minor === 1 && patch >= 2 || minor > 1;
  }
  if (major === 10) {
    return minor === 4 && patch >= 8 || minor >= 5;
  }
  return major > 11;
}
function wrapInSafeSerializableSceneObject(sceneObject) {
  const version = runtime.config.buildInfo.version;
  if (shouldWrapInSafeSerializableSceneObject(version)) {
    return new SafeSerializableSceneObject(sceneObject);
  }
  return { value: sceneObject, text: "__sceneObject" };
}

function DefaultGroupByCustomIndicatorContainer(props) {
  const { model } = props;
  const theme = ui.useTheme2();
  const styles = getStyles$l(theme);
  const inputStyles = ui.getInputStyles({ theme, invalid: false });
  const value = lodash.isArray(model.state.value) ? model.state.value : model.state.value ? [model.state.value] : [];
  let buttons = [];
  if (value && value.length) {
    buttons.push(
      /* @__PURE__ */ React__default.default.createElement(
        ui.IconButton,
        {
          "aria-label": i18n.t("grafana-scenes.variables.default-group-by-custom-indicator-container.aria-label-clear", "clear"),
          key: "clear",
          name: "times",
          size: "md",
          className: styles.clearIcon,
          onClick: (e) => {
            model.changeValueTo([], void 0, true);
            if (model.checkIfRestorable([])) {
              model.setState({ restorable: true });
            }
          }
        }
      )
    );
  }
  if (model.state.restorable) {
    buttons.push(
      /* @__PURE__ */ React__default.default.createElement(
        ui.IconButton,
        {
          onClick: (e) => {
            props.model.restoreDefaultValues();
          },
          onKeyDownCapture: (e) => {
            if (e.key === "Enter") {
              props.model.restoreDefaultValues();
            }
          },
          key: "restore",
          name: "history",
          size: "md",
          className: styles.clearIcon,
          tooltip: i18n.t(
            "grafana-scenes.variables.default-group-by-custom-indicator-container.tooltip-restore-groupby-set-by-this-dashboard",
            "Restore groupby set by this dashboard."
          )
        }
      )
    );
  }
  if (!model.state.restorable) {
    buttons.push(
      /* @__PURE__ */ React__default.default.createElement(
        ui.Tooltip,
        {
          key: "tooltip",
          content: i18n.t(
            "grafana-scenes.variables.default-group-by-custom-indicator-container.tooltip",
            "Applied by default in this dashboard. If edited, it carries over to other dashboards."
          ),
          placement: "bottom"
        },
        /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: "info-circle", size: "md" })
      )
    );
  }
  return /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      onMouseDown: (e) => {
        e.preventDefault();
        e.stopPropagation();
      },
      className: css.cx(
        inputStyles.suffix,
        css.css({
          position: "relative"
        })
      )
    },
    buttons
  );
}
const getStyles$l = (theme) => ({
  clearIcon: css.css({
    color: theme.colors.action.disabledText,
    cursor: "pointer",
    "&:hover:before": {
      backgroundColor: "transparent"
    },
    "&:hover": {
      color: theme.colors.text.primary
    }
  })
});

const GroupByValueContainer = ({
  keysApplicability,
  children
}) => {
  var _a, _b;
  const theme = ui.useTheme2();
  const styles = ui.getSelectStyles(theme);
  const { disabledPill, strikethrough } = getNonApplicablePillStyles(theme);
  const firstChild = React__default.default.Children.toArray(children)[0];
  let isApplicable = true;
  if (React__default.default.isValidElement(firstChild) && ((_b = (_a = firstChild.props) == null ? void 0 : _a.data) == null ? void 0 : _b.value)) {
    const value = firstChild.props.data.value;
    const applicability = keysApplicability == null ? void 0 : keysApplicability.find((item) => item.key === value);
    if (applicability && !applicability.applicable) {
      isApplicable = false;
    }
  }
  return /* @__PURE__ */ React__default.default.createElement("div", { className: css.cx(styles.multiValueContainer, !isApplicable && css.cx(disabledPill, strikethrough)) }, children);
};

function isInteractionTracker(s) {
  return "isInteractionTracker" in s;
}
class SceneInteractionTracker extends SceneObjectBase {
  constructor(state = {}, renderProfiler) {
    super(state);
    this.renderProfiler = renderProfiler;
    this.isInteractionTracker = true;
    if (renderProfiler) {
      this.renderProfiler = renderProfiler;
      this.renderProfiler.setInteractionCompleteHandler(state.onInteractionComplete);
    }
  }
  startInteraction(name) {
    var _a;
    if (!this.state.enableInteractionTracking) {
      return;
    }
    (_a = this.renderProfiler) == null ? void 0 : _a.startInteraction(name);
  }
  stopInteraction() {
    var _a;
    (_a = this.renderProfiler) == null ? void 0 : _a.stopInteraction();
  }
}

function getInteractionTracker(sceneObject) {
  let parent = sceneObject;
  while (parent) {
    if (parent.state.$behaviors) {
      for (const behavior of parent.state.$behaviors) {
        if (isInteractionTracker(behavior)) {
          return behavior;
        }
      }
    }
    parent = parent.parent;
  }
  return void 0;
}

function DrilldownRecommendations({ recentDrilldowns, recommendedDrilldowns }) {
  const styles = ui.useStyles2(getStyles$k);
  const [isPopoverVisible, setPopoverVisible] = React.useState(false);
  const ref = React.useRef(null);
  const openPopover = () => {
    setPopoverVisible(true);
  };
  const onClickAction = (action) => {
    action();
    setPopoverVisible(false);
  };
  const content = /* @__PURE__ */ React__default.default.createElement(ui.ClickOutsideWrapper, { onClick: () => setPopoverVisible(false), useCapture: true }, /* @__PURE__ */ React__default.default.createElement("div", { className: styles.menuContainer, onClick: (ev) => ev.stopPropagation() }, /* @__PURE__ */ React__default.default.createElement(ui.Stack, { direction: "column" }, /* @__PURE__ */ React__default.default.createElement(ui.Text, { weight: "bold", variant: "bodySmall", color: "secondary" }, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.components.drilldown-recommendations.recent" }, "Recent")), recentDrilldowns && recentDrilldowns.length > 0 ? recentDrilldowns.map((drilldown) => /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      key: drilldown.label,
      className: css.cx(styles.combinedFilterPill),
      onClick: () => onClickAction(drilldown.onClick)
    },
    drilldown.label
  )) : /* @__PURE__ */ React__default.default.createElement("div", { className: styles.emptyMessage }, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.components.drilldown-recommendations.recent-empty" }, "No recent values")), /* @__PURE__ */ React__default.default.createElement(ui.Text, { weight: "bold", variant: "bodySmall", color: "secondary" }, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.components.drilldown-recommendations.recommended" }, "Recommended")), recommendedDrilldowns && recommendedDrilldowns.length > 0 ? recommendedDrilldowns.map((drilldown) => /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      key: drilldown.label,
      className: css.cx(styles.combinedFilterPill),
      onClick: () => onClickAction(drilldown.onClick)
    },
    drilldown.label
  )) : /* @__PURE__ */ React__default.default.createElement("div", { className: styles.emptyMessage }, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.components.drilldown-recommendations.recommended-empty" }, "No recommended values")))));
  return /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, /* @__PURE__ */ React__default.default.createElement(
    ui.IconButton,
    {
      name: "plus",
      tooltip: i18n.t("grafana-scenes.components.drilldown-recommendations.tooltip", "Show recommendations"),
      ref,
      className: css.cx(isPopoverVisible && styles.iconActive),
      onClick: (ev) => {
        openPopover();
        ev.stopPropagation();
      }
    }
  ), isPopoverVisible && ref.current && /* @__PURE__ */ React__default.default.createElement(
    ui.Popover,
    {
      content,
      onKeyDown: (event) => {
        if (event.key === " ") {
          event.stopPropagation();
        }
      },
      placement: "bottom-start",
      referenceElement: ref.current,
      show: true
    }
  ));
}
const getStyles$k = (theme) => ({
  menuContainer: css.css({
    display: "flex",
    flexDirection: "column",
    background: theme.colors.background.elevated,
    border: `1px solid ${theme.colors.border.weak}`,
    borderRadius: theme.shape.radius.default,
    boxShadow: theme.shadows.z3,
    padding: theme.spacing(2)
  }),
  combinedFilterPill: css.css({
    alignItems: "center",
    background: theme.colors.action.selected,
    borderRadius: theme.shape.radius.default,
    border: `1px solid ${theme.colors.border.weak}`,
    padding: theme.spacing(0.2, 1),
    color: theme.colors.text.primary,
    overflow: "hidden",
    whiteSpace: "nowrap",
    minHeight: theme.spacing(2.75),
    ...theme.typography.bodySmall,
    fontWeight: theme.typography.fontWeightBold,
    cursor: "pointer",
    "&:hover": {
      background: theme.colors.action.hover
    }
  }),
  iconActive: css.css({
    "&:before": {
      backgroundColor: theme.colors.action.hover,
      opacity: 1
    }
  }),
  emptyMessage: css.css({
    padding: theme.spacing(0.5, 0),
    color: theme.colors.text.secondary,
    ...theme.typography.bodySmall
  })
});

class ScopesVariable extends SceneObjectBase {
  constructor(state) {
    super({
      skipUrlSync: true,
      loading: true,
      scopes: [],
      ...state,
      type: "system",
      name: SCOPES_VARIABLE_NAME,
      hide: schema.VariableHide.hideVariable
    });
    this._renderBeforeActivation = true;
    // Special options that enables variables to be hidden but still render to access react contexts
    this.UNSAFE_renderAsHidden = true;
  }
  /**
   * Temporary simple implementation to stringify the scopes.
   */
  getValue() {
    var _a;
    const scopes = (_a = this.state.scopes) != null ? _a : [];
    return new ScopesVariableFormatter(scopes.map((scope) => scope.metadata.name));
  }
  getScopes() {
    return this.state.scopes;
  }
  /**
   * This method is used to keep the context up to date with the scopes context received from React
   * 1) Subscribes to ScopesContext state changes and synchronizes it with the variable state
   * 2) Handles enable / disabling of scopes based on variable enable option.
   */
  setContext(context) {
    if (!context) {
      return;
    }
    this._context = context;
    const oldState = context.state;
    if (this.state.enable != null) {
      context.setEnabled(this.state.enable);
    }
    const sub = context.stateObservable.subscribe((state) => {
      this.updateStateFromContext(state);
    });
    return () => {
      sub.unsubscribe();
      if (this.state.enable != null) {
        context.setEnabled(oldState.enabled);
      }
    };
  }
  updateStateFromContext(state) {
    const loading = state.value.length === 0 ? false : state.loading;
    const oldScopes = this.state.scopes.map((scope) => scope.metadata.name);
    const newScopes = state.value.map((scope) => scope.metadata.name);
    const scopesHaveChanged = !lodash.isEqual(oldScopes, newScopes);
    if (!loading && (scopesHaveChanged || newScopes.length === 0)) {
      const queryController = getQueryController(this);
      queryController == null ? void 0 : queryController.startProfile(SCOPES_CHANGED_INTERACTION);
      this.setState({ scopes: state.value, loading });
      this.publishEvent(new SceneVariableValueChangedEvent(this), true);
    } else {
      this.setState({ loading });
    }
  }
}
ScopesVariable.Component = ScopesVariableRenderer;
function ScopesVariableRenderer({ model }) {
  const context = React.useContext(runtime.ScopesContext);
  React.useEffect(() => {
    return model.setContext(context);
  }, [context, model]);
  return null;
}
class ScopesVariableFormatter {
  constructor(_value) {
    this._value = _value;
  }
  formatter(formatNameOrFn) {
    if (formatNameOrFn === schema.VariableFormatID.QueryParam) {
      return this._value.map((scope) => `scope=${encodeURIComponent(scope)}`).join("&");
    }
    return this._value.join(", ");
  }
}

let originalGetAdhocFilters = void 0;
const allActiveFilterSets = /* @__PURE__ */ new Set();
function patchGetAdhocFilters(filterVar) {
  filterVar.addActivationHandler(() => {
    allActiveFilterSets.add(filterVar);
    return () => allActiveFilterSets.delete(filterVar);
  });
  if (originalGetAdhocFilters) {
    return;
  }
  const templateSrv = runtime.getTemplateSrv();
  if (!(templateSrv == null ? void 0 : templateSrv.getAdhocFilters)) {
    console.log("Failed to patch getAdhocFilters");
    return;
  }
  originalGetAdhocFilters = templateSrv.getAdhocFilters;
  templateSrv.getAdhocFilters = function getAdhocFiltersScenePatch(dsName) {
    var _a;
    if (allActiveFilterSets.size === 0) {
      return originalGetAdhocFilters.call(templateSrv, dsName);
    }
    const ds = runtime.getDataSourceSrv().getInstanceSettings(dsName);
    if (!ds) {
      return [];
    }
    for (const filter of allActiveFilterSets.values()) {
      if (((_a = filter.state.datasource) == null ? void 0 : _a.uid) === ds.uid) {
        return filter.state.filters;
      }
    }
    return [];
  }.bind(templateSrv);
}
function findActiveAdHocFilterVariableByUid(dsUid) {
  var _a;
  for (const filter of allActiveFilterSets.values()) {
    if (interpolate(filter, (_a = filter.state.datasource) == null ? void 0 : _a.uid) === dsUid) {
      return filter;
    }
  }
  return void 0;
}

function LoadingIndicator(props) {
  return /* @__PURE__ */ React__default.default.createElement(ui.Tooltip, { content: i18n.t("grafana-scenes.utils.loading-indicator.content-cancel-query", "Cancel query") }, /* @__PURE__ */ React__default.default.createElement(
    ui.Icon,
    {
      className: "spin-clockwise",
      name: "sync",
      size: "xs",
      role: "button",
      onMouseDown: (e) => {
        props.onCancel(e);
      }
    }
  ));
}

function ControlsLabel(props) {
  const styles = ui.useStyles2(getStyles$j);
  const theme = ui.useTheme2();
  const isVertical = props.layout === "vertical";
  const loadingIndicator = Boolean(props.isLoading) ? /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      style: { marginLeft: theme.spacing(1), marginTop: "-1px" },
      "aria-label": e2eSelectors.selectors.components.LoadingIndicator.icon
    },
    /* @__PURE__ */ React__default.default.createElement(
      LoadingIndicator,
      {
        onCancel: (e) => {
          var _a;
          e.preventDefault();
          e.stopPropagation();
          (_a = props.onCancel) == null ? void 0 : _a.call(props);
        }
      }
    )
  ) : null;
  let errorIndicator = null;
  if (props.error) {
    errorIndicator = /* @__PURE__ */ React__default.default.createElement(ui.Tooltip, { content: props.error, placement: "bottom" }, /* @__PURE__ */ React__default.default.createElement(ui.Icon, { className: styles.errorIcon, name: "exclamation-triangle" }));
  }
  let descriptionIndicator = null;
  if (props.description) {
    descriptionIndicator = /* @__PURE__ */ React__default.default.createElement(ui.Tooltip, { content: props.description, placement: isVertical ? "top" : "bottom" }, /* @__PURE__ */ React__default.default.createElement(ui.Icon, { className: styles.normalIcon, name: "info-circle" }));
  }
  const testId = typeof props.label === "string" ? e2eSelectors.selectors.pages.Dashboard.SubMenu.submenuItemLabels(props.label) : "";
  let labelElement;
  if (isVertical) {
    labelElement = /* @__PURE__ */ React__default.default.createElement("label", { className: css.cx(styles.verticalLabel, props.className), "data-testid": testId, htmlFor: props.htmlFor }, props.prefix, props.label, descriptionIndicator, errorIndicator, props.icon && /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: props.icon, className: styles.normalIcon }), loadingIndicator, props.onRemove && /* @__PURE__ */ React__default.default.createElement(
      ui.IconButton,
      {
        variant: "secondary",
        size: "xs",
        name: "times",
        onClick: props.onRemove,
        tooltip: i18n.t("grafana-scenes.utils.controls-label.tooltip-remove", "Remove")
      }
    ), props.suffix);
  } else {
    labelElement = /* @__PURE__ */ React__default.default.createElement("label", { className: css.cx(styles.horizontalLabel, props.className), "data-testid": testId, htmlFor: props.htmlFor }, props.prefix, errorIndicator, props.icon && /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: props.icon, className: styles.normalIcon }), props.label, descriptionIndicator, loadingIndicator, props.suffix);
  }
  return labelElement;
}
const getStyles$j = (theme) => ({
  horizontalLabel: css.css({
    background: theme.isDark ? theme.colors.background.primary : theme.colors.background.secondary,
    display: `flex`,
    alignItems: "center",
    padding: theme.spacing(0, 1),
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.bodySmall.fontSize,
    height: theme.spacing(theme.components.height.md),
    lineHeight: theme.spacing(theme.components.height.md),
    borderRadius: `${theme.shape.radius.default} 0 0 ${theme.shape.radius.default}`,
    border: `1px solid ${theme.components.input.borderColor}`,
    position: "relative",
    // To make the border line up with the input border
    right: -1,
    whiteSpace: "nowrap",
    gap: theme.spacing(0.5)
  }),
  verticalLabel: css.css({
    display: `flex`,
    alignItems: "center",
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.bodySmall.fontSize,
    lineHeight: theme.typography.bodySmall.lineHeight,
    whiteSpace: "nowrap",
    marginBottom: theme.spacing(0.5),
    gap: theme.spacing(1)
  }),
  errorIcon: css.css({
    color: theme.colors.error.text
  }),
  normalIcon: css.css({
    color: theme.colors.text.secondary
  })
});

function getAdhocOptionSearcher(options) {
  const haystack = options.map((o) => {
    var _a;
    return (_a = o.label) != null ? _a : String(o.value);
  });
  return (search) => fuzzyFind(options, haystack, search);
}

function keyLabelToOption(key, label) {
  return key !== "" ? {
    value: key,
    label: label || key
  } : null;
}
const filterNoOp$1 = () => true;
function AdHocFilterRenderer({ filter, model }) {
  var _a, _b, _c, _d, _e;
  const styles = ui.useStyles2(getStyles$i);
  const [keys, setKeys] = React.useState([]);
  const [values, setValues] = React.useState([]);
  const [isKeysLoading, setIsKeysLoading] = React.useState(false);
  const [isValuesLoading, setIsValuesLoading] = React.useState(false);
  const [isKeysOpen, setIsKeysOpen] = React.useState(false);
  const [isValuesOpen, setIsValuesOpen] = React.useState(false);
  const [isOperatorOpen, setIsOperatorOpen] = React.useState(false);
  const [valueInputValue, setValueInputValue] = React.useState("");
  const [valueHasCustomValue, setValueHasCustomValue] = React.useState(false);
  const [uncommittedValue, setUncommittedValue] = React.useState(
    filter.values ? filter.values.map((value, index) => {
      var _a2;
      return keyLabelToOption(value, (_a2 = filter.valueLabels) == null ? void 0 : _a2[index]);
    }) : []
  );
  const isMultiValue = isMultiValueOperator(filter.operator);
  const keyValue = keyLabelToOption(filter.key, filter.keyLabel);
  const valueValue = keyLabelToOption(filter.value, (_a = filter.valueLabels) == null ? void 0 : _a[0]);
  const optionSearcher = React.useMemo(() => getAdhocOptionSearcher(values), [values]);
  const onAddCustomValue = model.state.onAddCustomValue;
  const onValueInputChange = (value, { action }) => {
    if (action === "input-change") {
      setValueInputValue(value);
    }
    return value;
  };
  const onOperatorChange = (v) => {
    var _a2, _b2;
    const existingOperator = filter.operator;
    const newOperator = v.value;
    const update = { operator: newOperator };
    if (isMultiValueOperator(existingOperator) && !isMultiValueOperator(newOperator)) {
      update.value = "";
      update.valueLabels = [""];
      update.values = void 0;
      setUncommittedValue([]);
    } else if (!isMultiValueOperator(existingOperator) && isMultiValueOperator(newOperator) && filter.value) {
      update.values = [filter.value];
      setUncommittedValue([
        {
          value: filter.value,
          label: (_b2 = (_a2 = filter.valueLabels) == null ? void 0 : _a2[0]) != null ? _b2 : filter.value
        }
      ]);
    }
    model._updateFilter(filter, update);
  };
  const filteredValueOptions = React.useMemo(
    () => handleOptionGroups(optionSearcher(valueInputValue)),
    [optionSearcher, valueInputValue]
  );
  const multiValueProps = {
    isMulti: true,
    value: uncommittedValue,
    components: {
      Option: OptionWithCheckbox
    },
    hideSelectedOptions: false,
    closeMenuOnSelect: false,
    openMenuOnFocus: false,
    onChange: (v) => {
      setUncommittedValue(v);
      if (v.some((value) => value.__isNew__)) {
        setValueInputValue("");
      }
    },
    onBlur: () => {
      var _a2, _b2;
      model._updateFilter(filter, {
        value: (_b2 = (_a2 = uncommittedValue[0]) == null ? void 0 : _a2.value) != null ? _b2 : "",
        // TODO remove expect-error when we're on the latest version of @grafana/data
        values: uncommittedValue.map((option) => option.value),
        valueLabels: uncommittedValue.map((option) => option.label)
      });
    }
  };
  const operatorDefinition = OPERATORS.find((op) => filter.operator === op.value);
  const valueSelect = /* @__PURE__ */ React__default.default.createElement(
    ui.Select,
    {
      virtualized: true,
      allowCustomValue: (_b = model.state.allowCustomValue) != null ? _b : true,
      createOptionPosition: (operatorDefinition == null ? void 0 : operatorDefinition.isRegex) ? "first" : "last",
      isValidNewOption: (inputValue) => inputValue.trim().length > 0,
      allowCreateWhileLoading: true,
      formatCreateLabel: (inputValue) => `Use custom value: ${inputValue}`,
      disabled: model.state.readOnly,
      className: css.cx(styles.value, isValuesOpen ? styles.widthWhenOpen : void 0),
      width: "auto",
      value: valueValue,
      filterOption: filterNoOp$1,
      placeholder: i18n.t(
        "grafana-scenes.variables.ad-hoc-filter-renderer.value-select.placeholder-select-value",
        "Select value"
      ),
      options: filteredValueOptions,
      inputValue: valueInputValue,
      onInputChange: onValueInputChange,
      onChange: (v) => {
        if (onAddCustomValue && v.__isNew__) {
          model._updateFilter(filter, onAddCustomValue(v, filter));
        } else {
          model._updateFilter(filter, {
            value: v.value,
            valueLabels: v.label ? [v.label] : [v.value]
          });
        }
        if (valueHasCustomValue !== v.__isNew__) {
          setValueHasCustomValue(v.__isNew__);
        }
      },
      isOpen: isValuesOpen && !isValuesLoading,
      isLoading: isValuesLoading,
      openMenuOnFocus: true,
      onOpenMenu: async () => {
        var _a2;
        setIsValuesLoading(true);
        setIsValuesOpen(true);
        const values2 = await model._getValuesFor(filter);
        setIsValuesLoading(false);
        setValues(values2);
        if (valueHasCustomValue) {
          setValueInputValue((_a2 = valueValue == null ? void 0 : valueValue.label) != null ? _a2 : "");
        }
      },
      onCloseMenu: () => {
        setIsValuesOpen(false);
        setValueInputValue("");
      },
      ...isMultiValue && multiValueProps
    }
  );
  const keySelect = /* @__PURE__ */ React__default.default.createElement(
    ui.Select,
    {
      key: `${isValuesLoading ? "loading" : "loaded"}`,
      disabled: model.state.readOnly,
      className: css.cx(styles.key, isKeysOpen ? styles.widthWhenOpen : void 0),
      width: "auto",
      allowCustomValue: (_c = model.state.allowCustomValue) != null ? _c : true,
      createOptionPosition: (operatorDefinition == null ? void 0 : operatorDefinition.isRegex) ? "first" : "last",
      value: keyValue,
      placeholder: i18n.t(
        "grafana-scenes.variables.ad-hoc-filter-renderer.key-select.placeholder-select-label",
        "Select label"
      ),
      options: handleOptionGroups(keys),
      onChange: (v) => {
        model._updateFilter(filter, {
          key: v.value,
          keyLabel: v.label,
          // clear value if key has changed
          value: "",
          valueLabels: [""],
          values: void 0
        });
        setUncommittedValue([]);
      },
      autoFocus: filter.key === "",
      isOpen: isKeysOpen && !isKeysLoading,
      isLoading: isKeysLoading,
      onOpenMenu: async () => {
        setIsKeysOpen(true);
        setIsKeysLoading(true);
        const keys2 = await model._getKeys(filter.key);
        setIsKeysLoading(false);
        setKeys(keys2);
      },
      onCloseMenu: () => {
        setIsKeysOpen(false);
      },
      onBlur: () => {
        if (filter.key === "") {
          model._removeFilter(filter);
        }
      },
      openMenuOnFocus: true
    }
  );
  const operatorSelect = /* @__PURE__ */ React__default.default.createElement(
    ui.Select,
    {
      className: css.cx(styles.operator, {
        [styles.widthWhenOpen]: isOperatorOpen
      }),
      value: filter.operator,
      disabled: model.state.readOnly,
      options: model._getOperators(),
      onChange: onOperatorChange,
      onOpenMenu: () => {
        setIsOperatorOpen(true);
      },
      onCloseMenu: () => {
        setIsOperatorOpen(false);
      }
    }
  );
  if (model.state.layout === "vertical") {
    if (filter.key) {
      const label = /* @__PURE__ */ React__default.default.createElement(ControlsLabel, { layout: "vertical", label: (_d = filter.key) != null ? _d : "", onRemove: () => model._removeFilter(filter) });
      return /* @__PURE__ */ React__default.default.createElement(ui.Field, { label, "data-testid": `AdHocFilter-${filter.key}`, className: styles.field }, /* @__PURE__ */ React__default.default.createElement("div", { className: styles.wrapper }, operatorSelect, valueSelect));
    } else {
      return /* @__PURE__ */ React__default.default.createElement(
        ui.Field,
        {
          label: i18n.t("grafana-scenes.variables.ad-hoc-filter-renderer.label-select-label", "Select label"),
          "data-testid": `AdHocFilter-${filter.key}`,
          className: styles.field
        },
        keySelect
      );
    }
  }
  return /* @__PURE__ */ React__default.default.createElement("div", { className: styles.wrapper, "data-testid": `AdHocFilter-${filter.key}` }, keySelect, operatorSelect, valueSelect, /* @__PURE__ */ React__default.default.createElement(
    ui.Button,
    {
      variant: "secondary",
      "aria-label": i18n.t("grafana-scenes.variables.ad-hoc-filter-renderer.aria-label-remove-filter", "Remove filter"),
      title: i18n.t("grafana-scenes.variables.ad-hoc-filter-renderer.title-remove-filter", "Remove filter"),
      className: styles.removeButton,
      icon: "times",
      "data-testid": `AdHocFilter-remove-${(_e = filter.key) != null ? _e : ""}`,
      onClick: () => model._removeFilter(filter)
    }
  ));
}
const getStyles$i = (theme) => ({
  field: css.css({
    marginBottom: 0
  }),
  wrapper: css.css({
    display: "flex",
    "&:first-child": {
      "> :first-child": {
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0
      }
    },
    "> *": {
      "&:not(:first-child)": {
        // Negative margin hides the double-border on adjacent selects
        marginLeft: -1
      },
      "&:first-child": {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      "&:last-child": {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      },
      // Fix focus state zIndex issues
      position: "relative",
      zIndex: 0,
      // Adjacent borders are overlapping, so raise children up when hovering etc
      // so all that child's borders are visible.
      "&:hover": {
        zIndex: 1
      },
      "&:focus-within": {
        zIndex: 2
      }
    }
  }),
  widthWhenOpen: css.css({
    minWidth: theme.spacing(16)
  }),
  value: css.css({
    flexBasis: "content",
    flexShrink: 1,
    minWidth: "90px"
  }),
  key: css.css({
    flexBasis: "content",
    minWidth: "90px",
    flexShrink: 1
  }),
  operator: css.css({
    flexShrink: 0,
    flexBasis: "content"
  }),
  removeButton: css.css({
    paddingLeft: theme.spacing(3 / 2),
    paddingRight: theme.spacing(3 / 2),
    borderLeft: "none",
    width: theme.spacing(3),
    marginRight: theme.spacing(1),
    boxSizing: "border-box",
    // To not have button background and last select border intersect
    position: "relative",
    left: "1px"
  })
});

function AdHocFilterBuilder({ model, addFilterButtonText }) {
  const { _wip } = model.useState();
  const styles = ui.useStyles2(getStyles$h);
  if (!_wip) {
    return /* @__PURE__ */ React__default.default.createElement(
      ui.Button,
      {
        variant: "secondary",
        icon: "plus",
        title: i18n.t("grafana-scenes.variables.ad-hoc-filter-builder.title-add-filter", "Add filter"),
        "aria-label": i18n.t("grafana-scenes.variables.ad-hoc-filter-builder.aria-label-add-filter", "Add filter"),
        "data-testid": `AdHocFilter-add`,
        onClick: () => model._addWip(),
        className: styles.addButton
      },
      addFilterButtonText
    );
  }
  return /* @__PURE__ */ React__default.default.createElement(AdHocFilterRenderer, { filter: _wip, model });
}
const getStyles$h = (theme) => ({
  addButton: css.css({
    "&:first-child": {
      borderBottomLeftRadius: 0,
      borderTopLeftRadius: 0
    }
  })
});

class AdHocFiltersVariableUrlSyncHandler {
  constructor(_variable) {
    this._variable = _variable;
  }
  getKey() {
    return `var-${this._variable.state.name}`;
  }
  getKeys() {
    return [this.getKey()];
  }
  getUrlState() {
    const filters = this._variable.state.filters;
    const originFilters = this._variable.state.originFilters;
    let value = [];
    if (filters.length === 0 && (originFilters == null ? void 0 : originFilters.length) === 0) {
      return { [this.getKey()]: [""] };
    }
    if (filters.length) {
      value.push(
        ...filters.filter(isFilterComplete).filter((filter) => !filter.hidden).map((filter) => toArray(filter).map(escapeOriginFilterUrlDelimiters).join("|"))
      );
    }
    if (originFilters == null ? void 0 : originFilters.length) {
      value.push(
        ...originFilters == null ? void 0 : originFilters.filter(isFilterComplete).filter((filter) => !filter.hidden && filter.origin && filter.restorable).map(
          (filter) => toArray(filter).map(escapeOriginFilterUrlDelimiters).join("|").concat(`#${filter.origin}#restorable`)
        )
      );
    }
    return {
      [this.getKey()]: value.length ? value : [""]
    };
  }
  updateFromUrl(values) {
    const urlValue = values[this.getKey()];
    if (urlValue == null) {
      return;
    }
    const filters = deserializeUrlToFilters(urlValue);
    const originFilters = updateOriginFilters([...this._variable.state.originFilters || []], filters);
    this._variable.setState({
      filters: filters.filter((f) => !f.origin),
      originFilters
    });
  }
}
function updateOriginFilters(prevOriginFilters, filters) {
  const updatedOriginFilters = [...prevOriginFilters];
  for (let i = 0; i < filters.length; i++) {
    const foundOriginFilterIndex = prevOriginFilters.findIndex((f) => f.key === filters[i].key);
    if (foundOriginFilterIndex > -1 && filters[i].origin === prevOriginFilters[foundOriginFilterIndex].origin) {
      if (isMatchAllFilter(filters[i])) {
        filters[i].matchAllFilter = true;
      }
      updatedOriginFilters[foundOriginFilterIndex] = filters[i];
    } else if (filters[i].origin === "dashboard") {
      delete filters[i].origin;
      delete filters[i].restorable;
    } else if (foundOriginFilterIndex === -1 && filters[i].origin === "scope" && filters[i].restorable) {
      updatedOriginFilters.push(filters[i]);
    }
  }
  return updatedOriginFilters;
}
function deserializeUrlToFilters(value) {
  if (Array.isArray(value)) {
    const values = value;
    return values.map(toFilter).filter(isFilter);
  }
  const filter = toFilter(value);
  return filter === null ? [] : [filter];
}
function toArray(filter) {
  var _a;
  const result = [toUrlCommaDelimitedString(filter.key, filter.keyLabel), filter.operator];
  if (isMultiValueOperator(filter.operator)) {
    filter.values.forEach((value, index) => {
      var _a2;
      result.push(toUrlCommaDelimitedString(value, (_a2 = filter.valueLabels) == null ? void 0 : _a2[index]));
    });
  } else {
    result.push(toUrlCommaDelimitedString(filter.value, (_a = filter.valueLabels) == null ? void 0 : _a[0]));
  }
  return result;
}
function toFilter(urlValue) {
  if (typeof urlValue !== "string" || urlValue.length === 0) {
    return null;
  }
  const [filter, origin, restorable] = urlValue.split("#");
  const [key, keyLabel, operator, _operatorLabel, ...values] = filter.split("|").reduce((acc, v) => {
    const [key2, label] = v.split(",");
    acc.push(key2, label != null ? label : key2);
    return acc;
  }, []).map(unescapeUrlDelimiters);
  return {
    key,
    keyLabel,
    operator,
    value: values[0],
    values: isMultiValueOperator(operator) ? values.filter((_, index) => index % 2 === 0) : void 0,
    valueLabels: values.filter((_, index) => index % 2 === 1),
    condition: "",
    ...isFilterOrigin(origin) && { origin },
    ...!!restorable && { restorable: true }
  };
}
function isFilterOrigin(value) {
  return value === "scope" || value === "dashboard";
}
function isFilter(filter) {
  return filter !== null && typeof filter.key === "string" && typeof filter.value === "string";
}

const DropdownItem = React.forwardRef(
  function DropdownItem2({ children, active, addGroupBottomBorder, isMultiValueEdit, checked, ...rest }, ref) {
    const styles = ui.useStyles2(getStyles$g);
    const id = React.useId();
    return /* @__PURE__ */ React__default.default.createElement(
      "div",
      {
        ref,
        role: "option",
        id,
        "aria-selected": active,
        className: css.cx(styles.option, active && styles.optionFocused, addGroupBottomBorder && styles.groupBottomBorder),
        ...rest
      },
      /* @__PURE__ */ React__default.default.createElement("div", { className: styles.optionBody, "data-testid": `data-testid ad hoc filter option value ${children}` }, /* @__PURE__ */ React__default.default.createElement("span", null, isMultiValueEdit ? /* @__PURE__ */ React__default.default.createElement(ui.Checkbox, { tabIndex: -1, checked, className: styles.checkbox }) : null, children))
    );
  }
);
const getStyles$g = (theme) => ({
  option: css.css({
    label: "grafana-select-option",
    top: 0,
    left: 0,
    width: "100%",
    position: "absolute",
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    flexShrink: 0,
    whiteSpace: "nowrap",
    cursor: "pointer",
    "&:hover": {
      background: theme.colors.action.hover,
      "@media (forced-colors: active), (prefers-contrast: more)": {
        border: `1px solid ${theme.colors.primary.border}`
      }
    }
  }),
  optionFocused: css.css({
    label: "grafana-select-option-focused",
    background: theme.colors.action.focus,
    "@media (forced-colors: active), (prefers-contrast: more)": {
      border: `1px solid ${theme.colors.primary.border}`
    }
  }),
  optionBody: css.css({
    label: "grafana-select-option-body",
    display: "flex",
    fontWeight: theme.typography.fontWeightMedium,
    flexDirection: "column",
    flexGrow: 1
  }),
  groupBottomBorder: css.css({
    borderBottom: `1px solid ${theme.colors.border.weak}`
  }),
  checkbox: css.css({
    paddingRight: theme.spacing(0.5)
  }),
  multiValueApplyWrapper: css.css({
    position: "fixed",
    top: 0,
    left: 0,
    display: "flex",
    backgroundColor: theme.colors.background.primary,
    color: theme.colors.text.primary,
    boxShadow: theme.shadows.z2,
    overflowY: "auto",
    zIndex: theme.zIndex.dropdown,
    gap: theme.spacing(1.5),
    padding: `${theme.spacing(1.5)} ${theme.spacing(1)}`
  })
});
const LoadingOptionsPlaceholder = () => {
  return /* @__PURE__ */ React__default.default.createElement(DropdownItem, { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.variables.loading-options-placeholder.loading-options" }, "Loading options..."));
};
const NoOptionsPlaceholder = () => {
  return /* @__PURE__ */ React__default.default.createElement(DropdownItem, { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.variables.no-options-placeholder.no-options-found" }, "No options found"));
};
const OptionsErrorPlaceholder = ({ handleFetchOptions }) => {
  return /* @__PURE__ */ React__default.default.createElement(DropdownItem, { onClick: handleFetchOptions }, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.variables.options-error-placeholder.error-occurred-fetching-labels-click-retry" }, "An error has occurred fetching labels. Click to retry"));
};
const MultiValueApplyButton = ({
  onApply,
  floatingElement,
  maxOptionWidth,
  menuHeight
}) => {
  const styles = ui.useStyles2(getStyles$g);
  const floatingElementRect = floatingElement == null ? void 0 : floatingElement.getBoundingClientRect();
  return /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      className: styles.multiValueApplyWrapper,
      style: {
        width: `${maxOptionWidth}px`,
        transform: `translate(${floatingElementRect == null ? void 0 : floatingElementRect.left}px,${floatingElementRect ? floatingElementRect.top + menuHeight : 0}px)`
      }
    },
    /* @__PURE__ */ React__default.default.createElement(ui.Button, { onClick: onApply, size: "sm", tabIndex: -1 }, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.variables.multi-value-apply-button.apply" }, "Apply"))
  );
};

const VIRTUAL_LIST_WIDTH_ESTIMATE_MULTIPLIER = 8;
const VIRTUAL_LIST_DESCRIPTION_WIDTH_ESTIMATE_MULTIPLIER = 6;
const VIRTUAL_LIST_PADDING = 8;
const VIRTUAL_LIST_OVERSCAN = 5;
const VIRTUAL_LIST_ITEM_HEIGHT = 38;
const VIRTUAL_LIST_ITEM_HEIGHT_WITH_DESCRIPTION = 60;
const ERROR_STATE_DROPDOWN_WIDTH = 366;
const flattenOptionGroups = (options) => options.flatMap((option) => option.options ? [option, ...option.options] : [option]);
const setupDropdownAccessibility = (options, listRef, disabledIndicesRef) => {
  var _a, _b, _c, _d;
  let maxOptionWidth = 182;
  const listRefArr = [];
  const disabledIndices = [];
  for (let i = 0; i < options.length; i++) {
    listRefArr.push(null);
    if ((_a = options[i]) == null ? void 0 : _a.options) {
      disabledIndices.push(i);
    }
    let label = (_c = (_b = options[i].label) != null ? _b : options[i].value) != null ? _c : "";
    let multiplierToUse = VIRTUAL_LIST_WIDTH_ESTIMATE_MULTIPLIER;
    if (label.length * VIRTUAL_LIST_WIDTH_ESTIMATE_MULTIPLIER < (((_d = options[i].description) == null ? void 0 : _d.length) || 0) * VIRTUAL_LIST_DESCRIPTION_WIDTH_ESTIMATE_MULTIPLIER) {
      label = options[i].description;
      multiplierToUse = VIRTUAL_LIST_DESCRIPTION_WIDTH_ESTIMATE_MULTIPLIER;
    }
    const widthEstimate = (options[i].isCustom ? label.length + 18 : label.length) * multiplierToUse + VIRTUAL_LIST_PADDING * 2;
    if (widthEstimate > maxOptionWidth) {
      maxOptionWidth = widthEstimate;
    }
  }
  listRef.current = [...listRefArr];
  disabledIndicesRef.current = [...disabledIndices];
  return maxOptionWidth;
};
const nextInputTypeMap = {
  key: "operator",
  operator: "value",
  value: "key"
};
const switchToNextInputType = (filterInputType, setInputType, handleChangeViewMode, element, shouldFocusOnPillWrapperOverride) => switchInputType(
  nextInputTypeMap[filterInputType],
  setInputType,
  filterInputType === "value" ? handleChangeViewMode : void 0,
  element,
  shouldFocusOnPillWrapperOverride
);
const switchInputType = (filterInputType, setInputType, handleChangeViewMode, element, shouldFocusOnPillWrapperOverride) => {
  setInputType(filterInputType);
  handleChangeViewMode == null ? void 0 : handleChangeViewMode(void 0, shouldFocusOnPillWrapperOverride);
  setTimeout(() => element == null ? void 0 : element.focus());
};
const generateFilterUpdatePayload = ({
  filterInputType,
  item,
  filter,
  setFilterMultiValues,
  onAddCustomValue
}) => {
  var _a, _b, _c, _d, _e;
  if (filterInputType === "key") {
    return {
      key: item.value,
      keyLabel: item.label ? item.label : item.value,
      meta: item == null ? void 0 : item.meta
    };
  }
  if (filterInputType === "value") {
    if (item.isCustom && onAddCustomValue) {
      return onAddCustomValue(item, filter);
    }
    return {
      value: item.value,
      valueLabels: [item.label ? item.label : item.value]
    };
  }
  if (filterInputType === "operator") {
    if (isMultiValueOperator(filter.operator) && !isMultiValueOperator(item.value)) {
      setFilterMultiValues([]);
      return {
        operator: item.value,
        valueLabels: [((_a = filter.valueLabels) == null ? void 0 : _a[0]) || ((_b = filter.values) == null ? void 0 : _b[0]) || filter.value],
        values: void 0
      };
    }
    if (isMultiValueOperator(item.value) && !isMultiValueOperator(filter.operator)) {
      const valueLabels = [((_c = filter.valueLabels) == null ? void 0 : _c[0]) || ((_d = filter.values) == null ? void 0 : _d[0]) || filter.value];
      const values = [filter.value];
      if (values[0]) {
        setFilterMultiValues([
          {
            value: values[0],
            label: (_e = valueLabels == null ? void 0 : valueLabels[0]) != null ? _e : values[0]
          }
        ]);
      }
      return {
        operator: item.value,
        valueLabels,
        values
      };
    }
  }
  return {
    [filterInputType]: item.value
  };
};
const INPUT_PLACEHOLDER_DEFAULT = "Filter by label values";
const generatePlaceholder = (filter, filterInputType, isMultiValueEdit, isAlwaysWip, inputPlaceholder) => {
  var _a;
  if (filterInputType === "key") {
    return inputPlaceholder || INPUT_PLACEHOLDER_DEFAULT;
  }
  if (filterInputType === "value") {
    if (isMultiValueEdit) {
      return "Edit values";
    }
    return ((_a = filter.valueLabels) == null ? void 0 : _a[0]) || "";
  }
  if (isAlwaysWip && filterInputType === "operator") {
    return "";
  }
  return filter[filterInputType] && !isAlwaysWip ? `${filter[filterInputType]}` : inputPlaceholder || INPUT_PLACEHOLDER_DEFAULT;
};
const populateInputValueOnInputTypeSwitch = ({
  populateInputOnEdit,
  item,
  filterInputType,
  setInputValue,
  filter
}) => {
  var _a, _b, _c;
  if (populateInputOnEdit && !isMultiValueOperator(item.value || "") && nextInputTypeMap[filterInputType] === "value") {
    setInputValue((_c = (_b = (_a = filter == null ? void 0 : filter.valueLabels) == null ? void 0 : _a[0]) != null ? _b : filter == null ? void 0 : filter.value) != null ? _c : "");
  } else {
    setInputValue("");
  }
};

const MAX_MENU_HEIGHT = 300;
const useFloatingInteractions = ({
  open,
  onOpenChange,
  activeIndex,
  setActiveIndex,
  outsidePressIdsToIgnore,
  listRef,
  disabledIndicesRef
}) => {
  const { refs, floatingStyles, context } = react$1.useFloating({
    whileElementsMounted: react$1.autoUpdate,
    open,
    onOpenChange,
    placement: "bottom-start",
    middleware: [
      react$1.offset(10),
      react$1.flip({ padding: 10 }),
      react$1.size({
        apply({ availableHeight, availableWidth, elements }) {
          elements.floating.style.maxHeight = `${Math.min(MAX_MENU_HEIGHT, availableHeight)}px`;
          elements.floating.style.maxWidth = `${availableWidth}px`;
        },
        padding: 10
      })
    ],
    strategy: "fixed"
  });
  const role = react$1.useRole(context, { role: "listbox" });
  const dismiss = react$1.useDismiss(context, {
    // if outside click lands on operator pill, then ignore outside click
    outsidePress: (event) => {
      var _a;
      if (event.currentTarget instanceof Element) {
        const target = event.currentTarget;
        let idToCompare = target.id;
        if (target.nodeName === "path") {
          idToCompare = ((_a = target.parentElement) == null ? void 0 : _a.id) || "";
        }
        if (outsidePressIdsToIgnore.includes(idToCompare)) {
          return false;
        }
      }
      return true;
    }
  });
  const listNav = react$1.useListNavigation(context, {
    listRef,
    activeIndex,
    onNavigate: setActiveIndex,
    virtual: true,
    loop: true,
    disabledIndices: disabledIndicesRef.current
  });
  const { getReferenceProps, getFloatingProps, getItemProps } = react$1.useInteractions([role, dismiss, listNav]);
  return {
    refs,
    floatingStyles,
    context,
    getReferenceProps,
    getFloatingProps,
    getItemProps
  };
};

const MultiValuePill = ({
  item,
  handleRemoveMultiValue,
  index,
  handleEditMultiValuePill
}) => {
  var _a, _b;
  const styles = ui.useStyles2(getStyles$f);
  const editMultiValuePill = React.useCallback(
    (e) => {
      e.stopPropagation();
      e.preventDefault();
      handleEditMultiValuePill(item);
    },
    [handleEditMultiValuePill, item]
  );
  const editMultiValuePillWithKeyboard = React.useCallback(
    (e) => {
      if (e.key === "Enter") {
        editMultiValuePill(e);
      }
    },
    [editMultiValuePill]
  );
  const removePillHandler = React.useCallback(
    (e) => {
      e.stopPropagation();
      e.preventDefault();
      handleRemoveMultiValue(item);
    },
    [handleRemoveMultiValue, item]
  );
  const removePillHandlerWithKeyboard = React.useCallback(
    (e) => {
      if (e.key === "Enter") {
        removePillHandler(e);
      }
    },
    [removePillHandler]
  );
  return /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      className: css.cx(styles.basePill, styles.valuePill),
      onClick: editMultiValuePill,
      onKeyDown: editMultiValuePillWithKeyboard,
      tabIndex: 0,
      id: `${item.value}-${index}`
    },
    (_a = item.label) != null ? _a : item.value,
    /* @__PURE__ */ React__default.default.createElement(
      ui.Button,
      {
        onClick: removePillHandler,
        onKeyDownCapture: removePillHandlerWithKeyboard,
        fill: "text",
        size: "sm",
        variant: "secondary",
        className: styles.removeButton,
        tooltip: i18n.t(
          "grafana-scenes.components.adhoc-filters-combobox.remove-filter-value",
          "Remove filter value - {{itemLabel}}",
          {
            itemLabel: (_b = item.label) != null ? _b : item.value
          }
        )
      },
      /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: "times", size: "md", id: `${item.value}-${index}-close-icon` })
    )
  );
};
const getStyles$f = (theme) => ({
  basePill: css.css({
    display: "flex",
    alignItems: "center",
    background: theme.colors.action.disabledBackground,
    border: `1px solid ${theme.colors.border.weak}`,
    padding: theme.spacing(0.125, 1, 0.125, 1),
    color: theme.colors.text.primary,
    overflow: "hidden",
    whiteSpace: "nowrap",
    minHeight: theme.spacing(2.75),
    ...theme.typography.bodySmall,
    cursor: "pointer"
  }),
  valuePill: css.css({
    background: theme.colors.action.selected,
    padding: theme.spacing(0.125, 0, 0.125, 1)
  }),
  removeButton: css.css({
    marginInline: theme.spacing(0.5),
    height: "100%",
    padding: 0,
    cursor: "pointer",
    "&:hover": {
      color: theme.colors.text.primary
    }
  })
});

const AdHocCombobox = React.forwardRef(function AdHocCombobox2({
  filter,
  controller,
  isAlwaysWip,
  handleChangeViewMode,
  focusOnWipInputRef,
  populateInputOnEdit,
  onInputClick
}, parentRef) {
  var _a, _b, _c;
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [optionsLoading, setOptionsLoading] = React.useState(false);
  const [optionsError, setOptionsError] = React.useState(false);
  const [inputValue, setInputValue] = React.useState("");
  const [activeIndex, setActiveIndex] = React.useState(null);
  const [filterInputType, setInputType] = React.useState(!isAlwaysWip ? "value" : "key");
  const [preventFiltering, setPreventFiltering] = React.useState(!isAlwaysWip && filterInputType === "value");
  const styles = ui.useStyles2(getStyles$e);
  const [filterMultiValues, setFilterMultiValues] = React.useState([]);
  const [_, setForceRefresh] = React.useState({});
  const { allowCustomValue = true, onAddCustomValue, filters, inputPlaceholder } = controller.useState();
  const multiValuePillWrapperRef = React.useRef(null);
  const hasMultiValueOperator = isMultiValueOperator((filter == null ? void 0 : filter.operator) || "");
  const isMultiValueEdit = hasMultiValueOperator && filterInputType === "value";
  const operatorIdentifier = React.useId();
  const listRef = React.useRef([]);
  const disabledIndicesRef = React.useRef([]);
  const filterInputTypeRef = React.useRef(!isAlwaysWip ? "value" : "key");
  const optionsSearcher = React.useMemo(() => getAdhocOptionSearcher(options), [options]);
  const isLastFilter = React.useMemo(() => {
    if (isAlwaysWip) {
      return false;
    }
    if (filters.at(-1) === filter) {
      return true;
    }
    return false;
  }, [filter, isAlwaysWip, filters]);
  const handleResetWip = React.useCallback(() => {
    if (isAlwaysWip) {
      controller.addWip();
      setInputType("key");
      setInputValue("");
    }
  }, [controller, isAlwaysWip]);
  const handleMultiValueFilterCommit = React.useCallback(
    (controller2, filter2, filterMultiValues2, preventFocus) => {
      var _a2;
      if (!filterMultiValues2.length && filter2.origin) {
        controller2.updateToMatchAll(filter2);
      }
      if (filterMultiValues2.length) {
        const valueLabels = [];
        const values = [];
        filterMultiValues2.forEach((item) => {
          var _a3;
          valueLabels.push((_a3 = item.label) != null ? _a3 : item.value);
          values.push(item.value);
        });
        let shouldUpdate = true;
        if (Array.isArray(filter2.values) && filter2.values.length === values.length) {
          shouldUpdate = !filter2.values.every((v, i) => v === values[i]);
        }
        if (shouldUpdate) {
          (_a2 = controller2.startProfile) == null ? void 0 : _a2.call(controller2, FILTER_CHANGED_INTERACTION);
        }
        controller2.updateFilter(filter2, { valueLabels, values, value: values[0] });
        setFilterMultiValues([]);
      }
      if (!preventFocus) {
        setTimeout(() => {
          var _a3;
          return (_a3 = refs.domReference.current) == null ? void 0 : _a3.focus();
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const handleLocalMultiValueChange = React.useCallback((selectedItem) => {
    setFilterMultiValues((items) => {
      if (items.some((item) => item.value === selectedItem.value)) {
        return items.filter((item) => item.value !== selectedItem.value);
      }
      return [...items, selectedItem];
    });
  }, []);
  const onOpenChange = React.useCallback(
    (nextOpen, _2, reason) => {
      setOpen(nextOpen);
      if (reason && ["outside-press", "escape-key"].includes(reason)) {
        if (isMultiValueEdit) {
          handleMultiValueFilterCommit(controller, filter, filterMultiValues);
        } else {
          if (filter && filter.origin && inputValue === "") {
            controller.updateToMatchAll(filter);
          }
        }
        handleResetWip();
        handleChangeViewMode == null ? void 0 : handleChangeViewMode();
      }
    },
    [
      filter,
      filterMultiValues,
      handleChangeViewMode,
      handleMultiValueFilterCommit,
      handleResetWip,
      inputValue,
      isMultiValueEdit,
      controller
    ]
  );
  const outsidePressIdsToIgnore = React.useMemo(() => {
    return [
      operatorIdentifier,
      ...filterMultiValues.reduce(
        (acc, item, i) => [...acc, `${item.value}-${i}`, `${item.value}-${i}-close-icon`],
        []
      )
    ];
  }, [operatorIdentifier, filterMultiValues]);
  const { refs, floatingStyles, context, getReferenceProps, getFloatingProps, getItemProps } = useFloatingInteractions({
    open,
    onOpenChange,
    activeIndex,
    setActiveIndex,
    outsidePressIdsToIgnore,
    listRef,
    disabledIndicesRef
  });
  React.useImperativeHandle(parentRef, () => () => {
    var _a2;
    return (_a2 = refs.domReference.current) == null ? void 0 : _a2.focus();
  }, [refs.domReference]);
  function onChange(event) {
    const value = event.target.value;
    setInputValue(value);
    const nextFilteredItems = flattenOptionGroups(handleOptionGroups(optionsSearcher(value)));
    if (!nextFilteredItems.length && allowCustomValue) {
      setActiveIndex(0);
    } else {
      setActiveIndex(getFirstSelectableIndex(nextFilteredItems));
    }
    if (preventFiltering) {
      setPreventFiltering(false);
    }
  }
  const handleRemoveMultiValue = React.useCallback(
    (item) => {
      setFilterMultiValues((selected) => selected.filter((option) => option.value !== item.value));
      setTimeout(() => {
        var _a2;
        return (_a2 = refs.domReference.current) == null ? void 0 : _a2.focus();
      });
    },
    [refs.domReference]
  );
  const filteredDropDownItems = flattenOptionGroups(
    handleOptionGroups(optionsSearcher(preventFiltering ? "" : inputValue))
  );
  const getFirstSelectableIndex = React.useCallback((items) => {
    const index = items.findIndex((item) => !item.options);
    return index >= 0 ? index : null;
  }, []);
  if (allowCustomValue && filterInputType !== "operator" && inputValue) {
    const operatorDefinition = OPERATORS.find((op) => (filter == null ? void 0 : filter.operator) === op.value);
    const customOptionValue = {
      value: inputValue.trim(),
      label: inputValue.trim(),
      isCustom: true
    };
    if (operatorDefinition == null ? void 0 : operatorDefinition.isRegex) {
      filteredDropDownItems.unshift(customOptionValue);
    } else {
      filteredDropDownItems.push(customOptionValue);
    }
  }
  const maxOptionWidth = setupDropdownAccessibility(filteredDropDownItems, listRef, disabledIndicesRef);
  const handleFetchOptions = React.useCallback(
    async (inputType) => {
      var _a2, _b2, _c2, _d;
      const interactionName = inputType === "key" ? ADHOC_KEYS_DROPDOWN_INTERACTION : ADHOC_VALUES_DROPDOWN_INTERACTION;
      if (inputType !== "operator") {
        (_a2 = controller.startInteraction) == null ? void 0 : _a2.call(controller, interactionName);
      }
      setOptionsError(false);
      setOptionsLoading(true);
      setOptions([]);
      let options2 = [];
      try {
        if (inputType === "key") {
          options2 = await controller.getKeys(null);
        } else if (inputType === "operator") {
          options2 = controller.getOperators();
        } else if (inputType === "value") {
          options2 = await controller.getValuesFor(filter);
        }
        if (filterInputTypeRef.current !== inputType) {
          (_b2 = controller.stopInteraction) == null ? void 0 : _b2.call(controller);
          return;
        }
        setOptions(options2);
        if ((_c2 = options2[0]) == null ? void 0 : _c2.group) {
          setActiveIndex(1);
        } else {
          setActiveIndex(0);
        }
      } catch (e) {
        setOptionsError(true);
      }
      setOptionsLoading(false);
      (_d = controller.stopInteraction) == null ? void 0 : _d.call(controller);
    },
    [filter, controller]
  );
  const rowVirtualizer = reactVirtual.useVirtualizer({
    count: filteredDropDownItems.length,
    getScrollElement: () => refs.floating.current,
    estimateSize: (index) => filteredDropDownItems[index].description ? VIRTUAL_LIST_ITEM_HEIGHT_WITH_DESCRIPTION : VIRTUAL_LIST_ITEM_HEIGHT,
    overscan: VIRTUAL_LIST_OVERSCAN
  });
  const handleBackspaceInput = React.useCallback(
    (event, multiValueEdit) => {
      var _a2;
      if (event.key === "Backspace" && !inputValue) {
        if (filterInputType === "value") {
          if (multiValueEdit) {
            if (filterMultiValues.length) {
              setFilterMultiValues((items) => {
                const updated = [...items];
                updated.splice(-1, 1);
                return updated;
              });
              return;
            }
          }
          if (filter == null ? void 0 : filter.origin) {
            return;
          }
          setInputType("operator");
          return;
        }
        if (filterInputType === "operator") {
          event.preventDefault();
          setInputValue("");
          if (filter) {
            controller.updateFilter(filter, {
              key: "",
              keyLabel: "",
              operator: "",
              value: "",
              valueLabels: [],
              values: void 0
            });
          }
          switchInputType("key", setInputType, void 0, refs.domReference.current);
          return;
        }
        focusOnWipInputRef == null ? void 0 : focusOnWipInputRef();
        if (isFilterComplete(filter)) {
          (_a2 = controller.startProfile) == null ? void 0 : _a2.call(controller, FILTER_REMOVED_INTERACTION);
        }
        setOpen(false);
        controller.handleComboboxBackspace(filter);
        if (isAlwaysWip) {
          handleResetWip();
        }
      }
    },
    [
      inputValue,
      filterInputType,
      focusOnWipInputRef,
      filter,
      controller,
      isAlwaysWip,
      filterMultiValues.length,
      refs.domReference,
      handleResetWip
    ]
  );
  const handleTabInput = React.useCallback(
    (event, multiValueEdit) => {
      var _a2;
      if (event.key === "Tab" && !event.shiftKey) {
        if (multiValueEdit) {
          event.preventDefault();
          handleMultiValueFilterCommit(controller, filter, filterMultiValues);
          (_a2 = refs.domReference.current) == null ? void 0 : _a2.focus();
        }
        handleChangeViewMode == null ? void 0 : handleChangeViewMode();
        handleResetWip();
      }
    },
    [
      filter,
      filterMultiValues,
      handleChangeViewMode,
      handleMultiValueFilterCommit,
      handleResetWip,
      controller,
      refs.domReference
    ]
  );
  const handleShiftTabInput = React.useCallback(
    (event, multiValueEdit) => {
      if (event.key === "Tab" && event.shiftKey) {
        if (multiValueEdit) {
          event.preventDefault();
          handleMultiValueFilterCommit(controller, filter, filterMultiValues, true);
        }
        handleChangeViewMode == null ? void 0 : handleChangeViewMode();
        handleResetWip();
      }
    },
    [filter, filterMultiValues, handleChangeViewMode, handleMultiValueFilterCommit, handleResetWip, controller]
  );
  const handleEnterInput = React.useCallback(
    (event, multiValueEdit) => {
      var _a2;
      if (event.key === "Enter" && activeIndex != null) {
        if (!filteredDropDownItems[activeIndex]) {
          return;
        }
        const selectedItem = filteredDropDownItems[activeIndex];
        if (multiValueEdit) {
          handleLocalMultiValueChange(selectedItem);
          setInputValue("");
        } else {
          const payload = generateFilterUpdatePayload({
            filterInputType,
            item: selectedItem,
            filter,
            setFilterMultiValues,
            onAddCustomValue
          });
          if (filterInputType === "value" && payload.value !== (filter == null ? void 0 : filter.value)) {
            (_a2 = controller.startProfile) == null ? void 0 : _a2.call(controller, FILTER_CHANGED_INTERACTION);
          }
          controller.updateFilter(filter, payload);
          populateInputValueOnInputTypeSwitch({
            populateInputOnEdit,
            item: selectedItem,
            filterInputType,
            setInputValue,
            filter
          });
          switchToNextInputType(
            filterInputType,
            setInputType,
            handleChangeViewMode,
            refs.domReference.current,
            // preventing focus on filter pill only when last filter for better backspace experience
            isLastFilter ? false : void 0
          );
          setActiveIndex(null);
          if (isLastFilter) {
            focusOnWipInputRef == null ? void 0 : focusOnWipInputRef();
          }
        }
      }
    },
    [
      activeIndex,
      filteredDropDownItems,
      handleLocalMultiValueChange,
      controller,
      filter,
      filterInputType,
      populateInputOnEdit,
      handleChangeViewMode,
      refs.domReference,
      isLastFilter,
      focusOnWipInputRef,
      onAddCustomValue
    ]
  );
  const handleEditMultiValuePill = React.useCallback(
    (value) => {
      var _a2;
      const valueLabel = value.label || value.value;
      setFilterMultiValues((prev) => prev.filter((item) => item.value !== value.value));
      setPreventFiltering(true);
      setInputValue(valueLabel);
      (_a2 = refs.domReference.current) == null ? void 0 : _a2.focus();
      setTimeout(() => {
        var _a3;
        (_a3 = refs.domReference.current) == null ? void 0 : _a3.select();
      });
    },
    [refs.domReference]
  );
  React.useEffect(() => {
    if (open) {
      handleFetchOptions(filterInputType);
    }
  }, [open, filterInputType]);
  React.useEffect(() => {
    var _a2, _b2, _c2, _d;
    if (!isAlwaysWip) {
      if (hasMultiValueOperator && ((_a2 = filter == null ? void 0 : filter.values) == null ? void 0 : _a2.length)) {
        const multiValueOptions = filter.values.reduce(
          (acc, value, i) => {
            var _a3;
            return [
              ...acc,
              {
                label: ((_a3 = filter.valueLabels) == null ? void 0 : _a3[i]) || value,
                value
              }
            ];
          },
          []
        );
        setFilterMultiValues(multiValueOptions);
      }
      if (!hasMultiValueOperator && populateInputOnEdit) {
        setInputValue((_c2 = (_b2 = filter == null ? void 0 : filter.valueLabels) == null ? void 0 : _b2[0]) != null ? _c2 : (filter == null ? void 0 : filter.value) || "");
        setTimeout(() => {
          var _a3;
          (_a3 = refs.domReference.current) == null ? void 0 : _a3.select();
        });
      }
      (_d = refs.domReference.current) == null ? void 0 : _d.focus();
    }
  }, []);
  React.useEffect(() => {
    if (isMultiValueEdit && filterMultiValues) {
      setTimeout(() => setForceRefresh({}));
    }
  }, [filterMultiValues, isMultiValueEdit]);
  React.useLayoutEffect(() => {
    if (filterInputTypeRef.current) {
      filterInputTypeRef.current = filterInputType;
    }
  }, [filterInputType]);
  React.useLayoutEffect(() => {
    var _a2, _b2;
    if (activeIndex !== null && rowVirtualizer.range && (activeIndex > ((_a2 = rowVirtualizer.range) == null ? void 0 : _a2.endIndex) || activeIndex < ((_b2 = rowVirtualizer.range) == null ? void 0 : _b2.startIndex))) {
      rowVirtualizer.scrollToIndex(activeIndex);
    }
  }, [activeIndex, rowVirtualizer]);
  const keyLabel = (_a = filter == null ? void 0 : filter.keyLabel) != null ? _a : filter == null ? void 0 : filter.key;
  return /* @__PURE__ */ React__default.default.createElement("div", { className: styles.comboboxWrapper }, filter ? /* @__PURE__ */ React__default.default.createElement("div", { className: styles.pillWrapper }, (filter == null ? void 0 : filter.key) ? /* @__PURE__ */ React__default.default.createElement("div", { className: css.cx(styles.basePill, styles.keyPill) }, keyLabel) : null, (filter == null ? void 0 : filter.key) && (filter == null ? void 0 : filter.operator) && filterInputType !== "operator" ? /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      id: operatorIdentifier,
      className: css.cx(
        styles.basePill,
        !filter.origin && styles.operatorPill,
        filter.origin && styles.keyPill,
        operatorIdentifier
      ),
      "aria-label": i18n.t(
        "grafana-scenes.variables.ad-hoc-combobox.aria-label-edit-filter-operator",
        "Edit filter operator"
      ),
      tabIndex: filter.origin ? -1 : 0,
      onClick: (event) => {
        if (filter.origin) {
          handleChangeViewMode == null ? void 0 : handleChangeViewMode();
          return;
        }
        event.stopPropagation();
        setInputValue("");
        switchInputType("operator", setInputType, void 0, refs.domReference.current);
      },
      onKeyDown: (event) => {
        if (filter.origin) {
          return;
        }
        handleShiftTabInput(event, hasMultiValueOperator);
        if (event.key === "Enter") {
          setInputValue("");
          switchInputType("operator", setInputType, void 0, refs.domReference.current);
        }
      },
      ...!filter.origin && { role: "button" }
    },
    filter.operator
  ) : null, /* @__PURE__ */ React__default.default.createElement("div", { ref: multiValuePillWrapperRef }), isMultiValueEdit ? filterMultiValues.map((item, i) => /* @__PURE__ */ React__default.default.createElement(
    MultiValuePill,
    {
      key: `${item.value}-${i}`,
      item,
      index: i,
      handleRemoveMultiValue,
      handleEditMultiValuePill
    }
  )) : null) : null, /* @__PURE__ */ React__default.default.createElement(
    "input",
    {
      ...getReferenceProps({
        ref: refs.setReference,
        onChange,
        value: inputValue,
        // dynamic placeholder to display operator and/or value in filter edit mode
        placeholder: generatePlaceholder(filter, filterInputType, isMultiValueEdit, isAlwaysWip, inputPlaceholder),
        "aria-autocomplete": "list",
        onKeyDown(event) {
          if (!open) {
            setOpen(true);
            return;
          }
          if (filterInputType === "operator") {
            handleShiftTabInput(event);
          }
          handleBackspaceInput(event, isMultiValueEdit);
          handleTabInput(event, isMultiValueEdit);
          handleEnterInput(event, isMultiValueEdit);
        }
      }),
      className: css.cx(styles.inputStyle, { [styles.loadingInputPadding]: !optionsLoading }),
      onClick: (event) => {
        event.stopPropagation();
        onInputClick == null ? void 0 : onInputClick();
        setOpen(true);
      },
      onFocus: () => {
        setOpen(true);
      }
    }
  ), optionsLoading ? /* @__PURE__ */ React__default.default.createElement(ui.Spinner, { className: styles.loadingIndicator, inline: true }) : null, /* @__PURE__ */ React__default.default.createElement(react$1.FloatingPortal, null, open && /* @__PURE__ */ React__default.default.createElement(react$1.FloatingFocusManager, { context, initialFocus: -1, visuallyHiddenDismiss: true, modal: true }, /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      style: {
        ...floatingStyles,
        width: `${optionsError ? ERROR_STATE_DROPDOWN_WIDTH : maxOptionWidth}px`,
        transform: isMultiValueEdit ? `translate(${((_b = multiValuePillWrapperRef.current) == null ? void 0 : _b.getBoundingClientRect().left) || 0}px, ${(((_c = refs.domReference.current) == null ? void 0 : _c.getBoundingClientRect().bottom) || 0) + 10}px )` : floatingStyles.transform
      },
      ref: refs.setFloating,
      className: styles.dropdownWrapper,
      tabIndex: -1
    },
    /* @__PURE__ */ React__default.default.createElement(
      "div",
      {
        style: {
          height: `${rowVirtualizer.getTotalSize() || VIRTUAL_LIST_ITEM_HEIGHT}px`
          // fallback to 38px for loading/error/no options placeholders
        },
        ...getFloatingProps(),
        tabIndex: -1
      },
      optionsLoading ? /* @__PURE__ */ React__default.default.createElement(LoadingOptionsPlaceholder, null) : optionsError ? /* @__PURE__ */ React__default.default.createElement(OptionsErrorPlaceholder, { handleFetchOptions: () => handleFetchOptions(filterInputType) }) : !filteredDropDownItems.length && (!allowCustomValue || filterInputType === "operator" || !inputValue) ? /* @__PURE__ */ React__default.default.createElement(NoOptionsPlaceholder, null) : rowVirtualizer.getVirtualItems().map((virtualItem) => {
        var _a2;
        const item = filteredDropDownItems[virtualItem.index];
        const index = virtualItem.index;
        if (item.options) {
          return /* @__PURE__ */ React__default.default.createElement(
            "div",
            {
              key: `${item.label}+${index}`,
              className: css.cx(styles.optionGroupLabel, styles.groupTopBorder),
              style: {
                height: `${virtualItem.size}px`,
                transform: `translateY(${virtualItem.start}px)`
              }
            },
            /* @__PURE__ */ React__default.default.createElement(ui.Text, { weight: "bold", variant: "bodySmall", color: "secondary" }, item.label)
          );
        }
        const nextItem = filteredDropDownItems[virtualItem.index + 1];
        const shouldAddBottomBorder = nextItem && !nextItem.group && !nextItem.options && item.group;
        const itemLabel = (_a2 = item.label) != null ? _a2 : item.value;
        return (
          // key is included in getItemProps()
          // eslint-disable-next-line react/jsx-key
          /* @__PURE__ */ React__default.default.createElement(
            DropdownItem,
            {
              ...getItemProps({
                key: `${item.value}-${index}`,
                ref(node) {
                  listRef.current[index] = node;
                },
                onClick(event) {
                  var _a3, _b2;
                  if (filterInputType !== "value") {
                    event.stopPropagation();
                  }
                  if (isMultiValueEdit) {
                    event.preventDefault();
                    event.stopPropagation();
                    handleLocalMultiValueChange(item);
                    setInputValue("");
                    (_a3 = refs.domReference.current) == null ? void 0 : _a3.focus();
                  } else {
                    const payload = generateFilterUpdatePayload({
                      filterInputType,
                      item,
                      filter,
                      setFilterMultiValues,
                      onAddCustomValue
                    });
                    if (filterInputType === "value" && payload.value !== (filter == null ? void 0 : filter.value)) {
                      (_b2 = controller.startProfile) == null ? void 0 : _b2.call(controller, FILTER_CHANGED_INTERACTION);
                    }
                    controller.updateFilter(filter, payload);
                    populateInputValueOnInputTypeSwitch({
                      populateInputOnEdit,
                      item,
                      filterInputType,
                      setInputValue,
                      filter
                    });
                    switchToNextInputType(
                      filterInputType,
                      setInputType,
                      handleChangeViewMode,
                      refs.domReference.current,
                      // explicitly preventing focus on filter pill due to a11y error
                      false
                    );
                  }
                }
              }),
              active: activeIndex === index,
              addGroupBottomBorder: shouldAddBottomBorder,
              style: {
                height: `${virtualItem.size}px`,
                transform: `translateY(${virtualItem.start}px)`
              },
              "aria-setsize": filteredDropDownItems.length,
              "aria-posinset": virtualItem.index + 1,
              isMultiValueEdit,
              checked: filterMultiValues.some((val) => val.value === item.value)
            },
            /* @__PURE__ */ React__default.default.createElement("span", null, item.isCustom ? i18n.t(
              "grafana-scenes.components.adhoc-filters-combobox.use-custom-value",
              "Use custom value: {{itemLabel}}",
              { itemLabel, interpolation: { escapeValue: false } }
            ) : itemLabel),
            item.description ? /* @__PURE__ */ React__default.default.createElement("div", { className: styles.descriptionText }, item.description) : null
          )
        );
      })
    )
  ), isMultiValueEdit && !optionsLoading && !optionsError && filteredDropDownItems.length ? /* @__PURE__ */ React__default.default.createElement(
    MultiValueApplyButton,
    {
      onApply: () => {
        handleMultiValueFilterCommit(controller, filter, filterMultiValues);
        handleResetWip();
        handleChangeViewMode == null ? void 0 : handleChangeViewMode();
        setOpen(false);
      },
      floatingElement: refs.floating.current,
      maxOptionWidth,
      menuHeight: Math.min(rowVirtualizer.getTotalSize(), MAX_MENU_HEIGHT)
    }
  ) : null))));
});
const getStyles$e = (theme) => ({
  comboboxWrapper: css.css({
    display: "flex",
    flexWrap: "wrap"
  }),
  pillWrapper: css.css({
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap"
  }),
  basePill: css.css({
    display: "flex",
    alignItems: "center",
    background: theme.colors.action.disabledBackground,
    border: `1px solid ${theme.colors.border.weak}`,
    padding: theme.spacing(0.125, 1, 0.125, 1),
    color: theme.colors.text.primary,
    overflow: "hidden",
    whiteSpace: "nowrap",
    minHeight: theme.spacing(2.75),
    ...theme.typography.bodySmall,
    cursor: "pointer"
  }),
  keyPill: css.css({
    fontWeight: theme.typography.fontWeightBold,
    cursor: "default"
  }),
  operatorPill: css.css({
    "&:hover": {
      background: theme.colors.action.hover
    }
  }),
  dropdownWrapper: css.css({
    backgroundColor: theme.colors.background.primary,
    color: theme.colors.text.primary,
    boxShadow: theme.shadows.z2,
    overflowY: "auto",
    zIndex: theme.zIndex.portal
  }),
  inputStyle: css.css({
    paddingBlock: 0,
    "&:focus": {
      outline: "none"
    }
  }),
  loadingIndicator: css.css({
    color: theme.colors.text.secondary,
    marginLeft: theme.spacing(0.5)
  }),
  loadingInputPadding: css.css({
    paddingRight: theme.spacing(2.5)
  }),
  optionGroupLabel: css.css({
    padding: theme.spacing(1),
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%"
  }),
  groupTopBorder: css.css({
    "&:not(:first-child)": {
      borderTop: `1px solid ${theme.colors.border.weak}`
    }
  }),
  descriptionText: css.css({
    ...theme.typography.bodySmall,
    color: theme.colors.text.secondary,
    paddingTop: theme.spacing(0.5)
  })
});

const LABEL_MAX_VISIBLE_LENGTH = 20;
function AdHocFilterPill({ filter, controller, readOnly, focusOnWipInputRef }) {
  var _a, _b, _c, _d;
  const styles = ui.useStyles2(getStyles$d);
  const [viewMode, setViewMode] = React.useState(true);
  const [shouldFocusOnPillWrapper, setShouldFocusOnPillWrapper] = React.useState(false);
  const pillWrapperRef = React.useRef(null);
  const [populateInputOnEdit, setPopulateInputOnEdit] = React.useState(false);
  const keyLabel = (_a = filter.keyLabel) != null ? _a : filter.key;
  const valueLabel = ((_b = filter.valueLabels) == null ? void 0 : _b.join(", ")) || ((_c = filter.values) == null ? void 0 : _c.join(", ")) || filter.value;
  const handleChangeViewMode = React.useCallback(
    (event, shouldFocusOnPillWrapperOverride) => {
      event == null ? void 0 : event.stopPropagation();
      if (readOnly) {
        return;
      }
      setShouldFocusOnPillWrapper(shouldFocusOnPillWrapperOverride != null ? shouldFocusOnPillWrapperOverride : !viewMode);
      setViewMode(!viewMode);
    },
    [readOnly, viewMode]
  );
  React.useEffect(() => {
    var _a2;
    if (shouldFocusOnPillWrapper) {
      (_a2 = pillWrapperRef.current) == null ? void 0 : _a2.focus();
      setShouldFocusOnPillWrapper(false);
    }
  }, [shouldFocusOnPillWrapper]);
  React.useEffect(() => {
    if (filter.forceEdit && viewMode) {
      setViewMode(false);
      controller.updateFilter(filter, { forceEdit: void 0 });
    }
  }, [filter, controller, viewMode]);
  React.useEffect(() => {
    if (viewMode) {
      setPopulateInputOnEdit((prevValue) => prevValue ? false : prevValue);
    }
  }, [viewMode]);
  React.useEffect(() => {
    if (viewMode && !readOnly && !filter.origin && !filter.key && !filter.operator && !filter.value) {
      controller.removeFilter(filter);
      setTimeout(() => focusOnWipInputRef == null ? void 0 : focusOnWipInputRef());
    }
  }, [controller, filter, focusOnWipInputRef, readOnly, viewMode]);
  const getOriginFilterTooltips = (origin) => {
    if (origin === "dashboard") {
      return {
        info: "Applied by default in this dashboard. If edited, it carries over to other dashboards.",
        restore: "Restore the value set by this dashboard."
      };
    } else if (origin === "scope") {
      return {
        info: "Applied automatically from your selected scope.",
        restore: "Restore the value set by your selected scope."
      };
    } else {
      return {
        info: `This is a ${origin} injected filter.`,
        restore: `Restore filter to its original value.`
      };
    }
  };
  const cleanFilter = !filter.restorable && !filter.readOnly && !filter.nonApplicable;
  if (viewMode) {
    const pillTextContent = `${keyLabel} ${filter.operator} ${valueLabel}`;
    const pillText = /* @__PURE__ */ React__default.default.createElement("span", { className: css.cx(styles.pillText, filter.nonApplicable && styles.strikethrough) }, pillTextContent);
    return /* @__PURE__ */ React__default.default.createElement(
      "div",
      {
        className: css.cx(
          styles.combinedFilterPill,
          readOnly && styles.readOnlyCombinedFilter,
          (isMatchAllFilter(filter) || filter.nonApplicable) && styles.disabledPill,
          filter.readOnly && styles.filterReadOnly
        ),
        onClick: (e) => {
          e.stopPropagation();
          setPopulateInputOnEdit(true);
          handleChangeViewMode();
        },
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            setPopulateInputOnEdit(true);
            handleChangeViewMode();
          }
        },
        role: readOnly ? void 0 : "button",
        "aria-label": i18n.t(
          "grafana-scenes.components.adhoc-filter-pill.edit-filter-with-key",
          "Edit filter with key {{keyLabel}}",
          {
            keyLabel
          }
        ),
        tabIndex: 0,
        ref: pillWrapperRef
      },
      pillTextContent.length < LABEL_MAX_VISIBLE_LENGTH ? pillText : /* @__PURE__ */ React__default.default.createElement(ui.Tooltip, { content: /* @__PURE__ */ React__default.default.createElement("div", { className: styles.tooltipText }, pillTextContent), placement: "top" }, pillText),
      !readOnly && !filter.matchAllFilter && (!filter.origin || filter.origin === "dashboard") ? /* @__PURE__ */ React__default.default.createElement(
        ui.IconButton,
        {
          onClick: (e) => {
            e.stopPropagation();
            if (filter.origin && filter.origin === "dashboard") {
              controller.updateToMatchAll(filter);
            } else {
              controller.removeFilter(filter);
            }
            setTimeout(() => focusOnWipInputRef == null ? void 0 : focusOnWipInputRef());
          },
          onKeyDownCapture: (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              e.stopPropagation();
              if (filter.origin && filter.origin === "dashboard") {
                controller.updateToMatchAll(filter);
              } else {
                controller.removeFilter(filter);
              }
              setTimeout(() => focusOnWipInputRef == null ? void 0 : focusOnWipInputRef());
            }
          },
          name: "times",
          size: "md",
          className: css.cx(styles.pillIcon, filter.nonApplicable && styles.disabledPillIcon),
          tooltip: i18n.t(
            "grafana-scenes.components.adhoc-filter-pill.remove-filter-with-key",
            "Remove filter with key {{keyLabel}}",
            {
              keyLabel
            }
          )
        }
      ) : null,
      filter.origin && filter.readOnly && /* @__PURE__ */ React__default.default.createElement(
        ui.Tooltip,
        {
          content: i18n.t("grafana-scenes.components.adhoc-filter-pill.managed-filter", "{{origin}} managed filter", {
            origin: filter.origin
          }),
          placement: "bottom"
        },
        /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: "lock", size: "md", className: styles.readOnlyPillIcon })
      ),
      filter.origin && cleanFilter && /* @__PURE__ */ React__default.default.createElement(ui.Tooltip, { content: getOriginFilterTooltips(filter.origin).info, placement: "bottom" }, /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: "info-circle", size: "md", className: styles.infoPillIcon })),
      filter.origin && filter.restorable && !filter.readOnly && /* @__PURE__ */ React__default.default.createElement(
        ui.IconButton,
        {
          onClick: (e) => {
            e.stopPropagation();
            controller.restoreOriginalFilter(filter);
          },
          onKeyDownCapture: (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              e.stopPropagation();
              controller.restoreOriginalFilter(filter);
            }
          },
          name: "history",
          size: "md",
          className: isMatchAllFilter(filter) ? styles.matchAllPillIcon : styles.pillIcon,
          tooltip: getOriginFilterTooltips(filter.origin).restore
        }
      ),
      filter.nonApplicable && /* @__PURE__ */ React__default.default.createElement(
        ui.Tooltip,
        {
          content: (_d = filter.nonApplicableReason) != null ? _d : i18n.t("grafana-scenes.components.adhoc-filter-pill.non-applicable", "Filter is not applicable"),
          placement: "bottom"
        },
        /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: "info-circle", size: "md", className: styles.infoPillIcon })
      )
    );
  }
  return /* @__PURE__ */ React__default.default.createElement(
    AdHocCombobox,
    {
      filter,
      controller,
      handleChangeViewMode,
      focusOnWipInputRef,
      populateInputOnEdit
    }
  );
}
const getStyles$d = (theme) => ({
  combinedFilterPill: css.css({
    display: "flex",
    alignItems: "center",
    background: theme.colors.action.selected,
    borderRadius: theme.shape.radius.default,
    border: `1px solid ${theme.colors.border.weak}`,
    padding: theme.spacing(0.125, 0, 0.125, 1),
    color: theme.colors.text.primary,
    overflow: "hidden",
    whiteSpace: "nowrap",
    minHeight: theme.spacing(2.75),
    ...theme.typography.bodySmall,
    fontWeight: theme.typography.fontWeightBold,
    cursor: "pointer",
    "&:hover": {
      background: theme.colors.action.hover
    }
  }),
  readOnlyCombinedFilter: css.css({
    paddingRight: theme.spacing(1),
    cursor: "text",
    "&:hover": {
      background: theme.colors.action.selected
    }
  }),
  filterReadOnly: css.css({
    background: theme.colors.background.canvas,
    cursor: "text",
    "&:hover": {
      background: theme.colors.background.canvas
    }
  }),
  pillIcon: css.css({
    marginInline: theme.spacing(0.5),
    cursor: "pointer",
    "&:hover": {
      color: theme.colors.text.primary
    }
  }),
  pillText: css.css({
    maxWidth: "200px",
    width: "100%",
    textOverflow: "ellipsis",
    overflow: "hidden"
  }),
  tooltipText: css.css({
    textAlign: "center"
  }),
  infoPillIcon: css.css({
    marginInline: theme.spacing(0.5),
    cursor: "pointer"
  }),
  readOnlyPillIcon: css.css({
    marginInline: theme.spacing(0.5)
  }),
  matchAllPillIcon: css.css({
    marginInline: theme.spacing(0.5),
    cursor: "pointer",
    color: theme.colors.text.disabled
  }),
  disabledPillIcon: css.css({
    marginInline: theme.spacing(0.5),
    cursor: "pointer",
    color: theme.colors.text.disabled,
    "&:hover": {
      color: theme.colors.text.disabled
    }
  }),
  ...getNonApplicablePillStyles(theme)
});

const AdHocFiltersAlwaysWipCombobox = React.forwardRef(function AdHocFiltersAlwaysWipCombobox2({ controller, onInputClick }, parentRef) {
  const { wip } = controller.useState();
  React.useLayoutEffect(() => {
    if (!wip) {
      controller.addWip();
    }
  }, [wip]);
  return /* @__PURE__ */ React__default.default.createElement(AdHocCombobox, { controller, filter: wip, isAlwaysWip: true, ref: parentRef, onInputClick });
});

const MAX_VISIBLE_FILTERS = 5;
const AdHocFiltersComboboxRenderer = React.memo(function AdHocFiltersComboboxRenderer2({ controller }) {
  var _a;
  const { originFilters, filters, readOnly, collapsible, valueRecommendations } = controller.useState();
  const styles = ui.useStyles2(getStyles$c);
  const theme = ui.useTheme2();
  const [collapsed, setCollapsed] = React.useState(true);
  const [wrapperRef, { height: wrapperHeight }] = reactUse.useMeasure();
  const clearAll = () => {
    var _a2;
    (_a2 = controller.clearAll) == null ? void 0 : _a2.call(controller);
  };
  const focusOnWipInputRef = React.useRef();
  const singleLineThreshold = theme.spacing.gridSize * 5;
  const isMultiLine = collapsible && wrapperHeight > singleLineThreshold;
  const handleCollapseToggle = (event) => {
    event.stopPropagation();
    if (collapsible) {
      setCollapsed(true);
    }
  };
  const handleExpand = () => {
    var _a2, _b;
    if (!collapsible) {
      (_a2 = focusOnWipInputRef.current) == null ? void 0 : _a2.call(focusOnWipInputRef);
      return;
    }
    if (collapsed) {
      setCollapsed(false);
    } else {
      (_b = focusOnWipInputRef.current) == null ? void 0 : _b.call(focusOnWipInputRef);
    }
  };
  const visibleOriginFilters = (_a = originFilters == null ? void 0 : originFilters.filter((f) => f.origin)) != null ? _a : [];
  const visibleFilters = filters.filter((f) => !f.hidden);
  const allFilters = [...visibleOriginFilters, ...visibleFilters];
  const totalFiltersCount = allFilters.length;
  const shouldCollapse = collapsible && collapsed && totalFiltersCount > 0;
  const filtersToRender = shouldCollapse ? allFilters.slice(0, MAX_VISIBLE_FILTERS) : allFilters;
  React.useEffect(() => {
    if (collapsible && totalFiltersCount === 0 && collapsed) {
      setCollapsed(false);
    }
  }, [collapsible, totalFiltersCount, collapsed]);
  const showCollapseButton = collapsible && isMultiLine && !collapsed;
  return /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      ref: wrapperRef,
      className: css.cx(styles.comboboxWrapper, {
        [styles.comboboxFocusOutline]: !readOnly,
        [styles.collapsed]: shouldCollapse,
        [styles.clickableCollapsed]: shouldCollapse
      }),
      onClick: handleExpand
    },
    /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: "filter", className: styles.filterIcon, size: "lg" }),
    valueRecommendations && /* @__PURE__ */ React__default.default.createElement(valueRecommendations.Component, { model: valueRecommendations }),
    filtersToRender.map((filter, index) => /* @__PURE__ */ React__default.default.createElement(
      AdHocFilterPill,
      {
        key: `${filter.origin ? "origin-" : ""}${index}-${filter.key}`,
        filter,
        controller,
        readOnly: readOnly || filter.readOnly,
        focusOnWipInputRef: focusOnWipInputRef.current
      }
    )),
    !readOnly && !shouldCollapse ? /* @__PURE__ */ React__default.default.createElement(AdHocFiltersAlwaysWipCombobox, { controller, ref: focusOnWipInputRef }) : null,
    /* @__PURE__ */ React__default.default.createElement("div", { className: styles.rightControls }, showCollapseButton && /* @__PURE__ */ React__default.default.createElement(
      ui.Button,
      {
        className: styles.collapseButton,
        fill: "text",
        onClick: handleCollapseToggle,
        "aria-label": i18n.t(
          "grafana-scenes.variables.adhoc-filters-combobox-renderer.collapse-filters",
          "Collapse filters"
        ),
        "aria-expanded": !collapsed
      },
      i18n.t("grafana-scenes.variables.adhoc-filters-combobox-renderer.collapse", "Collapse"),
      /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: "angle-up", size: "md" })
    ), /* @__PURE__ */ React__default.default.createElement("div", { className: styles.clearAllButton }, /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: "times", size: "md", onClick: clearAll })), shouldCollapse && /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, totalFiltersCount > MAX_VISIBLE_FILTERS && /* @__PURE__ */ React__default.default.createElement("span", { className: styles.moreIndicator }, "(+", totalFiltersCount - MAX_VISIBLE_FILTERS, ")"), /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: "angle-down", className: styles.dropdownIndicator })))
  );
});
const getStyles$c = (theme) => ({
  comboboxWrapper: css.css({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    columnGap: theme.spacing(1),
    rowGap: theme.spacing(0.5),
    minHeight: theme.spacing(4),
    backgroundColor: theme.components.input.background,
    border: `1px solid ${theme.colors.border.strong}`,
    borderRadius: theme.shape.radius.default,
    paddingInline: theme.spacing(1),
    paddingBlock: theme.spacing(0.5),
    flexGrow: 1,
    width: "100%"
  }),
  comboboxFocusOutline: css.css({
    "&:focus-within": {
      outline: "2px dotted transparent",
      outlineOffset: "2px",
      boxShadow: `0 0 0 2px ${theme.colors.background.canvas}, 0 0 0px 4px ${theme.colors.primary.main}`,
      transitionTimingFunction: `cubic-bezier(0.19, 1, 0.22, 1)`,
      transitionDuration: "0.2s",
      transitionProperty: "outline, outline-offset, box-shadow",
      zIndex: 2
    }
  }),
  filterIcon: css.css({
    color: theme.colors.text.secondary,
    alignSelf: "center"
  }),
  collapsed: css.css({
    flexWrap: "nowrap",
    overflow: "hidden"
  }),
  clickableCollapsed: css.css({
    cursor: "pointer",
    "&:hover": {
      borderColor: theme.colors.border.medium
    }
  }),
  rightControls: css.css({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    flexShrink: 0
  }),
  moreIndicator: css.css({
    color: theme.colors.text.secondary,
    whiteSpace: "nowrap"
  }),
  dropdownIndicator: css.css({
    color: theme.colors.text.secondary,
    flexShrink: 0
  }),
  collapseButton: css.css({
    color: theme.colors.text.secondary,
    padding: 0,
    fontSize: theme.typography.bodySmall.fontSize,
    border: "none",
    "&:hover": {
      background: "transparent",
      color: theme.colors.text.primary
    }
  }),
  clearAllButton: css.css({
    fontSize: theme.typography.bodySmall.fontSize,
    cursor: "pointer",
    color: theme.colors.text.secondary,
    "&:hover": {
      color: theme.colors.text.primary
    }
  })
});

const reverseScopeFilterOperatorMap = Object.fromEntries(
  Object.entries(data.scopeFilterOperatorMap).map(([symbol, operator]) => [operator, symbol])
);
function isEqualityOrMultiOperator(value) {
  const operators = /* @__PURE__ */ new Set(["equals", "not-equals", "one-of", "not-one-of"]);
  return operators.has(value);
}
function isRegexOperator(value) {
  const operators = /* @__PURE__ */ new Set(["regex-match", "regex-not-match"]);
  return operators.has(value);
}
function getAdHocFiltersFromScopes(scopes) {
  const formattedFilters = /* @__PURE__ */ new Map();
  const duplicatedFilters = [];
  const allFilters = scopes.flatMap((scope) => scope.spec.filters);
  for (const filter of allFilters) {
    processFilter(formattedFilters, duplicatedFilters, filter);
  }
  return [...formattedFilters.values(), ...duplicatedFilters];
}
function processFilter(formattedFilters, duplicatedFilters, filter) {
  var _a, _b;
  if (!filter) {
    return;
  }
  const existingFilter = formattedFilters.get(filter.key);
  if (existingFilter && isEqualityValue(existingFilter.operator, filter.operator)) {
    mergeFilterValues(existingFilter, filter);
  } else if (existingFilter && isRegexValue(existingFilter.operator, filter.operator)) {
    existingFilter.value += `|${filter.value}`;
    existingFilter.values = [existingFilter.value];
  } else if (!existingFilter) {
    formattedFilters.set(filter.key, {
      key: filter.key,
      operator: reverseScopeFilterOperatorMap[filter.operator],
      value: filter.value,
      values: (_a = filter.values) != null ? _a : [filter.value],
      origin: "scope"
    });
  } else {
    duplicatedFilters.push({
      key: filter.key,
      operator: reverseScopeFilterOperatorMap[filter.operator],
      value: filter.value,
      values: (_b = filter.values) != null ? _b : [filter.value],
      origin: "scope"
    });
  }
}
function mergeFilterValues(adHocFilter, filter) {
  var _a, _b, _c, _d;
  const values = (_a = filter.values) != null ? _a : [filter.value];
  for (const value of values) {
    if (!((_b = adHocFilter.values) == null ? void 0 : _b.includes(value))) {
      (_c = adHocFilter.values) == null ? void 0 : _c.push(value);
    }
  }
  if (((_d = adHocFilter.values) == null ? void 0 : _d.length) === 1) {
    return;
  }
  if (filter.operator === "equals" && adHocFilter.operator === reverseScopeFilterOperatorMap["equals"]) {
    adHocFilter.operator = reverseScopeFilterOperatorMap["one-of"];
  } else if (filter.operator === "not-equals" && adHocFilter.operator === reverseScopeFilterOperatorMap["not-equals"]) {
    adHocFilter.operator = reverseScopeFilterOperatorMap["not-one-of"];
  }
}
function isRegexValue(adHocFilterOperator, filterOperator) {
  const scopeConvertedOperator = data.scopeFilterOperatorMap[adHocFilterOperator];
  if (!isRegexOperator(scopeConvertedOperator) || !isRegexOperator(filterOperator)) {
    return false;
  }
  return hasSameOperators(scopeConvertedOperator, filterOperator);
}
function isEqualityValue(adHocFilterOperator, filterOperator) {
  const scopeConvertedOperator = data.scopeFilterOperatorMap[adHocFilterOperator];
  if (!isEqualityOrMultiOperator(scopeConvertedOperator) || !isEqualityOrMultiOperator(filterOperator)) {
    return false;
  }
  return hasSameOperators(scopeConvertedOperator, filterOperator);
}
function hasSameOperators(scopeConvertedOperator, filterOperator) {
  if (scopeConvertedOperator.includes("not") && !filterOperator.includes("not") || !scopeConvertedOperator.includes("not") && filterOperator.includes("not")) {
    return false;
  }
  return true;
}

class AdHocFiltersVariableController {
  constructor(model) {
    this.model = model;
  }
  useState() {
    const state = this.model.useState();
    return {
      filters: state.filters,
      originFilters: state.originFilters,
      readOnly: state.readOnly,
      allowCustomValue: state.allowCustomValue,
      supportsMultiValueOperators: state.supportsMultiValueOperators,
      onAddCustomValue: state.onAddCustomValue,
      wip: state._wip,
      inputPlaceholder: state.inputPlaceholder,
      collapsible: state.collapsible,
      valueRecommendations: this.model.getRecommendations(),
      drilldownRecommendationsEnabled: state.drilldownRecommendationsEnabled
    };
  }
  async getKeys(currentKey) {
    return this.model._getKeys(currentKey);
  }
  async getValuesFor(filter) {
    return this.model._getValuesFor(filter);
  }
  getOperators() {
    return this.model._getOperators();
  }
  updateFilter(filter, update) {
    this.model._updateFilter(filter, update);
  }
  updateFilters(filters, options) {
    this.model.updateFilters(filters, options);
  }
  updateToMatchAll(filter) {
    this.model.updateToMatchAll(filter);
  }
  removeFilter(filter) {
    this.model._removeFilter(filter);
  }
  removeLastFilter() {
    this.model._removeLastFilter();
  }
  handleComboboxBackspace(filter) {
    this.model._handleComboboxBackspace(filter);
  }
  addWip() {
    this.model._addWip();
  }
  restoreOriginalFilter(filter) {
    this.model.restoreOriginalFilter(filter);
  }
  clearAll() {
    this.model.clearAll();
  }
  startProfile(name) {
    const queryController = getQueryController(this.model);
    queryController == null ? void 0 : queryController.startProfile(name);
  }
  startInteraction(name) {
    const interactionTracker = getInteractionTracker(this.model);
    interactionTracker == null ? void 0 : interactionTracker.startInteraction(name);
  }
  stopInteraction() {
    const interactionTracker = getInteractionTracker(this.model);
    interactionTracker == null ? void 0 : interactionTracker.stopInteraction();
  }
}

const ORIGIN_FILTERS_KEY = "originFilters";
const OPERATORS = [
  {
    value: "=",
    description: "Equals"
  },
  {
    value: "!=",
    description: "Not equal"
  },
  {
    value: "=|",
    description: "One of. Use to filter on multiple values.",
    isMulti: true
  },
  {
    value: "!=|",
    description: "Not one of. Use to exclude multiple values.",
    isMulti: true
  },
  {
    value: "=~",
    description: "Matches regex",
    isRegex: true
  },
  {
    value: "!~",
    description: "Does not match regex",
    isRegex: true
  },
  {
    value: "<",
    description: "Less than"
  },
  {
    value: "<=",
    description: "Less than or equal to"
  },
  {
    value: ">",
    description: "Greater than"
  },
  {
    value: ">=",
    description: "Greater than or equal to"
  }
];
class AdHocFiltersVariable extends SceneObjectBase {
  constructor(state) {
    var _a, _b, _c, _d, _e, _f;
    const behaviors = (_a = state.$behaviors) != null ? _a : [];
    const recommendations = state.drilldownRecommendationsEnabled ? new AdHocFiltersRecommendations() : void 0;
    if (recommendations) {
      behaviors.push(recommendations);
    }
    super({
      type: "adhoc",
      name: (_b = state.name) != null ? _b : "Filters",
      filters: [],
      datasource: null,
      applyMode: "auto",
      filterExpression: (_e = state.filterExpression) != null ? _e : renderExpression(state.expressionBuilder, [...(_c = state.originFilters) != null ? _c : [], ...(_d = state.filters) != null ? _d : []]),
      ...state,
      $behaviors: behaviors.length > 0 ? behaviors : void 0
    });
    this._scopedVars = { __sceneObject: wrapInSafeSerializableSceneObject(this) };
    this._dataSourceSrv = runtime.getDataSourceSrv();
    // holds the originalValues of all baseFilters in a map. The values
    // are set on construct and used to restore a baseFilter with an origin
    // to its original value if edited at some point
    this._originalValues = /* @__PURE__ */ new Map();
    this._prevScopes = [];
    /** Needed for scopes dependency */
    this._variableDependency = new VariableDependencyConfig(this, {
      dependsOnScopes: true,
      onReferencedVariableValueChanged: () => this._updateScopesFilters()
    });
    this._urlSync = new AdHocFiltersVariableUrlSyncHandler(this);
    this._debouncedVerifyApplicability = lodash.debounce(this._verifyApplicability, 100);
    this._activationHandler = () => {
      this._debouncedVerifyApplicability();
      return () => {
        var _a;
        (_a = this.state.originFilters) == null ? void 0 : _a.forEach((filter) => {
          if (filter.restorable) {
            this.restoreOriginalFilter(filter);
          }
        });
        this.setState({ applicabilityEnabled: false });
      };
    };
    this._recommendations = recommendations;
    if (this.state.applyMode === "auto") {
      patchGetAdhocFilters(this);
    }
    (_f = this.state.originFilters) == null ? void 0 : _f.forEach((filter) => {
      var _a2;
      this._originalValues.set(`${filter.key}-${filter.origin}`, {
        operator: filter.operator,
        value: (_a2 = filter.values) != null ? _a2 : [filter.value]
      });
    });
    this.addActivationHandler(this._activationHandler);
  }
  getRecommendations() {
    return this._recommendations;
  }
  _updateScopesFilters() {
    var _a, _b;
    const scopes = sceneGraph.getScopes(this);
    if (!scopes || !scopes.length) {
      this.setState({
        originFilters: (_a = this.state.originFilters) == null ? void 0 : _a.filter((filter) => filter.origin !== "scope")
      });
      return;
    }
    const scopeFilters = getAdHocFiltersFromScopes(scopes);
    if (!scopeFilters.length) {
      return;
    }
    let finalFilters = scopeFilters;
    const scopeInjectedFilters = [];
    const remainingFilters = [];
    finalFilters.forEach((scopeFilter) => {
      var _a2;
      this._originalValues.set(`${scopeFilter.key}-${scopeFilter.origin}`, {
        value: (_a2 = scopeFilter.values) != null ? _a2 : [scopeFilter.value],
        operator: scopeFilter.operator
      });
    });
    (_b = this.state.originFilters) == null ? void 0 : _b.forEach((filter) => {
      if (filter.origin === "scope") {
        scopeInjectedFilters.push(filter);
      } else {
        remainingFilters.push(filter);
      }
    });
    if (this._prevScopes.length) {
      this.setState({ originFilters: [...finalFilters, ...remainingFilters] });
      this._prevScopes = scopes;
      this._debouncedVerifyApplicability();
      return;
    }
    const editedScopeFilters = scopeInjectedFilters.filter((filter) => filter.restorable);
    const editedScopeFilterKeys = editedScopeFilters.map((filter) => filter.key);
    const scopeFilterKeys = scopeFilters.map((filter) => filter.key);
    finalFilters = [
      ...editedScopeFilters.filter((filter) => scopeFilterKeys.includes(filter.key)),
      ...scopeFilters.filter((filter) => !editedScopeFilterKeys.includes(filter.key))
    ];
    this.setState({ originFilters: [...finalFilters, ...remainingFilters] });
    this._prevScopes = scopes;
    this._debouncedVerifyApplicability();
  }
  async verifyApplicabilityAndStoreRecentFilter(update) {
    var _a;
    await this._verifyApplicability();
    (_a = this._recommendations) == null ? void 0 : _a.storeRecentFilter(update);
  }
  setState(update) {
    var _a, _b;
    let filterExpressionChanged = false;
    if ((update.filters && update.filters !== this.state.filters || update.originFilters && update.originFilters !== this.state.originFilters) && !update.filterExpression) {
      const filters = (_a = update.filters) != null ? _a : this.state.filters;
      const originFilters = (_b = update.originFilters) != null ? _b : this.state.originFilters;
      update.filterExpression = renderExpression(this.state.expressionBuilder, [...originFilters != null ? originFilters : [], ...filters]);
      filterExpressionChanged = update.filterExpression !== this.state.filterExpression;
    }
    super.setState(update);
    if (filterExpressionChanged) {
      this.publishEvent(new SceneVariableValueChangedEvent(this), true);
    }
  }
  _resolveOriginFlags(key, origin, values, operator, singleValue) {
    const original = this._originalValues.get(`${key}-${origin}`);
    const isMatchAll = operator === "=~" && singleValue === ".*";
    const isRestorable = !lodash.isEqual(values, original == null ? void 0 : original.value) || operator !== (original == null ? void 0 : original.operator);
    return {
      matchAllFilter: isMatchAll,
      restorable: isRestorable
    };
  }
  validateOriginFilters(filters) {
    return filters.map((filter) => {
      if (!filter.origin) {
        return filter;
      }
      if (!this._originalValues.has(`${filter.key}-${filter.origin}`)) {
        return filter;
      }
      const updateValues = filter.values || (filter.value ? [filter.value] : void 0);
      if (!updateValues) {
        return {
          ...filter,
          operator: "=~",
          value: ".*",
          values: [".*"],
          valueLabels: ["All"],
          matchAllFilter: true,
          nonApplicable: false,
          restorable: true
        };
      }
      const flags = this._resolveOriginFlags(filter.key, filter.origin, updateValues, filter.operator, filter.value);
      return { ...filter, ...flags };
    });
  }
  /**
   * Updates the variable's `filters` and `filterExpression` state.
   * If `skipPublish` option is true, this will not emit the `SceneVariableValueChangedEvent`,
   * allowing consumers to update the filters without triggering dependent data providers.
   */
  updateFilters(filters, options) {
    var _a;
    let filterExpressionChanged = false;
    let filterExpression = void 0;
    if (filters && filters !== this.state.filters) {
      filterExpression = renderExpression(this.state.expressionBuilder, [
        ...(_a = this.state.originFilters) != null ? _a : [],
        ...filters
      ]);
      filterExpressionChanged = filterExpression !== this.state.filterExpression;
    }
    super.setState({
      filters,
      filterExpression
    });
    if (filterExpressionChanged && (options == null ? void 0 : options.skipPublish) !== true || (options == null ? void 0 : options.forcePublish)) {
      this.publishEvent(new SceneVariableValueChangedEvent(this), true);
    }
  }
  restoreOriginalFilter(filter) {
    if (!filter.restorable) {
      return;
    }
    const originalFilter = this._originalValues.get(`${filter.key}-${filter.origin}`);
    if (!originalFilter) {
      return;
    }
    const queryController = getQueryController(this);
    queryController == null ? void 0 : queryController.startProfile(FILTER_RESTORED_INTERACTION);
    this._updateFilter(filter, {
      value: originalFilter.value[0],
      values: originalFilter.value,
      valueLabels: originalFilter.value,
      operator: originalFilter.operator,
      nonApplicable: originalFilter.nonApplicable
    });
  }
  /**
   * Get the original value for an origin filter before any user modifications.
   * Returns undefined if no original is tracked for this filter.
   */
  getOriginalValue(filter) {
    return this._originalValues.get(`${filter.key}-${filter.origin}`);
  }
  /**
   * Clear all user-added filters and restore origin filters to their original values.
   */
  clearAll() {
    var _a;
    (_a = this.state.originFilters) == null ? void 0 : _a.forEach((filter) => {
      if (filter.restorable) {
        this.restoreOriginalFilter(filter);
      }
    });
    this.setState({ filters: [] });
  }
  getValue(fieldPath) {
    if (fieldPath === ORIGIN_FILTERS_KEY) {
      const originFilters = this.state.originFilters;
      if (!originFilters || (originFilters == null ? void 0 : originFilters.length) === 0) {
        return [];
      }
      return [
        ...originFilters.map(
          (filter) => toArray(filter).map(escapeOriginFilterUrlDelimiters).join("|").concat(`#${filter.origin}`)
        )
      ];
    }
    return this.state.filterExpression;
  }
  _updateFilter(filter, update) {
    var _a, _b, _c, _d;
    const { originFilters, filters, _wip } = this.state;
    if (filter.origin) {
      const updateValues = update.values || (update.value ? [update.value] : void 0);
      if (updateValues) {
        const effectiveOperator = (_a = update.operator) != null ? _a : filter.operator;
        const effectiveValue = (_b = update.value) != null ? _b : filter.value;
        const flags = this._resolveOriginFlags(
          filter.key,
          filter.origin,
          updateValues,
          effectiveOperator,
          effectiveValue
        );
        Object.assign(update, flags);
      }
      const updatedFilters2 = (_c = originFilters == null ? void 0 : originFilters.map((f) => {
        return f === filter ? { ...f, ...update } : f;
      })) != null ? _c : [];
      this.setState({ originFilters: updatedFilters2 });
      return;
    }
    if (filter === _wip) {
      if ("value" in update && update["value"] !== "") {
        this.setState({
          filters: [...filters, { ..._wip, ...update }],
          _wip: void 0
        });
        this.verifyApplicabilityAndStoreRecentFilter({ ..._wip, ...update });
      } else {
        this.setState({ _wip: { ...filter, ...update } });
      }
      return;
    }
    const updatedFilters = this.state.filters.map((f) => {
      return f === filter ? { ...f, ...update } : f;
    });
    this.setState({ filters: updatedFilters });
    (_d = this._recommendations) == null ? void 0 : _d.storeRecentFilter({
      ...filter,
      ...update
    });
  }
  updateToMatchAll(filter) {
    this._updateFilter(filter, {
      operator: "=~",
      value: ".*",
      values: [".*"],
      valueLabels: ["All"],
      matchAllFilter: true,
      nonApplicable: false,
      restorable: true
    });
  }
  _removeFilter(filter) {
    if (filter === this.state._wip) {
      this.setState({ _wip: void 0 });
      return;
    }
    const queryController = getQueryController(this);
    queryController == null ? void 0 : queryController.startProfile(FILTER_REMOVED_INTERACTION);
    this.setState({ filters: this.state.filters.filter((f) => f !== filter) });
    this._debouncedVerifyApplicability();
  }
  _removeLastFilter() {
    const filterToRemove = this.state.filters.at(-1);
    if (filterToRemove) {
      this._removeFilter(filterToRemove);
    }
  }
  _handleComboboxBackspace(filter) {
    var _a;
    if (this.state.filters.length) {
      let filterToForceIndex = this.state.filters.length - 1;
      if (filter !== this.state._wip) {
        filterToForceIndex = -1;
      }
      this.setState({
        filters: this.state.filters.reduce((acc, f, index) => {
          if (index === filterToForceIndex && !f.readOnly) {
            return [
              ...acc,
              {
                ...f,
                forceEdit: true
              }
            ];
          }
          if (f === filter) {
            return acc;
          }
          return [...acc, f];
        }, [])
      });
    } else if ((_a = this.state.originFilters) == null ? void 0 : _a.length) {
      let filterToForceIndex = this.state.originFilters.length - 1;
      if (filter !== this.state._wip) {
        filterToForceIndex = -1;
      }
      this.setState({
        originFilters: this.state.originFilters.reduce((acc, f, index) => {
          if (index === filterToForceIndex && !f.readOnly) {
            return [
              ...acc,
              {
                ...f,
                forceEdit: true
              }
            ];
          }
          if (f === filter) {
            return acc;
          }
          return [...acc, f];
        }, [])
      });
    }
  }
  async getFiltersApplicabilityForQueries(filters, queries) {
    const ds = await this._dataSourceSrv.get(this.state.datasource, this._scopedVars);
    if (!ds || !ds.getDrilldownsApplicability) {
      return;
    }
    const timeRange = sceneGraph.getTimeRange(this).state.value;
    return await ds.getDrilldownsApplicability({
      filters,
      queries,
      timeRange,
      scopes: sceneGraph.getScopes(this),
      ...getEnrichedFiltersRequest(this)
    });
  }
  async _verifyApplicability() {
    var _a, _b, _c;
    const filters = [...this.state.filters, ...(_a = this.state.originFilters) != null ? _a : []];
    const queries = this.state.useQueriesAsFilterForOptions ? getQueriesForVariables(this) : void 0;
    const response = await this.getFiltersApplicabilityForQueries(filters, queries != null ? queries : []);
    if (!response) {
      return;
    }
    const responseMap = /* @__PURE__ */ new Map();
    response.forEach((filter) => {
      responseMap.set(`${filter.key}${filter.origin ? `-${filter.origin}` : ""}`, filter);
    });
    const update = {
      applicabilityEnabled: true,
      filters: [...this.state.filters],
      originFilters: [...(_b = this.state.originFilters) != null ? _b : []]
    };
    update.filters.forEach((f) => {
      const filter = responseMap.get(f.key);
      if (filter) {
        f.nonApplicable = !filter.applicable;
        f.nonApplicableReason = filter.reason;
      }
    });
    (_c = update.originFilters) == null ? void 0 : _c.forEach((f) => {
      const filter = responseMap.get(`${f.key}-${f.origin}`);
      if (filter) {
        if (!f.matchAllFilter) {
          f.nonApplicable = !filter.applicable;
          f.nonApplicableReason = filter.reason;
        }
        const originalValue = this._originalValues.get(`${f.key}-${f.origin}`);
        if (originalValue) {
          originalValue.nonApplicable = !filter.applicable;
          originalValue.nonApplicableReason = filter == null ? void 0 : filter.reason;
        }
      }
    });
    this.setState(update);
  }
  /**
   * Get possible keys given current filters. Do not call from plugins directly
   */
  async _getKeys(currentKey) {
    var _a, _b, _c, _d, _e;
    const override = await ((_b = (_a = this.state).getTagKeysProvider) == null ? void 0 : _b.call(_a, this, currentKey));
    if (override && override.replace) {
      return dataFromResponse(override.values).map(toSelectableValue$1);
    }
    if (this.state.defaultKeys) {
      return this.state.defaultKeys.map(toSelectableValue$1);
    }
    const ds = await this._dataSourceSrv.get(this.state.datasource, this._scopedVars);
    if (!ds || !ds.getTagKeys) {
      return [];
    }
    const applicableOriginFilters = (_d = (_c = this.state.originFilters) == null ? void 0 : _c.filter((f) => !f.nonApplicable)) != null ? _d : [];
    const otherFilters = this.state.filters.filter((f) => f.key !== currentKey && !f.nonApplicable).concat((_e = this.state.baseFilters) != null ? _e : []).concat(applicableOriginFilters);
    const timeRange = sceneGraph.getTimeRange(this).state.value;
    const queries = this.state.useQueriesAsFilterForOptions ? getQueriesForVariables(this) : void 0;
    const response = await ds.getTagKeys({
      filters: otherFilters,
      queries,
      timeRange,
      scopes: sceneGraph.getScopes(this),
      ...getEnrichedFiltersRequest(this)
    });
    if (responseHasError(response)) {
      this.setState({ error: response.error.message });
    }
    let keys = dataFromResponse(response);
    if (override) {
      keys = keys.concat(dataFromResponse(override.values));
    }
    const tagKeyRegexFilter = this.state.tagKeyRegexFilter;
    if (tagKeyRegexFilter) {
      keys = keys.filter((f) => f.text.match(tagKeyRegexFilter));
    }
    return keys.map(toSelectableValue$1);
  }
  /**
   * Get possible key values for a specific key given current filters. Do not call from plugins directly
   */
  async _getValuesFor(filter) {
    var _a, _b, _c, _d;
    const override = await ((_b = (_a = this.state).getTagValuesProvider) == null ? void 0 : _b.call(_a, this, filter));
    if (override && override.replace) {
      return dataFromResponse(override.values).map(toSelectableValue$1);
    }
    const ds = await this._dataSourceSrv.get(this.state.datasource, this._scopedVars);
    if (!ds || !ds.getTagValues) {
      return [];
    }
    const originFilters = (_d = (_c = this.state.originFilters) == null ? void 0 : _c.filter((f) => f.key !== filter.key)) != null ? _d : [];
    const otherFilters = this.state.filters.filter((f) => f.key !== filter.key).concat(originFilters);
    const timeRange = sceneGraph.getTimeRange(this).state.value;
    const queries = this.state.useQueriesAsFilterForOptions ? getQueriesForVariables(this) : void 0;
    let scopes = sceneGraph.getScopes(this);
    if (filter.origin === "scope") {
      scopes = scopes == null ? void 0 : scopes.map((scope) => {
        var _a2;
        return {
          ...scope,
          spec: {
            ...scope.spec,
            filters: (_a2 = scope.spec.filters) == null ? void 0 : _a2.filter((f) => f.key !== filter.key)
          }
        };
      });
    }
    const response = await ds.getTagValues({
      key: filter.key,
      filters: otherFilters,
      timeRange,
      queries,
      scopes,
      ...getEnrichedFiltersRequest(this)
    });
    if (responseHasError(response)) {
      this.setState({ error: response.error.message });
    }
    let values = dataFromResponse(response);
    if (override) {
      values = values.concat(dataFromResponse(override.values));
    }
    return values.map(toSelectableValue$1);
  }
  _addWip() {
    this.setState({
      _wip: { key: "", value: "", operator: "=", condition: "" }
    });
  }
  _getOperators() {
    const { supportsMultiValueOperators, allowCustomValue = true } = this.state;
    return OPERATORS.filter(({ isMulti, isRegex }) => {
      if (!supportsMultiValueOperators && isMulti) {
        return false;
      }
      if (!allowCustomValue && isRegex) {
        return false;
      }
      return true;
    }).map(({ value, description }) => ({
      label: value,
      value,
      description
    }));
  }
}
AdHocFiltersVariable.Component = AdHocFiltersVariableRenderer;
function renderExpression(builder, filters) {
  var _a;
  return (builder != null ? builder : renderPrometheusLabelFilters)((_a = filters == null ? void 0 : filters.filter((f) => isFilterApplicable(f))) != null ? _a : []);
}
function AdHocFiltersVariableRenderer({ model }) {
  const { filters, readOnly, addFilterButtonText } = model.useState();
  const styles = ui.useStyles2(getStyles$b);
  const controller = React.useMemo(
    () => model.state.layout === "combobox" ? new AdHocFiltersVariableController(model) : void 0,
    [model]
  );
  if (controller) {
    return /* @__PURE__ */ React__default.default.createElement(AdHocFiltersComboboxRenderer, { controller });
  }
  return /* @__PURE__ */ React__default.default.createElement("div", { className: styles.wrapper }, filters.filter((filter) => !filter.hidden).map((filter, index) => /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, { key: index }, /* @__PURE__ */ React__default.default.createElement(AdHocFilterRenderer, { filter, model }))), !readOnly && /* @__PURE__ */ React__default.default.createElement(AdHocFilterBuilder, { model, key: "'builder", addFilterButtonText }));
}
const getStyles$b = (theme) => ({
  wrapper: css.css({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    columnGap: theme.spacing(2),
    rowGap: theme.spacing(1)
  })
});
function toSelectableValue$1(input) {
  const { text, value } = input;
  const result = {
    // converting text to string due to some edge cases where it can be a number
    // TODO: remove once https://github.com/grafana/grafana/issues/99021 is closed
    label: String(text),
    value: String(value != null ? value : text)
  };
  if ("group" in input) {
    result.group = input.group;
  }
  if ("meta" in input) {
    result.meta = input.meta;
  }
  return result;
}
function isMatchAllFilter(filter) {
  return filter.operator === "=~" && filter.value === ".*";
}
function isFilterComplete(filter) {
  return filter.key !== "" && filter.operator !== "" && filter.value !== "";
}
function isFilterApplicable(filter) {
  return !filter.nonApplicable;
}
function isMultiValueOperator(operatorValue) {
  const operator = OPERATORS.find((o) => o.value === operatorValue);
  if (!operator) {
    return false;
  }
  return Boolean(operator.isMulti);
}

const getRecentFiltersKey = (datasourceUid) => `grafana.filters.recent.${datasourceUid != null ? datasourceUid : "default"}`;
class AdHocFiltersRecommendations extends SceneObjectBase {
  constructor(state = {}) {
    super(state);
    this._activationHandler = () => {
      const json = data.store.get(this._getStorageKey());
      const storedFilters = json ? JSON.parse(json) : [];
      if (storedFilters.length > 0) {
        this._verifyRecentFiltersApplicability(storedFilters);
      } else {
        this.setState({ recentFilters: [] });
      }
      this._fetchRecommendedDrilldowns();
      const scopesVariable = sceneGraph.lookupVariable(SCOPES_VARIABLE_NAME, this._adHocFilter);
      let scopesSubscription;
      let adHocSubscription;
      if (scopesVariable instanceof ScopesVariable) {
        this._subs.add(
          scopesSubscription = scopesVariable.subscribeToState((newState, prevState) => {
            if (newState.scopes !== prevState.scopes) {
              const json2 = data.store.get(this._getStorageKey());
              const storedFilters2 = json2 ? JSON.parse(json2) : [];
              if (storedFilters2.length > 0) {
                this._verifyRecentFiltersApplicability(storedFilters2);
              }
              this._fetchRecommendedDrilldowns();
            }
          })
        );
      }
      this._subs.add(
        adHocSubscription = this._adHocFilter.subscribeToState((newState, prevState) => {
          if (newState.filters !== prevState.filters) {
            const json2 = data.store.get(this._getStorageKey());
            const storedFilters2 = json2 ? JSON.parse(json2) : [];
            if (storedFilters2.length > 0) {
              this._verifyRecentFiltersApplicability(storedFilters2);
            }
            this._fetchRecommendedDrilldowns();
          }
        })
      );
      return () => {
        scopesSubscription == null ? void 0 : scopesSubscription.unsubscribe();
        adHocSubscription == null ? void 0 : adHocSubscription.unsubscribe();
      };
    };
    this.addActivationHandler(this._activationHandler);
  }
  get _adHocFilter() {
    if (!(this.parent instanceof AdHocFiltersVariable)) {
      throw new Error("AdHocFiltersRecommendations must be a child of AdHocFiltersVariable");
    }
    return this.parent;
  }
  get _scopedVars() {
    return { __sceneObject: wrapInSafeSerializableSceneObject(this._adHocFilter) };
  }
  _getStorageKey() {
    var _a;
    return getRecentFiltersKey((_a = this._adHocFilter.state.datasource) == null ? void 0 : _a.uid);
  }
  async _fetchRecommendedDrilldowns() {
    var _a;
    const adhoc = this._adHocFilter;
    const ds = await getDataSource(adhoc.state.datasource, this._scopedVars);
    if (!ds || !ds.getRecommendedDrilldowns) {
      return;
    }
    const queries = adhoc.state.useQueriesAsFilterForOptions ? getQueriesForVariables(adhoc) : void 0;
    const timeRange = sceneGraph.getTimeRange(adhoc).state.value;
    const scopes = sceneGraph.getScopes(adhoc);
    const filters = [...(_a = adhoc.state.originFilters) != null ? _a : [], ...adhoc.state.filters];
    const enrichedRequest = getEnrichedDataRequest(adhoc);
    const dashboardUid = enrichedRequest == null ? void 0 : enrichedRequest.dashboardUID;
    try {
      const recommendedDrilldowns = await ds.getRecommendedDrilldowns({
        timeRange,
        dashboardUid,
        queries: queries != null ? queries : [],
        filters,
        scopes
      });
      if (recommendedDrilldowns == null ? void 0 : recommendedDrilldowns.filters) {
        this.setState({ recommendedFilters: recommendedDrilldowns.filters });
      }
    } catch (error) {
      console.error("Failed to fetch recommended drilldowns:", error);
    }
  }
  async _verifyRecentFiltersApplicability(storedFilters) {
    const adhoc = this._adHocFilter;
    const queries = adhoc.state.useQueriesAsFilterForOptions ? getQueriesForVariables(adhoc) : void 0;
    const response = await adhoc.getFiltersApplicabilityForQueries(storedFilters, queries != null ? queries : []);
    if (!response) {
      this.setState({ recentFilters: storedFilters.slice(-3) });
      return;
    }
    const applicabilityMap = /* @__PURE__ */ new Map();
    response.forEach((item) => {
      applicabilityMap.set(item.key, item.applicable !== false);
    });
    const applicableFilters = storedFilters.filter((f) => {
      const isApplicable = applicabilityMap.get(f.key);
      return isApplicable === void 0 || isApplicable === true;
    }).slice(-3);
    this.setState({ recentFilters: applicableFilters });
  }
  /**
   * Stores a recent filter in localStorage and updates state.
   * Should be called by the parent variable when a filter is added/updated.
   */
  storeRecentFilter(filter) {
    const key = this._getStorageKey();
    const storedFilters = data.store.get(key);
    const allRecentFilters = storedFilters ? JSON.parse(storedFilters) : [];
    const updatedStoredFilters = [...allRecentFilters, filter].slice(-10);
    data.store.set(key, JSON.stringify(updatedStoredFilters));
    const adhoc = this._adHocFilter;
    const existingFilter = adhoc.state.filters.find((f) => f.key === filter.key && !Boolean(f.nonApplicable));
    if (existingFilter && !Boolean(existingFilter.nonApplicable)) {
      this.setState({ recentFilters: updatedStoredFilters.slice(-3) });
    }
  }
  addFilterToParent(filter) {
    this._adHocFilter.updateFilters([...this._adHocFilter.state.filters, filter]);
  }
}
AdHocFiltersRecommendations.Component = AdHocFiltersRecommendationsRenderer;
function AdHocFiltersRecommendationsRenderer({ model }) {
  const { recentFilters, recommendedFilters } = model.useState();
  const { filters } = model._adHocFilter.useState();
  const recentDrilldowns = recentFilters == null ? void 0 : recentFilters.map((filter) => ({
    label: `${filter.key} ${filter.operator} ${filter.value}`,
    onClick: () => {
      const exists = filters.some((f) => f.key === filter.key && f.value === filter.value);
      if (!exists) {
        model.addFilterToParent(filter);
      }
    }
  }));
  const recommendedDrilldowns = recommendedFilters == null ? void 0 : recommendedFilters.map((filter) => ({
    label: `${filter.key} ${filter.operator} ${filter.value}`,
    onClick: () => {
      const exists = filters.some((f) => f.key === filter.key && f.value === filter.value);
      if (!exists) {
        model.addFilterToParent(filter);
      }
    }
  }));
  return /* @__PURE__ */ React__default.default.createElement(DrilldownRecommendations, { recentDrilldowns, recommendedDrilldowns });
}

const getRecentGroupingKey = (datasourceUid) => `grafana.grouping.recent.${datasourceUid != null ? datasourceUid : "default"}`;
class GroupByRecommendations extends SceneObjectBase {
  constructor(state = {}) {
    super(state);
    this._activationHandler = () => {
      const json = data.store.get(this._getStorageKey());
      const storedGroupings = json ? JSON.parse(json) : [];
      if (storedGroupings.length > 0) {
        this._verifyRecentGroupingsApplicability(storedGroupings);
      } else {
        this.setState({ recentGrouping: [] });
      }
      this._fetchRecommendedDrilldowns();
      const scopesVariable = sceneGraph.lookupVariable(SCOPES_VARIABLE_NAME, this._groupBy);
      let scopesSubscription;
      let groupBySubscription;
      if (scopesVariable instanceof ScopesVariable) {
        this._subs.add(
          scopesSubscription = scopesVariable.subscribeToState((newState, prevState) => {
            if (newState.scopes !== prevState.scopes) {
              const json2 = data.store.get(this._getStorageKey());
              const storedGroupings2 = json2 ? JSON.parse(json2) : [];
              if (storedGroupings2.length > 0) {
                this._verifyRecentGroupingsApplicability(storedGroupings2);
              }
              this._fetchRecommendedDrilldowns();
            }
          })
        );
      }
      this._subs.add(
        groupBySubscription = this._groupBy.subscribeToState((newState, prevState) => {
          if (newState.value !== prevState.value) {
            const json2 = data.store.get(this._getStorageKey());
            const storedGroupings2 = json2 ? JSON.parse(json2) : [];
            if (storedGroupings2.length > 0) {
              this._verifyRecentGroupingsApplicability(storedGroupings2);
            }
            this._fetchRecommendedDrilldowns();
          }
        })
      );
      return () => {
        scopesSubscription == null ? void 0 : scopesSubscription.unsubscribe();
        groupBySubscription == null ? void 0 : groupBySubscription.unsubscribe();
      };
    };
    this.addActivationHandler(this._activationHandler);
  }
  get _groupBy() {
    if (!(this.parent instanceof GroupByVariable)) {
      throw new Error("GroupByRecommendations must be a child of GroupByVariable");
    }
    return this.parent;
  }
  get _scopedVars() {
    return { __sceneObject: wrapInSafeSerializableSceneObject(this._groupBy) };
  }
  _getStorageKey() {
    var _a;
    return getRecentGroupingKey((_a = this._groupBy.state.datasource) == null ? void 0 : _a.uid);
  }
  async _fetchRecommendedDrilldowns() {
    const ds = await getDataSource(this._groupBy.state.datasource, this._scopedVars);
    if (!ds || !ds.getRecommendedDrilldowns) {
      return;
    }
    const queries = getQueriesForVariables(this._groupBy);
    const timeRange = sceneGraph.getTimeRange(this._groupBy).state.value;
    const scopes = sceneGraph.getScopes(this._groupBy);
    const groupByKeys = Array.isArray(this._groupBy.state.value) ? this._groupBy.state.value.map((v) => String(v)) : this._groupBy.state.value ? [String(this._groupBy.state.value)] : [];
    const enrichedRequest = getEnrichedDataRequest(this._groupBy);
    const dashboardUid = enrichedRequest == null ? void 0 : enrichedRequest.dashboardUID;
    try {
      const recommendedDrilldowns = await ds.getRecommendedDrilldowns({
        timeRange,
        dashboardUid,
        queries,
        groupByKeys,
        scopes
      });
      if (recommendedDrilldowns == null ? void 0 : recommendedDrilldowns.groupByKeys) {
        this.setState({
          recommendedGrouping: recommendedDrilldowns.groupByKeys.map((key) => ({ value: key, text: key }))
        });
      }
    } catch (error) {
      console.error("Failed to fetch recommended drilldowns:", error);
    }
  }
  async _verifyRecentGroupingsApplicability(storedGroupings) {
    const queries = getQueriesForVariables(this._groupBy);
    const keys = storedGroupings.map((g) => String(g.value));
    const response = await this._groupBy.getGroupByApplicabilityForQueries(keys, queries);
    if (!response) {
      this.setState({ recentGrouping: storedGroupings.slice(-3) });
      return;
    }
    const applicabilityMap = /* @__PURE__ */ new Map();
    response.forEach((item) => {
      applicabilityMap.set(item.key, item.applicable !== false);
    });
    const applicableGroupings = storedGroupings.filter((g) => {
      const isApplicable = applicabilityMap.get(String(g.value));
      return isApplicable === void 0 || isApplicable === true;
    }).slice(-3);
    this.setState({ recentGrouping: applicableGroupings });
  }
  /**
   * Stores recent groupings in localStorage and updates state.
   * Should be called by the parent variable when a grouping is added/updated.
   */
  storeRecentGrouping(applicableValues) {
    if (applicableValues.length === 0) {
      return;
    }
    const key = this._getStorageKey();
    const storedGroupings = data.store.get(key);
    const allRecentGroupings = storedGroupings ? JSON.parse(storedGroupings) : [];
    const existingWithoutApplicableValues = allRecentGroupings.filter(
      (grouping) => !applicableValues.includes(String(grouping.value))
    );
    const updatedStoredGroupings = [
      ...existingWithoutApplicableValues,
      ...applicableValues.map((value) => ({ value, text: value }))
    ];
    const limitedStoredGroupings = updatedStoredGroupings.slice(-10);
    data.store.set(key, JSON.stringify(limitedStoredGroupings));
    this.setState({ recentGrouping: limitedStoredGroupings.slice(-3) });
  }
  /**
   * Add a grouping value to the parent variable
   */
  addValueToParent(newValue, newText) {
    const value = lodash.isArray(this._groupBy.state.value) ? this._groupBy.state.value : [this._groupBy.state.value];
    const text = lodash.isArray(this._groupBy.state.text) ? this._groupBy.state.text.map(String) : [String(this._groupBy.state.text)];
    if (value.includes(newValue)) {
      return;
    }
    this._groupBy.changeValueTo(
      [...value.filter((v) => v !== ""), newValue],
      [...text.filter((t) => t !== ""), newText != null ? newText : String(newValue)],
      true
    );
  }
}
GroupByRecommendations.Component = GroupByRecommendationsRenderer;
function GroupByRecommendationsRenderer({ model }) {
  const { recentGrouping, recommendedGrouping } = model.useState();
  const recentDrilldowns = recentGrouping == null ? void 0 : recentGrouping.map((groupBy) => ({
    label: `${groupBy.value}`,
    onClick: () => {
      var _a;
      model.addValueToParent(groupBy.value, (_a = groupBy.text) != null ? _a : String(groupBy.value));
    }
  }));
  const recommendedDrilldowns = recommendedGrouping == null ? void 0 : recommendedGrouping.map((groupBy) => ({
    label: `${groupBy.value}`,
    onClick: () => {
      var _a;
      model.addValueToParent(groupBy.value, (_a = groupBy.text) != null ? _a : String(groupBy.value));
    }
  }));
  return /* @__PURE__ */ React__default.default.createElement(DrilldownRecommendations, { recentDrilldowns, recommendedDrilldowns });
}

class GroupByVariable extends MultiValueVariable {
  constructor(initialState) {
    var _a;
    const behaviors = (_a = initialState.$behaviors) != null ? _a : [];
    const recommendations = initialState.drilldownRecommendationsEnabled ? new GroupByRecommendations() : void 0;
    if (recommendations) {
      behaviors.push(recommendations);
    }
    super({
      isMulti: true,
      name: "",
      value: [],
      text: [],
      options: [],
      datasource: null,
      baseFilters: [],
      applyMode: "auto",
      layout: "horizontal",
      type: "groupby",
      ...initialState,
      noValueOnClear: true,
      $behaviors: behaviors.length > 0 ? behaviors : void 0
    });
    this.isLazy = true;
    this._urlSync = new GroupByVariableUrlSyncHandler(this);
    this._scopedVars = { __sceneObject: wrapInSafeSerializableSceneObject(this) };
    this._activationHandler = () => {
      this._verifyApplicability();
      if (this.state.defaultValue) {
        if (this.checkIfRestorable(this.state.value)) {
          this.setState({ restorable: true });
        }
      }
      return () => {
        if (this.state.defaultValue) {
          this.restoreDefaultValues();
        }
        this.setState({ applicabilityEnabled: false });
      };
    };
    /**
     * Get possible keys given current filters. Do not call from plugins directly
     */
    this._getKeys = async (ds) => {
      var _a, _b, _c;
      const override = await ((_b = (_a = this.state).getTagKeysProvider) == null ? void 0 : _b.call(_a, this, null));
      if (override && override.replace) {
        return override.values;
      }
      if (this.state.defaultOptions) {
        return this.state.defaultOptions.concat(dataFromResponse((_c = override == null ? void 0 : override.values) != null ? _c : []));
      }
      if (!ds.getGroupByKeys && !ds.getTagKeys) {
        return [];
      }
      const keyMethod = (ds.getGroupByKeys || ds.getTagKeys).bind(ds);
      const queries = getQueriesForVariables(this);
      const otherFilters = this.state.baseFilters || [];
      const timeRange = sceneGraph.getTimeRange(this).state.value;
      const response = await keyMethod({
        filters: otherFilters,
        queries,
        timeRange,
        scopes: sceneGraph.getScopes(this),
        ...getEnrichedFiltersRequest(this)
      });
      if (responseHasError(response)) {
        this.setState({ error: response.error.message });
      }
      let keys = dataFromResponse(response);
      if (override) {
        keys = keys.concat(dataFromResponse(override.values));
      }
      const tagKeyRegexFilter = this.state.tagKeyRegexFilter;
      if (tagKeyRegexFilter) {
        keys = keys.filter((f) => f.text.match(tagKeyRegexFilter));
      }
      return keys;
    };
    this._recommendations = recommendations;
    if (this.state.defaultValue) {
      const currentValue = this.state.value;
      const hasCurrentValue = Array.isArray(currentValue) ? currentValue.length > 0 : !!currentValue;
      if (!hasCurrentValue) {
        this.changeValueTo(this.state.defaultValue.value, this.state.defaultValue.text, false);
      }
    }
    if (this.state.applyMode === "auto") {
      this.addActivationHandler(() => {
        allActiveGroupByVariables.add(this);
        return () => allActiveGroupByVariables.delete(this);
      });
    }
    this.addActivationHandler(this._activationHandler);
  }
  validateAndUpdate() {
    return this.getValueOptions({}).pipe(
      rxjs.map((options) => {
        this._updateValueGivenNewOptions(options);
        return {};
      })
    );
  }
  _updateValueGivenNewOptions(options) {
    const { value: currentValue, text: currentText } = this.state;
    const stateUpdate = {
      options,
      loading: false,
      value: currentValue != null ? currentValue : [],
      text: currentText != null ? currentText : []
    };
    this.setState(stateUpdate);
  }
  getValueOptions(args) {
    if (this.state.defaultOptions) {
      return rxjs.of(
        this.state.defaultOptions.map((o) => ({
          label: o.text,
          value: String(o.value),
          group: o.group
        }))
      );
    }
    this.setState({ loading: true, error: null });
    return rxjs.from(getDataSource(this.state.datasource, this._scopedVars)).pipe(
      rxjs.mergeMap((ds) => {
        return rxjs.from(this._getKeys(ds)).pipe(
          rxjs.tap((response) => {
            if (responseHasError(response)) {
              this.setState({ error: response.error.message });
            }
          }),
          rxjs.map((response) => dataFromResponse(response)),
          rxjs.take(1),
          rxjs.mergeMap((data) => {
            const a = data.map((i) => {
              return {
                label: i.text,
                value: i.value ? String(i.value) : i.text,
                group: i.group
              };
            });
            return rxjs.of(a);
          })
        );
      })
    );
  }
  /**
   * Gets the GroupByRecommendations behavior if it exists in $behaviors
   */
  getRecommendations() {
    return this._recommendations;
  }
  getApplicableKeys() {
    const { value, keysApplicability } = this.state;
    const valueArray = lodash.isArray(value) ? value.map(String) : value ? [String(value)] : [];
    if (!keysApplicability || keysApplicability.length === 0) {
      return valueArray;
    }
    const applicableValues = valueArray.filter((val) => {
      const applicability = keysApplicability.find((item) => item.key === val);
      return !applicability || applicability.applicable !== false;
    });
    return applicableValues;
  }
  async getGroupByApplicabilityForQueries(value, queries) {
    const ds = await getDataSource(this.state.datasource, this._scopedVars);
    if (!ds.getDrilldownsApplicability) {
      return;
    }
    const timeRange = sceneGraph.getTimeRange(this).state.value;
    return await ds.getDrilldownsApplicability({
      groupByKeys: Array.isArray(value) ? value.map((v) => String(v)) : value ? [String(value)] : [],
      queries,
      timeRange,
      scopes: sceneGraph.getScopes(this),
      ...getEnrichedFiltersRequest(this)
    });
  }
  async _verifyApplicability() {
    const queries = getQueriesForVariables(this);
    const value = this.state.value;
    const response = await this.getGroupByApplicabilityForQueries(value, queries);
    if (!response) {
      return;
    }
    if (!lodash.isEqual(response, this.state.keysApplicability)) {
      this.setState({ keysApplicability: response != null ? response : void 0, applicabilityEnabled: true });
      this.publishEvent(new SceneVariableValueChangedEvent(this), true);
    } else {
      this.setState({ applicabilityEnabled: true });
    }
  }
  // This method is related to the defaultValue property. We check if the current value
  // is different from the default value. If it is, the groupBy will show a button
  // allowing the user to restore the default values.
  checkIfRestorable(values) {
    var _a, _b, _c, _d;
    const originalValues = lodash.isArray((_a = this.state.defaultValue) == null ? void 0 : _a.value) ? (_b = this.state.defaultValue) == null ? void 0 : _b.value : ((_c = this.state.defaultValue) == null ? void 0 : _c.value) ? [(_d = this.state.defaultValue) == null ? void 0 : _d.value] : [];
    const vals = lodash.isArray(values) ? values : [values];
    if (vals.length !== originalValues.length) {
      return true;
    }
    return !lodash.isEqual(vals, originalValues);
  }
  restoreDefaultValues() {
    this.setState({ restorable: false });
    if (!this.state.defaultValue) {
      return;
    }
    this.changeValueTo(this.state.defaultValue.value, this.state.defaultValue.text, true);
  }
  async _verifyApplicabilityAndStoreRecentGrouping() {
    await this._verifyApplicability();
    if (!this._recommendations) {
      return;
    }
    const applicableValues = this.getApplicableKeys();
    if (applicableValues.length === 0) {
      return;
    }
    this._recommendations.storeRecentGrouping(applicableValues);
  }
  /**
   * Allows clearing the value of the variable to an empty value. Overrides default behavior of a MultiValueVariable
   */
  getDefaultMultiState(options) {
    return { value: [], text: [] };
  }
}
GroupByVariable.Component = GroupByVariableRenderer;
function GroupByVariableRenderer({ model }) {
  var _a, _b;
  const {
    value,
    text,
    key,
    isMulti = true,
    maxVisibleValues,
    noValueOnClear,
    options,
    includeAll,
    allowCustomValue = true,
    defaultValue,
    keysApplicability,
    drilldownRecommendationsEnabled
  } = model.useState();
  const recommendations = model.getRecommendations();
  const styles = ui.useStyles2(getStyles$a);
  const values = React.useMemo(() => {
    const arrayValue = lodash.isArray(value) ? value : [value];
    const arrayText = lodash.isArray(text) ? text : [text];
    return arrayValue.map((value2, idx) => {
      var _a2;
      return {
        value: value2,
        label: String((_a2 = arrayText[idx]) != null ? _a2 : value2)
      };
    });
  }, [value, text]);
  const [isFetchingOptions, setIsFetchingOptions] = React.useState(false);
  const [isOptionsOpen, setIsOptionsOpen] = React.useState(false);
  const [inputValue, setInputValue] = React.useState("");
  const [uncommittedValue, setUncommittedValue] = React.useState(values);
  const optionSearcher = React.useMemo(() => getOptionSearcher(options, includeAll), [options, includeAll]);
  const hasDefaultValue = defaultValue !== void 0;
  React.useEffect(() => {
    setUncommittedValue(values);
  }, [values]);
  const onInputChange = (value2, { action }) => {
    if (action === "input-change") {
      setInputValue(value2);
      if (model.onSearchChange) {
        model.onSearchChange(value2);
      }
      return value2;
    }
    if (action === "input-blur") {
      setInputValue("");
      return "";
    }
    return inputValue;
  };
  const filteredOptions = React.useMemo(
    () => handleOptionGroups(optionSearcher(inputValue).map(toSelectableValue)),
    [optionSearcher, inputValue]
  );
  const WideInputWrapper = (children) => /* @__PURE__ */ React__default.default.createElement("div", { className: styles.selectWrapper }, children);
  const select = isMulti ? /* @__PURE__ */ React__default.default.createElement(ConditionalWrapper, { condition: (_a = model.state.wideInput) != null ? _a : false, wrapper: WideInputWrapper }, /* @__PURE__ */ React__default.default.createElement(
    ui.MultiSelect,
    {
      "aria-label": i18n.t(
        "grafana-scenes.variables.group-by-variable-renderer.aria-label-group-by-selector",
        "Group by selector"
      ),
      "data-testid": `GroupBySelect-${key}`,
      id: key,
      placeholder: i18n.t(
        "grafana-scenes.variables.group-by-variable-renderer.placeholder-group-by-label",
        "Group by label"
      ),
      width: "auto",
      className: css.cx(drilldownRecommendationsEnabled && styles.selectStylesInWrapper),
      allowCustomValue,
      inputValue,
      value: uncommittedValue,
      noMultiValueWrap: true,
      maxVisibleValues: maxVisibleValues != null ? maxVisibleValues : 5,
      tabSelectsValue: false,
      virtualized: true,
      options: filteredOptions,
      filterOption: filterNoOp,
      closeMenuOnSelect: false,
      isOpen: isOptionsOpen,
      isClearable: true,
      hideSelectedOptions: false,
      isLoading: isFetchingOptions,
      components: {
        Option: OptionWithCheckbox,
        Menu: WideMenu,
        ...hasDefaultValue ? {
          IndicatorsContainer: () => /* @__PURE__ */ React__default.default.createElement(DefaultGroupByCustomIndicatorContainer, { model })
        } : {},
        MultiValueContainer: ({ innerProps, children }) => /* @__PURE__ */ React__default.default.createElement(GroupByValueContainer, { innerProps, keysApplicability }, children)
      },
      onInputChange,
      onBlur: () => {
        model.changeValueTo(
          uncommittedValue.map((x) => x.value),
          uncommittedValue.map((x) => x.label),
          true
        );
        const restorable = model.checkIfRestorable(uncommittedValue.map((v) => v.value));
        if (restorable !== model.state.restorable) {
          model.setState({ restorable });
        }
        model._verifyApplicabilityAndStoreRecentGrouping();
      },
      onChange: (newValue, action) => {
        if (action.action === "clear" && noValueOnClear) {
          model.changeValueTo([], void 0, true);
        }
        setUncommittedValue(newValue);
        setInputValue("");
      },
      onOpenMenu: async () => {
        const profiler = getInteractionTracker(model);
        profiler == null ? void 0 : profiler.startInteraction(GROUPBY_DIMENSIONS_INTERACTION);
        setIsFetchingOptions(true);
        await rxjs.lastValueFrom(model.validateAndUpdate());
        setIsFetchingOptions(false);
        setIsOptionsOpen(true);
        profiler == null ? void 0 : profiler.stopInteraction();
      },
      onCloseMenu: () => {
        setIsOptionsOpen(false);
      }
    }
  )) : /* @__PURE__ */ React__default.default.createElement(ConditionalWrapper, { condition: (_b = model.state.wideInput) != null ? _b : false, wrapper: WideInputWrapper }, /* @__PURE__ */ React__default.default.createElement(
    ui.Select,
    {
      "aria-label": i18n.t(
        "grafana-scenes.variables.group-by-variable-renderer.aria-label-group-by-selector",
        "Group by selector"
      ),
      "data-testid": `GroupBySelect-${key}`,
      id: key,
      placeholder: i18n.t(
        "grafana-scenes.variables.group-by-variable-renderer.placeholder-group-by-label",
        "Group by label"
      ),
      width: "auto",
      inputValue,
      value: uncommittedValue && uncommittedValue.length > 0 ? uncommittedValue : null,
      allowCustomValue,
      noMultiValueWrap: true,
      maxVisibleValues: maxVisibleValues != null ? maxVisibleValues : 5,
      tabSelectsValue: false,
      virtualized: true,
      options: filteredOptions,
      filterOption: filterNoOp,
      closeMenuOnSelect: true,
      isOpen: isOptionsOpen,
      isClearable: true,
      hideSelectedOptions: false,
      noValueOnClear: true,
      isLoading: isFetchingOptions,
      components: { Menu: WideMenu },
      onInputChange,
      onChange: (newValue, action) => {
        if (action.action === "clear") {
          setUncommittedValue([]);
          if (noValueOnClear) {
            model.changeValueTo([]);
          }
          return;
        }
        if (newValue == null ? void 0 : newValue.value) {
          setUncommittedValue([newValue]);
          model.changeValueTo([newValue.value], newValue.label ? [newValue.label] : void 0);
        }
      },
      onOpenMenu: async () => {
        const profiler = getInteractionTracker(model);
        profiler == null ? void 0 : profiler.startInteraction(GROUPBY_DIMENSIONS_INTERACTION);
        setIsFetchingOptions(true);
        await rxjs.lastValueFrom(model.validateAndUpdate());
        setIsFetchingOptions(false);
        setIsOptionsOpen(true);
        profiler == null ? void 0 : profiler.stopInteraction();
      },
      onCloseMenu: () => {
        setIsOptionsOpen(false);
      }
    }
  ));
  if (!recommendations) {
    return select;
  }
  return /* @__PURE__ */ React__default.default.createElement("div", { className: styles.wrapper }, /* @__PURE__ */ React__default.default.createElement("div", { className: styles.recommendations }, /* @__PURE__ */ React__default.default.createElement(recommendations.Component, { model: recommendations })), select);
}
const ConditionalWrapper = ({
  condition,
  wrapper,
  children
}) => {
  return condition ? wrapper(children) : /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, children);
};
const filterNoOp = () => true;
function WideMenu(props) {
  return /* @__PURE__ */ React__default.default.createElement(components.Menu, { ...props }, /* @__PURE__ */ React__default.default.createElement("div", { style: { minWidth: "220px" } }, props.children));
}
function toSelectableValue(input) {
  const { label, value, group } = input;
  const result = {
    label,
    value
  };
  if (group) {
    result.group = group;
  }
  return result;
}
const getStyles$a = (theme) => ({
  selectWrapper: css.css({
    display: "flex",
    minWidth: 0,
    width: "100%"
  }),
  // Fix for noMultiValueWrap grid layout - prevent pills from stretching
  // when the select is full width. The grid layout uses gridAutoFlow: column
  // which stretches items by default.
  fullWidthMultiSelect: css.css({
    width: "100%",
    // Target the value container (has data-testid) which uses grid layout
    "& [data-testid]": {
      gridAutoColumns: "max-content",
      justifyItems: "start"
    }
  }),
  wrapper: css.css({
    display: "flex"
  }),
  selectStylesInWrapper: css.css({
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    border: `1px solid ${theme.colors.border.strong}`,
    borderLeft: "none"
  }),
  recommendations: css.css({
    display: "flex",
    alignItems: "center",
    paddingInline: theme.spacing(0.5),
    borderTop: `1px solid ${theme.colors.border.strong}`,
    borderBottom: `1px solid ${theme.colors.border.strong}`,
    backgroundColor: theme.components.input.background,
    "& button": {
      borderRadius: 0,
      height: "100%",
      margin: 0,
      paddingInline: theme.spacing(0.5)
    }
  })
});

function VizPanelSeriesLimit({ data, showAll, seriesLimit, onShowAllSeries }) {
  const styles = ui.useStyles2(getStyles$9);
  const seriesCount = data == null ? void 0 : data.series.length;
  if (seriesCount === void 0 || seriesCount < seriesLimit) {
    return null;
  }
  const buttonText = showAll ? "Restore limit" : `Show all ${seriesCount}`;
  return /* @__PURE__ */ React__default.default.createElement("div", { className: styles.timeSeriesDisclaimer }, !showAll && /* @__PURE__ */ React__default.default.createElement("span", { className: styles.warningMessage }, /* @__PURE__ */ React__default.default.createElement(
    ui.Icon,
    {
      title: i18n.t(
        "grafana-scenes.components.viz-panel-series-limit.warning-message",
        `Showing only {{seriesLimit}} series`,
        {
          seriesLimit
        }
      ),
      name: "exclamation-triangle",
      "aria-hidden": "true"
    }
  )), /* @__PURE__ */ React__default.default.createElement(
    ui.Tooltip,
    {
      content: i18n.t(
        "grafana-scenes.components.viz-panel-series-limit.content-rendering-series-single-panel-impact-performance",
        "Rendering too many series in a single panel may impact performance and make data harder to read."
      )
    },
    /* @__PURE__ */ React__default.default.createElement(ui.Button, { variant: "secondary", size: "sm", onClick: onShowAllSeries }, buttonText)
  ));
}
const getStyles$9 = (theme) => ({
  timeSeriesDisclaimer: css.css({
    label: "time-series-disclaimer",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1)
  }),
  warningMessage: css.css({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    color: theme.colors.warning.main,
    fontSize: theme.typography.bodySmall.fontSize
  })
});

function useUniqueId() {
  var _a;
  const idRefLazy = React.useRef(void 0);
  (_a = idRefLazy.current) != null ? _a : idRefLazy.current = lodash.uniqueId();
  return idRefLazy.current;
}
const LazyLoader = React__default.default.forwardRef(
  ({ children, onLoad, onChange, className, ...rest }, ref) => {
    const id = useUniqueId();
    const { hideEmpty } = ui.useStyles2(getStyles$8);
    const [loaded, setLoaded] = React.useState(false);
    const [isInView, setIsInView] = React.useState(false);
    const innerRef = React.useRef(null);
    React.useImperativeHandle(ref, () => innerRef.current);
    reactUse.useEffectOnce(() => {
      LazyLoader.addCallback(id, (entry) => {
        if (!loaded && entry.isIntersecting) {
          setLoaded(true);
          onLoad == null ? void 0 : onLoad();
        }
        setIsInView(entry.isIntersecting);
        onChange == null ? void 0 : onChange(entry.isIntersecting);
      });
      const wrapperEl = innerRef.current;
      if (wrapperEl) {
        LazyLoader.observer.observe(wrapperEl);
      }
      return () => {
        wrapperEl && LazyLoader.observer.unobserve(wrapperEl);
        delete LazyLoader.callbacks[id];
        if (Object.keys(LazyLoader.callbacks).length === 0) {
          LazyLoader.observer.disconnect();
        }
      };
    });
    return /* @__PURE__ */ React__default.default.createElement("div", { id, ref: innerRef, className: `${hideEmpty} ${className}`, ...rest }, !loaded ? i18n.t("grafana-scenes.components.lazy-loader.placeholder", "\xA0") : /* @__PURE__ */ React__default.default.createElement(LazyLoaderInViewContext.Provider, { value: isInView }, children));
  }
);
function getStyles$8() {
  return {
    hideEmpty: css.css({
      "&:empty": {
        display: "none"
      }
    })
  };
}
LazyLoader.displayName = "LazyLoader";
LazyLoader.callbacks = {};
LazyLoader.addCallback = (id, c) => LazyLoader.callbacks[id] = c;
LazyLoader.observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (typeof LazyLoader.callbacks[entry.target.id] === "function") {
        LazyLoader.callbacks[entry.target.id](entry);
      }
    }
  },
  { rootMargin: "100px" }
);
const LazyLoaderInViewContext = React__default.default.createContext(true);
function useLazyLoaderIsInView() {
  return React__default.default.useContext(LazyLoaderInViewContext);
}

function VizPanelRenderer({ model }) {
  var _a;
  const {
    title,
    options,
    fieldConfig,
    _pluginLoadError,
    displayMode,
    hoverHeader,
    showMenuAlways,
    hoverHeaderOffset,
    menu,
    headerActions,
    subHeader,
    titleItems,
    seriesLimit,
    seriesLimitShowAll,
    description,
    collapsible,
    collapsed,
    _renderCounter = 0
  } = model.useState();
  const [ref, { width, height }] = reactUse.useMeasure();
  const appEvents = React.useMemo(() => runtime.getAppEvents(), []);
  const setPanelAttention = React.useCallback(() => {
    if (model.state.key) {
      appEvents.publish(new data.SetPanelAttentionEvent({ panelId: model.getPathId() }));
    }
  }, [model, appEvents]);
  const debouncedMouseMove = React.useMemo(
    () => lodash.debounce(setPanelAttention, 100, { leading: true, trailing: false }),
    [setPanelAttention]
  );
  const profiler = React.useMemo(() => model.getProfiler(), [model]);
  const currentRenderStart = performance.now();
  const endRenderCallbackRef = React__default.default.useRef(null);
  React.useLayoutEffect(() => {
    if (profiler) {
      const callback = profiler.onSimpleRenderStart(currentRenderStart);
      endRenderCallbackRef.current = callback || null;
    }
  });
  React.useEffect(() => {
    if (endRenderCallbackRef.current) {
      const timestamp = performance.now();
      const duration = timestamp - currentRenderStart;
      endRenderCallbackRef.current(timestamp, duration);
      endRenderCallbackRef.current = null;
    }
  });
  const plugin = model.getPlugin();
  const { dragClass, dragClassCancel } = getDragClasses(model);
  const dragHooks = getDragHooks(model);
  const dataObject = sceneGraph.getData(model);
  const rawData = dataObject.useState();
  const dataWithSeriesLimit = useDataWithSeriesLimit(rawData.data, seriesLimit, seriesLimitShowAll);
  const dataWithFieldConfig = model.applyFieldConfig(dataWithSeriesLimit);
  const sceneTimeRange = sceneGraph.getTimeRange(model);
  const timeZone = sceneTimeRange.getTimeZone();
  const timeRange = model.getTimeRange(dataWithFieldConfig);
  const isInView = useLazyLoaderIsInView();
  React.useEffect(() => {
    if (dataObject.isInViewChanged) {
      dataObject.isInViewChanged(isInView);
    }
  }, [isInView, dataObject]);
  const titleInterpolated = model.interpolate(title, void 0, "text");
  const alertStateStyles = ui.useStyles2(getAlertStateStyles);
  if (!plugin) {
    return /* @__PURE__ */ React__default.default.createElement("div", null, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.components.viz-panel-renderer.loading-plugin-panel" }, "Loading plugin panel..."));
  }
  if (!plugin.panel) {
    return /* @__PURE__ */ React__default.default.createElement("div", null, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.components.viz-panel-renderer.panel-plugin-has-no-panel-component" }, "Panel plugin has no panel component"));
  }
  const PanelComponent = plugin.panel;
  if (dataObject && dataObject.setContainerWidth) {
    dataObject.setContainerWidth(Math.round(width));
  }
  let subHeaderElement = [];
  if (subHeader) {
    if (Array.isArray(subHeader)) {
      subHeaderElement = subHeaderElement.concat(
        subHeader.map((subHeaderItem) => {
          return /* @__PURE__ */ React__default.default.createElement(subHeaderItem.Component, { model: subHeaderItem, key: `${subHeaderItem.state.key}` });
        })
      );
    } else if (isSceneObject(subHeader)) {
      subHeaderElement.push(/* @__PURE__ */ React__default.default.createElement(subHeader.Component, { model: subHeader, key: `${subHeader.state.key}` }));
    } else {
      subHeaderElement.push(subHeader);
    }
  }
  let titleItemsElement = [];
  if (titleItems) {
    if (Array.isArray(titleItems)) {
      titleItemsElement = titleItemsElement.concat(
        titleItems.map((titleItem) => {
          return /* @__PURE__ */ React__default.default.createElement(titleItem.Component, { model: titleItem, key: `${titleItem.state.key}` });
        })
      );
    } else if (isSceneObject(titleItems)) {
      titleItemsElement.push(/* @__PURE__ */ React__default.default.createElement(titleItems.Component, { model: titleItems }));
    } else {
      titleItemsElement.push(titleItems);
    }
  }
  if (seriesLimit) {
    titleItemsElement.push(
      /* @__PURE__ */ React__default.default.createElement(
        VizPanelSeriesLimit,
        {
          key: "series-limit",
          data: rawData.data,
          seriesLimit,
          showAll: seriesLimitShowAll,
          onShowAllSeries: () => model.setState({ seriesLimitShowAll: !seriesLimitShowAll })
        }
      )
    );
  }
  if (model.state.$timeRange) {
    titleItemsElement.push(/* @__PURE__ */ React__default.default.createElement(model.state.$timeRange.Component, { model: model.state.$timeRange, key: model.state.key }));
  }
  if (dataWithFieldConfig.alertState) {
    titleItemsElement.push(
      /* @__PURE__ */ React__default.default.createElement(ui.Tooltip, { content: (_a = dataWithFieldConfig.alertState.state) != null ? _a : "unknown", key: `alert-states-icon-${model.state.key}` }, /* @__PURE__ */ React__default.default.createElement(
        ui.PanelChrome.TitleItem,
        {
          className: css.cx({
            [alertStateStyles.ok]: dataWithFieldConfig.alertState.state === data.AlertState.OK,
            [alertStateStyles.pending]: dataWithFieldConfig.alertState.state === data.AlertState.Pending,
            [alertStateStyles.alerting]: dataWithFieldConfig.alertState.state === data.AlertState.Alerting
          })
        },
        /* @__PURE__ */ React__default.default.createElement(
          ui.Icon,
          {
            name: dataWithFieldConfig.alertState.state === "alerting" ? "heart-break" : "heart",
            className: "panel-alert-icon",
            size: "md"
          }
        )
      ))
    );
  }
  let panelMenu;
  if (menu) {
    panelMenu = /* @__PURE__ */ React__default.default.createElement(menu.Component, { model: menu });
  }
  let actionsElement;
  if (headerActions) {
    if (Array.isArray(headerActions)) {
      actionsElement = /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, headerActions.map((action) => {
        return /* @__PURE__ */ React__default.default.createElement(action.Component, { model: action, key: `${action.state.key}` });
      }));
    } else if (isSceneObject(headerActions)) {
      actionsElement = /* @__PURE__ */ React__default.default.createElement(headerActions.Component, { model: headerActions });
    } else {
      actionsElement = headerActions;
    }
  }
  const data$1 = dataWithFieldConfig;
  const isReadyToRender = dataObject.isDataReadyToDisplay ? dataObject.isDataReadyToDisplay() : true;
  const context = model.getPanelContext();
  const panelId = model.getLegacyPanelId();
  return /* @__PURE__ */ React__default.default.createElement("div", { className: relativeWrapper }, /* @__PURE__ */ React__default.default.createElement("div", { ref, className: absoluteWrapper, "data-viz-panel-key": model.state.key }, width > 0 && height > 0 && /* @__PURE__ */ React__default.default.createElement(
    ui.PanelChrome,
    {
      title: titleInterpolated,
      description: (description == null ? void 0 : description.trim()) ? model.getDescription : void 0,
      loadingState: data$1.state,
      statusMessage: getChromeStatusMessage(data$1, _pluginLoadError),
      statusMessageOnClick: model.onStatusMessageClick,
      width,
      height,
      selectionId: model.state.key,
      displayMode,
      titleItems: titleItemsElement.length > 0 ? titleItemsElement : void 0,
      dragClass,
      actions: actionsElement,
      dragClassCancel,
      padding: plugin.noPadding ? "none" : "md",
      menu: panelMenu,
      onCancelQuery: model.onCancelQuery,
      onFocus: setPanelAttention,
      onMouseEnter: setPanelAttention,
      onMouseMove: debouncedMouseMove,
      subHeaderContent: subHeaderElement.length ? subHeaderElement : void 0,
      onDragStart: (e) => {
        var _a2;
        (_a2 = dragHooks.onDragStart) == null ? void 0 : _a2.call(dragHooks, e, model);
      },
      showMenuAlways,
      ...collapsible ? {
        collapsible: Boolean(collapsible),
        collapsed,
        onToggleCollapse: model.onToggleCollapse
      } : { hoverHeader, hoverHeaderOffset }
    },
    (innerWidth, innerHeight) => /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, /* @__PURE__ */ React__default.default.createElement(ui.ErrorBoundaryAlert, { dependencies: [plugin, data$1] }, /* @__PURE__ */ React__default.default.createElement(data.PluginContextProvider, { meta: plugin.meta }, /* @__PURE__ */ React__default.default.createElement(ui.PanelContextProvider, { value: context }, isReadyToRender && /* @__PURE__ */ React__default.default.createElement(
      PanelComponent,
      {
        id: panelId,
        data: data$1,
        title,
        timeRange,
        timeZone,
        options,
        fieldConfig,
        transparent: displayMode === "transparent",
        width: innerWidth,
        height: innerHeight,
        renderCounter: _renderCounter,
        replaceVariables: model.interpolate,
        onOptionsChange: model.onOptionsChange,
        onFieldConfigChange: model.onFieldConfigChange,
        onChangeTimeRange: model.onTimeRangeChange,
        eventBus: context.eventBus
      }
    )))))
  )));
}
function useDataWithSeriesLimit(data, seriesLimit, showAllSeries) {
  return React.useMemo(() => {
    if (!(data == null ? void 0 : data.series) || !seriesLimit || showAllSeries) {
      return data;
    }
    return {
      ...data,
      series: data.series.slice(0, seriesLimit)
    };
  }, [data, seriesLimit, showAllSeries]);
}
function getDragClasses(panel) {
  var _a, _b;
  const parentLayout = sceneGraph.getLayout(panel);
  const isDraggable = parentLayout == null ? void 0 : parentLayout.isDraggable();
  if (!parentLayout || !isDraggable || itemDraggingDisabled(panel, parentLayout)) {
    return { dragClass: "", dragClassCancel: "" };
  }
  return { dragClass: (_a = parentLayout.getDragClass) == null ? void 0 : _a.call(parentLayout), dragClassCancel: (_b = parentLayout == null ? void 0 : parentLayout.getDragClassCancel) == null ? void 0 : _b.call(parentLayout) };
}
function getDragHooks(panel) {
  var _a, _b;
  const parentLayout = sceneGraph.getLayout(panel);
  return (_b = (_a = parentLayout == null ? void 0 : parentLayout.getDragHooks) == null ? void 0 : _a.call(parentLayout)) != null ? _b : {};
}
function itemDraggingDisabled(item, layout) {
  let obj = item;
  while (obj && obj !== layout) {
    if ("isDraggable" in obj.state && obj.state.isDraggable === false) {
      return true;
    }
    if ("repeatSourceKey" in obj.state && obj.state.repeatSourceKey) {
      return true;
    }
    obj = obj.parent;
  }
  return false;
}
function getChromeStatusMessage(data, pluginLoadingError) {
  if (pluginLoadingError) {
    return pluginLoadingError;
  }
  let message = data.error ? data.error.message : void 0;
  if (data.errors) {
    message = data.errors.map((e) => e.message).join(", ");
  }
  return message;
}
const relativeWrapper = css.css({
  position: "relative",
  width: "100%",
  height: "100%"
});
const absoluteWrapper = css.css({
  position: "absolute",
  width: "100%",
  height: "100%"
});
const getAlertStateStyles = (theme) => {
  return {
    ok: css.css({
      color: theme.colors.success.text
    }),
    pending: css.css({
      color: theme.colors.warning.text
    }),
    alerting: css.css({
      color: theme.colors.error.text
    })
  };
};

const displayOverrideRef = "hideSeriesFrom";
const isHideSeriesOverride = data.isSystemOverrideWithRef(displayOverrideRef);
function seriesVisibilityConfigFactory(label, mode, fieldConfig, data) {
  const { overrides } = fieldConfig;
  const displayName = label;
  const currentIndex = overrides.findIndex(isHideSeriesOverride);
  if (currentIndex < 0) {
    if (mode === ui.SeriesVisibilityChangeMode.ToggleSelection) {
      const override3 = createOverride$1([displayName, ...getNamesOfHiddenFields(overrides, data)]);
      return {
        ...fieldConfig,
        overrides: [...fieldConfig.overrides, override3]
      };
    }
    const displayNames = getDisplayNames(data, displayName);
    const override2 = createOverride$1(displayNames);
    return {
      ...fieldConfig,
      overrides: [...fieldConfig.overrides, override2]
    };
  }
  const overridesCopy = Array.from(overrides);
  const [current] = overridesCopy.splice(currentIndex, 1);
  if (mode === ui.SeriesVisibilityChangeMode.ToggleSelection) {
    let existing = getExistingDisplayNames(current);
    const nameOfHiddenFields = getNamesOfHiddenFields(overridesCopy, data);
    if (nameOfHiddenFields.length > 0) {
      existing = existing.filter((el) => nameOfHiddenFields.indexOf(el) < 0);
    }
    if (existing[0] === displayName && existing.length === 1) {
      return {
        ...fieldConfig,
        overrides: overridesCopy
      };
    }
    const override2 = createOverride$1([displayName, ...nameOfHiddenFields]);
    return {
      ...fieldConfig,
      overrides: [...overridesCopy, override2]
    };
  }
  const override = createExtendedOverride(current, displayName);
  if (allFieldsAreExcluded(override, data)) {
    return {
      ...fieldConfig,
      overrides: overridesCopy
    };
  }
  return {
    ...fieldConfig,
    overrides: [...overridesCopy, override]
  };
}
function createOverride$1(names, mode = data.ByNamesMatcherMode.exclude, property) {
  property = property != null ? property : {
    id: "custom.hideFrom",
    value: {
      viz: true,
      legend: false,
      tooltip: true
    }
  };
  return {
    __systemRef: displayOverrideRef,
    matcher: {
      id: data.FieldMatcherID.byNames,
      options: {
        mode,
        names,
        prefix: mode === data.ByNamesMatcherMode.exclude ? "All except:" : void 0,
        readOnly: true
      }
    },
    properties: [
      {
        ...property,
        value: {
          viz: true,
          legend: false,
          tooltip: true
        }
      }
    ]
  };
}
const createExtendedOverride = (current, displayName, mode = data.ByNamesMatcherMode.exclude) => {
  const property = current.properties.find((p) => p.id === "custom.hideFrom");
  const existing = getExistingDisplayNames(current);
  const index = existing.findIndex((name) => name === displayName);
  if (index < 0) {
    existing.push(displayName);
  } else {
    existing.splice(index, 1);
  }
  return createOverride$1(existing, mode, property);
};
const getExistingDisplayNames = (rule) => {
  var _a;
  const names = (_a = rule.matcher.options) == null ? void 0 : _a.names;
  if (!Array.isArray(names)) {
    return [];
  }
  return [...names];
};
const allFieldsAreExcluded = (override, data) => {
  return getExistingDisplayNames(override).length === getDisplayNames(data).length;
};
const getDisplayNames = (data$1, excludeName) => {
  const unique = /* @__PURE__ */ new Set();
  for (const frame of data$1) {
    for (const field of frame.fields) {
      if (field.type !== data.FieldType.number) {
        continue;
      }
      const name = data.getFieldDisplayName(field, frame, data$1);
      if (name === excludeName) {
        continue;
      }
      unique.add(name);
    }
  }
  return Array.from(unique);
};
const getNamesOfHiddenFields = (overrides, data$1) => {
  var _a;
  let names = [];
  for (const override of overrides) {
    const property = override.properties.find((p) => p.id === "custom.hideFrom");
    if (property !== void 0 && ((_a = property.value) == null ? void 0 : _a.legend) === true) {
      const info = data.fieldMatchers.get(override.matcher.id);
      const matcher = info.get(override.matcher.options);
      for (const frame of data$1) {
        for (const field of frame.fields) {
          if (field.type !== data.FieldType.number) {
            continue;
          }
          const name = data.getFieldDisplayName(field, frame, data$1);
          if (matcher(field, frame, data$1)) {
            names.push(name);
          }
        }
      }
    }
  }
  return names;
};

const changeSeriesColorConfigFactory = (label, color, fieldConfig) => {
  const { overrides } = fieldConfig;
  const currentIndex = fieldConfig.overrides.findIndex((override) => {
    return override.matcher.id === data.FieldMatcherID.byName && override.matcher.options === label;
  });
  if (currentIndex < 0) {
    return {
      ...fieldConfig,
      overrides: [...fieldConfig.overrides, createOverride(label, color)]
    };
  }
  const overridesCopy = Array.from(overrides);
  const existing = overridesCopy[currentIndex];
  const propertyIndex = existing.properties.findIndex((p) => p.id === "color");
  if (propertyIndex < 0) {
    overridesCopy[currentIndex] = {
      ...existing,
      properties: [...existing.properties, createProperty(color)]
    };
    return {
      ...fieldConfig,
      overrides: overridesCopy
    };
  }
  const propertiesCopy = Array.from(existing.properties);
  propertiesCopy[propertyIndex] = createProperty(color);
  overridesCopy[currentIndex] = {
    ...existing,
    properties: propertiesCopy
  };
  return {
    ...fieldConfig,
    overrides: overridesCopy
  };
};
const createOverride = (label, color) => {
  return {
    matcher: {
      id: data.FieldMatcherID.byName,
      options: label
    },
    properties: [createProperty(color)]
  };
};
const createProperty = (color) => {
  return {
    id: "color",
    value: {
      mode: data.FieldColorModeId.Fixed,
      fixedColor: color
    }
  };
};

class CursorSync extends SceneObjectBase {
  constructor(state) {
    super({
      ...state,
      sync: state.sync || schema.DashboardCursorSync.Off
    });
    this.getEventsBus = (panel) => {
      if (!this.parent) {
        throw new Error("EnableCursorSync cannot be used as a standalone scene object");
      }
      return new PanelContextEventBus(this.parent, panel);
    };
  }
  getEventsScope() {
    if (!this.parent) {
      throw new Error("EnableCursorSync cannot be used as a standalone scene object");
    }
    return this.state.key;
  }
}
class PanelContextEventBus {
  constructor(_source, _eventsOrigin) {
    this._source = _source;
    this._eventsOrigin = _eventsOrigin;
  }
  publish(event) {
    event.origin = this;
    this._eventsOrigin.publishEvent(event, true);
  }
  getStream(eventType) {
    return new rxjs.Observable((observer) => {
      const handler = (event) => {
        observer.next(event);
      };
      const sub = this._source.subscribeToEvent(eventType, handler);
      return () => sub.unsubscribe();
    });
  }
  subscribe(eventType, handler) {
    return this.getStream(eventType).pipe().subscribe(handler);
  }
  removeAllListeners() {
  }
  newScopedBus(key, filter) {
    throw new Error("For internal use only");
  }
}
function getCursorSyncScope(sceneObject) {
  return sceneGraph.findObject(sceneObject, (o) => o instanceof CursorSync);
}

const _LiveNowTimer = class _LiveNowTimer extends SceneObjectBase {
  // ms
  constructor({ enabled = false }) {
    super({ enabled });
    this.timerId = void 0;
    this._activationHandler = () => {
      if (this.state.enabled) {
        this.enable();
      }
      return () => {
        window.clearInterval(this.timerId);
        this.timerId = void 0;
      };
    };
    this.addActivationHandler(this._activationHandler);
  }
  enable() {
    window.clearInterval(this.timerId);
    this.timerId = void 0;
    this.timerId = window.setInterval(() => {
      const panels = sceneGraph.findAllObjects(this.getRoot(), (obj) => obj instanceof VizPanel);
      for (const panel of panels) {
        panel.forceRender();
      }
    }, _LiveNowTimer.REFRESH_RATE);
    this.setState({ enabled: true });
  }
  disable() {
    window.clearInterval(this.timerId);
    this.timerId = void 0;
    this.setState({ enabled: false });
  }
  get isEnabled() {
    return this.state.enabled;
  }
};
_LiveNowTimer.REFRESH_RATE = 100;
let LiveNowTimer = _LiveNowTimer;

class VizPanelRenderProfiler extends SceneObjectBase {
  constructor(state = {}) {
    super({
      ...state
    });
    this._isTracking = false;
    this._activeQueries = /* @__PURE__ */ new Map();
    this.addActivationHandler(() => {
      return this._onActivate();
    });
  }
  _onActivate() {
    var _a, _b;
    let panel;
    try {
      panel = sceneGraph.getAncestor(this, VizPanel);
    } catch (error) {
      writeSceneLog("VizPanelRenderProfiler", "Failed to find VizPanel ancestor", error);
      return;
    }
    if (!panel) {
      writeSceneLog("VizPanelRenderProfiler", "Not attached to a VizPanel");
      return;
    }
    if (!panel.state.key) {
      writeSceneLog("VizPanelRenderProfiler", "Panel has no key, skipping tracking");
      return;
    }
    this._panelKey = panel.state.key;
    this._panelId = String(panel.getLegacyPanelId());
    this._pluginId = panel.state.pluginId;
    const plugin = panel.getPlugin();
    this._pluginVersion = (_b = (_a = plugin == null ? void 0 : plugin.meta) == null ? void 0 : _a.info) == null ? void 0 : _b.version;
    this._subs.add(
      panel.subscribeToState((newState, prevState) => {
        this._handlePanelStateChange(panel, newState, prevState);
      })
    );
    return () => {
      this._cleanup();
    };
  }
  _handlePanelStateChange(panel, newState, prevState) {
    if (newState.pluginId !== prevState.pluginId) {
      this._onPluginChange(panel, newState.pluginId);
    }
  }
  /**
   * Track query execution with operation ID correlation
   */
  onQueryStarted(timestamp, entry, queryId) {
    if (!this._panelKey) {
      return null;
    }
    this._activeQueries.set(queryId, { entry, startTime: timestamp });
    const operationId = generateOperationId("query");
    getScenePerformanceTracker().notifyPanelOperationStart({
      operationId,
      panelId: this._panelId,
      panelKey: this._panelKey,
      pluginId: this._pluginId,
      pluginVersion: this._pluginVersion,
      operation: "query",
      timestamp,
      metadata: {
        queryId,
        queryType: entry.type
      }
    });
    return (endTimestamp, error) => {
      if (!this._panelKey) {
        return;
      }
      const queryInfo = this._activeQueries.get(queryId);
      if (!queryInfo) {
        return;
      }
      const duration = endTimestamp - queryInfo.startTime;
      this._activeQueries.delete(queryId);
      getScenePerformanceTracker().notifyPanelOperationComplete({
        operationId,
        panelId: this._panelId,
        panelKey: this._panelKey,
        pluginId: this._pluginId,
        pluginVersion: this._pluginVersion,
        operation: "query",
        timestamp: endTimestamp,
        duration,
        metadata: {
          queryId,
          queryType: entry.type
        },
        error: error ? (error == null ? void 0 : error.message) || String(error) || "Unknown error" : void 0
      });
    };
  }
  /**
   * Track plugin loading with operation ID correlation
   */
  onPluginLoadStart(pluginId) {
    if (!this._panelKey) {
      let panel;
      try {
        panel = sceneGraph.getAncestor(this, VizPanel);
      } catch (error) {
        return null;
      }
      if (panel && !this._panelKey && panel.state.key) {
        this._panelKey = panel.state.key;
        this._panelId = String(panel.getLegacyPanelId());
        this._pluginId = pluginId;
      }
    }
    if (!this._panelKey) {
      return null;
    }
    if (!this._isTracking) {
      this._startTracking();
    }
    this._loadPluginStartTime = performance.now();
    const operationId = generateOperationId("pluginLoad");
    getScenePerformanceTracker().notifyPanelOperationStart({
      operationId,
      panelId: this._panelId,
      panelKey: this._panelKey,
      pluginId: this._pluginId,
      operation: "plugin-load",
      timestamp: this._loadPluginStartTime,
      metadata: {
        pluginId
      }
    });
    return (plugin, fromCache = false) => {
      if (!this._panelKey || !this._loadPluginStartTime) {
        return;
      }
      const duration = performance.now() - this._loadPluginStartTime;
      getScenePerformanceTracker().notifyPanelOperationComplete({
        operationId,
        panelId: this._panelId,
        panelKey: this._panelKey,
        pluginId: this._pluginId,
        operation: "plugin-load",
        timestamp: performance.now(),
        duration,
        metadata: {
          pluginId: this._pluginId,
          fromCache,
          pluginLoadTime: duration
        }
      });
      this._loadPluginStartTime = void 0;
    };
  }
  /**
   * Track field config processing with operation ID correlation
   */
  onFieldConfigStart(timestamp) {
    if (!this._panelKey) {
      return null;
    }
    this._applyFieldConfigStartTime = timestamp;
    const operationId = generateOperationId("fieldConfig");
    getScenePerformanceTracker().notifyPanelOperationStart({
      operationId,
      panelId: this._panelId,
      panelKey: this._panelKey,
      pluginId: this._pluginId,
      operation: "fieldConfig",
      timestamp: this._applyFieldConfigStartTime,
      metadata: {}
    });
    return (endTimestamp, dataPointsCount, seriesCount) => {
      if (!this._panelKey || !this._applyFieldConfigStartTime) {
        return;
      }
      const duration = endTimestamp - this._applyFieldConfigStartTime;
      getScenePerformanceTracker().notifyPanelOperationComplete({
        operationId,
        panelId: this._panelId,
        panelKey: this._panelKey,
        pluginId: this._pluginId,
        operation: "fieldConfig",
        timestamp: endTimestamp,
        duration,
        metadata: {}
      });
      this._applyFieldConfigStartTime = void 0;
    };
  }
  /**
   * Get panel info for logging - truncates long titles for readability
   */
  _getPanelInfo() {
    let panel;
    try {
      panel = sceneGraph.getAncestor(this, VizPanel);
    } catch (error) {
    }
    let panelTitle = (panel == null ? void 0 : panel.state.title) || this._panelKey || "No-key panel";
    if (panelTitle.length > 30) {
      panelTitle = panelTitle.substring(0, 27) + "...";
    }
    return `VizPanelRenderProfiler [${panelTitle}]`;
  }
  /**
   * Track simple render timing with operation ID correlation
   */
  onSimpleRenderStart(timestamp) {
    if (!this._panelKey) {
      return void 0;
    }
    const operationId = generateOperationId("render");
    getScenePerformanceTracker().notifyPanelOperationStart({
      operationId,
      panelId: this._panelId || "unknown",
      panelKey: this._panelKey,
      pluginId: this._pluginId || "unknown",
      pluginVersion: this._pluginVersion,
      operation: "render",
      timestamp,
      metadata: {}
    });
    return (endTimestamp, duration) => {
      if (!this._panelKey) {
        return;
      }
      getScenePerformanceTracker().notifyPanelOperationComplete({
        operationId,
        panelId: this._panelId || "unknown",
        panelKey: this._panelKey,
        pluginId: this._pluginId || "unknown",
        pluginVersion: this._pluginVersion,
        operation: "render",
        duration,
        timestamp: endTimestamp,
        metadata: {}
      });
    };
  }
  /** Handle plugin changes */
  _onPluginChange(panel, newPluginId) {
    var _a, _b;
    this._pluginId = newPluginId;
    const plugin = panel.getPlugin();
    this._pluginVersion = (_b = (_a = plugin == null ? void 0 : plugin.meta) == null ? void 0 : _a.info) == null ? void 0 : _b.version;
    writeSceneLog(this._getPanelInfo(), `Plugin changed to ${newPluginId}`);
  }
  /** Start tracking this panel */
  _startTracking() {
    if (!this._panelKey || !this._pluginId || this._isTracking) {
      return;
    }
    this._isTracking = true;
  }
  /** Cleanup when behavior is deactivated */
  _cleanup() {
    this._activeQueries.clear();
    this._isTracking = false;
    writeSceneLog(this._getPanelInfo(), "Cleaned up");
  }
  /**
   * Track data transformation with operation ID correlation
   */
  onDataTransformStart(timestamp, transformationId, metrics) {
    if (!this._panelKey) {
      return null;
    }
    const operationId = generateOperationId("transform");
    getScenePerformanceTracker().notifyPanelOperationStart({
      operationId,
      panelId: this._panelId,
      panelKey: this._panelKey,
      pluginId: this._pluginId,
      operation: "transform",
      timestamp,
      metadata: {
        transformationId,
        transformationCount: metrics.transformationCount,
        seriesTransformationCount: metrics.seriesTransformationCount,
        annotationTransformationCount: metrics.annotationTransformationCount
      }
    });
    return (endTimestamp, duration, success, result) => {
      if (!this._panelKey) {
        return;
      }
      getScenePerformanceTracker().notifyPanelOperationComplete({
        operationId,
        panelId: this._panelId,
        panelKey: this._panelKey,
        pluginId: this._pluginId,
        operation: "transform",
        timestamp: endTimestamp,
        duration,
        metadata: {
          transformationId,
          transformationCount: metrics.transformationCount,
          seriesTransformationCount: metrics.seriesTransformationCount,
          annotationTransformationCount: metrics.annotationTransformationCount,
          success,
          error: (result == null ? void 0 : result.error) || (!success ? "Transform operation failed" : void 0)
        }
      });
    };
  }
}

class DataLayersMerger {
  constructor() {
    this._resultsMap = /* @__PURE__ */ new Map();
    this._prevLayers = [];
  }
  getMergedStream(layers) {
    if (areDifferentLayers(layers, this._prevLayers)) {
      this._resultsMap = /* @__PURE__ */ new Map();
      this._prevLayers = layers;
    }
    const resultStreams = layers.map((l) => l.getResultsStream());
    const deactivationHandlers = [];
    for (const layer of layers) {
      deactivationHandlers.push(layer.activate());
    }
    return rxjs.merge(resultStreams).pipe(
      rxjs.mergeAll(),
      rxjs.filter((v) => {
        return this._resultsMap.get(v.origin.state.key) !== v;
      }),
      rxjs.map((v) => {
        this._resultsMap.set(v.origin.state.key, v);
        return this._resultsMap.values();
      }),
      rxjs.finalize(() => {
        deactivationHandlers.forEach((handler) => handler());
      })
    );
  }
}
function areDifferentLayers(a, b) {
  if (a.length !== b.length) {
    return true;
  }
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return true;
    }
  }
  return false;
}

class SceneDataLayerSetBase extends SceneObjectBase {
  constructor() {
    super(...arguments);
    /** Mark it as a data layer */
    this.isDataLayer = true;
    /**
     * Subject to emit results to.
     */
    this._results = new rxjs.ReplaySubject(1);
    this._dataLayersMerger = new DataLayersMerger();
  }
  subscribeToAllLayers(layers) {
    if (layers.length > 0) {
      this.querySub = this._dataLayersMerger.getMergedStream(layers).subscribe(this._onLayerUpdateReceived.bind(this));
    } else {
      this._results.next({ origin: this, data: emptyPanelData });
      this.setStateHelper({ data: emptyPanelData });
    }
  }
  _onLayerUpdateReceived(results) {
    var _a;
    let series = [];
    for (const result of results) {
      if ((_a = result.data) == null ? void 0 : _a.series) {
        series = series.concat(result.data.series);
      }
    }
    const combinedData = { ...emptyPanelData, series };
    this._results.next({ origin: this, data: combinedData });
    this.setStateHelper({ data: combinedData });
  }
  getResultsStream() {
    return this._results;
  }
  cancelQuery() {
    var _a;
    (_a = this.querySub) == null ? void 0 : _a.unsubscribe();
  }
  /**
   * This helper function is to counter the contravariance of setState
   */
  setStateHelper(state) {
    setBaseClassState(this, state);
  }
}
class SceneDataLayerSet extends SceneDataLayerSetBase {
  constructor(state) {
    var _a, _b;
    super({
      name: (_a = state.name) != null ? _a : "Data layers",
      layers: (_b = state.layers) != null ? _b : []
    });
    this.addActivationHandler(() => this._onActivate());
  }
  _onActivate() {
    this._subs.add(
      this.subscribeToState((newState, oldState) => {
        var _a;
        if (newState.layers !== oldState.layers) {
          (_a = this.querySub) == null ? void 0 : _a.unsubscribe();
          this.subscribeToAllLayers(newState.layers);
        }
      })
    );
    this.subscribeToAllLayers(this.state.layers);
    return () => {
      var _a;
      (_a = this.querySub) == null ? void 0 : _a.unsubscribe();
    };
  }
}
SceneDataLayerSet.Component = ({ model }) => {
  const { layers } = model.useState();
  return /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, layers.map((layer) => /* @__PURE__ */ React__default.default.createElement(layer.Component, { model: layer, key: layer.state.key })));
};

class SceneDataTransformer extends SceneObjectBase {
  constructor(state) {
    super(state);
    this._results = new rxjs.ReplaySubject(1);
    /**
     * Scan transformations for variable usage and re-process transforms when a variable values change
     */
    this._variableDependency = new VariableDependencyConfig(
      this,
      {
        statePaths: ["transformations"],
        onReferencedVariableValueChanged: () => this.reprocessTransformations()
      }
    );
    this.addActivationHandler(() => this.activationHandler());
  }
  activationHandler() {
    const sourceData = this.getSourceData();
    this._subs.add(sourceData.subscribeToState((state) => this.transform(state.data)));
    if (sourceData.state.data) {
      this.transform(sourceData.state.data);
    }
    return () => {
      if (this._transformSub) {
        this._transformSub.unsubscribe();
      }
    };
  }
  getSourceData() {
    if (this.state.$data) {
      if (this.state.$data instanceof SceneDataLayerSet) {
        throw new Error("SceneDataLayerSet can not be used as data provider for SceneDataTransformer.");
      }
      return this.state.$data;
    }
    if (!this.parent || !this.parent.parent) {
      throw new Error("SceneDataTransformer must either have $data set on it or have a parent.parent with $data");
    }
    return sceneGraph.getData(this.parent.parent);
  }
  setContainerWidth(width) {
    if (this.state.$data && this.state.$data.setContainerWidth) {
      this.state.$data.setContainerWidth(width);
    }
  }
  isDataReadyToDisplay() {
    const dataObject = this.getSourceData();
    if (dataObject.isDataReadyToDisplay) {
      return dataObject.isDataReadyToDisplay();
    }
    return true;
  }
  reprocessTransformations() {
    this.transform(this.getSourceData().state.data, true);
  }
  /**
   * S3.1: Calculate transformation complexity metrics
   */
  _calculateTransformationMetrics(data$1, transformations) {
    const transformationCount = transformations.length;
    const seriesTransformationCount = transformations.filter((transformation) => {
      if ("options" in transformation || "topic" in transformation) {
        return transformation.topic == null || transformation.topic === data.DataTopic.Series;
      }
      return true;
    }).length;
    const annotationTransformationCount = transformations.filter((transformation) => {
      if ("options" in transformation || "topic" in transformation) {
        return transformation.topic === data.DataTopic.Annotations;
      }
      return false;
    }).length;
    return {
      transformationCount,
      seriesTransformationCount,
      annotationTransformationCount
    };
  }
  cancelQuery() {
    var _a, _b;
    (_b = (_a = this.getSourceData()).cancelQuery) == null ? void 0 : _b.call(_a);
  }
  getResultsStream() {
    return this._results;
  }
  clone(withState) {
    const clone = super.clone(withState);
    if (this._prevDataFromSource) {
      clone["_prevDataFromSource"] = this._prevDataFromSource;
    }
    return clone;
  }
  isInViewChanged(isInView) {
    var _a, _b;
    (_b = (_a = this.state.$data) == null ? void 0 : _a.isInViewChanged) == null ? void 0 : _b.call(_a, isInView);
  }
  bypassIsInViewChanged(bypassIsInView) {
    var _a, _b;
    (_b = (_a = this.state.$data) == null ? void 0 : _a.bypassIsInViewChanged) == null ? void 0 : _b.call(_a, bypassIsInView);
  }
  haveAlreadyTransformedData(data) {
    if (!this._prevDataFromSource) {
      return false;
    }
    if (data === this._prevDataFromSource) {
      return true;
    }
    const { series, annotations } = this._prevDataFromSource;
    if (data.series === series && data.annotations === annotations) {
      if (this.state.data && data.state !== this.state.data.state) {
        this.setState({ data: { ...this.state.data, state: data.state } });
      }
      return true;
    }
    return false;
  }
  transform(data$1, force = false) {
    var _a;
    const timestamp = performance.now();
    const profiler = findPanelProfiler(this);
    const transformStartTime = performance.now();
    let transformationId;
    let endTransformCallback = null;
    if (this.state.transformations.length === 0 || !data$1) {
      this._prevDataFromSource = data$1;
      this.setState({ data: data$1 });
      if (data$1) {
        this._results.next({ origin: this, data: data$1 });
      }
      return;
    }
    if (!force && this.haveAlreadyTransformedData(data$1)) {
      return;
    }
    if (profiler) {
      const transformationTypes = this.state.transformations.map((t) => {
        if ("id" in t) {
          return t.id;
        } else {
          return "customTransformation";
        }
      }).join("+");
      transformationId = transformationTypes || "no-transforms";
      const metrics = this._calculateTransformationMetrics(data$1, this.state.transformations);
      endTransformCallback = profiler.onDataTransformStart(timestamp, transformationId, metrics);
    }
    const interpolatedTransformations = this._interpolateVariablesInTransformationConfigs(data$1);
    const seriesTransformations = this._filterAndPrepareTransformationsByTopic(
      interpolatedTransformations,
      (transformation) => {
        if ("options" in transformation || "topic" in transformation) {
          return transformation.topic == null || transformation.topic === data.DataTopic.Series;
        }
        return true;
      }
    );
    const annotationsTransformations = this._filterAndPrepareTransformationsByTopic(
      interpolatedTransformations,
      (transformation) => {
        if ("options" in transformation || "topic" in transformation) {
          return transformation.topic === data.DataTopic.Annotations;
        }
        return false;
      }
    );
    if (this._transformSub) {
      this._transformSub.unsubscribe();
    }
    const ctx = {
      interpolate: (value, scopedVars) => {
        var _a2;
        return sceneGraph.interpolate(this, value, { ...(_a2 = data$1.request) == null ? void 0 : _a2.scopedVars, ...scopedVars });
      }
    };
    const seriesStream = data.transformDataFrame(seriesTransformations, data$1.series, ctx);
    const annotationsStream = data.transformDataFrame(annotationsTransformations, (_a = data$1.annotations) != null ? _a : []);
    let series = [];
    let annotations = [];
    this._transformSub = rxjs.forkJoin([seriesStream, annotationsStream]).pipe(
      rxjs.map((results) => {
        results.forEach((frames) => {
          var _a2;
          for (const frame of frames) {
            if (((_a2 = frame.meta) == null ? void 0 : _a2.dataTopic) === data.DataTopic.Annotations) {
              annotations.push(frame);
            } else {
              series.push(frame);
            }
          }
        });
        return { ...data$1, series, annotations };
      }),
      rxjs.catchError((err) => {
        var _a2;
        const timestamp2 = performance.now();
        const duration = timestamp2 - transformStartTime;
        if (endTransformCallback) {
          endTransformCallback(timestamp2, duration, false, {
            error: err.message || err
          });
        }
        console.error("Error transforming data: ", err);
        const sourceErr = ((_a2 = this.getSourceData().state.data) == null ? void 0 : _a2.errors) || [];
        const transformationError = runtime.toDataQueryError(err);
        transformationError.message = `Error transforming data: ${transformationError.message}`;
        const result = {
          ...data$1,
          state: data.LoadingState.Error,
          // Combine transformation error with upstream errors
          errors: [...sourceErr, transformationError]
        };
        return rxjs.of(result);
      })
    ).subscribe((transformedData) => {
      var _a2;
      const timestamp2 = performance.now();
      const duration = timestamp2 - transformStartTime;
      if (endTransformCallback) {
        endTransformCallback(timestamp2, duration, true, {
          outputSeriesCount: transformedData.series.length,
          outputAnnotationsCount: ((_a2 = transformedData.annotations) == null ? void 0 : _a2.length) || 0
        });
      }
      this.setState({ data: transformedData });
      this._results.next({ origin: this, data: transformedData });
      this._prevDataFromSource = data$1;
    });
  }
  _interpolateVariablesInTransformationConfigs(data) {
    var _a;
    const transformations = this.state.transformations;
    if (this._variableDependency.getNames().size === 0) {
      return transformations;
    }
    const onlyObjects = transformations.every((t) => typeof t === "object");
    if (onlyObjects) {
      return JSON.parse(sceneGraph.interpolate(this, JSON.stringify(transformations), (_a = data.request) == null ? void 0 : _a.scopedVars));
    }
    return transformations.map((t) => {
      var _a2;
      return typeof t === "object" ? JSON.parse(sceneGraph.interpolate(this, JSON.stringify(t), (_a2 = data.request) == null ? void 0 : _a2.scopedVars)) : t;
    });
  }
  _filterAndPrepareTransformationsByTopic(interpolatedTransformations, transformationFilter) {
    return interpolatedTransformations.filter(transformationFilter).map((transformation) => "operator" in transformation ? transformation.operator : transformation);
  }
}

class VizPanel extends SceneObjectBase {
  constructor(state) {
    var _a;
    super({
      options: {},
      fieldConfig: { defaults: {}, overrides: [] },
      title: i18n.t("grafana-scenes.components.viz-panel.title.title", "Title"),
      pluginId: "timeseries",
      _renderCounter: 0,
      ...state
    });
    this._variableDependency = new VariableDependencyConfig(this, {
      statePaths: ["title", "options", "fieldConfig"]
    });
    this._structureRev = 0;
    this.onTimeRangeChange = (timeRange) => {
      const sceneTimeRange = sceneGraph.getTimeRange(this);
      sceneTimeRange.onTimeRangeChange({
        raw: {
          from: data.toUtc(timeRange.from),
          to: data.toUtc(timeRange.to)
        },
        from: data.toUtc(timeRange.from),
        to: data.toUtc(timeRange.to)
      });
    };
    this.getTimeRange = (data) => {
      const liveNowTimer = sceneGraph.findObject(this, (o) => o instanceof LiveNowTimer);
      const sceneTimeRange = sceneGraph.getTimeRange(this);
      if (liveNowTimer instanceof LiveNowTimer && liveNowTimer.isEnabled) {
        return evaluateTimeRange(
          sceneTimeRange.state.from,
          sceneTimeRange.state.to,
          sceneTimeRange.getTimeZone(),
          sceneTimeRange.state.fiscalYearStartMonth,
          sceneTimeRange.state.UNSAFE_nowDelay,
          sceneTimeRange.state.weekStart
        );
      }
      const plugin = this.getPlugin();
      if (plugin && !plugin.meta.skipDataQuery && data && data.timeRange) {
        return data.timeRange;
      }
      return sceneTimeRange.state.value;
    };
    this.onTitleChange = (title) => {
      this.setState({ title });
    };
    this.onDescriptionChange = (description) => {
      this.setState({ description });
    };
    this.onDisplayModeChange = (displayMode) => {
      this.setState({ displayMode });
    };
    this.onToggleCollapse = (collapsed) => {
      this.setState({
        collapsed
      });
    };
    this.onOptionsChange = (optionsUpdate, replace = false, isAfterPluginChange = false) => {
      var _a;
      const { fieldConfig, options } = this.state;
      const nextOptions = replace ? optionsUpdate : lodash.mergeWith(lodash.cloneDeep(options), optionsUpdate, (objValue, srcValue, key, obj) => {
        if (lodash.isArray(srcValue)) {
          return srcValue;
        }
        if (objValue !== srcValue && typeof srcValue === "undefined") {
          obj[key] = srcValue;
          return;
        }
        return;
      });
      const withDefaults = data.getPanelOptionsWithDefaults({
        plugin: this._plugin,
        currentOptions: nextOptions,
        currentFieldConfig: fieldConfig,
        isAfterPluginChange
      });
      this.setState({
        options: withDefaults.options,
        _renderCounter: ((_a = this.state._renderCounter) != null ? _a : 0) + 1
      });
    };
    this.onFieldConfigChange = (fieldConfigUpdate, replace) => {
      const { fieldConfig, options } = this.state;
      const nextFieldConfig = replace ? fieldConfigUpdate : lodash.merge(lodash.cloneDeep(fieldConfig), fieldConfigUpdate);
      const withDefaults = data.getPanelOptionsWithDefaults({
        plugin: this._plugin,
        currentOptions: options,
        currentFieldConfig: nextFieldConfig,
        isAfterPluginChange: false
      });
      this._dataWithFieldConfig = void 0;
      this.setState({ fieldConfig: withDefaults.fieldConfig });
    };
    this.interpolate = (value, scoped, format) => {
      return sceneGraph.interpolate(this, value, scoped, format);
    };
    this.getDescription = () => {
      this.publishEvent(new UserActionEvent({ origin: this, interaction: "panel-description-shown" }), true);
      const { description } = this.state;
      if (description) {
        const markdown = this.interpolate(description);
        return data.renderMarkdown(markdown);
      }
      return "";
    };
    this.onCancelQuery = () => {
      var _a;
      this.publishEvent(new UserActionEvent({ origin: this, interaction: "panel-cancel-query-clicked" }), true);
      const data = sceneGraph.getData(this);
      (_a = data.cancelQuery) == null ? void 0 : _a.call(data);
    };
    this.onStatusMessageClick = () => {
      this.publishEvent(new UserActionEvent({ origin: this, interaction: "panel-status-message-clicked" }), true);
    };
    /**
     * Panel context functions
     */
    this._onSeriesColorChange = (label, color) => {
      this.onFieldConfigChange(changeSeriesColorConfigFactory(label, color, this.state.fieldConfig));
    };
    this._onSeriesVisibilityChange = (label, mode) => {
      if (!this._dataWithFieldConfig) {
        return;
      }
      this.onFieldConfigChange(
        seriesVisibilityConfigFactory(label, mode, this.state.fieldConfig, this._dataWithFieldConfig.series),
        true
      );
    };
    this._onInstanceStateChange = (state) => {
      if (this._panelContext) {
        this._panelContext = {
          ...this._panelContext,
          instanceState: state
        };
      }
      this.setState({ _pluginInstanceState: state });
    };
    this._onToggleLegendSort = (sortKey) => {
      const legendOptions = this.state.options.legend;
      if (!legendOptions) {
        return;
      }
      let sortDesc = legendOptions.sortDesc;
      let sortBy = legendOptions.sortBy;
      if (sortKey !== sortBy) {
        sortDesc = void 0;
      }
      if (sortDesc === false) {
        sortBy = void 0;
        sortDesc = void 0;
      } else {
        sortDesc = !sortDesc;
        sortBy = sortKey;
      }
      this.onOptionsChange(
        {
          ...this.state.options,
          legend: { ...legendOptions, sortBy, sortDesc }
        },
        true
      );
    };
    this.addActivationHandler(() => {
      this._onActivate();
    });
    (_a = state.menu) == null ? void 0 : _a.addActivationHandler(() => {
      this.publishEvent(new UserActionEvent({ origin: this, interaction: "panel-menu-shown" }), true);
    });
  }
  /**
   * Get the VizPanelRenderProfiler behavior if attached
   */
  getProfiler() {
    if (!this.state.$behaviors) {
      return void 0;
    }
    for (const behavior of this.state.$behaviors) {
      if (behavior instanceof VizPanelRenderProfiler) {
        return behavior;
      }
    }
    return void 0;
  }
  _onActivate() {
    if (!this._plugin) {
      this._loadPlugin(this.state.pluginId);
    }
  }
  forceRender() {
    var _a;
    this.setState({ _renderCounter: ((_a = this.state._renderCounter) != null ? _a : 0) + 1 });
  }
  async _loadPlugin(pluginId, overwriteOptions, overwriteFieldConfig, isAfterPluginChange) {
    const profiler = this.getProfiler();
    const plugin = loadPanelPluginSync(pluginId);
    if (plugin) {
      const endPluginLoadCallback = profiler == null ? void 0 : profiler.onPluginLoadStart(pluginId);
      endPluginLoadCallback == null ? void 0 : endPluginLoadCallback(plugin, true);
      this._pluginLoaded(plugin, overwriteOptions, overwriteFieldConfig, isAfterPluginChange);
    } else {
      const { importPanelPlugin } = runtime.getPluginImportUtils();
      try {
        const endPluginLoadCallback = profiler == null ? void 0 : profiler.onPluginLoadStart(pluginId);
        const panelPromise = importPanelPlugin(pluginId);
        const queryControler = sceneGraph.getQueryController(this);
        if (queryControler && queryControler.state.enableProfiling) {
          wrapPromiseInStateObservable(panelPromise).pipe(registerQueryWithController({ type: `VizPanel/loadPlugin/${pluginId}`, origin: this })).subscribe(() => {
          });
        }
        const result = await panelPromise;
        endPluginLoadCallback == null ? void 0 : endPluginLoadCallback(result, false);
        this._pluginLoaded(result, overwriteOptions, overwriteFieldConfig, isAfterPluginChange);
      } catch (err) {
        this._pluginLoaded(getPanelPluginNotFound(pluginId));
        if (err instanceof Error) {
          this.setState({ _pluginLoadError: err.message });
        }
      }
    }
  }
  getLegacyPanelId() {
    var _a, _b;
    const parts = (_b = (_a = this.state.key) == null ? void 0 : _a.split("/")) != null ? _b : [];
    if (parts.length === 0) {
      return 0;
    }
    const part = parts[parts.length - 1];
    const panelId = parseInt(part.replace("panel-", ""), 10);
    if (isNaN(panelId)) {
      return 0;
    }
    return panelId;
  }
  /**
   * Unique id string that includes local variable values (for repeated panels)
   */
  getPathId() {
    return buildPathIdFor(this);
  }
  async _pluginLoaded(plugin, overwriteOptions, overwriteFieldConfig, isAfterPluginChange) {
    var _a;
    const { options, fieldConfig, title, pluginVersion, _UNSAFE_customMigrationHandler } = this.state;
    const panel = {
      title,
      options,
      fieldConfig,
      id: this.getLegacyPanelId(),
      type: plugin.meta.id,
      pluginVersion
    };
    if (overwriteOptions) {
      panel.options = overwriteOptions;
    }
    if (overwriteFieldConfig) {
      panel.fieldConfig = overwriteFieldConfig;
    }
    const currentVersion = this._getPluginVersion(plugin);
    _UNSAFE_customMigrationHandler == null ? void 0 : _UNSAFE_customMigrationHandler(panel, plugin);
    const needsMigration = currentVersion !== pluginVersion || ((_a = plugin.shouldMigrate) == null ? void 0 : _a.call(plugin, panel));
    if (plugin.onPanelMigration && needsMigration && !isAfterPluginChange) {
      panel.options = await plugin.onPanelMigration(panel);
    }
    let $data = this.state.$data;
    if (panel.transformations && $data) {
      if ($data instanceof SceneDataTransformer) {
        $data.setState({ transformations: panel.transformations });
      } else if ($data instanceof SceneQueryRunner) {
        $data.clearParent();
        $data = new SceneDataTransformer({
          transformations: panel.transformations,
          $data
        });
      }
    }
    const withDefaults = data.getPanelOptionsWithDefaults({
      plugin,
      currentOptions: panel.options,
      currentFieldConfig: panel.fieldConfig,
      isAfterPluginChange: isAfterPluginChange != null ? isAfterPluginChange : false
    });
    this._plugin = plugin;
    this.setState({
      $data,
      options: withDefaults.options,
      fieldConfig: withDefaults.fieldConfig,
      pluginVersion: currentVersion,
      pluginId: plugin.meta.id
    });
    if (plugin.meta.skipDataQuery) {
      const sceneTimeRange = sceneGraph.getTimeRange(this);
      this._subs.add(sceneTimeRange.subscribeToState(() => this.forceRender()));
    }
  }
  _getPluginVersion(plugin) {
    return plugin && plugin.meta.info.version ? plugin.meta.info.version : runtime.config.buildInfo.version;
  }
  getPlugin() {
    return this._plugin;
  }
  getPanelContext() {
    var _a;
    (_a = this._panelContext) != null ? _a : this._panelContext = this.buildPanelContext();
    return this._panelContext;
  }
  async changePluginType(pluginId, newOptions, newFieldConfig) {
    var _a, _b;
    const { options: prevOptions, fieldConfig: prevFieldConfig, pluginId: prevPluginId } = this.state;
    this._dataWithFieldConfig = void 0;
    const isAfterPluginChange = this.state.pluginId !== pluginId;
    await this._loadPlugin(pluginId, newOptions != null ? newOptions : {}, newFieldConfig, isAfterPluginChange);
    const panel = {
      title: this.state.title,
      options: this.state.options,
      fieldConfig: this.state.fieldConfig,
      id: 1,
      type: pluginId
    };
    const updatedOptions = (_b = (_a = this._plugin) == null ? void 0 : _a.onPanelTypeChanged) == null ? void 0 : _b.call(_a, panel, prevPluginId, prevOptions, prevFieldConfig);
    if (updatedOptions && !lodash.isEmpty(updatedOptions)) {
      this.onOptionsChange(updatedOptions, true, true);
    }
  }
  clearFieldConfigCache() {
    this._dataWithFieldConfig = void 0;
  }
  /**
   * Called from the react render path to apply the field config to the data provided by the data provider
   */
  applyFieldConfig(rawData) {
    var _a, _b, _c, _d;
    const timestamp = performance.now();
    const plugin = this._plugin;
    const profiler = this.getProfiler();
    if (!plugin || plugin.meta.skipDataQuery || !rawData) {
      return emptyPanelData;
    }
    if (this._prevData && this._dataWithFieldConfig) {
      if (this._prevData === rawData) {
        return this._dataWithFieldConfig;
      }
      if (this._prevData.series === rawData.series) {
        this._prevData = rawData;
        this._dataWithFieldConfig = {
          ...rawData,
          structureRev: this._dataWithFieldConfig.structureRev,
          series: this._dataWithFieldConfig.series
        };
        return this._dataWithFieldConfig;
      }
    }
    const endFieldConfigCallback = profiler == null ? void 0 : profiler.onFieldConfigStart(timestamp);
    const pluginDataSupport = plugin.dataSupport || { alertStates: false, annotations: false };
    const fieldConfigRegistry = plugin.fieldConfigRegistry;
    const prevFrames = (_b = (_a = this._dataWithFieldConfig) == null ? void 0 : _a.series) != null ? _b : [];
    const newFrames = data.applyFieldOverrides({
      data: rawData.series,
      fieldConfig: this.state.fieldConfig,
      fieldConfigRegistry,
      replaceVariables: this.interpolate,
      theme: runtime.config.theme2,
      timeZone: (_c = rawData.request) == null ? void 0 : _c.timezone
    });
    if (!data.compareArrayValues(newFrames, prevFrames, data.compareDataFrameStructures)) {
      this._structureRev++;
    }
    this._dataWithFieldConfig = {
      ...rawData,
      structureRev: this._structureRev,
      series: newFrames
    };
    if (this._dataWithFieldConfig.annotations) {
      this._dataWithFieldConfig.annotations = data.applyFieldOverrides({
        data: this._dataWithFieldConfig.annotations,
        fieldConfig: {
          defaults: {},
          overrides: []
        },
        fieldConfigRegistry,
        replaceVariables: this.interpolate,
        theme: runtime.config.theme2,
        timeZone: (_d = rawData.request) == null ? void 0 : _d.timezone
      });
    }
    if (!pluginDataSupport.alertStates) {
      this._dataWithFieldConfig.alertState = void 0;
    }
    if (!pluginDataSupport.annotations) {
      this._dataWithFieldConfig.annotations = void 0;
    }
    this._prevData = rawData;
    if (profiler) {
      endFieldConfigCallback == null ? void 0 : endFieldConfigCallback(performance.now());
    }
    return this._dataWithFieldConfig;
  }
  clone(withState) {
    return super.clone({ _pluginInstanceState: void 0, _pluginLoadError: void 0, ...withState });
  }
  buildPanelContext() {
    const sync = getCursorSyncScope(this);
    const context = {
      eventsScope: sync ? sync.getEventsScope() : "__global_",
      eventBus: sync ? sync.getEventsBus(this) : runtime.getAppEvents(),
      app: data.CoreApp.Unknown,
      sync: () => {
        if (sync) {
          return sync.state.sync;
        }
        return data.DashboardCursorSync.Off;
      },
      onSeriesColorChange: this._onSeriesColorChange,
      onToggleSeriesVisibility: this._onSeriesVisibilityChange,
      onToggleLegendSort: this._onToggleLegendSort,
      onInstanceStateChange: this._onInstanceStateChange
    };
    if (this.state.extendPanelContext) {
      this.state.extendPanelContext(this, context);
    }
    return context;
  }
}
VizPanel.Component = VizPanelRenderer;
function getPanelPluginNotFound(id) {
  const plugin = new data.PanelPlugin(() => null);
  plugin.meta = {
    id,
    name: id,
    sort: 100,
    type: data.PluginType.panel,
    module: "",
    baseUrl: "",
    info: {
      author: {
        name: ""
      },
      description: "",
      links: [],
      logos: {
        large: "",
        small: "public/img/grafana_icon.svg"
      },
      screenshots: [],
      updated: "",
      version: ""
    }
  };
  return plugin;
}

function findPanelProfiler(sceneObject) {
  try {
    const panel = sceneGraph.getAncestor(sceneObject, VizPanel);
    if (panel) {
      const behaviors = panel.state.$behaviors || [];
      return behaviors.find((b) => b instanceof VizPanelRenderProfiler);
    }
  } catch (error) {
  }
  return void 0;
}

class DrilldownDependenciesManager {
  constructor(variableDependency) {
    this._variableDependency = variableDependency;
  }
  /**
   * Walk up scene graph and find the closest filterset with matching data source
   */
  findAndSubscribeToDrilldowns(interpolatedUid) {
    const filtersVar = findActiveAdHocFilterVariableByUid(interpolatedUid);
    const groupByVar = findActiveGroupByVariablesByUid(interpolatedUid);
    let hasChanges = false;
    if (this._adhocFiltersVar !== filtersVar) {
      this._adhocFiltersVar = filtersVar;
      hasChanges = true;
    }
    if (this._groupByVar !== groupByVar) {
      this._groupByVar = groupByVar;
      hasChanges = true;
    }
    if (hasChanges) {
      this._updateExplicitDrilldownVariableDependencies();
    }
  }
  _updateExplicitDrilldownVariableDependencies() {
    const explicitDependencies = [];
    if (this._adhocFiltersVar) {
      explicitDependencies.push(this._adhocFiltersVar.state.name);
    }
    if (this._groupByVar) {
      explicitDependencies.push(this._groupByVar.state.name);
    }
    this._variableDependency.setVariableNames(explicitDependencies);
  }
  get adHocFiltersVar() {
    return this._adhocFiltersVar;
  }
  get groupByVar() {
    return this._groupByVar;
  }
  getFilters() {
    var _a;
    return this._adhocFiltersVar ? [...(_a = this._adhocFiltersVar.state.originFilters) != null ? _a : [], ...this._adhocFiltersVar.state.filters].filter(
      (f) => isFilterComplete(f) && isFilterApplicable(f)
    ) : void 0;
  }
  getGroupByKeys() {
    return this._groupByVar ? this._groupByVar.getApplicableKeys() : void 0;
  }
  cleanup() {
    this._adhocFiltersVar = void 0;
    this._groupByVar = void 0;
  }
}

let counter$1 = 100;
function getNextRequestId$1(prefix = "SQR") {
  return prefix + counter$1++;
}
class SceneQueryRunner extends SceneObjectBase {
  constructor(initialState) {
    super(initialState);
    this._dataLayersMerger = new DataLayersMerger();
    this._variableValueRecorder = new VariableValueRecorder();
    this._results = new rxjs.ReplaySubject(1);
    this._scopedVars = { __sceneObject: wrapInSafeSerializableSceneObject(this) };
    this._isInView = true;
    this._bypassIsInView = false;
    this._queryNotExecutedWhenOutOfView = false;
    this._variableDependency = new VariableDependencyConfig(this, {
      statePaths: ["queries", "datasource", "minInterval"],
      onVariableUpdateCompleted: this.onVariableUpdatesCompleted.bind(this),
      onAnyVariableChanged: this.onAnyVariableChanged.bind(this),
      dependsOnScopes: true
    });
    this._drilldownDependenciesManager = new DrilldownDependenciesManager(this._variableDependency);
    this.onDataReceived = (data$1) => {
      var _a, _b, _c, _d, _e, _f;
      const preProcessedData = data.preProcessPanelData(data$1, this.state.data);
      this._resultAnnotations = data$1.annotations;
      const dataWithLayersApplied = this._combineDataLayers(preProcessedData);
      const last = this.state.data;
      if (last != null && dataWithLayersApplied.state !== schema.LoadingState.Streaming) {
        const sameSeries = data.compareArrayValues((_a = last.series) != null ? _a : [], (_b = dataWithLayersApplied.series) != null ? _b : [], (a, b) => a === b);
        const sameAnnotations = data.compareArrayValues(
          (_c = last.annotations) != null ? _c : [],
          (_d = dataWithLayersApplied.annotations) != null ? _d : [],
          (a, b) => a === b
        );
        const sameState = last.state === dataWithLayersApplied.state;
        const sameErrors = data.compareArrayValues(
          (_e = last.errors) != null ? _e : [],
          (_f = dataWithLayersApplied.errors) != null ? _f : [],
          (a, b) => lodash.isEqual(a, b)
        );
        if (sameSeries) {
          dataWithLayersApplied.series = last.series;
        }
        if (sameAnnotations) {
          dataWithLayersApplied.annotations = last.annotations;
        }
        if (sameSeries && sameAnnotations && sameState && sameErrors) {
          return;
        }
      }
      let hasFetchedData = this.state._hasFetchedData;
      if (!hasFetchedData && preProcessedData.state !== schema.LoadingState.Loading) {
        hasFetchedData = true;
      }
      this.setState({ data: dataWithLayersApplied, _hasFetchedData: hasFetchedData });
      this._results.next({ origin: this, data: dataWithLayersApplied });
    };
    this.addActivationHandler(() => this._onActivate());
  }
  getResultsStream() {
    return this._results;
  }
  _onActivate() {
    if (this.isQueryModeAuto()) {
      const timeRange = sceneGraph.getTimeRange(this);
      const providers = this.getClosestExtraQueryProviders();
      for (const provider of providers) {
        this._subs.add(
          provider.subscribeToState((n, p) => {
            if (provider.shouldRerun(p, n, this.state.queries)) {
              this.runQueries();
            }
          })
        );
      }
      this.subscribeToTimeRangeChanges(timeRange);
      if (this.shouldRunQueriesOnActivate()) {
        this.runQueries();
      }
    }
    if (!this._dataLayersSub) {
      this._handleDataLayers();
    }
    return () => this._onDeactivate();
  }
  // This method subscribes to all SceneDataLayers up until the root, and combines the results into data provided from SceneQueryRunner
  _handleDataLayers() {
    const dataLayers = sceneGraph.getDataLayers(this);
    if (dataLayers.length === 0) {
      return;
    }
    this._dataLayersSub = this._dataLayersMerger.getMergedStream(dataLayers).subscribe(this._onLayersReceived.bind(this));
  }
  _onLayersReceived(results) {
    var _a, _b, _c, _d, _e;
    const timeRange = sceneGraph.getTimeRange(this);
    const { dataLayerFilter } = this.state;
    let annotations = [];
    let alertStates = [];
    let alertState;
    for (const result of results) {
      for (let frame of result.data.series) {
        if (((_a = frame.meta) == null ? void 0 : _a.dataTopic) === data.DataTopic.Annotations) {
          annotations = annotations.concat(frame);
        }
        if (((_b = frame.meta) == null ? void 0 : _b.dataTopic) === data.DataTopic.AlertStates) {
          alertStates = alertStates.concat(frame);
        }
      }
    }
    if (dataLayerFilter == null ? void 0 : dataLayerFilter.panelId) {
      if (annotations.length > 0) {
        annotations = filterAnnotations(annotations, dataLayerFilter);
      }
      if (alertStates.length > 0) {
        for (const frame of alertStates) {
          const frameView = new data.DataFrameView(frame);
          for (const row of frameView) {
            if (row.panelId === dataLayerFilter.panelId) {
              alertState = row;
              break;
            }
          }
        }
      }
    }
    if (allFramesEmpty(annotations) && allFramesEmpty(this._layerAnnotations) && lodash.isEqual(alertState, (_c = this.state.data) == null ? void 0 : _c.alertState)) {
      return;
    }
    this._layerAnnotations = annotations;
    const baseStateUpdate = this.state.data ? this.state.data : { ...emptyPanelData, timeRange: timeRange.state.value };
    this.setState({
      data: {
        ...baseStateUpdate,
        annotations: [...(_d = this._resultAnnotations) != null ? _d : [], ...annotations],
        alertState: alertState != null ? alertState : (_e = this.state.data) == null ? void 0 : _e.alertState
      }
    });
  }
  /**
   * This tries to start a new query whenever a variable completes or is changed.
   *
   * We care about variable update completions even when the variable has not changed and even when it is not a direct dependency.
   * Example: Variables A and B (B depends on A). A update depends on time range. So when time change query runner will
   * find that variable A is loading which is a dependency on of variable B so will set _isWaitingForVariables to true and
   * not issue any query.
   *
   * When A completes it's loading (with no value change, so B never updates) it will cause a call of this function letting
   * the query runner know that A has completed, and in case _isWaitingForVariables we try to run the query. The query will
   * only run if all variables are in a non loading state so in other scenarios where a query depends on many variables this will
   * be called many times until all dependencies are in a non loading state.   *
   */
  onVariableUpdatesCompleted() {
    if (this.isQueryModeAuto()) {
      this.runQueries();
    }
  }
  /**
   * Check if value changed is a adhoc filter o group by variable that did not exist when we issued the last query
   */
  onAnyVariableChanged(variable) {
    if (this._drilldownDependenciesManager.adHocFiltersVar === variable || this._drilldownDependenciesManager.groupByVar === variable || !this.isQueryModeAuto()) {
      return;
    }
    if (variable instanceof AdHocFiltersVariable && this._isRelevantAutoVariable(variable)) {
      this.runQueries();
    }
    if (variable instanceof GroupByVariable && this._isRelevantAutoVariable(variable)) {
      this.runQueries();
    }
  }
  _isRelevantAutoVariable(variable) {
    var _a, _b;
    const datasource = (_a = this.state.datasource) != null ? _a : findFirstDatasource(this.state.queries);
    return variable.state.applyMode === "auto" && (datasource == null ? void 0 : datasource.uid) === ((_b = variable.state.datasource) == null ? void 0 : _b.uid);
  }
  shouldRunQueriesOnActivate() {
    if (this._variableValueRecorder.hasDependenciesChanged(this)) {
      writeSceneLog(
        "SceneQueryRunner",
        "Variable dependency changed while inactive, shouldRunQueriesOnActivate returns true"
      );
      return true;
    }
    if (!this.state.data) {
      return true;
    }
    if (this._isDataTimeRangeStale(this.state.data)) {
      return true;
    }
    return false;
  }
  _isDataTimeRangeStale(data) {
    const timeRange = sceneGraph.getTimeRange(this);
    const stateTimeRange = timeRange.state.value;
    const dataTimeRange = data.timeRange;
    if (stateTimeRange.from.unix() === dataTimeRange.from.unix() && stateTimeRange.to.unix() === dataTimeRange.to.unix()) {
      return false;
    }
    writeSceneLog("SceneQueryRunner", "Data time range is stale");
    return true;
  }
  _onDeactivate() {
    var _a;
    if (this._querySub) {
      this._querySub.unsubscribe();
      this._querySub = void 0;
    }
    if (this._dataLayersSub) {
      this._dataLayersSub.unsubscribe();
      this._dataLayersSub = void 0;
    }
    (_a = this._timeSub) == null ? void 0 : _a.unsubscribe();
    this._timeSub = void 0;
    this._timeSubRange = void 0;
    this._drilldownDependenciesManager.cleanup();
  }
  setContainerWidth(width) {
    if (!this._containerWidth && width > 0) {
      this._containerWidth = width;
      if (this.state.maxDataPointsFromWidth && !this.state.maxDataPoints) {
        setTimeout(() => {
          if (this.isActive && !this.state._hasFetchedData) {
            this.runQueries();
          }
        }, 0);
      }
    } else {
      if (width > 0) {
        this._containerWidth = width;
      }
    }
  }
  isDataReadyToDisplay() {
    return Boolean(this.state._hasFetchedData);
  }
  subscribeToTimeRangeChanges(timeRange) {
    if (this._timeSubRange === timeRange) {
      return;
    }
    if (this._timeSub) {
      this._timeSub.unsubscribe();
    }
    this._timeSubRange = timeRange;
    this._timeSub = timeRange.subscribeToState(() => {
      this.runWithTimeRange(timeRange);
    });
  }
  runQueries() {
    const timeRange = sceneGraph.getTimeRange(this);
    if (this.isQueryModeAuto()) {
      this.subscribeToTimeRangeChanges(timeRange);
    }
    this.runWithTimeRange(timeRange);
  }
  getMaxDataPoints() {
    var _a;
    if (this.state.maxDataPoints) {
      return this.state.maxDataPoints;
    }
    return this.state.maxDataPointsFromWidth ? (_a = this._containerWidth) != null ? _a : 500 : 500;
  }
  cancelQuery() {
    var _a, _b;
    (_a = this._querySub) == null ? void 0 : _a.unsubscribe();
    if (this._dataLayersSub) {
      this._dataLayersSub.unsubscribe();
      this._dataLayersSub = void 0;
    }
    this.setState({
      data: { ...(_b = this.state.data) != null ? _b : emptyPanelData, state: schema.LoadingState.Done }
    });
  }
  async runWithTimeRange(timeRange) {
    var _a, _b, _c;
    if (!this.state.maxDataPoints && this.state.maxDataPointsFromWidth && !this._containerWidth) {
      return;
    }
    if (this.isQueryModeAuto() && !this._isInView && !this._bypassIsInView) {
      this._queryNotExecutedWhenOutOfView = true;
      return;
    }
    this._queryNotExecutedWhenOutOfView = false;
    if (!this._dataLayersSub) {
      this._handleDataLayers();
    }
    (_a = this._querySub) == null ? void 0 : _a.unsubscribe();
    if (this._variableDependency.hasDependencyInLoadingState()) {
      writeSceneLog("SceneQueryRunner", "Variable dependency is in loading state, skipping query execution");
      this.setState({ data: { ...(_b = this.state.data) != null ? _b : emptyPanelData, state: schema.LoadingState.Loading } });
      return;
    }
    this._variableValueRecorder.recordCurrentDependencyValuesForSceneObject(this);
    const { queries } = this.state;
    if (!(queries == null ? void 0 : queries.length)) {
      this._setNoDataState();
      return;
    }
    try {
      const datasource = (_c = this.state.datasource) != null ? _c : findFirstDatasource(queries);
      const ds = await getDataSource(datasource, this._scopedVars);
      this._drilldownDependenciesManager.findAndSubscribeToDrilldowns(ds.uid);
      const runRequest = runtime.getRunRequest();
      const { primary, secondaries, processors } = this.prepareRequests(timeRange, ds);
      writeSceneLog("SceneQueryRunner", "Starting runRequest", this.state.key);
      let stream = runRequest(ds, primary);
      if (secondaries.length > 0) {
        const secondaryStreams = secondaries.map((r) => runRequest(ds, r));
        const op = extraQueryProcessingOperator(processors);
        stream = rxjs.forkJoin([stream, ...secondaryStreams]).pipe(op);
      }
      const panelProfiler = findPanelProfiler(this);
      stream = stream.pipe(
        registerQueryWithController(
          {
            type: "SceneQueryRunner/runQueries",
            request: primary,
            origin: this,
            cancel: () => this.cancelQuery()
          },
          panelProfiler
        )
      );
      this._querySub = stream.subscribe(this.onDataReceived);
    } catch (err) {
      console.error("PanelQueryRunner Error", err);
      this.onDataReceived({
        ...emptyPanelData,
        ...this.state.data,
        state: schema.LoadingState.Error,
        errors: [runtime.toDataQueryError(err)]
      });
    }
  }
  clone(withState) {
    var _a;
    const clone = super.clone(withState);
    if (this._resultAnnotations) {
      clone["_resultAnnotations"] = this._resultAnnotations.map((frame) => ({ ...frame }));
    }
    if (this._layerAnnotations) {
      clone["_layerAnnotations"] = this._layerAnnotations.map((frame) => ({ ...frame }));
    }
    clone["_variableValueRecorder"] = this._variableValueRecorder.cloneAndRecordCurrentValuesForSceneObject(this);
    clone["_containerWidth"] = this._containerWidth;
    clone["_results"].next({ origin: this, data: (_a = this.state.data) != null ? _a : emptyPanelData });
    return clone;
  }
  prepareRequests(timeRange, ds) {
    var _a;
    const { minInterval, queries, requestIdPrefix } = this.state;
    let request = {
      app: "scenes",
      requestId: getNextRequestId$1(requestIdPrefix),
      timezone: timeRange.getTimeZone(),
      range: timeRange.state.value,
      interval: "1s",
      intervalMs: 1e3,
      targets: lodash.cloneDeep(queries),
      maxDataPoints: this.getMaxDataPoints(),
      scopedVars: this._scopedVars,
      startTime: Date.now(),
      liveStreaming: this.state.liveStreaming,
      rangeRaw: {
        from: timeRange.state.from,
        to: timeRange.state.to
      },
      cacheTimeout: this.state.cacheTimeout,
      queryCachingTTL: this.state.queryCachingTTL,
      scopes: sceneGraph.getScopes(this),
      // This asks the scene root to provide context properties like app, panel and dashboardUID
      ...getEnrichedDataRequest(this)
    };
    const filters = this._drilldownDependenciesManager.getFilters();
    const groupByKeys = this._drilldownDependenciesManager.getGroupByKeys();
    if (filters) {
      request.filters = filters;
    }
    if (groupByKeys) {
      request.groupByKeys = groupByKeys;
    }
    request.targets = request.targets.map((query) => {
      var _a2;
      if (!query.datasource || query.datasource.uid !== ds.uid && !((_a2 = ds.meta) == null ? void 0 : _a2.mixed) && runtime.isExpressionReference && !runtime.isExpressionReference(query.datasource)) {
        query.datasource = ds.getRef();
      }
      return query;
    });
    const lowerIntervalLimit = minInterval ? interpolate(this, minInterval) : ds.interval;
    const norm = data.rangeUtil.calculateInterval(timeRange.state.value, request.maxDataPoints, lowerIntervalLimit);
    request.scopedVars = Object.assign({}, request.scopedVars, {
      __interval: { text: norm.interval, value: norm.interval },
      __interval_ms: { text: norm.intervalMs.toString(), value: norm.intervalMs }
    });
    request.interval = norm.interval;
    request.intervalMs = norm.intervalMs;
    const primaryTimeRange = timeRange.state.value;
    let secondaryRequests = [];
    let secondaryProcessors = /* @__PURE__ */ new Map();
    for (const provider of (_a = this.getClosestExtraQueryProviders()) != null ? _a : []) {
      for (const { req, processor } of provider.getExtraQueries(request)) {
        const requestId = getNextRequestId$1(requestIdPrefix);
        secondaryRequests.push({ ...req, requestId });
        secondaryProcessors.set(requestId, processor != null ? processor : passthroughProcessor);
      }
    }
    request.range = primaryTimeRange;
    return { primary: request, secondaries: secondaryRequests, processors: secondaryProcessors };
  }
  _combineDataLayers(data) {
    if (this._layerAnnotations && this._layerAnnotations.length > 0) {
      data.annotations = (data.annotations || []).concat(this._layerAnnotations);
    }
    if (this.state.data && this.state.data.alertState) {
      data.alertState = this.state.data.alertState;
    }
    return data;
  }
  _setNoDataState() {
    if (this.state.data !== emptyPanelData) {
      this.setState({ data: emptyPanelData });
    }
  }
  /**
   * Walk up the scene graph and find any ExtraQueryProviders.
   *
   * This will return an array of the closest provider of each type.
   */
  getClosestExtraQueryProviders() {
    const found = /* @__PURE__ */ new Map();
    if (!this.parent) {
      return [];
    }
    getClosest(this.parent, (s) => {
      if (isExtraQueryProvider(s) && !found.has(s.constructor)) {
        found.set(s.constructor, s);
      }
      s.forEachChild((child) => {
        if (isExtraQueryProvider(child) && !found.has(child.constructor)) {
          found.set(child.constructor, child);
        }
      });
      return null;
    });
    return Array.from(found.values());
  }
  isQueryModeAuto() {
    var _a;
    return ((_a = this.state.runQueriesMode) != null ? _a : "auto") === "auto";
  }
  isInViewChanged(isInView) {
    writeSceneLog("SceneQueryRunner", `isInViewChanged: ${isInView}`, this.state.key);
    this._isInView = isInView;
    if (isInView && this._queryNotExecutedWhenOutOfView) {
      this.runQueries();
    }
  }
  bypassIsInViewChanged(bypassIsInView) {
    writeSceneLog("SceneQueryRunner", `bypassIsInViewChanged: ${bypassIsInView}`, this.state.key);
    this._bypassIsInView = bypassIsInView;
    if (bypassIsInView && this._queryNotExecutedWhenOutOfView) {
      this.runQueries();
    }
  }
}
function findFirstDatasource(targets) {
  var _a, _b;
  return (_b = (_a = targets.find((t) => t.datasource !== null)) == null ? void 0 : _a.datasource) != null ? _b : void 0;
}
function allFramesEmpty(frames) {
  if (!frames) {
    return true;
  }
  for (let i = 0; i < frames.length; i++) {
    if (frames[i].length > 0) {
      return false;
    }
  }
  return true;
}

function isVariableValueEqual(a, b) {
  if (a === b) {
    return true;
  }
  return lodash.isEqual(a, b);
}
function safeStringifyValue(value) {
  const getCircularReplacer = () => {
    const seen = /* @__PURE__ */ new WeakSet();
    return (_, value2) => {
      if (typeof value2 === "object" && value2 !== null) {
        if (seen.has(value2)) {
          return;
        }
        seen.add(value2);
      }
      return value2;
    };
  };
  try {
    return JSON.stringify(value, getCircularReplacer());
  } catch (error) {
    console.error(error);
  }
  return "";
}
function renderPrometheusLabelFilters(filters) {
  return filters.map((filter) => renderFilter(filter)).join(",");
}
function renderFilter(filter) {
  var _a, _b;
  let value = "";
  let operator = filter.operator;
  if (operator === "=|") {
    operator = "=~";
    value = (_a = filter.values) == null ? void 0 : _a.map(escapeLabelValueInRegexSelector).join("|");
  } else if (operator === "!=|") {
    operator = "!~";
    value = (_b = filter.values) == null ? void 0 : _b.map(escapeLabelValueInRegexSelector).join("|");
  } else if (operator === "=~" || operator === "!~") {
    value = escapeLabelValueInRegexSelector(filter.value);
  } else {
    value = escapeLabelValueInExactSelector(filter.value);
  }
  return `${filter.key}${operator}"${value}"`;
}
function escapeLabelValueInExactSelector(labelValue) {
  return labelValue.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/"/g, '\\"');
}
function escapeLabelValueInRegexSelector(labelValue) {
  return escapeLabelValueInExactSelector(escapeLokiRegexp(labelValue));
}
const RE2_METACHARACTERS = /[*+?()|\\.\[\]{}^$]/g;
function escapeLokiRegexp(value) {
  return value.replace(RE2_METACHARACTERS, "\\$&");
}
function getQueriesForVariables(sourceObject) {
  var _a;
  const runners = sceneGraph.findAllObjects(
    sourceObject.getRoot(),
    (o) => o instanceof SceneQueryRunner
  );
  const interpolatedDsUuid = sceneGraph.interpolate(sourceObject, (_a = sourceObject.state.datasource) == null ? void 0 : _a.uid);
  const applicableRunners = filterOutInactiveRunnerDuplicates(runners).filter((r) => {
    var _a2;
    if ((_a2 = r.state.datasource) == null ? void 0 : _a2.uid) {
      const interpolatedQueryDsUuid = sceneGraph.interpolate(sourceObject, r.state.datasource.uid);
      return interpolatedQueryDsUuid === interpolatedDsUuid;
    }
    return r.state.queries.some((q) => {
      var _a3;
      if (!((_a3 = q.datasource) == null ? void 0 : _a3.uid)) {
        return false;
      }
      const interpolatedQueryDsUuid = sceneGraph.interpolate(sourceObject, q.datasource.uid);
      return interpolatedQueryDsUuid === interpolatedDsUuid;
    });
  });
  if (applicableRunners.length === 0) {
    return [];
  }
  const result = [];
  applicableRunners.forEach((r) => {
    result.push(
      ...r.state.queries.filter((q) => {
        if (!q.datasource || !q.datasource.uid) {
          return true;
        }
        const interpolatedQueryDsUuid = sceneGraph.interpolate(sourceObject, q.datasource.uid);
        return interpolatedQueryDsUuid === interpolatedDsUuid;
      })
    );
  });
  return result;
}
function filterOutInactiveRunnerDuplicates(runners) {
  const groupedItems = {};
  for (const item of runners) {
    if (item.state.key) {
      if (!(item.state.key in groupedItems)) {
        groupedItems[item.state.key] = [];
      }
      groupedItems[item.state.key].push(item);
    }
  }
  return Object.values(groupedItems).flatMap((group) => {
    const activeItems = group.filter((item) => item.isActive);
    if (activeItems.length === 0 && group.length === 1) {
      return group;
    }
    return activeItems;
  });
}
function escapeUrlPipeDelimiters(value) {
  if (value === null || value === void 0) {
    return "";
  }
  return value = /\|/g[Symbol.replace](value, "__gfp__");
}
function escapeUrlCommaDelimiters(value) {
  if (value === null || value === void 0) {
    return "";
  }
  return /,/g[Symbol.replace](value, "__gfc__");
}
function escapeUrlHashDelimiters(value) {
  if (value === null || value === void 0) {
    return "";
  }
  return /#/g[Symbol.replace](value, "__gfh__");
}
function escapeOriginFilterUrlDelimiters(value) {
  return escapeUrlHashDelimiters(escapeUrlPipeDelimiters(value));
}
function escapeURLDelimiters(value) {
  return escapeUrlCommaDelimiters(escapeUrlPipeDelimiters(value));
}
function unescapeUrlDelimiters(value) {
  if (value === null || value === void 0) {
    return "";
  }
  value = /__gfp__/g[Symbol.replace](value, "|");
  value = /__gfc__/g[Symbol.replace](value, ",");
  value = /__gfh__/g[Symbol.replace](value, "#");
  return value;
}
function toUrlCommaDelimitedString(key, label) {
  if (!label || key === label) {
    return escapeUrlCommaDelimiters(key);
  }
  return [key, label].map(escapeUrlCommaDelimiters).join(",");
}
function dataFromResponse(response) {
  return Array.isArray(response) ? response : response.data;
}
function responseHasError(response) {
  return !Array.isArray(response) && Boolean(response.error);
}
function handleOptionGroups(values) {
  const result = [];
  const groupedResults = /* @__PURE__ */ new Map();
  for (const value of values) {
    const groupLabel = value.group;
    if (groupLabel) {
      let group = groupedResults.get(groupLabel);
      if (!group) {
        group = [];
        groupedResults.set(groupLabel, group);
        result.push({ label: groupLabel, options: group });
      }
      group.push(value);
    } else {
      result.push(value);
    }
  }
  return result;
}
function getNonApplicablePillStyles(theme) {
  return {
    disabledPill: css.css({
      background: theme.colors.action.selected,
      color: theme.colors.text.disabled,
      border: 0,
      "&:hover": {
        background: theme.colors.action.selected
      }
    }),
    strikethrough: css.css({
      textDecoration: "line-through"
    })
  };
}

class ConstantVariable extends SceneObjectBase {
  constructor(initialState) {
    super({
      type: "constant",
      value: "",
      name: "",
      ...initialState,
      skipUrlSync: true
    });
    this._variableDependency = new VariableDependencyConfig(this, {
      statePaths: ["value"]
    });
    this._prevValue = "";
  }
  /**
   * This function is called on when SceneVariableSet is activated or when a dependency changes.
   */
  validateAndUpdate() {
    const newValue = this.getValue();
    if (this._prevValue !== newValue) {
      this._prevValue = newValue;
      this.publishEvent(new SceneVariableValueChangedEvent(this), true);
    }
    return rxjs.of({});
  }
  getValue() {
    if (typeof this.state.value === "string") {
      return sceneGraph.interpolate(this, this.state.value);
    }
    return this.state.value;
  }
}

class VariableDependencyConfig {
  constructor(_sceneObject, _options) {
    this._sceneObject = _sceneObject;
    this._options = _options;
    this._dependencies = /* @__PURE__ */ new Set();
    this._isWaitingForVariables = false;
    this.scanCount = 0;
    this._statePaths = _options.statePaths;
    if (this._options.handleTimeMacros) {
      this.handleTimeMacros();
    }
  }
  /**
   * Used to check for dependency on a specific variable
   */
  hasDependencyOn(name) {
    return this.getNames().has(name);
  }
  /**
   * This is called whenever any set of variables have new values. It is up to this implementation to check if it's relevant given the current dependencies.
   */
  variableUpdateCompleted(variable, hasChanged) {
    var _a, _b, _c, _d;
    const deps = this.getNames();
    const dependencyChanged = (deps.has(variable.state.name) || deps.has(data.DataLinkBuiltInVars.includeVars)) && hasChanged;
    writeSceneLog(
      "VariableDependencyConfig",
      "variableUpdateCompleted",
      variable.state.name,
      dependencyChanged,
      this._isWaitingForVariables
    );
    (_b = (_a = this._options).onAnyVariableChanged) == null ? void 0 : _b.call(_a, variable);
    if (this._options.onVariableUpdateCompleted && (this._isWaitingForVariables || dependencyChanged)) {
      this._options.onVariableUpdateCompleted();
    }
    if (dependencyChanged) {
      (_d = (_c = this._options).onReferencedVariableValueChanged) == null ? void 0 : _d.call(_c, variable);
      if (!this._options.onReferencedVariableValueChanged && !this._options.onVariableUpdateCompleted) {
        this._sceneObject.forceRender();
      }
    }
  }
  hasDependencyInLoadingState() {
    this._isWaitingForVariables = sceneGraph.hasVariableDependencyInLoadingState(this._sceneObject);
    return this._isWaitingForVariables;
  }
  getNames() {
    const prevState = this._state;
    const newState = this._state = this._sceneObject.state;
    const noPreviousState = !prevState;
    const stateDiffers = newState !== prevState;
    const shouldScanForDependencies = noPreviousState || stateDiffers && (!this._statePaths || this._statePaths.some((path) => path === "*" || newState[path] !== prevState[path]));
    if (shouldScanForDependencies) {
      this.scanStateForDependencies(newState);
    }
    return this._dependencies;
  }
  /**
   * Update variableNames
   */
  setVariableNames(varNames) {
    this._options.variableNames = varNames;
    this.scanStateForDependencies(this._state);
  }
  setPaths(paths) {
    this._statePaths = paths;
  }
  scanStateForDependencies(state) {
    this._dependencies.clear();
    this.scanCount++;
    if (this._options.variableNames) {
      for (const name of this._options.variableNames) {
        this._dependencies.add(name);
      }
    }
    if (this._options.dependsOnScopes) {
      this._dependencies.add(SCOPES_VARIABLE_NAME);
    }
    if (this._statePaths) {
      for (const path of this._statePaths) {
        if (path === "*") {
          this.extractVariablesFrom(state);
          break;
        } else {
          const value = state[path];
          if (value) {
            this.extractVariablesFrom(value);
          }
        }
      }
    }
  }
  extractVariablesFrom(value) {
    VARIABLE_REGEX.lastIndex = 0;
    const stringToCheck = typeof value !== "string" ? safeStringifyValue(value) : value;
    const matches = stringToCheck.matchAll(VARIABLE_REGEX);
    if (!matches) {
      return;
    }
    for (const match of matches) {
      const [, var1, var2, , var3] = match;
      const variableName = var1 || var2 || var3;
      this._dependencies.add(variableName);
    }
  }
  handleTimeMacros() {
    this._sceneObject.addActivationHandler(() => {
      const timeRange = sceneGraph.getTimeRange(this._sceneObject);
      const sub = timeRange.subscribeToState((newState, oldState) => {
        const deps = this.getNames();
        const hasFromDep = deps.has("__from");
        const hasToDep = deps.has("__to");
        const hasTimeZone = deps.has("__timezone");
        if (newState.value !== oldState.value) {
          if (hasFromDep) {
            const variable = new ConstantVariable({ name: "__from", value: newState.from });
            this.variableUpdateCompleted(variable, true);
          } else if (hasToDep) {
            const variable = new ConstantVariable({ name: "__to", value: newState.to });
            this.variableUpdateCompleted(variable, true);
          }
        }
        if (newState.timeZone !== oldState.timeZone && hasTimeZone) {
          const variable = new ConstantVariable({ name: "__timezone", value: newState.timeZone });
          this.variableUpdateCompleted(variable, true);
        }
      });
      return () => sub.unsubscribe();
    });
  }
}

const hasLegacyVariableSupport = (datasource) => {
  return Boolean(datasource.metricFindQuery) && !Boolean(datasource.variables);
};
const hasStandardVariableSupport = (datasource) => {
  if (!datasource.variables) {
    return false;
  }
  if (datasource.variables.getType() !== data.VariableSupportType.Standard) {
    return false;
  }
  const variableSupport = datasource.variables;
  return "toDataQuery" in variableSupport && Boolean(variableSupport.toDataQuery);
};
const hasCustomVariableSupport = (datasource) => {
  if (!datasource.variables) {
    return false;
  }
  if (datasource.variables.getType() !== data.VariableSupportType.Custom) {
    return false;
  }
  const variableSupport = datasource.variables;
  return "query" in variableSupport && "editor" in variableSupport && Boolean(variableSupport.query) && Boolean(variableSupport.editor);
};
const hasDataSourceVariableSupport = (datasource) => {
  if (!datasource.variables) {
    return false;
  }
  return datasource.variables.getType() === data.VariableSupportType.Datasource;
};

class StandardQueryRunner {
  constructor(datasource, _runRequest = runtime.getRunRequest()) {
    this.datasource = datasource;
    this._runRequest = _runRequest;
  }
  getTarget(variable) {
    if (hasStandardVariableSupport(this.datasource)) {
      return this.datasource.variables.toDataQuery(ensureVariableQueryModelIsADataQuery(variable));
    }
    throw new Error("Couldn't create a target with supplied arguments.");
  }
  runRequest(_, request) {
    if (!hasStandardVariableSupport(this.datasource)) {
      return getEmptyMetricFindValueObservable();
    }
    if (!this.datasource.variables.query) {
      return this._runRequest(this.datasource, request);
    }
    return this._runRequest(this.datasource, request, this.datasource.variables.query.bind(this.datasource.variables));
  }
}
class LegacyQueryRunner {
  constructor(datasource) {
    this.datasource = datasource;
  }
  getTarget(variable) {
    if (hasLegacyVariableSupport(this.datasource)) {
      return variable.state.query;
    }
    throw new Error("Couldn't create a target with supplied arguments.");
  }
  runRequest({ variable, searchFilter }, request) {
    if (!hasLegacyVariableSupport(this.datasource)) {
      return getEmptyMetricFindValueObservable();
    }
    return rxjs.from(
      this.datasource.metricFindQuery(variable.state.query, {
        ...request,
        // variable is used by SQL common data source
        variable: {
          name: variable.state.name,
          type: variable.state.type
        },
        searchFilter
      })
    ).pipe(
      rxjs.mergeMap((values) => {
        if (!values || !values.length) {
          return getEmptyMetricFindValueObservable();
        }
        const series = values;
        return rxjs.of({ series, state: data.LoadingState.Done, timeRange: request.range });
      })
    );
  }
}
class CustomQueryRunner {
  constructor(datasource, _runRequest = runtime.getRunRequest()) {
    this.datasource = datasource;
    this._runRequest = _runRequest;
  }
  getTarget(variable) {
    if (hasCustomVariableSupport(this.datasource)) {
      return variable.state.query;
    }
    throw new Error("Couldn't create a target with supplied arguments.");
  }
  runRequest(_, request) {
    if (!hasCustomVariableSupport(this.datasource)) {
      return getEmptyMetricFindValueObservable();
    }
    if (!this.datasource.variables.query) {
      return this._runRequest(this.datasource, request);
    }
    return this._runRequest(this.datasource, request, this.datasource.variables.query.bind(this.datasource.variables));
  }
}
const variableDummyRefId = "variable-query";
class DatasourceQueryRunner {
  constructor(datasource, _runRequest = runtime.getRunRequest()) {
    this.datasource = datasource;
    this._runRequest = _runRequest;
  }
  getTarget(variable) {
    var _a;
    if (hasDataSourceVariableSupport(this.datasource)) {
      if (typeof variable.state.query === "string") {
        return variable.state.query;
      }
      return { ...variable.state.query, refId: (_a = variable.state.query.refId) != null ? _a : variableDummyRefId };
    }
    throw new Error("Couldn't create a target with supplied arguments.");
  }
  runRequest(_, request) {
    if (!hasDataSourceVariableSupport(this.datasource)) {
      return getEmptyMetricFindValueObservable();
    }
    return this._runRequest(this.datasource, request);
  }
}
function getEmptyMetricFindValueObservable() {
  return rxjs.of({ state: data.LoadingState.Done, series: [], timeRange: data.getDefaultTimeRange() });
}
function createQueryVariableRunnerFactory(datasource) {
  if (hasStandardVariableSupport(datasource)) {
    return new StandardQueryRunner(datasource, runtime.getRunRequest());
  }
  if (hasLegacyVariableSupport(datasource)) {
    return new LegacyQueryRunner(datasource);
  }
  if (hasCustomVariableSupport(datasource)) {
    return new CustomQueryRunner(datasource);
  }
  if (hasDataSourceVariableSupport(datasource)) {
    return new DatasourceQueryRunner(datasource);
  }
  throw new Error(`Couldn't create a query runner for datasource ${datasource.type}`);
}
let createQueryVariableRunner = createQueryVariableRunnerFactory;
function ensureVariableQueryModelIsADataQuery(variable) {
  var _a;
  const query = (_a = variable.state.query) != null ? _a : "";
  if (typeof query === "string") {
    return { query, refId: `variable-${variable.state.name}` };
  }
  if (query.refId == null) {
    return { ...query, refId: `variable-${variable.state.name}` };
  }
  return variable.state.query;
}

function metricNamesToVariableValues({
  variableRegEx,
  variableRegexApplyTo,
  sort,
  metricNames
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  let regex;
  let options = [];
  if (variableRegEx) {
    regex = data.stringToJsRegex(variableRegEx);
  }
  for (let i = 0; i < metricNames.length; i++) {
    const item = metricNames[i];
    let text = (_b = (_a = item.text) != null ? _a : item.value) != null ? _b : "";
    let value = (_d = (_c = item.value) != null ? _c : item.text) != null ? _d : "";
    if (lodash.isNumber(value)) {
      value = value.toString();
    }
    if (lodash.isNumber(text)) {
      text = text.toString();
    }
    if (regex) {
      const applyTo = variableRegexApplyTo === "text" ? text : value;
      const matches = getAllMatches(applyTo, regex);
      if (!matches.length) {
        continue;
      }
      const valueGroup = matches.find((m) => m.groups && m.groups.value);
      const textGroup = matches.find((m) => m.groups && m.groups.text);
      const firstMatch = matches.find((m) => m.length > 1);
      const manyMatches = matches.length > 1 && firstMatch;
      if (valueGroup || textGroup) {
        value = (_g = (_e = valueGroup == null ? void 0 : valueGroup.groups) == null ? void 0 : _e.value) != null ? _g : (_f = textGroup == null ? void 0 : textGroup.groups) == null ? void 0 : _f.text;
        text = (_j = (_h = textGroup == null ? void 0 : textGroup.groups) == null ? void 0 : _h.text) != null ? _j : (_i = valueGroup == null ? void 0 : valueGroup.groups) == null ? void 0 : _i.value;
      } else if (manyMatches) {
        for (let j = 0; j < matches.length; j++) {
          const match = matches[j];
          options.push({ label: match[1], value: match[1] });
        }
        continue;
      } else if (firstMatch) {
        text = firstMatch[1];
        value = firstMatch[1];
      }
    }
    options.push({ label: text, value, properties: item.properties });
  }
  options = lodash.uniqBy(options, "value");
  return sortVariableValues(options, sort);
}
const getAllMatches = (str, regex) => {
  const results = [];
  let matches = null;
  regex.lastIndex = 0;
  do {
    matches = regex.exec(str);
    if (matches) {
      results.push(matches);
    }
  } while (regex.global && matches && matches[0] !== "" && matches[0] !== void 0);
  return results;
};
const sortVariableValues = (options, sortOrder) => {
  if (sortOrder === data.VariableSort.disabled) {
    return options;
  }
  switch (sortOrder) {
    case data.VariableSort.alphabeticalAsc:
      options = lodash.sortBy(options, "label");
      break;
    case data.VariableSort.alphabeticalDesc:
      options = lodash.sortBy(options, "label").reverse();
      break;
    case data.VariableSort.numericalAsc:
      options = lodash.sortBy(options, sortByNumeric);
      break;
    case data.VariableSort.numericalDesc:
      options = lodash.sortBy(options, sortByNumeric);
      options = options.reverse();
      break;
    case data.VariableSort.alphabeticalCaseInsensitiveAsc:
      options = lodash.sortBy(options, (opt) => {
        return lodash.toLower(opt.label);
      });
      break;
    case data.VariableSort.alphabeticalCaseInsensitiveDesc:
      options = lodash.sortBy(options, (opt) => {
        return lodash.toLower(opt.label);
      });
      options = options.reverse();
      break;
    case data.VariableSort.naturalAsc:
      options = sortByNaturalSort(options);
      break;
    case data.VariableSort.naturalDesc:
      options = sortByNaturalSort(options);
      options = options.reverse();
      break;
  }
  return options;
};
function sortByNumeric(opt) {
  if (!opt.label) {
    return -1;
  }
  const matches = opt.label.match(/.*?(\d+).*/);
  if (!matches || matches.length < 2) {
    return -1;
  } else {
    return parseInt(matches[1], 10);
  }
}
const collator = new Intl.Collator(void 0, { sensitivity: "accent", numeric: true });
function sortByNaturalSort(options) {
  return options.slice().sort((a, b) => {
    return collator.compare(a.label, b.label);
  });
}

function toMetricFindValues(valueProp, textProp) {
  return (source) => source.pipe(
    rxjs.map((panelData) => {
      const frames = panelData.series;
      if (!frames || !frames.length) {
        return [];
      }
      if (areMetricFindValues(frames)) {
        return frames;
      }
      if (frames[0].fields.length === 0) {
        return [];
      }
      const indices = validateIndices(findFieldsIndices(frames));
      const metrics = [];
      for (const frame of frames) {
        for (let index = 0; index < frame.length; index++) {
          const fieldValue = (fieldIndex) => fieldIndex !== -1 ? frame.fields[fieldIndex].values[index] : void 0;
          const value = fieldValue(indices.value);
          const text = fieldValue(indices.text);
          const expandable = fieldValue(indices.expandable);
          const properties = {};
          for (const p of indices.properties) {
            properties[p.name] = fieldValue(p.index);
          }
          const result = { value, text, properties };
          if (expandable !== void 0) {
            result.expandable = Boolean(expandable);
          }
          metrics.push(result);
        }
      }
      return metrics;
    })
  );
}
function findFieldsIndices(frames, valueProp, textProp) {
  const indices = {
    value: -1,
    text: -1,
    expandable: -1,
    properties: []
  };
  for (const frame of data.getProcessedDataFrames(frames)) {
    for (let index = 0; index < frame.fields.length; index++) {
      const field = frame.fields[index];
      const fieldName = data.getFieldDisplayName(field, frame, frames).toLowerCase();
      if (field.type === data.FieldType.string || field.type === data.FieldType.number) {
        if (fieldName === "value" && indices.value === -1) {
          indices.value = index;
        }
        indices.properties.push({ name: fieldName, index });
      }
      if (field.type === data.FieldType.string) {
        if (fieldName === "text" && indices.text === -1) {
          indices.text = index;
        }
        continue;
      }
      if (fieldName === "expandable" && (field.type === data.FieldType.boolean || field.type === data.FieldType.number) && indices.expandable === -1) {
        indices.expandable = index;
      }
    }
  }
  indices.properties = lodash.uniqWith(indices.properties, lodash.isEqual);
  return indices;
}
function validateIndices(indices) {
  const hasNoValueOrText = indices.value === -1 && indices.text === -1;
  if (!indices.properties.length) {
    throw new Error("Couldn't find any field of type string or number in the results");
  }
  if (hasNoValueOrText) {
    indices.value = indices.properties[0].index;
    indices.text = indices.properties[0].index;
  }
  if (indices.value === -1 && indices.text !== -1) {
    indices.value = indices.text;
  }
  if (indices.text === -1 && indices.value !== -1) {
    indices.text = indices.value;
  }
  return indices;
}
function areMetricFindValues(data$1) {
  if (!data$1) {
    return false;
  }
  if (!data$1.length) {
    return true;
  }
  const firstValue = data$1[0];
  if (data.isDataFrame(firstValue)) {
    return false;
  }
  for (const firstValueKey in firstValue) {
    if (!firstValue.hasOwnProperty(firstValueKey)) {
      continue;
    }
    const value = firstValue[firstValueKey];
    if (value !== null && typeof value !== "string" && typeof value !== "number") {
      continue;
    }
    const key = firstValueKey.toLowerCase();
    if (key === "text" || key === "value") {
      return true;
    }
  }
  return false;
}

class QueryVariable extends MultiValueVariable {
  constructor(initialState) {
    super({
      type: "query",
      name: "",
      value: "",
      text: "",
      options: [],
      datasource: null,
      regex: "",
      query: "",
      regexApplyTo: "value",
      refresh: data.VariableRefresh.onDashboardLoad,
      sort: data.VariableSort.disabled,
      ...initialState
    });
    this._variableDependency = new VariableDependencyConfig(this, {
      statePaths: ["regex", "regexApplyTo", "query", "datasource"]
    });
    this.onSearchChange = (searchFilter) => {
      if (!containsSearchFilter(this.state.query)) {
        return;
      }
      this._updateOptionsBasedOnSearchFilter(searchFilter);
    };
    this._updateOptionsBasedOnSearchFilter = lodash.debounce(async (searchFilter) => {
      const result = await rxjs.lastValueFrom(this.getValueOptions({ searchFilter }));
      this.setState({ options: result, loading: false });
    }, 400);
  }
  getValueOptions(args) {
    if (!this.state.query) {
      return rxjs.of([]);
    }
    this.setState({ loading: true, error: null });
    return rxjs.from(
      getDataSource(this.state.datasource, {
        __sceneObject: wrapInSafeSerializableSceneObject(this)
      })
    ).pipe(
      rxjs.mergeMap((ds) => {
        const runner = createQueryVariableRunner(ds);
        const target = runner.getTarget(this);
        const request = this.getRequest(target, args.searchFilter);
        return runner.runRequest({ variable: this, searchFilter: args.searchFilter }, request).pipe(
          registerQueryWithController({
            type: "QueryVariable/getValueOptions",
            request,
            origin: this
          }),
          rxjs.filter((data$1) => data$1.state === data.LoadingState.Done || data$1.state === data.LoadingState.Error),
          // we only care about done or error for now
          rxjs.take(1),
          // take the first result, using first caused a bug where it in some situations throw an uncaught error because of no results had been received yet
          rxjs.mergeMap((data$1) => {
            if (data$1.state === data.LoadingState.Error) {
              return rxjs.throwError(() => data$1.error);
            }
            return rxjs.of(data$1);
          }),
          toMetricFindValues(),
          rxjs.mergeMap((values) => {
            let regex = "";
            if (this.state.regex) {
              regex = sceneGraph.interpolate(this, this.state.regex, void 0, "regex");
            }
            let options = metricNamesToVariableValues({
              variableRegEx: regex,
              variableRegexApplyTo: this.state.regexApplyTo,
              sort: this.state.sort,
              metricNames: values
            });
            if (this.state.staticOptions) {
              const customOptions = this.state.staticOptions;
              options = options.filter((option) => !customOptions.find((custom) => custom.value === option.value));
              if (this.state.staticOptionsOrder === "after") {
                options.push(...customOptions);
              } else if (this.state.staticOptionsOrder === "sorted") {
                options = sortVariableValues(options.concat(customOptions), this.state.sort);
              } else {
                options.unshift(...customOptions);
              }
            }
            return rxjs.of(options);
          }),
          rxjs.catchError((error) => {
            if (error.cancelled) {
              return rxjs.of([]);
            }
            return rxjs.throwError(() => error);
          })
        );
      })
    );
  }
  getRequest(target, searchFilter) {
    const scopedVars = {
      __sceneObject: wrapInSafeSerializableSceneObject(this)
    };
    if (searchFilter) {
      scopedVars.__searchFilter = { value: searchFilter, text: searchFilter };
    }
    const range = sceneGraph.getTimeRange(this).state.value;
    const request = {
      app: data.CoreApp.Dashboard,
      requestId: uuid.v4(),
      timezone: "",
      range,
      interval: "",
      intervalMs: 0,
      // @ts-ignore
      targets: [target],
      scopedVars,
      startTime: Date.now()
    };
    return request;
  }
}
QueryVariable.Component = ({ model }) => {
  return /* @__PURE__ */ React__default.default.createElement(MultiOrSingleValueSelect, { model });
};
function containsSearchFilter(query) {
  const str = safeStringifyValue(query);
  return str.indexOf(SEARCH_FILTER_VARIABLE) > -1;
}

function getVariables(sceneObject) {
  var _a;
  return (_a = getClosest(sceneObject, (s) => s.state.$variables)) != null ? _a : EmptyVariableSet;
}
function getData(sceneObject) {
  var _a;
  return (_a = getClosest(sceneObject, (s) => s.state.$data)) != null ? _a : EmptyDataNode;
}
function isSceneLayout(s) {
  return "isDraggable" in s;
}
function getLayout(scene) {
  const parent = getClosest(scene, (s) => isSceneLayout(s) ? s : void 0);
  if (parent) {
    return parent;
  }
  return null;
}
function interpolate(sceneObject, value, scopedVars, format, interpolations) {
  if (value === "" || value == null) {
    return "";
  }
  return sceneInterpolator(sceneObject, value, scopedVars, format, interpolations);
}
function hasVariableDependencyInLoadingState(sceneObject) {
  if (!sceneObject.variableDependency) {
    return false;
  }
  for (const name of sceneObject.variableDependency.getNames()) {
    if (sceneObject instanceof QueryVariable && sceneObject.state.name === name) {
      console.warn("Query variable is referencing itself");
      continue;
    }
    const variable = lookupVariable(name, sceneObject);
    if (!variable) {
      continue;
    }
    const set = variable.parent;
    if (set.isVariableLoadingOrWaitingToUpdate(variable)) {
      return true;
    }
  }
  return false;
}
function findObjectInternal(scene, check, alreadySearchedChild, shouldSearchUp) {
  if (check(scene)) {
    return scene;
  }
  let found = null;
  scene.forEachChild((child) => {
    if (child === alreadySearchedChild) {
      return;
    }
    let maybe = findObjectInternal(child, check);
    if (maybe) {
      found = maybe;
      return false;
    }
    return;
  });
  if (found) {
    return found;
  }
  if (shouldSearchUp && scene.parent) {
    return findObjectInternal(scene.parent, check, scene, true);
  }
  return null;
}
function findByKey(sceneObject, key) {
  const found = findObject(sceneObject, (sceneToCheck) => {
    return sceneToCheck.state.key === key;
  });
  if (!found) {
    throw new Error("Unable to find scene with key " + key);
  }
  return found;
}
function findByKeyAndType(sceneObject, key, targetType) {
  const found = findObject(sceneObject, (sceneToCheck) => {
    return sceneToCheck.state.key === key;
  });
  if (!found) {
    throw new Error("Unable to find scene with key " + key);
  }
  if (!(found instanceof targetType)) {
    throw new Error(`Found scene object with key ${key} does not match type ${targetType.name}`);
  }
  return found;
}
function findObject(scene, check) {
  return findObjectInternal(scene, check, void 0, true);
}
function findAllObjects(scene, check) {
  const found = [];
  scene.forEachChild((child) => {
    if (check(child)) {
      found.push(child);
    }
    found.push(...findAllObjects(child, check));
  });
  return found;
}
function getDataLayers(sceneObject, localOnly = false) {
  let currentLevel = sceneObject;
  let collected = [];
  while (currentLevel) {
    const dataProvider = currentLevel.state.$data;
    if (!dataProvider) {
      currentLevel = currentLevel.parent;
      continue;
    }
    if (isDataLayer(dataProvider)) {
      collected = collected.concat(dataProvider);
    } else {
      if (dataProvider.state.$data && isDataLayer(dataProvider.state.$data)) {
        collected = collected.concat(dataProvider.state.$data);
      }
    }
    if (localOnly && collected.length > 0) {
      break;
    }
    currentLevel = currentLevel.parent;
  }
  return collected;
}
function getAncestor(sceneObject, ancestorType) {
  let parent = sceneObject;
  while (parent) {
    if (parent instanceof ancestorType) {
      return parent;
    }
    parent = parent.parent;
  }
  if (!parent) {
    throw new Error("Unable to find parent of type " + ancestorType.name);
  }
  return parent;
}
function findDescendents(scene, descendentType) {
  function isDescendentType(scene2) {
    return scene2 instanceof descendentType;
  }
  const targetScenes = findAllObjects(scene, isDescendentType);
  return targetScenes.filter(isDescendentType);
}
function getScopes(sceneObject) {
  const scopesVariable = lookupVariable(SCOPES_VARIABLE_NAME, sceneObject);
  if (scopesVariable instanceof ScopesVariable) {
    return scopesVariable.state.scopes;
  }
  return void 0;
}

const sceneGraph = {
  getVariables,
  getData,
  getTimeRange,
  getLayout,
  getDataLayers,
  interpolate,
  lookupVariable,
  hasVariableDependencyInLoadingState,
  findByKey,
  findByKeyAndType,
  findObject,
  findAllObjects,
  getAncestor,
  getQueryController,
  findDescendents,
  getScopes
};

const _LocalValueVariable = class _LocalValueVariable extends SceneObjectBase {
  constructor(initialState) {
    super({
      type: "system",
      value: "",
      text: "",
      name: "",
      ...initialState,
      skipUrlSync: true
    });
  }
  getValue(fieldPath) {
    if (fieldPath != null && this.state.properties) {
      return this.getFieldAccessor(fieldPath)(this.state.properties);
    }
    return this.state.value;
  }
  getFieldAccessor(fieldPath) {
    const accessor = _LocalValueVariable.fieldAccessorCache[fieldPath];
    if (accessor) {
      return accessor;
    }
    return _LocalValueVariable.fieldAccessorCache[fieldPath] = lodash.property(fieldPath);
  }
  getValueText(fieldPath) {
    if (fieldPath && this.state.properties) {
      const value = this.getFieldAccessor(fieldPath)(this.state.properties);
      if (value != null) {
        return String(value);
      }
    }
    return this.state.text.toString();
  }
  /**
   * Checks the ancestor of our parent SceneVariableSet for loading state of a variable with the same name
   * This function is unit tested from SceneVariableSet tests.
   */
  isAncestorLoading() {
    var _a, _b;
    const ancestorScope = (_b = (_a = this.parent) == null ? void 0 : _a.parent) == null ? void 0 : _b.parent;
    if (!ancestorScope) {
      throw new Error("LocalValueVariable requires a parent SceneVariableSet that has an ancestor SceneVariableSet");
    }
    const set = sceneGraph.getVariables(ancestorScope);
    const parentVar = sceneGraph.lookupVariable(this.state.name, ancestorScope);
    if (set && parentVar) {
      return set.isVariableLoadingOrWaitingToUpdate(parentVar);
    }
    return false;
  }
};
_LocalValueVariable.fieldAccessorCache = {};
let LocalValueVariable = _LocalValueVariable;

const PATH_ID_SEPARATOR = "$";
function buildPathIdFor(panel) {
  let pathId = `panel-${panel.getLegacyPanelId()}`;
  let lastName;
  let currentObj = panel;
  while (currentObj) {
    const variables = currentObj.state.$variables;
    if (variables) {
      variables.state.variables.forEach((variable) => {
        if (variable.state.name === lastName) {
          return;
        }
        if (variable instanceof LocalValueVariable) {
          pathId = `${variable.state.value}${PATH_ID_SEPARATOR}${pathId}`;
          lastName = variable.state.name;
        }
      });
    }
    currentObj = currentObj.parent;
  }
  return pathId;
}

function isAdHocVariable(variable) {
  return variable.state.type === "adhoc";
}
function isConstantVariable(variable) {
  return variable.state.type === "constant";
}
function isCustomVariable(variable) {
  return variable.state.type === "custom";
}
function isDataSourceVariable(variable) {
  return variable.state.type === "datasource";
}
function isIntervalVariable(variable) {
  return variable.state.type === "interval";
}
function isQueryVariable(variable) {
  return variable.state.type === "query";
}
function isTextBoxVariable(variable) {
  return variable.state.type === "textbox";
}
function isGroupByVariable(variable) {
  return variable.state.type === "groupby";
}
function isSwitchVariable(variable) {
  return variable.state.type === "switch";
}

class ActWhenVariableChanged extends SceneObjectBase {
  constructor() {
    super(...arguments);
    this._runningEffect = null;
    this._variableDependency = new VariableDependencyConfig(this, {
      variableNames: [this.state.variableName],
      onReferencedVariableValueChanged: this._onVariableChanged.bind(this)
    });
  }
  _onVariableChanged(variable) {
    const effect = this.state.onChange;
    if (this._runningEffect) {
      this._runningEffect();
      this._runningEffect = null;
    }
    const cancellation = effect(variable, this);
    if (cancellation) {
      this._runningEffect = cancellation;
    }
  }
}

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ActWhenVariableChanged: ActWhenVariableChanged,
  CursorSync: CursorSync,
  LiveNowTimer: LiveNowTimer,
  SceneInteractionTracker: SceneInteractionTracker,
  SceneQueryController: SceneQueryController
});

function writePerformanceLog(logger, message, ...rest) {
  let loggingEnabled = false;
  if (typeof window !== "undefined") {
    loggingEnabled = localStorage.getItem("grafana.debug.sceneProfiling") === "true";
  }
  if (loggingEnabled) {
    console.log(`${logger}: `, message, ...rest);
  }
}

class PanelProfilingManager {
  constructor(_config) {
    this._config = _config;
    this._subscriptions = [];
  }
  /**
   * Attach panel profiling to a scene object
   */
  attachToScene(sceneObject) {
    this._sceneObject = sceneObject;
    const subscription = sceneObject.subscribeToState((newState, prevState) => {
      if (this._config.watchStateKey) {
        if (newState[this._config.watchStateKey] !== prevState[this._config.watchStateKey]) {
          this._attachProfilersToPanels();
        }
      } else {
        this._attachProfilersToPanels();
      }
    });
    this._subscriptions.push(subscription);
    this._attachProfilersToPanels();
  }
  /**
   * Attach VizPanelRenderProfiler to a specific panel if it doesn't already have one
   * @param panel - The VizPanel to attach profiling to
   */
  attachProfilerToPanel(panel) {
    var _a;
    const existingProfiler = (_a = panel.state.$behaviors) == null ? void 0 : _a.find((b) => b instanceof VizPanelRenderProfiler);
    if (existingProfiler) {
      return;
    }
    const profiler = new VizPanelRenderProfiler();
    panel.setState({
      $behaviors: [...panel.state.$behaviors || [], profiler]
    });
  }
  /**
   * Attach VizPanelRenderProfiler to all VizPanels that don't already have one
   */
  _attachProfilersToPanels() {
    if (!this._sceneObject) {
      return;
    }
    const panels = sceneGraph.findAllObjects(this._sceneObject, (obj) => obj instanceof VizPanel);
    panels.forEach((panel) => {
      this.attachProfilerToPanel(panel);
    });
  }
  /**
   * Clean up subscriptions and references
   */
  cleanup() {
    this._subscriptions.forEach((sub) => sub.unsubscribe());
    this._subscriptions = [];
    this._sceneObject = void 0;
  }
}

var __typeError$2 = (msg) => {
  throw TypeError(msg);
};
var __accessCheck$2 = (obj, member, msg) => member.has(obj) || __typeError$2("Cannot " + msg);
var __privateGet$2 = (obj, member, getter) => (__accessCheck$2(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$2 = (obj, member, value) => member.has(obj) ? __typeError$2("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$2 = (obj, member, value, setter) => (__accessCheck$2(obj, member, "write to private field"), member.set(obj, value), value);
var _isTracking, _callback, _frameTrackingId, _lastFrameTime, _loafObserver;
const LONG_FRAME_THRESHOLD = 50;
class LongFrameDetector {
  constructor() {
    __privateAdd$2(this, _isTracking, false);
    __privateAdd$2(this, _callback, null);
    // Manual tracking state
    __privateAdd$2(this, _frameTrackingId, null);
    __privateAdd$2(this, _lastFrameTime, 0);
    // LoAF tracking state
    __privateAdd$2(this, _loafObserver, null);
    /**
     * Measure frame durations using requestAnimationFrame
     */
    this.measureFrames = () => {
      if (!__privateGet$2(this, _isTracking)) {
        return;
      }
      const currentFrameTime = performance.now();
      const frameLength = currentFrameTime - __privateGet$2(this, _lastFrameTime);
      if (frameLength > LONG_FRAME_THRESHOLD) {
        const event = {
          duration: frameLength,
          timestamp: currentFrameTime,
          method: "manual"
        };
        if (__privateGet$2(this, _callback)) {
          __privateGet$2(this, _callback).call(this, event);
        }
        if (typeof performance !== "undefined" && performance.mark && performance.measure) {
          const frameId = `long-frame-manual-${currentFrameTime.toFixed(0)}`;
          const startMarkName = `${frameId}-start`;
          const endMarkName = `${frameId}-end`;
          const measureName = `Long Frame (Manual): ${frameLength.toFixed(1)}ms`;
          try {
            performance.mark(startMarkName, { startTime: currentFrameTime - frameLength });
            performance.mark(endMarkName, { startTime: currentFrameTime });
            performance.measure(measureName, startMarkName, endMarkName);
          } catch (e) {
            performance.mark(measureName);
          }
        }
        writePerformanceLog(
          "LFD",
          `Long frame detected (manual): ${frameLength}ms (threshold: ${LONG_FRAME_THRESHOLD}ms)`
        );
      }
      __privateSet$2(this, _lastFrameTime, currentFrameTime);
      if (__privateGet$2(this, _isTracking)) {
        __privateSet$2(this, _frameTrackingId, requestAnimationFrame(this.measureFrames));
      }
    };
  }
  /**
   * Check if LoAF API is available in the browser
   */
  isLoAFAvailable() {
    return typeof PerformanceObserver !== "undefined" && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame");
  }
  /**
   * Start detecting long frames and call the provided callback when they occur
   */
  start(callback) {
    if (__privateGet$2(this, _isTracking)) {
      writePerformanceLog("LFD", "Already tracking frames, stopping previous session");
      this.stop();
    }
    __privateSet$2(this, _callback, callback);
    __privateSet$2(this, _isTracking, true);
    if (this.isLoAFAvailable()) {
      this.startLoAFTracking();
    } else {
      this.startManualFrameTracking();
    }
    writePerformanceLog(
      "LFD",
      `Started tracking with ${this.isLoAFAvailable() ? "LoAF API" : "manual"} method, threshold: ${LONG_FRAME_THRESHOLD}ms`
    );
  }
  /**
   * Stop detecting long frames
   */
  stop() {
    if (!__privateGet$2(this, _isTracking)) {
      return;
    }
    __privateSet$2(this, _isTracking, false);
    __privateSet$2(this, _callback, null);
    this.stopLoAFTracking();
    this.stopManualFrameTracking();
  }
  /**
   * Check if currently tracking frames
   */
  isTracking() {
    return __privateGet$2(this, _isTracking);
  }
  /**
   * Start tracking using the Long Animation Frame API
   * @see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceLongAnimationFrameTiming
   */
  startLoAFTracking() {
    if (!this.isLoAFAvailable()) {
      writePerformanceLog("LFD", "LoAF API not available, falling back to manual tracking");
      this.startManualFrameTracking();
      return;
    }
    try {
      __privateSet$2(this, _loafObserver, new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          const event = {
            duration: entry.duration,
            timestamp: entry.startTime,
            method: "loaf"
          };
          if (__privateGet$2(this, _callback)) {
            __privateGet$2(this, _callback).call(this, event);
          }
          if (typeof performance !== "undefined" && performance.mark && performance.measure) {
            const frameId = `long-frame-${entry.startTime.toFixed(0)}`;
            const startMarkName = `${frameId}-start`;
            const endMarkName = `${frameId}-end`;
            const measureName = `Long Frame (LoAF): ${entry.duration.toFixed(1)}ms`;
            try {
              performance.mark(startMarkName, { startTime: entry.startTime });
              performance.mark(endMarkName, { startTime: entry.startTime + entry.duration });
              performance.measure(measureName, startMarkName, endMarkName);
            } catch (e) {
              performance.mark(measureName);
            }
          }
          writePerformanceLog("LFD", `Long frame detected (LoAF): ${entry.duration}ms at ${entry.startTime}ms`);
        }
      }));
      __privateGet$2(this, _loafObserver).observe({ type: "long-animation-frame", buffered: false });
    } catch (error) {
      writePerformanceLog("LFD", "Failed to start LoAF tracking, falling back to manual:", error);
      this.startManualFrameTracking();
    }
  }
  /**
   * Stop LoAF tracking
   */
  stopLoAFTracking() {
    if (__privateGet$2(this, _loafObserver)) {
      __privateGet$2(this, _loafObserver).disconnect();
      __privateSet$2(this, _loafObserver, null);
      writePerformanceLog("LFD", "Stopped LoAF tracking");
    }
  }
  /**
   * Start manual frame tracking using requestAnimationFrame
   */
  startManualFrameTracking() {
    __privateSet$2(this, _lastFrameTime, performance.now());
    __privateSet$2(this, _frameTrackingId, requestAnimationFrame(() => this.measureFrames()));
  }
  /**
   * Stop manual frame tracking
   */
  stopManualFrameTracking() {
    if (__privateGet$2(this, _frameTrackingId)) {
      cancelAnimationFrame(__privateGet$2(this, _frameTrackingId));
      __privateSet$2(this, _frameTrackingId, null);
      writePerformanceLog("LFD", "Stopped manual frame tracking");
    }
  }
}
_isTracking = new WeakMap();
_callback = new WeakMap();
_frameTrackingId = new WeakMap();
_lastFrameTime = new WeakMap();
_loafObserver = new WeakMap();

var __typeError$1 = (msg) => {
  throw TypeError(msg);
};
var __accessCheck$1 = (obj, member, msg) => member.has(obj) || __typeError$1("Cannot " + msg);
var __privateGet$1 = (obj, member, getter) => (__accessCheck$1(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd$1 = (obj, member, value) => member.has(obj) ? __typeError$1("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet$1 = (obj, member, value, setter) => (__accessCheck$1(obj, member, "write to private field"), member.set(obj, value), value);
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet$1(obj, member, value);
  },
  get _() {
    return __privateGet$1(obj, member, getter);
  }
});
var _profileInProgress, _interactionInProgress, _profileStartTs, _trailAnimationFrameId, _currentOperationId, _recordedTrailingSpans, _longFrameDetector, _longFramesCount, _longFramesTotalTime, _visibilityChangeHandler, _onInteractionComplete;
const POST_STORM_WINDOW = 2e3;
const DEFAULT_LONG_FRAME_THRESHOLD = 30;
class SceneRenderProfiler {
  constructor(panelProfilingConfig) {
    __privateAdd$1(this, _profileInProgress, null);
    __privateAdd$1(this, _interactionInProgress, null);
    __privateAdd$1(this, _profileStartTs, null);
    __privateAdd$1(this, _trailAnimationFrameId, null);
    // Generic metadata for observer notifications
    this.metadata = {};
    // Operation ID for correlating dashboard interaction events
    __privateAdd$1(this, _currentOperationId);
    // Trailing frame measurements
    __privateAdd$1(this, _recordedTrailingSpans, []);
    // Long frame tracking
    __privateAdd$1(this, _longFrameDetector);
    __privateAdd$1(this, _longFramesCount, 0);
    __privateAdd$1(this, _longFramesTotalTime, 0);
    __privateAdd$1(this, _visibilityChangeHandler, null);
    __privateAdd$1(this, _onInteractionComplete, null);
    this.measureTrailingFrames = (measurementStartTs, lastFrameTime, profileStartTs) => {
      const currentFrameTime = performance.now();
      const frameLength = currentFrameTime - lastFrameTime;
      __privateGet$1(this, _recordedTrailingSpans).push(frameLength);
      if (currentFrameTime - measurementStartTs < POST_STORM_WINDOW) {
        if (__privateGet$1(this, _profileInProgress)) {
          __privateSet$1(this, _trailAnimationFrameId, requestAnimationFrame(
            () => this.measureTrailingFrames(measurementStartTs, currentFrameTime, profileStartTs)
          ));
        }
      } else {
        const slowFrames = processRecordedSpans(__privateGet$1(this, _recordedTrailingSpans));
        const slowFramesTime = slowFrames.reduce((acc, val) => acc + val, 0);
        writePerformanceLog(
          "SRP",
          "Profile tail recorded, slow frames duration:",
          slowFramesTime,
          slowFrames,
          __privateGet$1(this, _profileInProgress)
        );
        __privateSet$1(this, _recordedTrailingSpans, []);
        const profileDuration = measurementStartTs - profileStartTs;
        const slowFrameSummary = slowFrames.length > 0 ? `${slowFramesTime.toFixed(1)}ms slow frames[tail recording] (${slowFrames.length}) \u26A0\uFE0F` : `${slowFramesTime.toFixed(1)}ms slow frames[tail recording] (${slowFrames.length})`;
        const longFrameSummary = __privateGet$1(this, _longFramesCount) > 0 ? `${__privateGet$1(this, _longFramesTotalTime).toFixed(1)}ms long frames[LoAF] (${__privateGet$1(this, _longFramesCount)}) \u26A0\uFE0F` : `${__privateGet$1(this, _longFramesTotalTime).toFixed(1)}ms long frames[LoAF] (${__privateGet$1(this, _longFramesCount)})`;
        writePerformanceLog(
          "SRP",
          `[PROFILER] Complete: ${(profileDuration + slowFramesTime).toFixed(
            1
          )}ms total | ${slowFrameSummary} | ${longFrameSummary}`
        );
        __privateGet$1(this, _longFrameDetector).stop();
        __privateSet$1(this, _trailAnimationFrameId, null);
        const profileEndTs = profileStartTs + profileDuration + slowFramesTime;
        if (!__privateGet$1(this, _profileInProgress)) {
          return;
        }
        const networkDuration = captureNetwork(profileStartTs, profileEndTs);
        if (__privateGet$1(this, _profileInProgress)) {
          const dashboardData = {
            operationId: __privateGet$1(this, _currentOperationId) || generateOperationId("dashboard-fallback"),
            interactionType: __privateGet$1(this, _profileInProgress).origin,
            timestamp: profileEndTs,
            duration: profileDuration + slowFramesTime,
            networkDuration,
            longFramesCount: __privateGet$1(this, _longFramesCount),
            longFramesTotalTime: __privateGet$1(this, _longFramesTotalTime),
            metadata: this.metadata
          };
          const tracker = getScenePerformanceTracker();
          tracker.notifyDashboardInteractionComplete(dashboardData);
          __privateSet$1(this, _profileInProgress, null);
          __privateSet$1(this, _trailAnimationFrameId, null);
        }
      }
    };
    __privateSet$1(this, _longFrameDetector, new LongFrameDetector());
    this.setupVisibilityChangeHandler();
    __privateSet$1(this, _interactionInProgress, null);
    if (panelProfilingConfig) {
      this._panelProfilingManager = new PanelProfilingManager(panelProfilingConfig);
    }
  }
  /** Set generic metadata for observer notifications */
  setMetadata(metadata) {
    this.metadata = { ...metadata };
  }
  setQueryController(queryController) {
    this.queryController = queryController;
  }
  /** Attach panel profiling to a scene object */
  attachPanelProfiling(sceneObject) {
    var _a;
    (_a = this._panelProfilingManager) == null ? void 0 : _a.attachToScene(sceneObject);
  }
  /** Attach profiler to a specific panel */
  attachProfilerToPanel(panel) {
    var _a;
    writePerformanceLog("SRP", "Attaching profiler to panel", panel.state.key);
    (_a = this._panelProfilingManager) == null ? void 0 : _a.attachProfilerToPanel(panel);
  }
  setInteractionCompleteHandler(handler) {
    __privateSet$1(this, _onInteractionComplete, handler != null ? handler : null);
  }
  setupVisibilityChangeHandler() {
    if (__privateGet$1(this, _visibilityChangeHandler)) {
      return;
    }
    __privateSet$1(this, _visibilityChangeHandler, () => {
      if (document.hidden && __privateGet$1(this, _profileInProgress)) {
        writePerformanceLog("SRP", "Tab became inactive, cancelling profile");
        this.cancelProfile();
      }
    });
    if (typeof document !== "undefined") {
      document.addEventListener("visibilitychange", __privateGet$1(this, _visibilityChangeHandler));
    }
  }
  cleanup() {
    var _a;
    if (__privateGet$1(this, _visibilityChangeHandler) && typeof document !== "undefined") {
      document.removeEventListener("visibilitychange", __privateGet$1(this, _visibilityChangeHandler));
      __privateSet$1(this, _visibilityChangeHandler, null);
    }
    __privateGet$1(this, _longFrameDetector).stop();
    this.cancelProfile();
    (_a = this._panelProfilingManager) == null ? void 0 : _a.cleanup();
  }
  startProfile(name) {
    if (document.hidden) {
      writePerformanceLog("SRP", "Tab is inactive, skipping profile", name);
      return;
    }
    if (__privateGet$1(this, _profileInProgress)) {
      if (__privateGet$1(this, _trailAnimationFrameId)) {
        this.cancelProfile();
        this._startNewProfile(name, true);
      } else {
        this.addCrumb(name);
      }
    } else {
      this._startNewProfile(name);
    }
  }
  startInteraction(interaction) {
    if (__privateGet$1(this, _interactionInProgress)) {
      writePerformanceLog("SRP", "Cancelled interaction:", __privateGet$1(this, _interactionInProgress));
      __privateSet$1(this, _interactionInProgress, null);
    }
    __privateSet$1(this, _interactionInProgress, {
      interaction,
      startTs: performance.now()
    });
    writePerformanceLog("SRP", "Started interaction:", interaction);
  }
  stopInteraction() {
    if (!__privateGet$1(this, _interactionInProgress)) {
      return;
    }
    const endTs = performance.now();
    const interactionDuration = endTs - __privateGet$1(this, _interactionInProgress).startTs;
    const networkDuration = captureNetwork(__privateGet$1(this, _interactionInProgress).startTs, endTs);
    writePerformanceLog(
      "SRP",
      `[INTERACTION] Complete: ${interactionDuration.toFixed(1)}ms total | ${networkDuration.toFixed(1)}ms network`
    );
    if (__privateGet$1(this, _onInteractionComplete) && __privateGet$1(this, _profileInProgress)) {
      __privateGet$1(this, _onInteractionComplete).call(this, {
        origin: __privateGet$1(this, _interactionInProgress).interaction,
        duration: interactionDuration,
        networkDuration,
        startTs: __privateGet$1(this, _interactionInProgress).startTs,
        endTs
      });
    }
    performance.mark(`${__privateGet$1(this, _interactionInProgress).interaction}_start`, {
      startTime: __privateGet$1(this, _interactionInProgress).startTs
    });
    performance.mark(`${__privateGet$1(this, _interactionInProgress).interaction}_end`, {
      startTime: endTs
    });
    performance.measure(
      `Interaction_${__privateGet$1(this, _interactionInProgress).interaction}`,
      `${__privateGet$1(this, _interactionInProgress).interaction}_start`,
      `${__privateGet$1(this, _interactionInProgress).interaction}_end`
    );
    __privateSet$1(this, _interactionInProgress, null);
  }
  getCurrentInteraction() {
    var _a, _b;
    return (_b = (_a = __privateGet$1(this, _interactionInProgress)) == null ? void 0 : _a.interaction) != null ? _b : null;
  }
  /**
   * Start new performance profile
   * @param name - Profile trigger (e.g., 'time_range_change')
   * @param force - True if canceling existing profile, false if starting clean
   */
  _startNewProfile(name, force = false) {
    const profileType = force ? "forced" : "clean";
    writePerformanceLog("SRP", `[PROFILER] ${name} started (${profileType})`);
    __privateSet$1(this, _profileInProgress, { origin: name, crumbs: [] });
    __privateSet$1(this, _profileStartTs, performance.now());
    __privateSet$1(this, _longFramesCount, 0);
    __privateSet$1(this, _longFramesTotalTime, 0);
    __privateSet$1(this, _currentOperationId, generateOperationId("dashboard"));
    getScenePerformanceTracker().notifyDashboardInteractionStart({
      operationId: __privateGet$1(this, _currentOperationId),
      interactionType: name,
      timestamp: __privateGet$1(this, _profileStartTs),
      metadata: this.metadata
    });
    __privateGet$1(this, _longFrameDetector).start((event) => {
      if (!__privateGet$1(this, _profileInProgress) || !__privateGet$1(this, _profileStartTs)) {
        return;
      }
      if (event.timestamp < __privateGet$1(this, _profileStartTs)) {
        return;
      }
      __privateWrapper(this, _longFramesCount)._++;
      __privateSet$1(this, _longFramesTotalTime, __privateGet$1(this, _longFramesTotalTime) + event.duration);
    });
  }
  recordProfileTail(measurementStartTime, profileStartTs) {
    __privateSet$1(this, _trailAnimationFrameId, requestAnimationFrame(
      () => this.measureTrailingFrames(measurementStartTime, measurementStartTime, profileStartTs)
    ));
  }
  tryCompletingProfile() {
    var _a;
    writePerformanceLog("SRP", "Trying to complete profile", __privateGet$1(this, _profileInProgress));
    if (((_a = this.queryController) == null ? void 0 : _a.runningQueriesCount()) === 0 && __privateGet$1(this, _profileInProgress)) {
      writePerformanceLog("SRP", "All queries completed, stopping profile");
      this.recordProfileTail(performance.now(), __privateGet$1(this, _profileStartTs));
    }
  }
  isTailRecording() {
    return Boolean(__privateGet$1(this, _trailAnimationFrameId));
  }
  cancelTailRecording() {
    if (__privateGet$1(this, _trailAnimationFrameId)) {
      cancelAnimationFrame(__privateGet$1(this, _trailAnimationFrameId));
      __privateSet$1(this, _trailAnimationFrameId, null);
      writePerformanceLog("SRP", "Cancelled recording frames, new profile started");
    }
  }
  cancelProfile() {
    if (__privateGet$1(this, _profileInProgress)) {
      writePerformanceLog("SRP", "Cancelling profile", __privateGet$1(this, _profileInProgress));
      __privateSet$1(this, _profileInProgress, null);
      if (__privateGet$1(this, _trailAnimationFrameId)) {
        cancelAnimationFrame(__privateGet$1(this, _trailAnimationFrameId));
        __privateSet$1(this, _trailAnimationFrameId, null);
      }
      __privateGet$1(this, _longFrameDetector).stop();
      writePerformanceLog("SRP", "Stopped long frame detection - profile cancelled");
      __privateSet$1(this, _recordedTrailingSpans, []);
      __privateSet$1(this, _longFramesCount, 0);
      __privateSet$1(this, _longFramesTotalTime, 0);
    }
  }
  addCrumb(crumb) {
    if (__privateGet$1(this, _profileInProgress)) {
      getScenePerformanceTracker().notifyDashboardInteractionMilestone({
        operationId: generateOperationId("dashboard-milestone"),
        interactionType: __privateGet$1(this, _profileInProgress).origin,
        timestamp: performance.now(),
        milestone: crumb,
        metadata: this.metadata
      });
      __privateGet$1(this, _profileInProgress).crumbs.push(crumb);
    }
  }
}
_profileInProgress = new WeakMap();
_interactionInProgress = new WeakMap();
_profileStartTs = new WeakMap();
_trailAnimationFrameId = new WeakMap();
_currentOperationId = new WeakMap();
_recordedTrailingSpans = new WeakMap();
_longFrameDetector = new WeakMap();
_longFramesCount = new WeakMap();
_longFramesTotalTime = new WeakMap();
_visibilityChangeHandler = new WeakMap();
_onInteractionComplete = new WeakMap();
function processRecordedSpans(spans) {
  for (let i = spans.length - 1; i >= 0; i--) {
    if (spans[i] > DEFAULT_LONG_FRAME_THRESHOLD) {
      return spans.slice(0, i + 1);
    }
  }
  return [spans[0]];
}
function captureNetwork(startTs, endTs) {
  const entries = performance.getEntriesByType("resource");
  performance.clearResourceTimings();
  const networkEntries = entries.filter(
    (entry) => entry.startTime >= startTs && entry.startTime <= endTs && entry.responseEnd >= startTs && entry.responseEnd <= endTs
  );
  for (const entry of networkEntries) {
    performance.measure("Network entry " + entry.name, {
      start: entry.startTime,
      end: entry.responseEnd
    });
  }
  return calculateNetworkTime(networkEntries);
}
function calculateNetworkTime(requests) {
  if (requests.length === 0) {
    return 0;
  }
  requests.sort((a, b) => a.startTime - b.startTime);
  let totalNetworkTime = 0;
  let currentStart = requests[0].startTime;
  let currentEnd = requests[0].responseEnd;
  for (let i = 1; i < requests.length; i++) {
    if (requests[i].startTime <= currentEnd) {
      currentEnd = Math.max(currentEnd, requests[i].responseEnd);
    } else {
      totalNetworkTime += currentEnd - currentStart;
      currentStart = requests[i].startTime;
      currentEnd = requests[i].responseEnd;
    }
  }
  totalNetworkTime += currentEnd - currentStart;
  return totalNetworkTime;
}

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SceneRenderProfiler: SceneRenderProfiler,
  getScenePerformanceTracker: getScenePerformanceTracker
});

function getMessageFromError(err) {
  if (typeof err === "string") {
    return err;
  }
  if (err) {
    if (err instanceof Error) {
      return err.message;
    } else if (runtime.isFetchError(err)) {
      if (err.data && err.data.message) {
        return err.data.message;
      } else if (err.statusText) {
        return err.statusText;
      }
    } else if (err.hasOwnProperty("message")) {
      return err.message;
    }
  }
  return JSON.stringify(err);
}

class SceneDataLayerBase extends SceneObjectBase {
  /**
   * For variables support in data layer provide variableDependencyStatePaths with keys of the state to be scanned for variables.
   */
  constructor(initialState, variableDependencyStatePaths = []) {
    super({
      isEnabled: true,
      ...initialState
    });
    /**
     * Subject to emit results to.
     */
    this._results = new rxjs.ReplaySubject(1);
    /**
     * Mark data provider as data layer
     */
    this.isDataLayer = true;
    this._variableValueRecorder = new VariableValueRecorder();
    this._variableDependency = new VariableDependencyConfig(this, {
      onVariableUpdateCompleted: this.onVariableUpdateCompleted.bind(this),
      dependsOnScopes: true
    });
    this._variableDependency.setPaths(variableDependencyStatePaths);
    this.addActivationHandler(() => this.onActivate());
  }
  onActivate() {
    if (this.state.isEnabled) {
      this.onEnable();
    }
    if (this.shouldRunLayerOnActivate()) {
      this.runLayer();
    }
    this.subscribeToState((n, p) => {
      if (!n.isEnabled && this.querySub) {
        this.querySub.unsubscribe();
        this.querySub = void 0;
        this.onDisable();
        this._results.next({ origin: this, data: emptyPanelData });
        this.setStateHelper({ data: emptyPanelData });
      }
      if (n.isEnabled && !p.isEnabled) {
        this.onEnable();
        this.runLayer();
      }
    });
    return () => {
      this.onDeactivate();
    };
  }
  onDeactivate() {
    if (this.querySub) {
      this.querySub.unsubscribe();
      this.querySub = void 0;
    }
    this.onDisable();
    this._variableValueRecorder.recordCurrentDependencyValuesForSceneObject(this);
  }
  onVariableUpdateCompleted() {
    this.runLayer();
  }
  cancelQuery() {
    if (this.querySub) {
      this.querySub.unsubscribe();
      this.querySub = void 0;
      this.publishResults(emptyPanelData);
    }
  }
  publishResults(data) {
    if (this.state.isEnabled) {
      this._results.next({ origin: this, data });
      this.setStateHelper({ data });
    }
  }
  getResultsStream() {
    return this._results;
  }
  shouldRunLayerOnActivate() {
    if (!this.state.isEnabled) {
      return false;
    }
    if (this._variableValueRecorder.hasDependenciesChanged(this)) {
      writeSceneLog(
        "SceneDataLayerBase",
        "Variable dependency changed while inactive, shouldRunLayerOnActivate returns true"
      );
      return true;
    }
    if (!this.state.data) {
      return true;
    }
    return false;
  }
  /**
   * This helper function is to counter the contravariance of setState
   */
  setStateHelper(state) {
    setBaseClassState(this, state);
  }
}

const standardAnnotationSupport = {
  /**
   * Assume the stored value is standard model.
   */
  prepareAnnotation: (json) => {
    if (lodash.isString(json == null ? void 0 : json.query)) {
      const { query, ...rest } = json;
      return {
        ...rest,
        target: {
          refId: "annotation_query",
          query
        },
        mappings: {}
      };
    }
    return json;
  },
  /**
   * Default will just return target from the annotation.
   */
  prepareQuery: (anno) => anno.target,
  /**
   * Provides default processing from dataFrame to annotation events.
   */
  processEvents: (anno, data) => {
    return getAnnotationsFromData(data, anno.mappings);
  }
};
function singleFrameFromPanelData() {
  return (source) => source.pipe(
    operators.mergeMap((data$1) => {
      if (!(data$1 == null ? void 0 : data$1.length)) {
        return rxjs.of(void 0);
      }
      if (data$1.length === 1) {
        return rxjs.of(data$1[0]);
      }
      const ctx = {
        interpolate: (v) => v
      };
      return rxjs.of(data$1).pipe(
        data.standardTransformers.mergeTransformer.operator({}, ctx),
        operators.map((d) => d[0])
      );
    })
  );
}
const annotationEventNames = [
  {
    key: "time",
    field: (frame) => frame.fields.find((f) => f.type === data.FieldType.time),
    placeholder: "time, or the first time field"
  },
  { key: "timeEnd", help: "When this field is defined, the annotation will be treated as a range" },
  {
    key: "title"
  },
  {
    key: "text",
    field: (frame) => frame.fields.find((f) => f.type === data.FieldType.string),
    placeholder: "text, or the first text field"
  },
  { key: "tags", split: ",", help: "The results will be split on comma (,)" },
  {
    key: "id"
  }
];
const publicDashboardEventNames = [
  {
    key: "color"
  },
  {
    key: "isRegion"
  },
  {
    key: "source"
  }
];
const alertEventAndAnnotationFields = [
  ...runtime.config.publicDashboardAccessToken ? publicDashboardEventNames : [],
  ...annotationEventNames,
  { key: "userId" },
  { key: "login" },
  { key: "email" },
  { key: "prevState" },
  { key: "newState" },
  { key: "data" },
  { key: "panelId" },
  { key: "alertId" },
  { key: "dashboardId" },
  { key: "dashboardUID" }
];
function getAnnotationsFromData(data$1, options) {
  return rxjs.of(data$1).pipe(
    singleFrameFromPanelData(),
    operators.map((frame) => {
      if (!(frame == null ? void 0 : frame.length)) {
        return [];
      }
      let hasTime = false;
      let hasText = false;
      const byName = {};
      for (const f of frame.fields) {
        const name = data.getFieldDisplayName(f, frame);
        byName[name.toLowerCase()] = f;
      }
      if (!options) {
        options = {};
      }
      const fields = [];
      for (const evts of alertEventAndAnnotationFields) {
        const opt = options[evts.key] || {};
        if (opt.source === data.AnnotationEventFieldSource.Skip) {
          continue;
        }
        const setter = { key: evts.key, split: evts.split };
        if (opt.source === data.AnnotationEventFieldSource.Text) {
          setter.text = opt.value;
        } else {
          const lower = (opt.value || evts.key).toLowerCase();
          setter.field = byName[lower];
          if (!setter.field && evts.field) {
            setter.field = evts.field(frame);
          }
        }
        if (setter.field || setter.text) {
          fields.push(setter);
          if (setter.key === "time") {
            hasTime = true;
          } else if (setter.key === "text") {
            hasText = true;
          }
        }
      }
      if (!hasTime || !hasText) {
        console.error("Cannot process annotation fields. No time or text present.");
        return [];
      }
      const events = [];
      for (let i = 0; i < frame.length; i++) {
        const anno = {
          type: "default",
          color: "red"
        };
        for (const f of fields) {
          let v = void 0;
          if (f.text) {
            v = f.text;
          } else if (f.field) {
            v = f.field.values[i];
            if (v !== void 0 && f.regex) {
              const match = f.regex.exec(v);
              if (match) {
                v = match[1] ? match[1] : match[0];
              }
            }
          }
          if (v !== null && v !== void 0) {
            if (f.split && typeof v === "string") {
              v = v.split(",");
            }
            anno[f.key] = v;
          }
        }
        events.push(anno);
      }
      return events;
    })
  );
}
const legacyRunner = [
  "prometheus",
  "loki",
  "elasticsearch",
  "grafana-opensearch-datasource"
  // external
];
function shouldUseLegacyRunner(datasource) {
  const { type } = datasource;
  return !datasource.annotations || legacyRunner.includes(type);
}

let counter = 100;
function getNextRequestId() {
  return "AQ" + counter++;
}
function executeAnnotationQuery(datasource, timeRange, query, layer, filters, groupByKeys) {
  var _a;
  if (datasource.annotationQuery && shouldUseLegacyRunner(datasource)) {
    console.warn("Using deprecated annotationQuery method, please upgrade your datasource");
    return rxjs.from(
      datasource.annotationQuery({
        range: timeRange.state.value,
        rangeRaw: timeRange.state.value.raw,
        annotation: query,
        dashboard: {
          getVariables: runtime.getTemplateSrv().getVariables
        }
      })
    ).pipe(
      operators.map((events) => ({
        state: schema.LoadingState.Done,
        events
      }))
    );
  }
  const processor = {
    ...standardAnnotationSupport,
    ...datasource.annotations
  };
  const annotationWithDefaults = {
    // Default query provided by a data source
    ...(_a = processor.getDefaultQuery) == null ? void 0 : _a.call(processor),
    ...query
  };
  const annotation = processor.prepareAnnotation(annotationWithDefaults);
  if (!annotation) {
    return rxjs.of({
      state: schema.LoadingState.Done,
      events: []
    });
  }
  const processedQuery = processor.prepareQuery(annotation);
  if (!processedQuery) {
    return rxjs.of({
      state: schema.LoadingState.Done,
      events: []
    });
  }
  const maxDataPoints = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  const interval = data.rangeUtil.calculateInterval(timeRange.state.value, maxDataPoints, datasource.interval);
  const scopedVars = {
    __interval: { text: interval.interval, value: interval.interval },
    __interval_ms: { text: interval.intervalMs.toString(), value: interval.intervalMs },
    __annotation: { text: annotation.name, value: annotation },
    __sceneObject: wrapInSafeSerializableSceneObject(layer)
  };
  const queryRequest = {
    startTime: Date.now(),
    requestId: getNextRequestId(),
    range: timeRange.state.value,
    maxDataPoints,
    scopedVars,
    ...interval,
    app: data.CoreApp.Dashboard,
    timezone: timeRange.getTimeZone(),
    targets: [
      {
        ...processedQuery,
        refId: "Anno"
      }
    ],
    scopes: sceneGraph.getScopes(layer),
    filters,
    groupByKeys,
    ...getEnrichedDataRequest(layer)
  };
  const runRequest = runtime.getRunRequest();
  return runRequest(datasource, queryRequest).pipe(
    operators.mergeMap((panelData) => {
      const data$1 = (panelData == null ? void 0 : panelData.series.length) ? panelData.series : panelData.annotations;
      if (!(data$1 == null ? void 0 : data$1.length)) {
        return rxjs.of({
          state: panelData.state,
          events: []
        });
      }
      data$1.forEach((frame) => {
        var _a2;
        if (!((_a2 = frame.meta) == null ? void 0 : _a2.dataTopic)) {
          frame.meta = { ...frame.meta || {}, dataTopic: data.DataTopic.Annotations };
        }
      });
      return processor.processEvents(annotation, data$1).pipe(
        operators.map((events) => {
          return {
            state: panelData.state,
            events: events || []
          };
        })
      );
    })
  );
}

function postProcessQueryResult(annotation, results) {
  if (annotation.snapshotData) {
    annotation = lodash.cloneDeep(annotation);
    delete annotation.snapshotData;
  }
  const processed = results.map((item) => {
    var _a;
    const processedItem = { ...item };
    processedItem.source = annotation;
    processedItem.color = runtime.config.theme2.visualization.getColorByName(annotation.iconColor);
    processedItem.type = annotation.name;
    processedItem.isRegion = Boolean(processedItem.timeEnd && processedItem.time !== processedItem.timeEnd);
    switch ((_a = processedItem.newState) == null ? void 0 : _a.toLowerCase()) {
      case "pending":
        processedItem.color = "yellow";
        break;
      case "alerting":
        processedItem.color = "red";
        break;
      case "ok":
        processedItem.color = "green";
        break;
      case "normal":
        processedItem.color = "green";
        break;
      case "no_data":
        processedItem.color = "gray";
        break;
      case "nodata":
        processedItem.color = "gray";
        break;
    }
    return processedItem;
  });
  return processed;
}
function dedupAnnotations(annotations) {
  let dedup = [];
  const events = lodash.partition(annotations, "id");
  const eventsById = lodash.groupBy(events[0], "id");
  dedup = lodash.map(eventsById, (eventGroup) => {
    if (eventGroup.length > 1 && !lodash.every(eventGroup, isPanelAlert)) {
      return lodash.find(eventGroup, (event) => {
        return event.eventType !== "panel-alert";
      });
    } else {
      return lodash.head(eventGroup);
    }
  });
  dedup = lodash.concat(dedup, events[1]);
  return dedup;
}
function isPanelAlert(event) {
  return event.eventType === "panel-alert";
}

class AnnotationsDataLayer extends SceneDataLayerBase {
  constructor(initialState) {
    super(
      {
        isEnabled: true,
        ...initialState
      },
      ["query"]
    );
    this._scopedVars = {
      __sceneObject: wrapInSafeSerializableSceneObject(this)
    };
    this._drilldownDependenciesManager = new DrilldownDependenciesManager(this._variableDependency);
  }
  onEnable() {
    this.publishEvent(new runtime.RefreshEvent(), true);
    const timeRange = sceneGraph.getTimeRange(this);
    this.setState({
      query: {
        ...this.state.query,
        enable: true
      }
    });
    this._timeRangeSub = timeRange.subscribeToState(() => {
      this.runWithTimeRange(timeRange);
    });
  }
  onDisable() {
    var _a;
    this.publishEvent(new runtime.RefreshEvent(), true);
    this.setState({
      query: {
        ...this.state.query,
        enable: false
      }
    });
    (_a = this._timeRangeSub) == null ? void 0 : _a.unsubscribe();
  }
  runLayer() {
    writeSceneLog("AnnotationsDataLayer", "run layer");
    const timeRange = sceneGraph.getTimeRange(this);
    this.runWithTimeRange(timeRange);
  }
  async runWithTimeRange(timeRange) {
    var _a;
    const { query } = this.state;
    if (!query.enable) {
      return;
    }
    this._drilldownDependenciesManager.findAndSubscribeToDrilldowns((_a = query.datasource) == null ? void 0 : _a.uid);
    if (this.querySub) {
      this.querySub.unsubscribe();
    }
    if (this._variableDependency.hasDependencyInLoadingState()) {
      writeSceneLog("AnnotationsDataLayer", "Variable dependency is in loading state, skipping query execution");
      return;
    }
    try {
      const ds = await this.resolveDataSource(query);
      let stream = executeAnnotationQuery(
        ds,
        timeRange,
        query,
        this,
        this._drilldownDependenciesManager.getFilters(),
        this._drilldownDependenciesManager.getGroupByKeys()
      ).pipe(
        registerQueryWithController({
          type: "AnnotationsDataLayer/annotationsLoading",
          origin: this,
          cancel: () => this.cancelQuery()
        }),
        rxjs.map((events) => {
          const stateUpdate = this.processEvents(query, events);
          return stateUpdate;
        })
      );
      this.querySub = stream.subscribe((stateUpdate) => {
        this.publishResults(stateUpdate);
      });
    } catch (e) {
      this.publishResults({
        ...emptyPanelData,
        state: schema.LoadingState.Error,
        errors: [
          {
            message: getMessageFromError(e)
          }
        ]
      });
      console.error("AnnotationsDataLayer error", e);
    }
  }
  async resolveDataSource(query) {
    return await getDataSource(query.datasource || void 0, this._scopedVars);
  }
  processEvents(query, events) {
    let processedEvents = postProcessQueryResult(query, events.events || []);
    processedEvents = dedupAnnotations(processedEvents);
    const stateUpdate = { ...emptyPanelData, state: events.state };
    const df = data.arrayToDataFrame(processedEvents);
    df.meta = {
      ...df.meta,
      dataTopic: data.DataTopic.Annotations
    };
    stateUpdate.series = [df];
    return stateUpdate;
  }
}
AnnotationsDataLayer.Component = AnnotationsDataLayerRenderer;
function AnnotationsDataLayerRenderer({ model }) {
  const { isEnabled, isHidden } = model.useState();
  const elementId = `data-layer-${model.state.key}`;
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ React__default.default.createElement(
    ui.InlineSwitch,
    {
      className: switchStyle,
      id: elementId,
      value: isEnabled,
      onChange: () => model.setState({ isEnabled: !isEnabled })
    }
  );
}
const switchStyle = css.css({
  borderBottomLeftRadius: 0,
  borderTopLeftRadius: 0
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AnnotationsDataLayer: AnnotationsDataLayer
});

class SceneTimeRangeTransformerBase extends SceneObjectBase {
  constructor(state) {
    super(state);
    this._activationHandler = () => {
      const ancestorTimeRange = this.getAncestorTimeRange();
      this.ancestorTimeRangeChanged(ancestorTimeRange.state);
      this._subs.add(ancestorTimeRange.subscribeToState((s) => this.ancestorTimeRangeChanged(s)));
    };
    this.addActivationHandler(this._activationHandler);
  }
  getAncestorTimeRange() {
    if (!this.parent || !this.parent.parent) {
      throw new Error(typeof this + " must be used within $timeRange scope");
    }
    return sceneGraph.getTimeRange(this.parent.parent);
  }
  getTimeZone() {
    return this.getAncestorTimeRange().getTimeZone();
  }
  onTimeRangeChange(timeRange) {
    this.getAncestorTimeRange().onTimeRangeChange(timeRange);
  }
  onTimeZoneChange(timeZone) {
    this.getAncestorTimeRange().onTimeZoneChange(timeZone);
  }
  onRefresh() {
    this.getAncestorTimeRange().onRefresh();
  }
}

class SceneTimeZoneOverride extends SceneTimeRangeTransformerBase {
  constructor(state) {
    super({
      ...state,
      timeZone: state.timeZone,
      // We set a default time range here. It will be overwritten on activation based on ancestor time range.
      from: "now-6h",
      to: "now",
      value: data.getDefaultTimeRange()
    });
  }
  ancestorTimeRangeChanged(timeRange) {
    this.setState({
      ...timeRange,
      timeZone: this.state.timeZone,
      value: evaluateTimeRange(
        timeRange.from,
        timeRange.to,
        this.state.timeZone,
        timeRange.fiscalYearStartMonth,
        timeRange.UNSAFE_nowDelay,
        timeRange.weekStart
      )
    });
  }
  getTimeZone() {
    return this.state.timeZone;
  }
  onTimeZoneChange(timeZone) {
    const parentTimeRange = this.getAncestorTimeRange();
    this.setState({
      timeZone,
      value: evaluateTimeRange(
        parentTimeRange.state.from,
        parentTimeRange.state.to,
        timeZone,
        parentTimeRange.state.fiscalYearStartMonth,
        parentTimeRange.state.UNSAFE_nowDelay,
        parentTimeRange.state.weekStart
      )
    });
  }
}

class DataProviderProxy extends SceneObjectBase {
  constructor(state) {
    super({
      source: state.source,
      data: state.source.resolve().state.data
    });
    this.addActivationHandler(() => {
      this._subs.add(
        this.state.source.resolve().subscribeToState((newState, oldState) => {
          if (newState.data !== oldState.data) {
            this.setState({ data: newState.data });
          }
        })
      );
    });
  }
  setContainerWidth(width) {
    var _a, _b;
    (_b = (_a = this.state.source.resolve()).setContainerWidth) == null ? void 0 : _b.call(_a, width);
  }
  isDataReadyToDisplay() {
    var _a, _b, _c;
    return (_c = (_b = (_a = this.state.source.resolve()).isDataReadyToDisplay) == null ? void 0 : _b.call(_a)) != null ? _c : true;
  }
  cancelQuery() {
    var _a, _b;
    (_b = (_a = this.state.source.resolve()).cancelQuery) == null ? void 0 : _b.call(_a);
  }
  getResultsStream() {
    return this.state.source.resolve().getResultsStream();
  }
}

class SceneDataLayerControls extends SceneObjectBase {
  constructor() {
    super({});
  }
}
SceneDataLayerControls.Component = SceneDataLayerControlsRenderer;
function SceneDataLayerControlsRenderer({ model }) {
  const layers = sceneGraph.getDataLayers(model, true);
  if (layers.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, layers.map((layer) => /* @__PURE__ */ React__default.default.createElement(SceneDataLayerControlRenderer, { layer, key: layer.state.key })));
}
function SceneDataLayerControlRenderer({ layer }) {
  var _a, _b;
  const elementId = `data-layer-${layer.state.key}`;
  const { data, isHidden } = layer.useState();
  const showLoading = Boolean(data && data.state === schema.LoadingState.Loading);
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ React__default.default.createElement("div", { className: containerStyle$1 }, /* @__PURE__ */ React__default.default.createElement(
    ControlsLabel,
    {
      htmlFor: elementId,
      isLoading: showLoading,
      onCancel: () => {
        var _a2;
        return (_a2 = layer.cancelQuery) == null ? void 0 : _a2.call(layer);
      },
      label: layer.state.name,
      description: layer.state.description,
      error: (_b = (_a = layer.state.data) == null ? void 0 : _a.errors) == null ? void 0 : _b[0].message
    }
  ), /* @__PURE__ */ React__default.default.createElement(layer.Component, { model: layer }));
}
const containerStyle$1 = css.css({ display: "flex" });

class VariableValueSelectors extends SceneObjectBase {
}
VariableValueSelectors.Component = VariableValueSelectorsRenderer;
function VariableValueSelectorsRenderer({ model }) {
  const variables = sceneGraph.getVariables(model).useState();
  return /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, variables.variables.map((variable) => /* @__PURE__ */ React__default.default.createElement(VariableValueSelectWrapper, { key: variable.state.key, variable, layout: model.state.layout })));
}
function VariableValueSelectWrapper({ variable, layout, showAlways, hideLabel }) {
  const state = useSceneObjectState(variable, { shouldActivateOrKeepAlive: true });
  if (state.hide === data.VariableHide.hideVariable && !showAlways) {
    if (variable.UNSAFE_renderAsHidden) {
      return /* @__PURE__ */ React__default.default.createElement(variable.Component, { model: variable });
    }
    return null;
  }
  if (layout === "vertical") {
    return /* @__PURE__ */ React__default.default.createElement("div", { className: verticalContainer, "data-testid": e2eSelectors.selectors.pages.Dashboard.SubMenu.submenuItem }, /* @__PURE__ */ React__default.default.createElement(VariableLabel, { variable, layout, hideLabel }), /* @__PURE__ */ React__default.default.createElement(variable.Component, { model: variable }));
  }
  return /* @__PURE__ */ React__default.default.createElement("div", { className: containerStyle, "data-testid": e2eSelectors.selectors.pages.Dashboard.SubMenu.submenuItem }, /* @__PURE__ */ React__default.default.createElement(VariableLabel, { variable, hideLabel }), /* @__PURE__ */ React__default.default.createElement(variable.Component, { model: variable }));
}
function VariableLabel({ variable, layout, hideLabel }) {
  var _a;
  const { state } = variable;
  if (variable.state.hide === data.VariableHide.hideLabel || hideLabel) {
    return null;
  }
  const elementId = `var-${state.key}`;
  const labelOrName = state.label || state.name;
  return /* @__PURE__ */ React__default.default.createElement(
    ControlsLabel,
    {
      htmlFor: elementId,
      isLoading: state.loading,
      onCancel: () => {
        var _a2;
        return (_a2 = variable.onCancel) == null ? void 0 : _a2.call(variable);
      },
      label: labelOrName,
      error: state.error,
      layout,
      description: (_a = state.description) != null ? _a : void 0
    }
  );
}
const containerStyle = css.css({
  display: "flex",
  // No border for second element (inputs) as label and input border is shared
  "> :nth-child(2)": css.css({
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  })
});
const verticalContainer = css.css({ display: "flex", flexDirection: "column" });

class VariableValueControl extends SceneObjectBase {
}
VariableValueControl.Component = VariableValueControlRenderer;
function VariableValueControlRenderer({ model }) {
  const variable = sceneGraph.lookupVariable(model.state.variableName, model);
  if (!variable) {
    return null;
  }
  return /* @__PURE__ */ React__default.default.createElement(
    VariableValueSelectWrapper,
    {
      key: variable.state.key,
      variable,
      layout: model.state.layout,
      showAlways: true
    }
  );
}

class SceneVariableSet extends SceneObjectBase {
  constructor(state) {
    super(state);
    /** Variables that are scheduled to be validated and updated */
    this._variablesToUpdate = /* @__PURE__ */ new Set();
    /** Variables currently updating  */
    this._updating = /* @__PURE__ */ new Map();
    this._variableValueRecorder = new VariableValueRecorder();
    /**
     * This makes sure SceneVariableSet's higher up in the chain notify us when parent level variables complete update batches.
     **/
    this._variableDependency = new SceneVariableSetVariableDependencyHandler(
      this._handleParentVariableUpdatesCompleted.bind(this)
    );
    /**
     * Subscribes to child variable value changes, and starts the variable value validation process
     */
    this._onActivate = () => {
      const timeRange = sceneGraph.getTimeRange(this);
      this._subs.add(
        this.subscribeToEvent(SceneVariableValueChangedEvent, (event) => this._handleVariableValueChanged(event.payload))
      );
      this._subs.add(
        timeRange.subscribeToState(() => {
          this._refreshTimeRangeBasedVariables();
        })
      );
      this._subs.add(this.subscribeToState(this._onStateChanged));
      this._checkForVariablesThatChangedWhileInactive();
      for (const variable of this.state.variables) {
        if (this._variableNeedsUpdate(variable)) {
          this._variablesToUpdate.add(variable);
        }
      }
      this._updateNextBatch();
      return this._onDeactivate;
    };
    /**
     * Cancel all currently running updates
     */
    this._onDeactivate = () => {
      var _a;
      for (const update of this._updating.values()) {
        (_a = update.subscription) == null ? void 0 : _a.unsubscribe();
      }
      for (const variable of this.state.variables) {
        if (!this._variablesToUpdate.has(variable) && !this._updating.has(variable)) {
          this._variableValueRecorder.recordCurrentValue(variable);
        }
      }
      this._variablesToUpdate.clear();
      this._updating.clear();
    };
    /**
     * Look for new variables that need to be initialized
     */
    this._onStateChanged = (newState, oldState) => {
      const variablesToUpdateCountStart = this._variablesToUpdate.size;
      for (const variable of oldState.variables) {
        if (!newState.variables.includes(variable)) {
          const updating = this._updating.get(variable);
          if (updating == null ? void 0 : updating.subscription) {
            updating.subscription.unsubscribe();
          }
          this._updating.delete(variable);
          this._variablesToUpdate.delete(variable);
        }
      }
      for (const variable of newState.variables) {
        if (!oldState.variables.includes(variable)) {
          if (this._variableNeedsUpdate(variable)) {
            this._variablesToUpdate.add(variable);
          }
        }
      }
      if (variablesToUpdateCountStart === 0 && this._variablesToUpdate.size > 0) {
        this._updateNextBatch();
      }
    };
    this.addActivationHandler(this._onActivate);
  }
  getByName(name) {
    return this.state.variables.find((x) => x.state.name === name);
  }
  /**
   * Add all variables that depend on the changed variable to the update queue
   */
  _refreshTimeRangeBasedVariables() {
    for (const variable of this.state.variables) {
      if ("refresh" in variable.state && variable.state.refresh === data.VariableRefresh.onTimeRangeChanged) {
        this._variablesToUpdate.add(variable);
      }
    }
    this._updateNextBatch();
  }
  /**
   * If variables changed while in in-active state we don't get any change events, so we need to check for that here.
   */
  _checkForVariablesThatChangedWhileInactive() {
    if (!this._variableValueRecorder.hasValues()) {
      return;
    }
    for (const variable of this.state.variables) {
      if (this._variableValueRecorder.hasValueChanged(variable)) {
        writeVariableTraceLog(variable, "Changed while in-active");
        this._addDependentVariablesToUpdateQueue(variable);
      }
    }
  }
  _variableNeedsUpdate(variable) {
    if (variable.isLazy) {
      return false;
    }
    if (!variable.validateAndUpdate) {
      return false;
    }
    if (this._variableValueRecorder.hasRecordedValue(variable)) {
      writeVariableTraceLog(variable, "Skipping updateAndValidate current value valid");
      return false;
    }
    return true;
  }
  /**
   * This loops through variablesToUpdate and update all that can.
   * If one has a dependency that is currently in variablesToUpdate it will be skipped for now.
   */
  _updateNextBatch() {
    for (const variable of this._variablesToUpdate) {
      if (!variable.validateAndUpdate) {
        console.error("Variable added to variablesToUpdate but does not have validateAndUpdate");
        continue;
      }
      if (this._updating.has(variable)) {
        continue;
      }
      if (sceneGraph.hasVariableDependencyInLoadingState(variable)) {
        continue;
      }
      const variableToUpdate = {
        variable
      };
      this._updating.set(variable, variableToUpdate);
      writeVariableTraceLog(variable, "updateAndValidate started");
      variableToUpdate.subscription = variable.validateAndUpdate().subscribe({
        next: () => this._validateAndUpdateCompleted(variable),
        complete: () => this._validateAndUpdateCompleted(variable),
        error: (err) => this._handleVariableError(variable, err)
      });
    }
  }
  /**
   * A variable has completed its update process. This could mean that variables that depend on it can now be updated in turn.
   */
  _validateAndUpdateCompleted(variable) {
    var _a;
    if (!this._updating.has(variable)) {
      return;
    }
    const update = this._updating.get(variable);
    (_a = update == null ? void 0 : update.subscription) == null ? void 0 : _a.unsubscribe();
    this._updating.delete(variable);
    this._variablesToUpdate.delete(variable);
    writeVariableTraceLog(variable, "updateAndValidate completed");
    this._notifyDependentSceneObjects(variable);
    this._updateNextBatch();
  }
  cancel(variable) {
    var _a;
    const update = this._updating.get(variable);
    (_a = update == null ? void 0 : update.subscription) == null ? void 0 : _a.unsubscribe();
    this._updating.delete(variable);
    this._variablesToUpdate.delete(variable);
  }
  _handleVariableError(variable, err) {
    var _a;
    const update = this._updating.get(variable);
    (_a = update == null ? void 0 : update.subscription) == null ? void 0 : _a.unsubscribe();
    this._updating.delete(variable);
    this._variablesToUpdate.delete(variable);
    variable.setState({ loading: false, error: err.message });
    console.error("SceneVariableSet updateAndValidate error", err);
    writeVariableTraceLog(variable, "updateAndValidate error", err);
    this._notifyDependentSceneObjects(variable);
    this._updateNextBatch();
  }
  _handleVariableValueChanged(variableThatChanged) {
    this._addDependentVariablesToUpdateQueue(variableThatChanged);
    if (!this._updating.has(variableThatChanged)) {
      this._updateNextBatch();
      this._notifyDependentSceneObjects(variableThatChanged);
    }
  }
  /**
   * This is called by any parent level variable set to notify scene that an update batch is completed.
   * This is the main mechanism lower level variable set's react to changes on higher levels.
   */
  _handleParentVariableUpdatesCompleted(variable, hasChanged) {
    if (hasChanged) {
      this._addDependentVariablesToUpdateQueue(variable);
    }
    if (this._variablesToUpdate.size > 0 && this._updating.size === 0) {
      this._updateNextBatch();
    }
  }
  _addDependentVariablesToUpdateQueue(variableThatChanged) {
    for (const otherVariable of this.state.variables) {
      if (otherVariable.variableDependency) {
        if (otherVariable.variableDependency.hasDependencyOn(variableThatChanged.state.name)) {
          writeVariableTraceLog(otherVariable, "Added to update queue, dependant variable value changed");
          if (this._updating.has(otherVariable) && otherVariable.onCancel) {
            otherVariable.onCancel();
          }
          if (otherVariable.validateAndUpdate) {
            this._variablesToUpdate.add(otherVariable);
          }
          otherVariable.variableDependency.variableUpdateCompleted(variableThatChanged, true);
        }
      }
    }
  }
  /**
   * Walk scene object graph and update all objects that depend on variables that have changed
   */
  _notifyDependentSceneObjects(variable) {
    if (!this.parent) {
      return;
    }
    this._traverseSceneAndNotify(this.parent, variable, true);
  }
  /**
   * Recursivly walk the full scene object graph and notify all objects with dependencies that include any of changed variables
   */
  _traverseSceneAndNotify(sceneObject, variable, hasChanged) {
    if (this === sceneObject) {
      return;
    }
    if (!sceneObject.isActive) {
      return;
    }
    if (sceneObject.state.$variables && sceneObject.state.$variables !== this) {
      const localVar = sceneObject.state.$variables.getByName(variable.state.name);
      if (localVar == null ? void 0 : localVar.isAncestorLoading) {
        variable = localVar;
      } else if (localVar) {
        return;
      }
    }
    if (sceneObject.variableDependency) {
      sceneObject.variableDependency.variableUpdateCompleted(variable, hasChanged);
    }
    sceneObject.forEachChild((child) => this._traverseSceneAndNotify(child, variable, hasChanged));
  }
  /**
   * Return true if variable is waiting to update or currently updating.
   * It also returns true if a dependency of the variable is loading.
   *
   * For example if C depends on variable B which depends on variable A and A is loading this returns true for variable C and B.
   */
  isVariableLoadingOrWaitingToUpdate(variable) {
    if (variable.state.loading) {
      return true;
    }
    if (variable.isAncestorLoading && variable.isAncestorLoading()) {
      return true;
    }
    if (this._variablesToUpdate.has(variable) || this._updating.has(variable)) {
      return true;
    }
    return sceneGraph.hasVariableDependencyInLoadingState(variable);
  }
}
function writeVariableTraceLog(variable, message, err) {
  if (err) {
    writeSceneLog("SceneVariableSet", `Variable[${variable.state.name}]: ${message}`, err);
  } else {
    writeSceneLog("SceneVariableSet", `Variable[${variable.state.name}]: ${message}`);
  }
}
class SceneVariableSetVariableDependencyHandler {
  constructor(_variableUpdatesCompleted) {
    this._variableUpdatesCompleted = _variableUpdatesCompleted;
    this._emptySet = /* @__PURE__ */ new Set();
  }
  getNames() {
    return this._emptySet;
  }
  hasDependencyOn(name) {
    return false;
  }
  variableUpdateCompleted(variable, hasChanged) {
    this._variableUpdatesCompleted(variable, hasChanged);
  }
}

class CustomVariable extends MultiValueVariable {
  constructor(initialState) {
    super({
      type: "custom",
      query: "",
      valuesFormat: "csv",
      value: "",
      text: "",
      options: [],
      name: "",
      ...initialState
    });
    this._variableDependency = new VariableDependencyConfig(this, {
      statePaths: ["query"]
    });
  }
  // We expose this publicly as we also need it outside the variable
  // The interpolate flag is needed since we don't always want to get the interpolated options
  transformCsvStringToOptions(str, interpolate = true) {
    var _a;
    str = interpolate ? sceneGraph.interpolate(this, str) : str;
    const match = (_a = str.match(/(?:\\,|[^,])+/g)) != null ? _a : [];
    return match.map((text) => {
      var _a2;
      text = text.replace(/\\,/g, ",");
      const textMatch = (_a2 = /^\s*(.+)\s:\s(.+)$/g.exec(text)) != null ? _a2 : [];
      if (textMatch.length === 3) {
        const [, key, value] = textMatch;
        return { label: key.trim(), value: value.trim() };
      } else {
        return { label: text.trim(), value: text.trim() };
      }
    });
  }
  transformJsonToOptions(json) {
    if (!json) {
      return [];
    }
    const parsedOptions = JSON.parse(json);
    if (!Array.isArray(parsedOptions) || parsedOptions.some((o) => typeof o !== "object" || o === null)) {
      throw new Error("Query must be a JSON array of objects");
    }
    const textProp = "text";
    const valueProp = "value";
    return parsedOptions.map((o) => {
      var _a;
      return {
        label: (_a = String(o[textProp] || o[valueProp])) == null ? void 0 : _a.trim(),
        value: String(o[valueProp]).trim(),
        properties: o
      };
    });
  }
  getValueOptions(args) {
    const options = this.state.valuesFormat === "json" ? this.transformJsonToOptions(this.state.query) : this.transformCsvStringToOptions(this.state.query);
    if (!options.length) {
      this.skipNextValidation = true;
    }
    return rxjs.of(options);
  }
}
CustomVariable.Component = ({ model }) => {
  return /* @__PURE__ */ React__default.default.createElement(MultiOrSingleValueSelect, { model });
};

class SwitchVariable extends SceneObjectBase {
  constructor(initialState) {
    super({
      // TODO: remove this once switch is in the schema @leventebalogh
      // @ts-expect-error - switch is a valid variable type, but not in the schema yet
      type: "switch",
      value: "false",
      enabledValue: "true",
      disabledValue: "false",
      name: "",
      ...initialState
    });
    this._prevValue = "";
    this._urlSync = new SceneObjectUrlSyncConfig(this, { keys: () => this.getKeys() });
  }
  /**
   * This function is called on when SceneVariableSet is activated or when a dependency changes.
   */
  validateAndUpdate() {
    const newValue = this.getValue();
    if (this._prevValue !== newValue) {
      this._prevValue = newValue;
      this.publishEvent(new SceneVariableValueChangedEvent(this), true);
    }
    return rxjs.of({});
  }
  setValue(newValue) {
    if (this.getValue() === newValue) {
      return;
    }
    if ([this.state.enabledValue, this.state.disabledValue].includes(newValue)) {
      this.setState({ value: newValue });
      this.publishEvent(new SceneVariableValueChangedEvent(this), true);
    } else {
      console.error(
        `Invalid value for switch variable: "${newValue}". Valid values are: "${this.state.enabledValue}" and "${this.state.disabledValue}".`
      );
    }
  }
  getValue() {
    return this.state.value;
  }
  isEnabled() {
    return this.state.value === this.state.enabledValue;
  }
  isDisabled() {
    return this.state.value === this.state.disabledValue;
  }
  getKey() {
    return `var-${this.state.name}`;
  }
  getKeys() {
    if (this.state.skipUrlSync) {
      return [];
    }
    return [this.getKey()];
  }
  getUrlState() {
    if (this.state.skipUrlSync) {
      return {};
    }
    return { [this.getKey()]: this.state.value };
  }
  updateFromUrl(values) {
    const val = values[this.getKey()];
    if (typeof val === "string") {
      this.setValue(val);
    }
  }
}
SwitchVariable.Component = SwitchVariableRenderer;
function SwitchVariableRenderer({ model }) {
  const state = model.useState();
  const styles = ui.useStyles2(getStyles$7);
  return /* @__PURE__ */ React__default.default.createElement("div", { className: styles.container }, /* @__PURE__ */ React__default.default.createElement(
    ui.Switch,
    {
      id: `var-switch-${state.key}`,
      value: state.value === state.enabledValue,
      onChange: (event) => {
        model.setValue(event.currentTarget.checked ? state.enabledValue : state.disabledValue);
      }
    }
  ));
}
function getStyles$7(theme) {
  return {
    container: css.css({
      display: "flex",
      alignItems: "center",
      padding: theme.spacing(0, 1),
      height: theme.spacing(theme.components.height.md),
      borderRadius: theme.shape.radius.default,
      border: `1px solid ${theme.components.input.borderColor}`,
      background: theme.colors.background.primary
    })
  };
}

class DataSourceVariable extends MultiValueVariable {
  constructor(initialState) {
    super({
      type: "datasource",
      value: "",
      text: "",
      options: [],
      name: "",
      regex: "",
      pluginId: "",
      ...initialState
    });
    this._variableDependency = new VariableDependencyConfig(this, {
      statePaths: ["regex"]
    });
  }
  getValueOptions(args) {
    if (!this.state.pluginId) {
      return rxjs.of([]);
    }
    const dataSources = runtime.getDataSourceSrv().getList({ metrics: true, variables: false, pluginId: this.state.pluginId });
    let regex;
    if (this.state.regex) {
      const interpolated = sceneGraph.interpolate(this, this.state.regex, void 0, "regex");
      regex = data.stringToJsRegex(interpolated);
    }
    const options = [];
    for (let i = 0; i < dataSources.length; i++) {
      const source = dataSources[i];
      if (isValid(source, regex)) {
        options.push({ label: source.name, value: source.uid });
      }
      if (this.state.defaultOptionEnabled && isDefault(source, regex)) {
        options.push({
          label: i18n.t("grafana-scenes.variables.data-source-variable.label.default", "default"),
          value: "default"
        });
      }
    }
    if (options.length === 0) {
      this.setState({ error: "No data sources found" });
    } else if (this.state.error) {
      this.setState({ error: null });
    }
    return rxjs.of(options);
  }
}
DataSourceVariable.Component = ({ model }) => {
  return /* @__PURE__ */ React__default.default.createElement(MultiOrSingleValueSelect, { model });
};
function isValid(source, regex) {
  if (!regex) {
    return true;
  }
  return regex.exec(source.name);
}
function isDefault(source, regex) {
  if (!source.isDefault) {
    return false;
  }
  if (!regex) {
    return true;
  }
  return regex.exec("default");
}

function buildMetricTree(parent, depth) {
  const chars = ["A", "B", "C", "D", "E", "F", "G", "H"];
  const children = [];
  if (depth > 5) {
    return [];
  }
  for (const letter of chars) {
    const nodeName = `${parent}${letter}`;
    children.push({
      name: nodeName,
      children: buildMetricTree(nodeName, depth + 1)
    });
  }
  return children;
}
function queryTree(children, query, queryIndex) {
  if (queryIndex >= query.length) {
    return children;
  }
  if (query[queryIndex] === "*") {
    return children;
  }
  const nodeQuery = query[queryIndex];
  let result = [];
  let namesToMatch = [nodeQuery];
  if (nodeQuery.startsWith("{")) {
    namesToMatch = nodeQuery.replace(/\{|\}/g, "").split(",");
  }
  for (const node of children) {
    for (const nameToMatch of namesToMatch) {
      if (nameToMatch.indexOf("*") !== -1) {
        const pattern = nameToMatch.replace("*", "");
        const regex = new RegExp(`^${pattern}.*`, "gi");
        if (regex.test(node.name)) {
          result = result.concat(queryTree([node], query, queryIndex + 1));
        }
      } else if (node.name === nameToMatch) {
        result = result.concat(queryTree(node.children, query, queryIndex + 1));
      }
    }
  }
  return result;
}
function queryMetricTree(query) {
  if (query.indexOf("value") === 0) {
    return [{ name: query, children: [] }];
  }
  const children = buildMetricTree("", 0);
  return queryTree(children, query.split("."), 0);
}

class TestVariable extends MultiValueVariable {
  constructor(initialState, isLazy = false) {
    super({
      type: "custom",
      name: "Test",
      value: "Value",
      text: i18n.t("grafana-scenes.variables.test-variable.text.text", "Text"),
      query: "Query",
      options: [],
      refresh: data.VariableRefresh.onDashboardLoad,
      updateOptions: true,
      ...initialState
    });
    this.completeUpdate = new rxjs.Subject();
    this.isGettingValues = true;
    this.getValueOptionsCount = 0;
    this.isLazy = false;
    this._variableDependency = new VariableDependencyConfig(this, {
      statePaths: ["query"]
    });
    this.isLazy = isLazy;
  }
  getValueOptions(args) {
    const { delayMs } = this.state;
    this.getValueOptionsCount += 1;
    const queryController = sceneGraph.getQueryController(this);
    return new rxjs.Observable((observer) => {
      const queryEntry = {
        type: "variable",
        origin: this,
        cancel: () => observer.complete()
      };
      if (queryController) {
        queryController.queryStarted(queryEntry);
      }
      this.setState({ loading: true });
      if (this.state.throwError) {
        throw new Error(this.state.throwError);
      }
      const interpolatedQuery = sceneGraph.interpolate(this, this.state.query);
      const options = this.getOptions(interpolatedQuery);
      const sub = this.completeUpdate.subscribe({
        next: () => {
          const newState = { issuedQuery: interpolatedQuery, loading: false };
          if (this.state.updateOptions) {
            newState.options = options;
          }
          this.setState(newState);
          observer.next(options);
          observer.complete();
        }
      });
      let timeout;
      if (delayMs) {
        timeout = window.setTimeout(() => this.signalUpdateCompleted(), delayMs);
      } else if (delayMs === 0) {
        this.signalUpdateCompleted();
      }
      this.isGettingValues = true;
      return () => {
        sub.unsubscribe();
        window.clearTimeout(timeout);
        this.isGettingValues = false;
        if (this.state.loading) {
          this.setState({ loading: false });
        }
        if (queryController) {
          queryController.queryCompleted(queryEntry);
        }
      };
    });
  }
  cancel() {
    const sceneVarSet = getClosest(this, (s) => s instanceof SceneVariableSet ? s : void 0);
    sceneVarSet == null ? void 0 : sceneVarSet.cancel(this);
  }
  getOptions(interpolatedQuery) {
    if (this.state.optionsToReturn) {
      return this.state.optionsToReturn;
    }
    return queryMetricTree(interpolatedQuery).map((x) => ({ label: x.name, value: x.name }));
  }
  /** Useful from tests */
  signalUpdateCompleted() {
    this.completeUpdate.next(1);
  }
}
TestVariable.Component = ({ model }) => {
  return /* @__PURE__ */ React__default.default.createElement(MultiOrSingleValueSelect, { model });
};

function VariableValueInput({ model }) {
  const { value, key, loading } = model.useState();
  const onBlur = React.useCallback(
    (e) => {
      model.setValue(e.currentTarget.value);
    },
    [model]
  );
  const onKeyDown = React.useCallback(
    (e) => {
      if (e.key === "Enter") {
        model.setValue(e.currentTarget.value);
      }
    },
    [model]
  );
  return /* @__PURE__ */ React__default.default.createElement(
    ui.AutoSizeInput,
    {
      id: key,
      placeholder: i18n.t("grafana-scenes.variables.variable-value-input.placeholder-enter-value", "Enter value"),
      minWidth: 15,
      maxWidth: 30,
      value,
      loading,
      onBlur,
      onKeyDown
    }
  );
}

class TextBoxVariable extends SceneObjectBase {
  constructor(initialState) {
    super({
      type: "textbox",
      value: "",
      name: "",
      ...initialState
    });
    this._urlSync = new SceneObjectUrlSyncConfig(this, { keys: () => this.getKeys() });
  }
  getValue() {
    return this.state.value;
  }
  setValue(newValue) {
    if (newValue !== this.state.value) {
      this.setState({ value: newValue });
      this.publishEvent(new SceneVariableValueChangedEvent(this), true);
    }
  }
  getKey() {
    return `var-${this.state.name}`;
  }
  getKeys() {
    if (this.state.skipUrlSync) {
      return [];
    }
    return [this.getKey()];
  }
  getUrlState() {
    if (this.state.skipUrlSync) {
      return {};
    }
    return { [this.getKey()]: this.state.value };
  }
  updateFromUrl(values) {
    const val = values[this.getKey()];
    if (typeof val === "string") {
      this.setValue(val);
    }
  }
}
TextBoxVariable.Component = ({ model }) => {
  return /* @__PURE__ */ React__default.default.createElement(VariableValueInput, { model });
};

class IntervalVariable extends SceneObjectBase {
  constructor(initialState) {
    super({
      type: "interval",
      value: "",
      intervals: ["1m", "10m", "30m", "1h", "6h", "12h", "1d", "7d", "14d", "30d"],
      name: "",
      autoStepCount: 30,
      autoMinInterval: "10s",
      autoEnabled: false,
      refresh: schema.VariableRefresh.onTimeRangeChanged,
      ...initialState
    });
    this._onChange = (value) => {
      this.setState({ value: value.value });
      this.publishEvent(new SceneVariableValueChangedEvent(this), true);
    };
    this._urlSync = new SceneObjectUrlSyncConfig(this, { keys: () => [this.getKey()] });
  }
  getKey() {
    return `var-${this.state.name}`;
  }
  getUrlState() {
    return { [this.getKey()]: this.state.value };
  }
  updateFromUrl(values) {
    const update = {};
    const val = values[this.getKey()];
    if (typeof val === "string") {
      if (val.startsWith("$__auto_interval_")) {
        update.value = AUTO_VARIABLE_VALUE;
      } else {
        update.value = val;
      }
    }
    this.setState(update);
  }
  getOptionsForSelect() {
    const { value: currentValue, intervals, autoEnabled } = this.state;
    let options = intervals.map((interval) => ({ value: interval, label: interval }));
    if (autoEnabled) {
      options = [{ value: AUTO_VARIABLE_VALUE, label: AUTO_VARIABLE_TEXT }, ...options];
    }
    if (currentValue && !options.some((option) => option.value === currentValue)) {
      options.push({ value: currentValue, label: currentValue });
    }
    return options;
  }
  getValue() {
    const { value, autoStepCount, autoMinInterval } = this.state;
    if (value === AUTO_VARIABLE_VALUE) {
      return this.getAutoRefreshInteval(autoStepCount, autoMinInterval);
    }
    return value;
  }
  getAutoRefreshInteval(autoStepCount, minRefreshInterval) {
    const timeRange = sceneGraph.getTimeRange(this).state.value;
    const intervalObject = data.rangeUtil.calculateInterval(timeRange, autoStepCount, minRefreshInterval);
    return intervalObject.interval;
  }
  validateAndUpdate() {
    const { value, intervals } = this.state;
    let shouldPublish = false;
    if (value === AUTO_VARIABLE_VALUE) {
      shouldPublish = true;
    } else if (!value && intervals.length > 0) {
      const firstOption = intervals[0];
      this.setState({ value: firstOption });
      shouldPublish = true;
    }
    if (shouldPublish) {
      this.publishEvent(new SceneVariableValueChangedEvent(this), true);
    }
    return rxjs.of({});
  }
}
IntervalVariable.Component = ({ model }) => {
  const { key, value } = model.useState();
  return /* @__PURE__ */ React__default.default.createElement(
    ui.Select,
    {
      id: key,
      placeholder: i18n.t("grafana-scenes.variables.interval-variable.placeholder-select-value", "Select value"),
      width: "auto",
      value,
      tabSelectsValue: false,
      options: model.getOptionsForSelect(),
      onChange: model._onChange
    }
  );
};

var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);
var _cache, _location;
class NewSceneObjectAddedEvent extends data.BusEventWithPayload {
}
NewSceneObjectAddedEvent.type = "new-scene-object-added";
class UrlSyncManager {
  constructor(_options = {}, locationService = runtime.locationService) {
    this._options = _options;
    this._locationService = locationService;
    this._paramsCache = new UrlParamsCache(locationService);
    this._urlKeyMapper = new UniqueUrlKeyMapper({
      namespace: _options.namespace,
      excludeFromNamespace: _options.excludeFromNamespace
    });
  }
  /**
   * Updates the current scene state to match URL state.
   */
  initSync(root) {
    var _a;
    if (this._subs) {
      writeSceneLog("UrlSyncManager", "Unregister previous scene state subscription", (_a = this._sceneRoot) == null ? void 0 : _a.state.key);
      this._subs.unsubscribe();
    }
    writeSceneLog("UrlSyncManager", "init", root.state.key);
    this._sceneRoot = root;
    this._subs = new rxjs.Subscription();
    this._subs.add(
      root.subscribeToEvent(SceneObjectStateChangedEvent, (evt) => {
        this.handleSceneObjectStateChanged(evt.payload.changedObject);
      })
    );
    this._subs.add(
      root.subscribeToEvent(NewSceneObjectAddedEvent, (evt) => {
        this.handleNewObject(evt.payload);
      })
    );
    this._urlKeyMapper.clear();
    this._lastLocation = this._locationService.getLocation();
    this.handleNewObject(this._sceneRoot);
    if (this._options.updateUrlOnInit) {
      const urlState = getUrlState(root, this._urlKeyMapper.getOptions());
      if (isUrlStateDifferent(urlState, this._paramsCache.getParams())) {
        this._locationService.partial(urlState, true);
      }
    }
  }
  cleanUp(root) {
    if (this._sceneRoot !== root) {
      return;
    }
    writeSceneLog("UrlSyncManager", "Clean up");
    if (this._subs) {
      this._subs.unsubscribe();
      this._subs = void 0;
      writeSceneLog(
        "UrlSyncManager",
        "Root deactived, unsub to state",
        "same key",
        this._sceneRoot.state.key === root.state.key
      );
    }
    this._sceneRoot = void 0;
    this._lastLocation = void 0;
  }
  handleNewLocation(location) {
    if (!this._sceneRoot || this._lastLocation === location) {
      return;
    }
    writeSceneLog("UrlSyncManager", "handleNewLocation");
    this._lastLocation = location;
    syncStateFromUrl(this._sceneRoot, this._paramsCache.getParams(), this._urlKeyMapper);
  }
  handleNewObject(sceneObj) {
    if (!this._sceneRoot) {
      return;
    }
    syncStateFromUrl(sceneObj, this._paramsCache.getParams(), this._urlKeyMapper);
  }
  handleSceneObjectStateChanged(changedObject) {
    var _a, _b;
    if (!changedObject.urlSync) {
      return;
    }
    const newUrlState = changedObject.urlSync.getUrlState();
    const searchParams = this._locationService.getSearch();
    const mappedUpdated = {};
    for (const [key, newUrlValue] of Object.entries(newUrlState)) {
      const uniqueKey = this._urlKeyMapper.getUniqueKey(key, changedObject);
      const currentUrlValue = searchParams.getAll(uniqueKey);
      if (!isUrlValueEqual(currentUrlValue, newUrlValue)) {
        mappedUpdated[uniqueKey] = newUrlValue;
      }
    }
    if (Object.keys(mappedUpdated).length > 0) {
      const shouldCreateHistoryEntry = (_b = (_a = changedObject.urlSync).shouldCreateHistoryStep) == null ? void 0 : _b.call(_a, newUrlState);
      const shouldReplace = shouldCreateHistoryEntry !== true;
      writeSceneLog("UrlSyncManager", "onStateChange updating URL");
      this._locationService.partial(mappedUpdated, shouldReplace);
      this._lastLocation = this._locationService.getLocation();
    }
  }
  getUrlState(root) {
    return getUrlState(root, this._urlKeyMapper.getOptions());
  }
}
class UrlParamsCache {
  constructor(locationService) {
    this.locationService = locationService;
    __privateAdd(this, _cache);
    __privateAdd(this, _location);
  }
  getParams() {
    const location = this.locationService.getLocation();
    if (__privateGet(this, _location) === location) {
      return __privateGet(this, _cache);
    }
    __privateSet(this, _location, location);
    __privateSet(this, _cache, new URLSearchParams(location.search));
    return __privateGet(this, _cache);
  }
}
_cache = new WeakMap();
_location = new WeakMap();
function isUrlStateDifferent(sceneUrlState, currentParams) {
  for (let key in sceneUrlState) {
    if (!isUrlValueEqual(currentParams.getAll(key), sceneUrlState[key])) {
      return true;
    }
  }
  return false;
}
function useUrlSyncManager(options, locationService) {
  return React.useMemo(
    () => new UrlSyncManager(
      {
        updateUrlOnInit: options.updateUrlOnInit,
        createBrowserHistorySteps: options.createBrowserHistorySteps,
        namespace: options.namespace,
        excludeFromNamespace: options.excludeFromNamespace
      },
      locationService
    ),
    [
      options.updateUrlOnInit,
      options.createBrowserHistorySteps,
      options.namespace,
      options.excludeFromNamespace,
      locationService
    ]
  );
}

function useUrlSync(sceneRoot, options = {}) {
  const location = reactRouterDom.useLocation();
  const locationService = useLocationServiceSafe();
  const [isInitialized, setIsInitialized] = React.useState(false);
  const urlSyncManager = useUrlSyncManager(options, locationService);
  React.useEffect(() => {
    urlSyncManager.initSync(sceneRoot);
    setIsInitialized(true);
    return () => urlSyncManager.cleanUp(sceneRoot);
  }, [sceneRoot, urlSyncManager]);
  React.useEffect(() => {
    const latestLocation = locationService.getLocation();
    const locationToHandle = latestLocation !== location ? latestLocation : location;
    if (latestLocation !== location) {
      writeSceneLog("useUrlSync", "latestLocation different from location");
    }
    urlSyncManager.handleNewLocation(locationToHandle);
  }, [sceneRoot, urlSyncManager, location, locationService]);
  return isInitialized;
}

function UrlSyncContextProvider({
  children,
  scene,
  updateUrlOnInit,
  createBrowserHistorySteps,
  namespace,
  excludeFromNamespace
}) {
  const isInitialized = useUrlSync(scene, {
    updateUrlOnInit,
    createBrowserHistorySteps,
    namespace,
    excludeFromNamespace
  });
  if (!isInitialized) {
    return null;
  }
  return children;
}

function setWindowGrafanaSceneContext(activeScene) {
  const prevScene = window.__grafanaSceneContext;
  writeSceneLog("setWindowGrafanaScene", "set window.__grafanaSceneContext", activeScene);
  window.__grafanaSceneContext = activeScene;
  return () => {
    if (window.__grafanaSceneContext === activeScene) {
      writeSceneLog("setWindowGrafanaScene", "restore window.__grafanaSceneContext", prevScene);
      window.__grafanaSceneContext = prevScene;
    }
  };
}

class EmbeddedScene extends SceneObjectBase {
  constructor(state) {
    super(state);
    this.addActivationHandler(() => {
      const unsetGlobalScene = setWindowGrafanaSceneContext(this);
      return () => {
        unsetGlobalScene();
      };
    });
  }
}
EmbeddedScene.Component = EmbeddedSceneRenderer;
function EmbeddedSceneRenderer({ model }) {
  const { body, controls } = model.useState();
  const styles = ui.useStyles2(getStyles$6);
  return /* @__PURE__ */ React__default.default.createElement("div", { className: styles.container }, controls && /* @__PURE__ */ React__default.default.createElement("div", { className: styles.controls }, controls.map((control) => /* @__PURE__ */ React__default.default.createElement(control.Component, { key: control.state.key, model: control }))), /* @__PURE__ */ React__default.default.createElement("div", { className: styles.body }, /* @__PURE__ */ React__default.default.createElement(body.Component, { model: body })));
}
const getStyles$6 = (theme) => {
  return {
    container: css.css({
      flexGrow: 1,
      display: "flex",
      gap: theme.spacing(2),
      minHeight: "100%",
      flexDirection: "column"
    }),
    body: css.css({
      flexGrow: 1,
      display: "flex",
      gap: theme.spacing(1)
    }),
    controls: css.css({
      display: "flex",
      gap: theme.spacing(2),
      alignItems: "flex-end",
      flexWrap: "wrap"
    })
  };
};

class VizPanelMenu extends SceneObjectBase {
  // Allows adding menu items dynamically
  addItem(item) {
    this.setState({
      items: this.state.items ? [...this.state.items, item] : [item]
    });
  }
  // Allows replacing all menu items
  setItems(items) {
    this.setState({
      items
    });
  }
}
VizPanelMenu.Component = VizPanelMenuRenderer;
function VizPanelMenuRenderer({ model }) {
  const { items = [] } = model.useState();
  const ref = React__default.default.useRef(null);
  React.useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
  }, []);
  const renderItems = (items2) => {
    return items2.map((item) => {
      switch (item.type) {
        case "divider":
          return /* @__PURE__ */ React__default.default.createElement(ui.Menu.Divider, { key: item.text });
        case "group":
          return /* @__PURE__ */ React__default.default.createElement(ui.Menu.Group, { key: item.text, label: item.text }, item.subMenu ? renderItems(item.subMenu) : void 0);
        default:
          return /* @__PURE__ */ React__default.default.createElement(
            ui.Menu.Item,
            {
              key: item.text,
              role: "menuitem",
              label: item.text,
              icon: item.iconClassName,
              childItems: item.subMenu ? renderItems(item.subMenu) : void 0,
              url: item.href,
              onClick: item.onClick,
              shortcut: item.shortcut,
              target: item.target || void 0,
              testId: e2eSelectors.selectors.components.Panels.Panel.menuItems(item.text)
            }
          );
      }
    });
  };
  return /* @__PURE__ */ React__default.default.createElement(ui.Menu, { ref }, renderItems(items));
}

async function getExploreURL(data, model, timeRange, transform) {
  var _a, _b, _c, _d;
  const targets = (_a = data.request) == null ? void 0 : _a.targets;
  if (!targets) {
    return "";
  }
  const { from, to } = timeRange;
  const filters = (_b = data.request) == null ? void 0 : _b.filters;
  const scopedVars = {
    __sceneObject: wrapInSafeSerializableSceneObject(model)
  };
  const interpolatedQueries = (await Promise.allSettled(
    targets.map(async (q) => {
      var _a2;
      const queryDs = await runtime.getDataSourceSrv().get(q.datasource);
      return ((_a2 = queryDs.interpolateVariablesInQueries) == null ? void 0 : _a2.call(queryDs, [q], scopedVars != null ? scopedVars : {}, filters)[0]) || q;
    })
  )).filter((promise) => promise.status === "fulfilled").map((q) => q.value).map((q) => {
    var _a2;
    return (_a2 = transform == null ? void 0 : transform(q)) != null ? _a2 : q;
  });
  const queries = interpolatedQueries != null ? interpolatedQueries : [];
  const hasMixedDatasources = new Set(queries.map((q) => {
    var _a2;
    return (_a2 = q.datasource) == null ? void 0 : _a2.uid;
  })).size > 1;
  let datasource = hasMixedDatasources ? "-- Mixed --" : (_d = (_c = queries.find((query) => {
    var _a2;
    return !!((_a2 = query.datasource) == null ? void 0 : _a2.uid);
  })) == null ? void 0 : _c.datasource) == null ? void 0 : _d.uid;
  if ((queries == null ? void 0 : queries.length) && datasource && from && to) {
    const left = encodeURIComponent(
      JSON.stringify({
        datasource,
        queries,
        range: {
          from,
          to
        }
      })
    );
    return `/explore?left=${left}`;
  }
  return "";
}

class VizPanelExploreButton extends SceneObjectBase {
  constructor(options = {}) {
    super({ options });
  }
}
VizPanelExploreButton.Component = VizPanelExploreButtonComponent;
function VizPanelExploreButtonComponent({ model }) {
  const { options } = model.useState();
  const { data } = sceneGraph.getData(model).useState();
  const { from, to } = sceneGraph.getTimeRange(model).useState();
  const { value: exploreLink } = reactUse.useAsync(async () => {
    if (!data) {
      return "";
    }
    return getExploreURL(data, model, { from, to }, options.transform);
  }, [data, model, from, to]);
  const returnToPrevious = runtime.useReturnToPrevious();
  if (exploreLink) {
    return /* @__PURE__ */ React__default.default.createElement(
      ui.LinkButton,
      {
        key: "explore",
        icon: "compass",
        size: "sm",
        variant: "secondary",
        href: exploreLink,
        onClick: () => {
          var _a;
          if (options.returnToPrevious) {
            returnToPrevious(options.returnToPrevious.title, options.returnToPrevious.href);
          }
          (_a = options.onClick) == null ? void 0 : _a.call(options);
        }
      },
      /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.components.viz-panel-explore-button.explore" }, "Explore")
    );
  }
  return null;
}

const DEFAULT_PANEL_SPAN = 4;
const GRID_CELL_HEIGHT = 30;
const GRID_CELL_VMARGIN = 8;
const GRID_COLUMN_COUNT = 24;

class SceneGridItem extends SceneObjectBase {
}
SceneGridItem.Component = SceneGridItemRenderer;
function SceneGridItemRenderer({ model }) {
  const { body } = model.useState();
  const parent = model.parent;
  if (parent && !isSceneGridLayout(parent) && !isSceneGridRow(parent)) {
    throw new Error("SceneGridItem must be a child of SceneGridLayout or SceneGridRow");
  }
  if (!body) {
    return null;
  }
  return /* @__PURE__ */ React__default.default.createElement(body.Component, { model: body });
}
function isSceneGridRow(child) {
  return child instanceof SceneGridRow;
}
function isSceneGridLayout(child) {
  return child instanceof SceneGridLayout;
}

function SceneGridLayoutRenderer({ model }) {
  const { children, isLazy, isDraggable, isResizable } = model.useState();
  const [outerDivRef, { width, height }] = reactUse.useMeasure();
  const ref = React.useRef(null);
  React.useEffect(() => {
    updateAnimationClass(ref, !!isDraggable);
  }, [isDraggable]);
  validateChildrenSize(children);
  const renderGrid = (width2, height2) => {
    if (!width2 || !height2) {
      return null;
    }
    const layout = model.buildGridLayout(width2, height2);
    return (
      /**
       * The children is using a width of 100% so we need to guarantee that it is wrapped
       * in an element that has the calculated size given by the AutoSizer. The AutoSizer
       * has a width of 0 and will let its content overflow its div.
       */
      /* @__PURE__ */ React__default.default.createElement(
        "div",
        {
          ref,
          style: { width: `${width2}px`, height: layout.length > 0 ? "100%" : "0" },
          className: "react-grid-layout"
        },
        /* @__PURE__ */ React__default.default.createElement(
          ReactGridLayout__default.default,
          {
            width: width2,
            isDraggable: isDraggable && width2 > 768,
            isResizable: isResizable != null ? isResizable : false,
            containerPadding: [0, 0],
            useCSSTransforms: true,
            margin: [GRID_CELL_VMARGIN, GRID_CELL_VMARGIN],
            cols: GRID_COLUMN_COUNT,
            rowHeight: GRID_CELL_HEIGHT,
            draggableHandle: `.grid-drag-handle-${model.state.key}`,
            draggableCancel: ".grid-drag-cancel",
            layout,
            onDragStart: model.onDragStart,
            onDragStop: model.onDragStop,
            onResizeStop: model.onResizeStop,
            onLayoutChange: model.onLayoutChange,
            isBounded: false,
            resizeHandle: /* @__PURE__ */ React__default.default.createElement(ResizeHandle, null)
          },
          layout.map((gridItem, index) => /* @__PURE__ */ React__default.default.createElement(
            GridItemWrapper,
            {
              key: gridItem.i,
              grid: model,
              layoutItem: gridItem,
              index,
              isLazy,
              totalCount: layout.length
            }
          ))
        )
      )
    );
  };
  return /* @__PURE__ */ React__default.default.createElement("div", { ref: outerDivRef, className: gridWrapperClass }, renderGrid(width, height));
}
const gridWrapperClass = css.css({
  flex: "1 1 auto",
  position: "relative",
  zIndex: 1,
  width: "100%"
});
const GridItemWrapper = React__default.default.forwardRef((props, ref) => {
  var _a;
  const { grid, layoutItem, index, totalCount, isLazy, style, onLoad, onChange, children, ...divProps } = props;
  const sceneChild = grid.getSceneLayoutChild(layoutItem.i);
  const className = (_a = sceneChild.getClassName) == null ? void 0 : _a.call(sceneChild);
  const innerContent = /* @__PURE__ */ React__default.default.createElement(sceneChild.Component, { model: sceneChild, key: sceneChild.state.key });
  if (isLazy) {
    return /* @__PURE__ */ React__default.default.createElement(
      LazyLoader,
      {
        ...divProps,
        key: sceneChild.state.key,
        "data-griditem-key": sceneChild.state.key,
        className: css.cx(className, props.className),
        style,
        ref
      },
      innerContent,
      children
    );
  }
  return /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      ...divProps,
      ref,
      key: sceneChild.state.key,
      "data-griditem-key": sceneChild.state.key,
      className: css.cx(className, props.className),
      style
    },
    innerContent,
    children
  );
});
GridItemWrapper.displayName = "GridItemWrapper";
function validateChildrenSize(children) {
  if (children.some(
    (c) => c.state.height === void 0 || c.state.width === void 0 || c.state.x === void 0 || c.state.y === void 0
  )) {
    throw new Error("All children must have a size specified");
  }
}
function updateAnimationClass(ref, isDraggable, retry) {
  if (ref.current) {
    if (isDraggable) {
      ref.current.classList.add("react-grid-layout--enable-move-animations");
    } else {
      ref.current.classList.remove("react-grid-layout--enable-move-animations");
    }
  } else if (!retry) {
    setTimeout(() => updateAnimationClass(ref, isDraggable, true), 50);
  }
}
const ResizeHandle = React__default.default.forwardRef(({ handleAxis, ...divProps }, ref) => {
  const customCssClass = ui.useStyles2(getResizeHandleStyles);
  return /* @__PURE__ */ React__default.default.createElement("div", { ref, ...divProps, className: `${customCssClass} scene-resize-handle` }, /* @__PURE__ */ React__default.default.createElement("svg", { width: "16px", height: "16px", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React__default.default.createElement(
    "path",
    {
      d: "M21 15L15 21M21 8L8 21",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )));
});
ResizeHandle.displayName = "ResizeHandle";
function getResizeHandleStyles(theme) {
  return css.css({
    position: "absolute",
    bottom: 0,
    right: 0,
    zIndex: 999,
    padding: theme.spacing(1.5, 0, 0, 1.5),
    color: theme.colors.border.strong,
    cursor: "se-resize",
    "&:hover": {
      color: theme.colors.text.link
    },
    svg: {
      display: "block"
    },
    ".react-resizable-hide &": {
      display: "none"
    }
  });
}

class SceneGridLayoutDragStartEvent extends data.BusEventWithPayload {
}
SceneGridLayoutDragStartEvent.type = "scene-grid-layout-drag-start";

function fitPanelsInHeight(cells, height) {
  const visibleHeight = height - GRID_CELL_VMARGIN * 4;
  const currentGridHeight = Math.max(...cells.map((cell) => cell.h + cell.y));
  const visibleGridHeight = Math.floor(visibleHeight / (GRID_CELL_HEIGHT + GRID_CELL_VMARGIN));
  const scaleFactor = currentGridHeight / visibleGridHeight;
  return cells.map((cell) => {
    return {
      ...cell,
      y: Math.round(cell.y / scaleFactor) || 0,
      h: Math.round(cell.h / scaleFactor) || 1
    };
  });
}

const _SceneGridLayout = class _SceneGridLayout extends SceneObjectBase {
  constructor(state) {
    super({
      ...state,
      children: sortChildrenByPosition(state.children)
    });
    this._skipOnLayoutChange = false;
    this._oldLayout = [];
    this._loadOldLayout = false;
    this.onLayoutChange = (layout) => {
      if (this._skipOnLayoutChange) {
        this._skipOnLayoutChange = false;
        return;
      }
      if (this._loadOldLayout) {
        layout = [...this._oldLayout];
        this._loadOldLayout = false;
      }
      for (const item of layout) {
        const child = this.getSceneLayoutChild(item.i);
        const nextSize = {
          x: item.x,
          y: item.y,
          width: item.w,
          height: item.h
        };
        if (!isItemSizeEqual(child.state, nextSize)) {
          child.setState({
            ...nextSize
          });
        }
      }
      this.setState({ children: sortChildrenByPosition(this.state.children) });
    };
    this.onResizeStop = (_, o, n) => {
      const child = this.getSceneLayoutChild(n.i);
      child.setState({
        width: n.w,
        height: n.h
      });
    };
    this.onDragStart = (gridLayout) => {
      this._oldLayout = [...gridLayout];
    };
    this.onDragStop = (gridLayout, o, updatedItem) => {
      const sceneChild = this.getSceneLayoutChild(updatedItem.i);
      gridLayout = sortGridLayout(gridLayout);
      const indexOfUpdatedItem = gridLayout.findIndex((item) => item.i === updatedItem.i);
      let newParent = this.findGridItemSceneParent(gridLayout, indexOfUpdatedItem - 1);
      let newChildren = this.state.children;
      for (let i = 0; i < gridLayout.length; i++) {
        const gridItem = gridLayout[i];
        const child = this.getSceneLayoutChild(gridItem.i);
        const childSize = child.state;
        if ((childSize == null ? void 0 : childSize.x) !== gridItem.x || (childSize == null ? void 0 : childSize.y) !== gridItem.y) {
          child.setState({
            x: gridItem.x,
            y: gridItem.y
          });
        }
      }
      if (newParent instanceof SceneGridRow && isRepeatCloneOrChildOf(newParent)) {
        this._loadOldLayout = true;
      }
      if (sceneChild instanceof SceneGridRow && newParent instanceof SceneGridRow) {
        if (!this.isRowDropValid(gridLayout, updatedItem, indexOfUpdatedItem)) {
          this._loadOldLayout = true;
        }
        newParent = this;
      }
      if (newParent !== sceneChild.parent && !this._loadOldLayout) {
        newChildren = this.moveChildTo(sceneChild, newParent);
      }
      this.setState({ children: sortChildrenByPosition(newChildren) });
      this._skipOnLayoutChange = true;
    };
  }
  /**
   * SceneLayout interface. Used for example by VizPanelRenderer
   */
  isDraggable() {
    var _a;
    return (_a = this.state.isDraggable) != null ? _a : false;
  }
  getDragClass() {
    return `grid-drag-handle-${this.state.key}`;
  }
  getDragClassCancel() {
    return `grid-drag-cancel`;
  }
  getDragHooks() {
    return {
      onDragStart: (evt, panel) => {
        this.publishEvent(new SceneGridLayoutDragStartEvent({ evt, panel }), true);
      }
    };
  }
  adjustYPositions(after, amount) {
    for (const child of this.state.children) {
      if (child.state.y > after) {
        child.setState({ y: child.state.y + amount });
      }
      if (child instanceof SceneGridRow) {
        for (const rowChild of child.state.children) {
          if (rowChild.state.y > after) {
            rowChild.setState({ y: rowChild.state.y + amount });
          }
        }
      }
    }
  }
  toggleRow(row) {
    var _a, _b;
    const isCollapsed = row.state.isCollapsed;
    if (!isCollapsed) {
      row.setState({ isCollapsed: true });
      this.setState({});
      return;
    }
    const rowChildren = row.state.children;
    if (rowChildren.length === 0) {
      row.setState({ isCollapsed: false });
      this.setState({});
      return;
    }
    const rowY = row.state.y;
    const firstPanelYPos = (_a = rowChildren[0].state.y) != null ? _a : rowY;
    const yDiff = firstPanelYPos - (rowY + 1);
    let yMax = rowY;
    for (const panel of rowChildren) {
      const newSize = { ...panel.state };
      newSize.y = (_b = newSize.y) != null ? _b : rowY;
      newSize.y -= yDiff;
      if (newSize.y !== panel.state.y) {
        panel.setState(newSize);
      }
      yMax = Math.max(yMax, Number(newSize.y) + Number(newSize.height));
    }
    const pushDownAmount = yMax - rowY - 1;
    for (const child of this.state.children) {
      if (child.state.y > rowY) {
        this.pushChildDown(child, pushDownAmount);
      }
      if (isSceneGridRow(child) && child !== row) {
        for (const rowChild of child.state.children) {
          if (rowChild.state.y > rowY) {
            this.pushChildDown(rowChild, pushDownAmount);
          }
        }
      }
    }
    row.setState({ isCollapsed: false });
    this.setState({});
  }
  ignoreLayoutChange(shouldIgnore) {
    this._skipOnLayoutChange = shouldIgnore;
  }
  /**
   * Will also scan row children and return child of the row
   */
  getSceneLayoutChild(key) {
    for (const child of this.state.children) {
      if (child.state.key === key) {
        return child;
      }
      if (child instanceof SceneGridRow) {
        for (const rowChild of child.state.children) {
          if (rowChild.state.key === key) {
            return rowChild;
          }
        }
      }
    }
    throw new Error("Scene layout child not found for GridItem");
  }
  pushChildDown(child, amount) {
    child.setState({
      y: child.state.y + amount
    });
  }
  /**
   *  We assume the layout array is sorted according to y pos, and walk upwards until we find a row.
   *  If it is collapsed there is no row to add it to. The default is then to return the SceneGridLayout itself
   */
  findGridItemSceneParent(layout, startAt) {
    for (let i = startAt; i >= 0; i--) {
      const gridItem = layout[i];
      const sceneChild = this.getSceneLayoutChild(gridItem.i);
      if (sceneChild instanceof SceneGridRow) {
        if (sceneChild.state.isCollapsed) {
          return this;
        }
        return sceneChild;
      }
    }
    return this;
  }
  /**
   * Helper func to check if we are dropping a row in between panels of another row
   */
  isRowDropValid(gridLayout, updatedItem, indexOfUpdatedItem) {
    if (gridLayout[gridLayout.length - 1].i === updatedItem.i) {
      return true;
    }
    const nextSceneChild = this.getSceneLayoutChild(gridLayout[indexOfUpdatedItem + 1].i);
    if (nextSceneChild instanceof SceneGridRow) {
      return true;
    } else if (nextSceneChild.parent instanceof _SceneGridLayout) {
      return true;
    }
    return false;
  }
  /**
   * This likely needs a slightly different approach. Where we clone or deactivate or and re-activate the moved child
   */
  moveChildTo(child, target) {
    const currentParent = child.parent;
    let rootChildren = this.state.children;
    const newChild = child.clone({ key: child.state.key });
    if (currentParent instanceof SceneGridRow) {
      const newRow = currentParent.clone();
      newRow.setState({
        children: newRow.state.children.filter((c) => c.state.key !== child.state.key)
      });
      rootChildren = rootChildren.map((c) => c === currentParent ? newRow : c);
      if (target instanceof SceneGridRow) {
        const targetRow = target.clone();
        targetRow.setState({ children: [...targetRow.state.children, newChild] });
        rootChildren = rootChildren.map((c) => c === target ? targetRow : c);
      } else {
        rootChildren = [...rootChildren, newChild];
      }
    } else {
      if (!(target instanceof _SceneGridLayout)) {
        rootChildren = rootChildren.filter((c) => c.state.key !== child.state.key);
        const targetRow = target.clone();
        targetRow.setState({ children: [...targetRow.state.children, newChild] });
        rootChildren = rootChildren.map((c) => c === target ? targetRow : c);
      }
    }
    return rootChildren;
  }
  toGridCell(child) {
    const size = child.state;
    let x = Number.isFinite(Number(size.x)) ? Number(size.x) : 0;
    let y = Number.isFinite(Number(size.y)) ? Number(size.y) : 0;
    const w = Number.isFinite(Number(size.width)) ? Number(size.width) : DEFAULT_PANEL_SPAN;
    const h = Number.isFinite(Number(size.height)) ? Number(size.height) : DEFAULT_PANEL_SPAN;
    let isDraggable = child.state.isDraggable;
    let isResizable = child.state.isResizable;
    if (child instanceof SceneGridRow) {
      isDraggable = child.state.isCollapsed ? true : false;
      isResizable = false;
    }
    if (isRepeatCloneOrChildOf(child)) {
      isDraggable = false;
      isResizable = false;
    }
    return { i: child.state.key, x, y, h, w, isResizable, isDraggable };
  }
  buildGridLayout(width, height) {
    let cells = [];
    for (const child of this.state.children) {
      cells.push(this.toGridCell(child));
      if (child instanceof SceneGridRow && !child.state.isCollapsed) {
        for (const rowChild of child.state.children) {
          cells.push(this.toGridCell(rowChild));
        }
      }
    }
    cells = sortGridLayout(cells);
    if (this.state.UNSAFE_fitPanels) {
      cells = fitPanelsInHeight(cells, height);
    }
    if (width < 768) {
      this._skipOnLayoutChange = true;
      return cells.map((cell) => ({ ...cell, w: 24 }));
    }
    this._skipOnLayoutChange = false;
    return cells;
  }
};
_SceneGridLayout.Component = SceneGridLayoutRenderer;
let SceneGridLayout = _SceneGridLayout;
function isItemSizeEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
function sortChildrenByPosition(children) {
  children.forEach((child) => {
    if (child instanceof SceneGridRow) {
      child.setState({ children: sortChildrenByPosition(child.state.children) });
    }
  });
  return [...children].sort((a, b) => {
    return a.state.y - b.state.y || a.state.x - b.state.x;
  });
}
function sortGridLayout(layout) {
  return [...layout].sort((a, b) => a.y - b.y || a.x - b.x);
}

class SceneGridRow extends SceneObjectBase {
  constructor(state) {
    super({
      children: state.children || [],
      isCollapsible: state.isCollapsible || true,
      title: state.title || "",
      ...state,
      x: 0,
      height: 1,
      width: GRID_COLUMN_COUNT
    });
    this._variableDependency = new VariableDependencyConfig(this, {
      statePaths: ["title"],
      handleTimeMacros: true
    });
    this.onCollapseToggle = () => {
      if (!this.state.isCollapsible) {
        return;
      }
      this.getGridLayout().toggleRow(this);
    };
  }
  getGridLayout() {
    const layout = this.parent;
    if (!layout || !(layout instanceof SceneGridLayout)) {
      throw new Error("SceneGridRow must be a child of SceneGridLayout");
    }
    return layout;
  }
  getUrlState() {
    return { rowc: this.state.isCollapsed ? "1" : "0" };
  }
  updateFromUrl(values) {
    if (values.rowc == null) {
      return;
    }
    if (values.rowc !== this.getUrlState().rowc) {
      this.onCollapseToggle();
    }
  }
  getPanelCount(children) {
    var _a;
    let count = 0;
    for (const child of children) {
      count += ((_a = child.getChildCount) == null ? void 0 : _a.call(child)) || 1;
    }
    return count;
  }
}
SceneGridRow.Component = SceneGridRowRenderer;
function SceneGridRowRenderer({ model }) {
  const styles = ui.useStyles2(getSceneGridRowStyles);
  const { isCollapsible, isCollapsed, title, actions, children } = model.useState();
  const layout = model.getGridLayout();
  const layoutDragClass = layout.getDragClass();
  const isDraggable = layout.isDraggable() && !isRepeatCloneOrChildOf(model);
  const count = model.getPanelCount(children);
  const panels = count === 1 ? "panel" : "panels";
  return /* @__PURE__ */ React__default.default.createElement("div", { className: css.cx(styles.row, isCollapsed && styles.rowCollapsed) }, /* @__PURE__ */ React__default.default.createElement("div", { className: styles.rowTitleAndActionsGroup }, /* @__PURE__ */ React__default.default.createElement(
    "button",
    {
      onClick: model.onCollapseToggle,
      className: styles.rowTitleButton,
      "aria-label": isCollapsed ? i18n.t("grafana-scenes.components.scene-grid-row.expand-row", "Expand row") : i18n.t("grafana-scenes.components.scene-grid-row.collapse-row", "Collapse row"),
      "data-testid": e2eSelectors.selectors.components.DashboardRow.title(sceneGraph.interpolate(model, title, void 0, "text"))
    },
    isCollapsible && /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: isCollapsed ? "angle-right" : "angle-down" }),
    /* @__PURE__ */ React__default.default.createElement("span", { className: styles.rowTitle, role: "heading" }, sceneGraph.interpolate(model, title, void 0, "text"))
  ), /* @__PURE__ */ React__default.default.createElement("span", { className: css.cx(styles.panelCount, isCollapsed && styles.panelCountCollapsed) }, "(", count, " ", panels, ")"), actions && /* @__PURE__ */ React__default.default.createElement("div", { className: styles.rowActions }, /* @__PURE__ */ React__default.default.createElement(actions.Component, { model: actions }))), isDraggable && isCollapsed && /* @__PURE__ */ React__default.default.createElement("div", { className: css.cx(styles.dragHandle, layoutDragClass) }, /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: "draggabledots" })));
}
const getSceneGridRowStyles = (theme) => {
  return {
    row: css.css({
      width: "100%",
      height: "30px",
      display: "flex",
      justifyContent: "space-between",
      gap: theme.spacing(1)
    }),
    rowTitleButton: css.css({
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      background: "transparent",
      border: "none",
      minWidth: 0,
      gap: theme.spacing(1)
    }),
    rowCollapsed: css.css({
      borderBottom: `1px solid ${theme.colors.border.weak}`
    }),
    rowTitle: css.css({
      fontSize: theme.typography.h5.fontSize,
      fontWeight: theme.typography.fontWeightMedium,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "100%",
      flexGrow: 1,
      minWidth: 0
    }),
    collapsedInfo: css.css({
      fontSize: theme.typography.bodySmall.fontSize,
      color: theme.colors.text.secondary,
      display: "flex",
      alignItems: "center",
      flexGrow: 1
    }),
    rowTitleAndActionsGroup: css.css({
      display: "flex",
      minWidth: 0,
      "&:hover, &:focus-within": {
        "& > div": {
          opacity: 1
        }
      }
    }),
    rowActions: css.css({
      display: "flex",
      whiteSpace: "nowrap",
      opacity: 0,
      transition: "200ms opacity ease-in 200ms",
      "&:hover, &:focus-within": {
        opacity: 1
      }
    }),
    dragHandle: css.css({
      display: "flex",
      padding: theme.spacing(0, 1),
      alignItems: "center",
      justifyContent: "flex-end",
      cursor: "move",
      color: theme.colors.text.secondary,
      "&:hover": {
        color: theme.colors.text.primary
      }
    }),
    panelCount: css.css({
      whiteSpace: "nowrap",
      paddingLeft: theme.spacing(2),
      color: theme.colors.text.secondary,
      fontStyle: "italic",
      fontSize: theme.typography.size.sm,
      fontWeight: "normal",
      display: "none",
      lineHeight: "30px"
    }),
    panelCountCollapsed: css.css({
      display: "inline-block"
    })
  };
};

class NestedScene extends SceneObjectBase {
  constructor() {
    super(...arguments);
    this.onToggle = () => {
      this.setState({
        isCollapsed: !this.state.isCollapsed
      });
    };
    /** Removes itself from its parent's children array */
    this.onRemove = () => {
      const parent = this.parent;
      if (isSceneLayoutItem(parent)) {
        parent.setState({
          body: void 0
        });
      }
    };
  }
}
NestedScene.Component = NestedSceneRenderer;
function NestedSceneRenderer({ model }) {
  const { title, isCollapsed, canCollapse, canRemove, body, controls } = model.useState();
  const gridRow = ui.useStyles2(getSceneGridRowStyles);
  const styles = ui.useStyles2(getStyles$5);
  const toolbarControls = (controls != null ? controls : []).map((action) => /* @__PURE__ */ React__default.default.createElement(action.Component, { key: action.state.key, model: action }));
  if (canRemove) {
    toolbarControls.push(
      /* @__PURE__ */ React__default.default.createElement(
        ui.ToolbarButton,
        {
          icon: "times",
          variant: "default",
          onClick: model.onRemove,
          key: "remove-button",
          "aria-label": i18n.t("grafana-scenes.components.nested-scene-renderer.remove-button-label", "Remove scene")
        }
      )
    );
  }
  return /* @__PURE__ */ React__default.default.createElement("div", { className: styles.wrapper }, /* @__PURE__ */ React__default.default.createElement("div", { className: css.cx(styles.row, isCollapsed && styles.rowCollapsed) }, /* @__PURE__ */ React__default.default.createElement(
    "button",
    {
      onClick: model.onToggle,
      className: gridRow.rowTitleButton,
      "aria-label": isCollapsed ? i18n.t("grafana-scenes.components.nested-scene-renderer.expand-button-label", "Expand scene") : i18n.t("grafana-scenes.components.nested-scene-renderer.collapse-button-label", "Collapse scene")
    },
    canCollapse && /* @__PURE__ */ React__default.default.createElement(ui.Icon, { name: isCollapsed ? "angle-right" : "angle-down" }),
    /* @__PURE__ */ React__default.default.createElement("span", { className: gridRow.rowTitle, role: "heading" }, sceneGraph.interpolate(model, title, void 0, "text"))
  ), /* @__PURE__ */ React__default.default.createElement("div", { className: styles.actions }, toolbarControls)), !isCollapsed && /* @__PURE__ */ React__default.default.createElement(body.Component, { model: body }));
}
const getStyles$5 = (theme) => ({
  wrapper: css.css({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    gap: theme.spacing(1)
  }),
  row: css.css({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(1)
  }),
  rowCollapsed: css.css({
    borderBottom: `1px solid ${theme.colors.border.weak}`,
    paddingBottom: theme.spacing(1)
  }),
  actions: css.css({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    justifyContent: "flex-end",
    flexGrow: 1
  })
});
function isSceneLayoutItem(x) {
  return "body" in x.state;
}

class SceneCanvasText extends SceneObjectBase {
  constructor() {
    super(...arguments);
    this._variableDependency = new VariableDependencyConfig(this, { statePaths: ["text"] });
  }
}
SceneCanvasText.Component = SceneCanvasTextRenderer;
function SceneCanvasTextRenderer({ model }) {
  const { text, fontSize = 20, align = "left", key, spacing } = model.useState();
  const theme = ui.useTheme2();
  const style = css.css({
    fontSize,
    display: "flex",
    flexGrow: 1,
    alignItems: "center",
    padding: spacing ? theme.spacing(spacing, 0) : void 0,
    justifyContent: align
  });
  return /* @__PURE__ */ React__default.default.createElement("div", { className: style, "data-testid": key }, sceneGraph.interpolate(model, text));
}

class SceneToolbarButton extends SceneObjectBase {
}
SceneToolbarButton.Component = ({ model }) => {
  const state = model.useState();
  return /* @__PURE__ */ React__default.default.createElement(ui.ToolbarButton, { onClick: state.onClick, icon: state.icon });
};
class SceneToolbarInput extends SceneObjectBase {
}
SceneToolbarInput.Component = ({ model }) => {
  const state = model.useState();
  return /* @__PURE__ */ React__default.default.createElement("div", { style: { display: "flex" } }, state.label && /* @__PURE__ */ React__default.default.createElement(ControlsLabel, { label: state.label }), /* @__PURE__ */ React__default.default.createElement(
    ui.Input,
    {
      defaultValue: state.value,
      width: 8,
      onBlur: (evt) => {
        model.state.onChange(parseInt(evt.currentTarget.value, 10));
      }
    }
  ));
};

class SceneTimePicker extends SceneObjectBase {
  constructor() {
    super(...arguments);
    this.onZoom = () => {
      const timeRange = sceneGraph.getTimeRange(this);
      const zoomedTimeRange = getZoomedTimeRange(timeRange.state.value, 2);
      timeRange.onTimeRangeChange(zoomedTimeRange);
    };
    this.onChangeFiscalYearStartMonth = (month) => {
      const timeRange = sceneGraph.getTimeRange(this);
      timeRange.setState({ fiscalYearStartMonth: month });
    };
    this.toAbsolute = () => {
      const timeRange = sceneGraph.getTimeRange(this);
      const timeRangeVal = timeRange.state.value;
      const from = data.toUtc(timeRangeVal.from);
      const to = data.toUtc(timeRangeVal.to);
      timeRange.onTimeRangeChange({ from, to, raw: { from, to } });
    };
    this.onMoveBackward = () => {
      const timeRange = sceneGraph.getTimeRange(this);
      const {
        state: { value: range }
      } = timeRange;
      timeRange.onTimeRangeChange(getShiftedTimeRange(0 /* Backward */, range));
    };
    this.onMoveForward = () => {
      const timeRange = sceneGraph.getTimeRange(this);
      const {
        state: { value: range }
      } = timeRange;
      timeRange.onTimeRangeChange(getShiftedTimeRange(1 /* Forward */, range, Date.now()));
    };
  }
}
SceneTimePicker.Component = SceneTimePickerRenderer;
function SceneTimePickerRenderer({ model }) {
  const { hidePicker, isOnCanvas, quickRanges, defaultQuickRanges } = model.useState();
  const timeRange = sceneGraph.getTimeRange(model);
  const timeZone = timeRange.getTimeZone();
  const timeRangeState = timeRange.useState();
  const [timeRangeHistory, setTimeRangeHistory] = reactUse.useLocalStorage(HISTORY_LOCAL_STORAGE_KEY, [], {
    raw: false,
    serializer: serializeHistory,
    deserializer: deserializeHistory
  });
  if (hidePicker) {
    return null;
  }
  const rangesToUse = quickRanges || defaultQuickRanges;
  const halfSpanMs = (timeRangeState.value.to.valueOf() - timeRangeState.value.from.valueOf()) / 2;
  const moveBackwardDuration = data.intervalToAbbreviatedDurationString({
    start: new Date(timeRangeState.value.from.valueOf()),
    end: new Date(timeRangeState.value.from.valueOf() + halfSpanMs)
  });
  const canMoveForward = timeRangeState.value.to.valueOf() + halfSpanMs <= Date.now();
  const moveForwardDuration = canMoveForward ? moveBackwardDuration : void 0;
  return /* @__PURE__ */ React__default.default.createElement(
    ui.TimeRangePicker,
    {
      isOnCanvas: isOnCanvas != null ? isOnCanvas : true,
      value: timeRangeState.value,
      onChange: (range) => {
        if (isAbsolute(range)) {
          setTimeRangeHistory([range, ...timeRangeHistory != null ? timeRangeHistory : []]);
        }
        timeRange.onTimeRangeChange(range);
      },
      timeZone,
      fiscalYearStartMonth: timeRangeState.fiscalYearStartMonth,
      onMoveBackward: model.onMoveBackward,
      onMoveForward: model.onMoveForward,
      moveForwardTooltip: moveForwardDuration ? i18n.t("grafana-scenes.components.time-picker.move-forward-tooltip", "Move {{moveForwardDuration}} forward", {
        moveForwardDuration
      }) : void 0,
      moveBackwardTooltip: i18n.t(
        "grafana-scenes.components.time-picker.move-backward-tooltip",
        "Move {{moveBackwardDuration}} backward",
        { moveBackwardDuration }
      ),
      onZoom: model.onZoom,
      onChangeTimeZone: timeRange.onTimeZoneChange,
      onChangeFiscalYearStartMonth: model.onChangeFiscalYearStartMonth,
      weekStart: timeRangeState.weekStart,
      history: timeRangeHistory,
      quickRanges: rangesToUse
    }
  );
}
function getZoomedTimeRange(timeRange, factor) {
  const timespan = timeRange.to.valueOf() - timeRange.from.valueOf();
  const center = timeRange.to.valueOf() - timespan / 2;
  const newTimespan = timespan === 0 ? 3e4 : timespan * factor;
  const to = center + newTimespan / 2;
  const from = center - newTimespan / 2;
  return { from: data.toUtc(from), to: data.toUtc(to), raw: { from: data.toUtc(from), to: data.toUtc(to) } };
}
function getShiftedTimeRange(dir, timeRange, upperLimit) {
  const oldTo = timeRange.to.valueOf();
  const oldFrom = timeRange.from.valueOf();
  const halfSpan = (oldTo - oldFrom) / 2;
  let fromRaw;
  let toRaw;
  if (dir === 0 /* Backward */) {
    fromRaw = oldFrom - halfSpan;
    toRaw = oldTo - halfSpan;
  } else {
    fromRaw = oldFrom + halfSpan;
    toRaw = oldTo + halfSpan;
    if (upperLimit !== void 0 && toRaw > upperLimit && oldTo < upperLimit) {
      toRaw = upperLimit;
      fromRaw = oldFrom;
    }
  }
  const from = data.toUtc(fromRaw);
  const to = data.toUtc(toRaw);
  return {
    from,
    to,
    raw: { from, to }
  };
}
const HISTORY_LOCAL_STORAGE_KEY = "grafana.dashboard.timepicker.history";
function deserializeHistory(value) {
  const values = JSON.parse(value);
  return values.map((item) => data.rangeUtil.convertRawToRange(item, "utc", void 0, "YYYY-MM-DD HH:mm:ss"));
}
function serializeHistory(values) {
  return JSON.stringify(
    limit(
      values.map((v) => ({
        from: typeof v.raw.from === "string" ? v.raw.from : v.raw.from.toISOString(),
        to: typeof v.raw.to === "string" ? v.raw.to : v.raw.to.toISOString()
      }))
    )
  );
}
function limit(value) {
  return lodash.uniqBy(value, (v) => v.from + v.to).slice(0, 4);
}
function isAbsolute(value) {
  return data.isDateTime(value.raw.from) || data.isDateTime(value.raw.to);
}

const DEFAULT_INTERVALS = ["5s", "10s", "30s", "1m", "5m", "15m", "30m", "1h", "2h", "1d"];
class SceneRefreshPicker extends SceneObjectBase {
  constructor(state) {
    var _a, _b, _c;
    const filterDissalowedIntervals = (i) => {
      var _a2;
      const minInterval = (_a2 = state.minRefreshInterval) != null ? _a2 : runtime.config.minRefreshInterval;
      try {
        return minInterval ? data.rangeUtil.intervalToMs(i) >= data.rangeUtil.intervalToMs(minInterval) : true;
      } catch (e) {
        return false;
      }
    };
    super({
      refresh: "",
      ...state,
      autoValue: void 0,
      autoEnabled: (_a = state.autoEnabled) != null ? _a : true,
      autoMinInterval: (_b = state.autoMinInterval) != null ? _b : runtime.config.minRefreshInterval,
      intervals: ((_c = state.intervals) != null ? _c : DEFAULT_INTERVALS).filter(filterDissalowedIntervals)
    });
    this._urlSync = new SceneObjectUrlSyncConfig(this, { keys: ["refresh"] });
    this._autoRefreshBlocked = false;
    this.onRefresh = () => {
      const queryController = sceneGraph.getQueryController(this);
      if (queryController == null ? void 0 : queryController.state.isRunning) {
        queryController.cancelAll();
        queryController.cancelProfile();
        return;
      }
      queryController == null ? void 0 : queryController.startProfile(REFRESH_INTERACTION);
      const timeRange = sceneGraph.getTimeRange(this);
      if (this._intervalTimer) {
        clearInterval(this._intervalTimer);
      }
      timeRange.onRefresh();
      this.setupIntervalTimer();
    };
    this.onIntervalChanged = (interval) => {
      this.setState({ refresh: interval });
      this.setupIntervalTimer();
    };
    this.setupAutoTimeRangeListener = () => {
      return sceneGraph.getTimeRange(this).subscribeToState((newState, prevState) => {
        if (newState.from !== prevState.from || newState.to !== prevState.to) {
          this.setupIntervalTimer();
        }
      });
    };
    this.calculateAutoRefreshInterval = () => {
      var _a;
      const timeRange = sceneGraph.getTimeRange(this);
      const resolution = (_a = window == null ? void 0 : window.innerWidth) != null ? _a : 2e3;
      return data.rangeUtil.calculateInterval(timeRange.state.value, resolution, this.state.autoMinInterval);
    };
    this.setupIntervalTimer = () => {
      var _a;
      const timeRange = sceneGraph.getTimeRange(this);
      const { refresh, intervals } = this.state;
      if (this._intervalTimer || refresh === "") {
        clearInterval(this._intervalTimer);
      }
      if (refresh === "") {
        return;
      }
      if (refresh !== ui.RefreshPicker.autoOption.value && intervals && !intervals.includes(refresh)) {
        return;
      }
      let intervalMs;
      (_a = this._autoTimeRangeListener) == null ? void 0 : _a.unsubscribe();
      if (refresh === ui.RefreshPicker.autoOption.value) {
        const autoRefreshInterval = this.calculateAutoRefreshInterval();
        intervalMs = autoRefreshInterval.intervalMs;
        this._autoTimeRangeListener = this.setupAutoTimeRangeListener();
        if (autoRefreshInterval.interval !== this.state.autoValue) {
          this.setState({ autoValue: autoRefreshInterval.interval });
        }
      } else {
        intervalMs = data.rangeUtil.intervalToMs(refresh);
      }
      this._intervalTimer = setInterval(() => {
        if (this.isTabVisible()) {
          const queryController = sceneGraph.getQueryController(this);
          if (queryController == null ? void 0 : queryController.state.isRunning) {
            queryController.cancelProfile();
          }
          queryController == null ? void 0 : queryController.startProfile(REFRESH_INTERACTION);
          timeRange.onRefresh();
        } else {
          this._autoRefreshBlocked = true;
        }
      }, intervalMs);
    };
    this.addActivationHandler(() => {
      this.setupIntervalTimer();
      const onVisibilityChange = () => {
        if (this._autoRefreshBlocked && document.visibilityState === "visible") {
          this._autoRefreshBlocked = false;
          this.onRefresh();
        }
      };
      document.addEventListener("visibilitychange", onVisibilityChange);
      return () => {
        var _a2;
        if (this._intervalTimer) {
          clearInterval(this._intervalTimer);
        }
        document.removeEventListener("visibilitychange", onVisibilityChange);
        (_a2 = this._autoTimeRangeListener) == null ? void 0 : _a2.unsubscribe();
      };
    });
  }
  getUrlState() {
    let refresh = this.state.refresh;
    if (typeof refresh !== "string" || refresh.length === 0) {
      refresh = void 0;
    }
    return { refresh };
  }
  updateFromUrl(values) {
    const { intervals } = this.state;
    let refresh = values.refresh;
    if (typeof refresh === "string" && isIntervalString(refresh)) {
      if (intervals == null ? void 0 : intervals.includes(refresh)) {
        this.setState({ refresh });
      } else {
        this.setState({
          // Round down to the largest allowed refresh interval <= the URL interval if the interval from the URL is not allowed.
          refresh: intervals ? findClosestInterval(refresh, intervals) : void 0
        });
      }
    }
  }
  isTabVisible() {
    return document.visibilityState === void 0 || document.visibilityState === "visible";
  }
}
SceneRefreshPicker.Component = SceneRefreshPickerRenderer;
function SceneRefreshPickerRenderer({ model }) {
  var _a;
  const { refresh, intervals, autoEnabled, autoValue, isOnCanvas, primary, withText } = model.useState();
  const isRunning = useQueryControllerState(model);
  let text = refresh === ((_a = ui.RefreshPicker.autoOption) == null ? void 0 : _a.value) ? autoValue : withText ? i18n.t("grafana-scenes.components.scene-refresh-picker.text-refresh", "Refresh") : void 0;
  let tooltip;
  let width;
  if (isRunning) {
    tooltip = i18n.t("grafana-scenes.components.scene-refresh-picker.tooltip-cancel", "Cancel all queries");
    if (withText) {
      text = i18n.t("grafana-scenes.components.scene-refresh-picker.text-cancel", "Cancel");
    }
  }
  if (withText) {
    width = "96px";
  }
  return /* @__PURE__ */ React__default.default.createElement(
    ui.RefreshPicker,
    {
      showAutoInterval: autoEnabled,
      value: refresh,
      intervals,
      tooltip,
      width,
      text,
      onRefresh: () => {
        model.onRefresh();
      },
      primary,
      onIntervalChanged: model.onIntervalChanged,
      isLoading: isRunning,
      isOnCanvas: isOnCanvas != null ? isOnCanvas : true
    }
  );
}
function useQueryControllerState(model) {
  const queryController = sceneGraph.getQueryController(model);
  if (!queryController) {
    return false;
  }
  return queryController.useState().isRunning;
}
function isIntervalString(str) {
  try {
    const res = data.rangeUtil.describeInterval(str);
    return res.count > 0;
  } catch (e) {
    return false;
  }
}
function findClosestInterval(userInterval, allowedIntervals) {
  if (allowedIntervals.length === 0) {
    return void 0;
  }
  const userIntervalMs = data.rangeUtil.intervalToMs(userInterval);
  let selectedInterval = allowedIntervals[0];
  for (let i = 1; i < allowedIntervals.length; i++) {
    const intervalMs = data.rangeUtil.intervalToMs(allowedIntervals[i]);
    if (intervalMs > userIntervalMs) {
      break;
    }
    selectedInterval = allowedIntervals[i];
  }
  return selectedInterval;
}

const getCompareSeriesRefId = (refId) => `${refId}-compare`;

const PREVIOUS_PERIOD_VALUE = "__previousPeriod";
const NO_PERIOD_VALUE = "__noPeriod";
const PREVIOUS_PERIOD_COMPARE_OPTION = {
  label: "Previous period",
  value: PREVIOUS_PERIOD_VALUE
};
const NO_COMPARE_OPTION = {
  label: "None",
  value: NO_PERIOD_VALUE
};
const DEFAULT_COMPARE_OPTIONS = [
  { label: "Day before", value: "24h" },
  { label: "Week before", value: "1w" },
  { label: "Month before", value: "1M" }
];
class SceneTimeRangeCompare extends SceneObjectBase {
  constructor(state) {
    super({ compareOptions: DEFAULT_COMPARE_OPTIONS, ...state });
    this._urlSync = new SceneObjectUrlSyncConfig(this, { keys: ["compareWith"] });
    this._onActivate = () => {
      const sceneTimeRange = sceneGraph.getTimeRange(this);
      this.setState({ compareOptions: this.getCompareOptions(sceneTimeRange.state.value) });
      this._subs.add(
        sceneTimeRange.subscribeToState((timeRange) => {
          const compareOptions = this.getCompareOptions(timeRange.value);
          const stateUpdate = { compareOptions };
          if (Boolean(this.state.compareWith) && !compareOptions.find(({ value }) => value === this.state.compareWith)) {
            stateUpdate.compareWith = PREVIOUS_PERIOD_VALUE;
          }
          this.setState(stateUpdate);
        })
      );
    };
    this.getCompareOptions = (timeRange) => {
      const diffDays = Math.ceil(timeRange.to.diff(timeRange.from));
      const matchIndex = DEFAULT_COMPARE_OPTIONS.findIndex(({ value }) => {
        const intervalInMs = data.rangeUtil.intervalToMs(value);
        return intervalInMs >= diffDays;
      });
      return [
        NO_COMPARE_OPTION,
        PREVIOUS_PERIOD_COMPARE_OPTION,
        ...DEFAULT_COMPARE_OPTIONS.slice(matchIndex).map(({ label, value }) => ({ label, value }))
      ];
    };
    this.onCompareWithChanged = (compareWith) => {
      if (compareWith === NO_PERIOD_VALUE) {
        this.onClearCompare();
      } else {
        this.setState({ compareWith });
      }
    };
    this.onClearCompare = () => {
      this.setState({ compareWith: void 0 });
    };
    this.addActivationHandler(this._onActivate);
  }
  // Get a time shifted request to compare with the primary request.
  getExtraQueries(request) {
    const extraQueries = [];
    const compareRange = this.getCompareTimeRange(request.range);
    if (!compareRange) {
      return extraQueries;
    }
    const targets = request.targets.filter((query) => query.timeRangeCompare !== false);
    if (targets.length) {
      extraQueries.push({
        req: {
          ...request,
          targets,
          range: compareRange
        },
        processor: timeShiftAlignmentProcessor
      });
    }
    return extraQueries;
  }
  // The query runner should rerun the comparison query if the compareWith value has changed and there are queries that haven't opted out of TWC
  shouldRerun(prev, next, queries) {
    return prev.compareWith !== next.compareWith && queries.find((query) => query.timeRangeCompare !== false) !== void 0;
  }
  getCompareTimeRange(timeRange) {
    let compareFrom;
    let compareTo;
    if (this.state.compareWith) {
      if (this.state.compareWith === PREVIOUS_PERIOD_VALUE) {
        const diffMs = timeRange.to.diff(timeRange.from);
        compareFrom = data.dateTime(timeRange.from).subtract(diffMs);
        compareTo = data.dateTime(timeRange.to).subtract(diffMs);
      } else {
        compareFrom = data.dateTime(timeRange.from).subtract(data.rangeUtil.intervalToMs(this.state.compareWith));
        compareTo = data.dateTime(timeRange.to).subtract(data.rangeUtil.intervalToMs(this.state.compareWith));
      }
      return {
        from: compareFrom,
        to: compareTo,
        raw: {
          from: compareFrom,
          to: compareTo
        }
      };
    }
    return void 0;
  }
  getUrlState() {
    return {
      compareWith: this.state.compareWith
    };
  }
  updateFromUrl(values) {
    if (!values.compareWith) {
      return;
    }
    const compareWith = parseUrlParam(values.compareWith);
    if (compareWith) {
      const compareOptions = this.getCompareOptions(sceneGraph.getTimeRange(this).state.value);
      if (compareOptions.find(({ value }) => value === compareWith)) {
        this.setState({
          compareWith
        });
      } else {
        this.setState({
          compareWith: "__previousPeriod"
        });
      }
    }
  }
}
SceneTimeRangeCompare.Component = SceneTimeRangeCompareRenderer;
const timeShiftAlignmentProcessor = (primary, secondary) => {
  const diff = secondary.timeRange.from.diff(primary.timeRange.from);
  secondary.series.forEach((series) => {
    series.refId = getCompareSeriesRefId(series.refId || "");
    series.meta = {
      ...series.meta,
      // @ts-ignore Remove when https://github.com/grafana/grafana/pull/71129 is released
      timeCompare: {
        diffMs: diff,
        isTimeShiftQuery: true
      }
    };
  });
  return rxjs.of(secondary);
};
function SceneTimeRangeCompareRenderer({ model }) {
  var _a;
  const styles = ui.useStyles2(getStyles$4);
  const { compareWith, compareOptions, hideCheckbox } = model.useState();
  const [previousCompare, setPreviousCompare] = React__default.default.useState(compareWith);
  const previousValue = (_a = compareOptions.find(({ value: value2 }) => value2 === previousCompare)) != null ? _a : PREVIOUS_PERIOD_COMPARE_OPTION;
  const value = compareOptions.find(({ value: value2 }) => value2 === compareWith);
  const enabled = Boolean(value);
  const onClick = () => {
    if (enabled) {
      setPreviousCompare(compareWith);
      model.onClearCompare();
    } else if (!enabled) {
      model.onCompareWithChanged(previousValue.value);
    }
  };
  const selectValue = hideCheckbox && !compareWith ? NO_COMPARE_OPTION : value;
  const showSelect = hideCheckbox || enabled;
  const displayValue = hideCheckbox && selectValue ? {
    ...selectValue,
    label: `Comparison: ${selectValue.label}`
  } : selectValue;
  return /* @__PURE__ */ React__default.default.createElement(ui.ButtonGroup, null, !hideCheckbox && /* @__PURE__ */ React__default.default.createElement(
    ui.ToolbarButton,
    {
      variant: "canvas",
      tooltip: i18n.t(
        "grafana-scenes.components.scene-time-range-compare-renderer.button-tooltip",
        "Enable time frame comparison"
      ),
      onClick: (e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }
    },
    /* @__PURE__ */ React__default.default.createElement(ui.Checkbox, { label: " ", value: enabled, onClick }),
    /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.components.scene-time-range-compare-renderer.button-label" }, "Comparison")
  ), showSelect ? /* @__PURE__ */ React__default.default.createElement(
    ui.ButtonSelect,
    {
      variant: "canvas",
      value: displayValue,
      options: compareOptions,
      onChange: (v) => {
        model.onCompareWithChanged(v.value);
      }
    }
  ) : /* @__PURE__ */ React__default.default.createElement(ui.ToolbarButton, { className: styles.previewButton, disabled: true, variant: "canvas", isOpen: false }, previousValue.label));
}
function getStyles$4(theme) {
  return {
    previewButton: css.css({
      "&:disabled": {
        border: `1px solid ${theme.colors.secondary.border}`,
        color: theme.colors.text.disabled,
        opacity: 1
      }
    })
  };
}

class SceneByFrameRepeater extends SceneObjectBase {
  constructor(state) {
    super(state);
    this.addActivationHandler(() => {
      const dataProvider = sceneGraph.getData(this);
      this._subs.add(
        dataProvider.subscribeToState((data$1) => {
          var _a;
          if (((_a = data$1.data) == null ? void 0 : _a.state) === data.LoadingState.Done) {
            this.performRepeat(data$1.data);
          }
        })
      );
      if (dataProvider.state.data) {
        this.performRepeat(dataProvider.state.data);
      }
    });
  }
  performRepeat(data) {
    const newChildren = [];
    for (let seriesIndex = 0; seriesIndex < data.series.length; seriesIndex++) {
      const layoutChild = this.state.getLayoutChild(data, data.series[seriesIndex], seriesIndex);
      newChildren.push(layoutChild);
    }
    this.state.body.setState({ children: newChildren });
  }
}
SceneByFrameRepeater.Component = ({ model }) => {
  const { body } = model.useState();
  return /* @__PURE__ */ React__default.default.createElement(body.Component, { model: body });
};

class SceneByVariableRepeater extends SceneObjectBase {
  constructor(state) {
    super(state);
    this._variableDependency = new VariableDependencyConfig(
      this,
      {
        variableNames: [this.state.variableName],
        onVariableUpdateCompleted: () => this.performRepeat()
      }
    );
    this.addActivationHandler(() => this.performRepeat());
  }
  performRepeat() {
    if (this._variableDependency.hasDependencyInLoadingState()) {
      return;
    }
    const variable = sceneGraph.lookupVariable(this.state.variableName, this);
    if (!(variable instanceof MultiValueVariable)) {
      console.error("SceneByVariableRepeater: variable is not a MultiValueVariable");
      return;
    }
    const values = getMultiVariableValues(variable);
    const newChildren = [];
    for (const option of values) {
      const layoutChild = this.state.getLayoutChild(option);
      newChildren.push(layoutChild);
    }
    this.state.body.setState({ children: newChildren });
  }
}
SceneByVariableRepeater.Component = ({ model }) => {
  const { body } = model.useState();
  return /* @__PURE__ */ React__default.default.createElement(body.Component, { model: body });
};
function getMultiVariableValues(variable) {
  const { value, text, options } = variable.state;
  if (variable.hasAllValue()) {
    return options;
  }
  if (Array.isArray(value) && Array.isArray(text)) {
    return value.map((v, i) => ({ value: v, label: text[i] }));
  }
  return [{ value, label: text }];
}

class SceneControlsSpacer extends SceneObjectBase {
  constructor() {
    super({});
    this._renderBeforeActivation = true;
  }
}
SceneControlsSpacer.Component = (_props) => {
  return /* @__PURE__ */ React__default.default.createElement("div", { style: { flexGrow: 1 } });
};

class SceneFlexLayout extends SceneObjectBase {
  toggleDirection() {
    this.setState({
      direction: this.state.direction === "row" ? "column" : "row"
    });
  }
  isDraggable() {
    return false;
  }
}
SceneFlexLayout.Component = SceneFlexLayoutRenderer;
function SceneFlexLayoutRenderer({ model, parentState }) {
  const { children, isHidden } = model.useState();
  const style = useLayoutStyle$1(model.state, parentState);
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ React__default.default.createElement("div", { className: style }, children.map((item) => {
    const Component = item.Component;
    return /* @__PURE__ */ React__default.default.createElement(Component, { key: item.state.key, model: item, parentState: model.state });
  }));
}
class SceneFlexItem extends SceneObjectBase {
}
SceneFlexItem.Component = SceneFlexItemRenderer;
function SceneFlexItemRenderer({ model, parentState }) {
  if (!parentState) {
    throw new Error("SceneFlexItem must be a child of SceneFlexLayout");
  }
  const { body, isHidden } = model.useState();
  const style = useLayoutItemStyle(model.state, parentState);
  if (!body || isHidden) {
    return null;
  }
  return /* @__PURE__ */ React__default.default.createElement("div", { className: style }, /* @__PURE__ */ React__default.default.createElement(body.Component, { model: body }));
}
function applyItemStyles(style, state, parentState) {
  var _a, _b, _c;
  const parentDirection = (_a = parentState.direction) != null ? _a : "row";
  const { xSizing = "fill", ySizing = "fill" } = state;
  style.display = "flex";
  style.position = "relative";
  style.flexDirection = parentDirection;
  if (parentDirection === "column") {
    if (state.height) {
      style.height = state.height;
    } else {
      style.flexGrow = ySizing === "fill" ? 1 : 0;
    }
    if (state.width) {
      style.width = state.width;
    } else {
      style.alignSelf = xSizing === "fill" ? "stretch" : "flex-start";
    }
  } else {
    if (state.height) {
      style.height = state.height;
    } else {
      style.alignSelf = ySizing === "fill" ? "stretch" : "flex-start";
    }
    if (state.width) {
      style.width = state.width;
    } else {
      style.flexGrow = xSizing === "fill" ? 1 : 0;
    }
    if (state.wrap) {
      style.flexWrap = state.wrap;
      if (state.wrap !== "nowrap") {
        if (parentDirection === "row") {
          style.rowGap = "8px";
        } else {
          style.columnGap = "8px";
        }
      }
    }
  }
  style.minWidth = state.minWidth;
  style.maxWidth = state.maxWidth;
  style.maxHeight = state.maxHeight;
  style.minHeight = (_b = state.minHeight) != null ? _b : parentState.minHeight;
  style.height = (_c = state.height) != null ? _c : parentState.height;
  return style;
}
function useLayoutItemStyle(state, parentState) {
  return React.useMemo(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    const theme = runtime.config.theme2;
    const style = applyItemStyles({}, state, parentState);
    style[theme.breakpoints.down("md")] = {
      maxWidth: (_b = (_a = state.md) == null ? void 0 : _a.maxWidth) != null ? _b : "unset",
      maxHeight: (_d = (_c = state.md) == null ? void 0 : _c.maxHeight) != null ? _d : "unset",
      height: (_g = (_e = state.md) == null ? void 0 : _e.height) != null ? _g : (_f = parentState.md) == null ? void 0 : _f.height,
      width: (_j = (_h = state.md) == null ? void 0 : _h.width) != null ? _j : (_i = parentState.md) == null ? void 0 : _i.width
    };
    return css.css(style);
  }, [state, parentState]);
}
function useLayoutStyle$1(state, parentState) {
  return React.useMemo(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    const { direction = "row", wrap } = state;
    const theme = runtime.config.theme2;
    const style = {};
    if (parentState) {
      applyItemStyles(style, state, parentState);
    } else {
      style.display = "flex";
      style.flexGrow = 1;
      style.minWidth = state.minWidth;
      style.minHeight = state.minHeight;
    }
    style.flexDirection = direction;
    style.gap = "8px";
    style.flexWrap = wrap || "nowrap";
    style.alignContent = "baseline";
    style.minWidth = style.minWidth || 0;
    style.minHeight = style.minHeight || 0;
    style[theme.breakpoints.down("md")] = {
      flexDirection: (_b = (_a = state.md) == null ? void 0 : _a.direction) != null ? _b : "column",
      maxWidth: (_d = (_c = state.md) == null ? void 0 : _c.maxWidth) != null ? _d : "unset",
      maxHeight: (_f = (_e = state.md) == null ? void 0 : _e.maxHeight) != null ? _f : "unset",
      height: (_h = (_g = state.md) == null ? void 0 : _g.height) != null ? _h : "unset",
      width: (_j = (_i = state.md) == null ? void 0 : _i.width) != null ? _j : "unset"
    };
    return css.css(style);
  }, [parentState, state]);
}

class SceneCSSGridLayout extends SceneObjectBase {
  constructor(state) {
    var _a, _b;
    super({
      rowGap: 1,
      columnGap: 1,
      templateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
      autoRows: (_a = state.autoRows) != null ? _a : `320px`,
      children: (_b = state.children) != null ? _b : [],
      ...state
    });
  }
  isDraggable() {
    return false;
  }
}
SceneCSSGridLayout.Component = SceneCSSGridLayoutRenderer;
function SceneCSSGridLayoutRenderer({ model }) {
  const { children, isHidden, isLazy } = model.useState();
  const style = useLayoutStyle(model.state);
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ React__default.default.createElement("div", { className: style }, children.map((item) => {
    const Component = item.Component;
    if (isLazy) {
      return /* @__PURE__ */ React__default.default.createElement(LazyLoader, { key: item.state.key, className: style }, /* @__PURE__ */ React__default.default.createElement(Component, { key: item.state.key, model: item, parentState: model.state }));
    }
    return /* @__PURE__ */ React__default.default.createElement(Component, { key: item.state.key, model: item, parentState: model.state });
  }));
}
class SceneCSSGridItem extends SceneObjectBase {
}
SceneCSSGridItem.Component = SceneCSSGridItemRenderer;
function SceneCSSGridItemRenderer({ model, parentState }) {
  if (!parentState) {
    throw new Error("SceneCSSGridItem must be a child of SceneCSSGridLayout");
  }
  const { body, isHidden } = model.useState();
  const style = useItemStyle(model.state);
  if (!body || isHidden) {
    return null;
  }
  return /* @__PURE__ */ React__default.default.createElement("div", { className: style }, /* @__PURE__ */ React__default.default.createElement(body.Component, { model: body }));
}
function useLayoutStyle(state) {
  return React.useMemo(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
    const style = {};
    const theme = runtime.config.theme2;
    style.display = "grid";
    style.gridTemplateColumns = state.templateColumns;
    style.gridTemplateRows = state.templateRows || "unset";
    style.gridAutoRows = state.autoRows || "unset";
    style.rowGap = theme.spacing((_a = state.rowGap) != null ? _a : 1);
    style.columnGap = theme.spacing((_b = state.columnGap) != null ? _b : 1);
    style.justifyItems = state.justifyItems || "unset";
    style.alignItems = state.alignItems || "unset";
    style.justifyContent = state.justifyContent || "unset";
    style.flexGrow = 1;
    if (state.md) {
      style[theme.breakpoints.down("md")] = {
        gridTemplateRows: (_c = state.md) == null ? void 0 : _c.templateRows,
        gridTemplateColumns: (_d = state.md) == null ? void 0 : _d.templateColumns,
        rowGap: state.md.rowGap ? theme.spacing((_f = (_e = state.md) == null ? void 0 : _e.rowGap) != null ? _f : 1) : void 0,
        columnGap: state.md.columnGap ? theme.spacing((_h = (_g = state.md) == null ? void 0 : _g.rowGap) != null ? _h : 1) : void 0,
        justifyItems: (_i = state.md) == null ? void 0 : _i.justifyItems,
        alignItems: (_j = state.md) == null ? void 0 : _j.alignItems,
        justifyContent: (_k = state.md) == null ? void 0 : _k.justifyContent
      };
    }
    return css.css(style);
  }, [state]);
}
function useItemStyle(state) {
  return React.useMemo(() => {
    const style = {};
    style.gridColumn = state.gridColumn || "unset";
    style.gridRow = state.gridRow || "unset";
    style.position = "relative";
    return css.css(style);
  }, [state]);
}

const PIXELS_PER_MS = 0.3;
const VERTICAL_KEYS = /* @__PURE__ */ new Set(["ArrowUp", "ArrowDown"]);
const HORIZONTAL_KEYS = /* @__PURE__ */ new Set(["ArrowLeft", "ArrowRight"]);
const propsForDirection = {
  row: {
    dim: "width",
    axis: "clientX",
    min: "minWidth",
    max: "maxWidth"
  },
  column: {
    dim: "height",
    axis: "clientY",
    min: "minHeight",
    max: "maxHeight"
  }
};
function Splitter({
  direction = "row",
  handleSize = 32,
  initialSize = "auto",
  primaryPaneStyles,
  secondaryPaneStyles,
  onDragFinished,
  children
}) {
  const kids = React__default.default.Children.toArray(children);
  const splitterRef = React.useRef(null);
  const firstPaneRef = React.useRef(null);
  const secondPaneRef = React.useRef(null);
  const containerRef = React.useRef(null);
  const containerSize = React.useRef(null);
  const primarySizeRef = React.useRef("1fr");
  const firstPaneMeasurements = React.useRef(void 0);
  const savedPos = React.useRef(void 0);
  const measurementProp = propsForDirection[direction].dim;
  const clientAxis = propsForDirection[direction].axis;
  const minDimProp = propsForDirection[direction].min;
  const maxDimProp = propsForDirection[direction].max;
  useResizeObserver(
    containerRef.current,
    (entries) => {
      for (const entry of entries) {
        if (!entry.target.isSameNode(containerRef.current)) {
          return;
        }
        const curSize = firstPaneRef.current.getBoundingClientRect()[measurementProp];
        const newDims = measureElement(firstPaneRef.current);
        splitterRef.current.ariaValueNow = `${lodash.clamp(
          (curSize - newDims[minDimProp]) / (newDims[maxDimProp] - newDims[minDimProp]) * 100,
          0,
          100
        )}`;
      }
    },
    500,
    [maxDimProp, minDimProp, direction, measurementProp]
  );
  const dragStart = React.useRef(null);
  const onPointerDown = React.useCallback(
    (e) => {
      primarySizeRef.current = firstPaneRef.current.getBoundingClientRect()[measurementProp];
      containerSize.current = containerRef.current.getBoundingClientRect()[measurementProp];
      dragStart.current = e[clientAxis];
      splitterRef.current.setPointerCapture(e.pointerId);
      firstPaneMeasurements.current = measureElement(firstPaneRef.current);
      savedPos.current = void 0;
    },
    [measurementProp, clientAxis]
  );
  const onPointerMove = React.useCallback(
    (e) => {
      if (dragStart.current !== null && primarySizeRef.current !== "1fr") {
        const diff = e[clientAxis] - dragStart.current;
        const dims = firstPaneMeasurements.current;
        const newSize = lodash.clamp(primarySizeRef.current + diff, dims[minDimProp], dims[maxDimProp]);
        const newFlex = newSize / (containerSize.current - handleSize);
        firstPaneRef.current.style.flexGrow = `${newFlex}`;
        secondPaneRef.current.style.flexGrow = `${1 - newFlex}`;
        const ariaValueNow = lodash.clamp(
          (newSize - dims[minDimProp]) / (dims[maxDimProp] - dims[minDimProp]) * 100,
          0,
          100
        );
        splitterRef.current.ariaValueNow = `${ariaValueNow}`;
      }
    },
    [handleSize, clientAxis, minDimProp, maxDimProp]
  );
  const onPointerUp = React.useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      splitterRef.current.releasePointerCapture(e.pointerId);
      dragStart.current = null;
      onDragFinished == null ? void 0 : onDragFinished(parseFloat(firstPaneRef.current.style.flexGrow));
    },
    [onDragFinished]
  );
  const pressedKeys = React.useRef(/* @__PURE__ */ new Set());
  const keysLastHandledAt = React.useRef(null);
  const handlePressedKeys = React.useCallback(
    (time) => {
      var _a;
      const nothingPressed = pressedKeys.current.size === 0;
      if (nothingPressed) {
        keysLastHandledAt.current = null;
        return;
      } else if (primarySizeRef.current === "1fr") {
        return;
      }
      const dt = time - ((_a = keysLastHandledAt.current) != null ? _a : time);
      const dx = dt * PIXELS_PER_MS;
      let sizeChange = 0;
      if (direction === "row") {
        if (pressedKeys.current.has("ArrowLeft")) {
          sizeChange -= dx;
        }
        if (pressedKeys.current.has("ArrowRight")) {
          sizeChange += dx;
        }
      } else {
        if (pressedKeys.current.has("ArrowUp")) {
          sizeChange -= dx;
        }
        if (pressedKeys.current.has("ArrowDown")) {
          sizeChange += dx;
        }
      }
      const firstPaneDims = firstPaneMeasurements.current;
      const curSize = firstPaneRef.current.getBoundingClientRect()[measurementProp];
      const newSize = lodash.clamp(curSize + sizeChange, firstPaneDims[minDimProp], firstPaneDims[maxDimProp]);
      const newFlex = newSize / (containerSize.current - handleSize);
      firstPaneRef.current.style.flexGrow = `${newFlex}`;
      secondPaneRef.current.style.flexGrow = `${1 - newFlex}`;
      const ariaValueNow = (newSize - firstPaneDims[minDimProp]) / (firstPaneDims[maxDimProp] - firstPaneDims[minDimProp]) * 100;
      splitterRef.current.ariaValueNow = `${lodash.clamp(ariaValueNow, 0, 100)}`;
      keysLastHandledAt.current = time;
      window.requestAnimationFrame(handlePressedKeys);
    },
    [direction, handleSize, minDimProp, maxDimProp, measurementProp]
  );
  const onKeyDown = React.useCallback(
    (e) => {
      if (e.key === "Enter") {
        if (savedPos.current === void 0) {
          savedPos.current = firstPaneRef.current.style.flexGrow;
          firstPaneRef.current.style.flexGrow = "0";
          secondPaneRef.current.style.flexGrow = "1";
        } else {
          firstPaneRef.current.style.flexGrow = savedPos.current;
          secondPaneRef.current.style.flexGrow = `${1 - parseFloat(savedPos.current)}`;
          savedPos.current = void 0;
        }
        return;
      } else if (e.key === "Home") {
        firstPaneMeasurements.current = measureElement(firstPaneRef.current);
        containerSize.current = containerRef.current.getBoundingClientRect()[measurementProp];
        const newFlex = firstPaneMeasurements.current[minDimProp] / (containerSize.current - handleSize);
        firstPaneRef.current.style.flexGrow = `${newFlex}`;
        secondPaneRef.current.style.flexGrow = `${1 - newFlex}`;
        splitterRef.current.ariaValueNow = "0";
        return;
      } else if (e.key === "End") {
        firstPaneMeasurements.current = measureElement(firstPaneRef.current);
        containerSize.current = containerRef.current.getBoundingClientRect()[measurementProp];
        const newFlex = firstPaneMeasurements.current[maxDimProp] / (containerSize.current - handleSize);
        firstPaneRef.current.style.flexGrow = `${newFlex}`;
        secondPaneRef.current.style.flexGrow = `${1 - newFlex}`;
        splitterRef.current.ariaValueNow = "100";
        return;
      }
      if (!(direction === "column" && VERTICAL_KEYS.has(e.key) || direction === "row" && HORIZONTAL_KEYS.has(e.key)) || pressedKeys.current.has(e.key)) {
        return;
      }
      savedPos.current = void 0;
      e.preventDefault();
      e.stopPropagation();
      primarySizeRef.current = firstPaneRef.current.getBoundingClientRect()[measurementProp];
      containerSize.current = containerRef.current.getBoundingClientRect()[measurementProp];
      firstPaneMeasurements.current = measureElement(firstPaneRef.current);
      const newKey = !pressedKeys.current.has(e.key);
      if (newKey) {
        const initiateAnimationLoop = pressedKeys.current.size === 0;
        pressedKeys.current.add(e.key);
        if (initiateAnimationLoop) {
          window.requestAnimationFrame(handlePressedKeys);
        }
      }
    },
    [direction, handlePressedKeys, handleSize, maxDimProp, measurementProp, minDimProp]
  );
  const onKeyUp = React.useCallback(
    (e) => {
      if (direction === "row" && !HORIZONTAL_KEYS.has(e.key) || direction === "column" && !VERTICAL_KEYS.has(e.key)) {
        return;
      }
      pressedKeys.current.delete(e.key);
      onDragFinished == null ? void 0 : onDragFinished(parseFloat(firstPaneRef.current.style.flexGrow));
    },
    [direction, onDragFinished]
  );
  const onDoubleClick = React.useCallback(() => {
    firstPaneRef.current.style.flexGrow = "0.5";
    secondPaneRef.current.style.flexGrow = "0.5";
    const dim = measureElement(firstPaneRef.current);
    firstPaneMeasurements.current = dim;
    primarySizeRef.current = firstPaneRef.current.getBoundingClientRect()[measurementProp];
    splitterRef.current.ariaValueNow = `${(primarySizeRef.current - dim[minDimProp]) / (dim[maxDimProp] - dim[minDimProp]) * 100}`;
  }, [maxDimProp, measurementProp, minDimProp]);
  const onBlur = React.useCallback(() => {
    if (pressedKeys.current.size > 0) {
      pressedKeys.current.clear();
      dragStart.current = null;
      onDragFinished == null ? void 0 : onDragFinished(parseFloat(firstPaneRef.current.style.flexGrow));
    }
  }, [onDragFinished]);
  const styles = ui.useStyles2(getStyles$3);
  const id = useUniqueId();
  const secondAvailable = kids.length === 2;
  const visibilitySecond = secondAvailable ? "visible" : "hidden";
  return /* @__PURE__ */ React__default.default.createElement(
    "div",
    {
      ref: containerRef,
      className: styles.container,
      style: {
        flexDirection: direction
      }
    },
    /* @__PURE__ */ React__default.default.createElement(
      "div",
      {
        ref: firstPaneRef,
        className: styles.panel,
        style: {
          flexGrow: initialSize === "auto" ? 0.5 : lodash.clamp(initialSize, 0, 1),
          [minDimProp]: "min-content",
          ...primaryPaneStyles
        },
        id: `start-panel-${id}`
      },
      kids[0]
    ),
    kids[1] && /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, /* @__PURE__ */ React__default.default.createElement(
      "div",
      {
        ref: splitterRef,
        style: { [measurementProp]: `${handleSize}px` },
        className: css.cx(styles.handle, { [styles.handleHorizontal]: direction === "column" }),
        onPointerUp,
        onPointerDown,
        onPointerMove,
        onKeyDown,
        onKeyUp,
        onDoubleClick,
        onBlur,
        role: "separator",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": 50,
        "aria-controls": `start-panel-${id}`,
        "aria-label": i18n.t("grafana-scenes.components.splitter.aria-label-pane-resize-widget", "Pane resize widget"),
        tabIndex: 0
      }
    ), /* @__PURE__ */ React__default.default.createElement(
      "div",
      {
        ref: secondPaneRef,
        className: styles.panel,
        style: {
          flexGrow: initialSize === "auto" ? 0.5 : lodash.clamp(1 - initialSize, 0, 1),
          [minDimProp]: "min-content",
          visibility: `${visibilitySecond}`,
          ...secondaryPaneStyles
        },
        id: `end-panel-${id}`
      },
      kids[1]
    ))
  );
}
function getStyles$3(theme) {
  return {
    handle: css.css({
      cursor: "col-resize",
      position: "relative",
      flexShrink: 0,
      userSelect: "none",
      "&::before": {
        content: '""',
        position: "absolute",
        backgroundColor: theme.colors.primary.main,
        left: "50%",
        transform: "translate(-50%)",
        top: 0,
        height: "100%",
        width: "1px",
        opacity: 0,
        transition: "opacity ease-in-out 0.2s"
      },
      "&::after": {
        content: '""',
        width: "4px",
        borderRadius: "4px",
        backgroundColor: theme.colors.border.weak,
        transition: "background-color ease-in-out 0.2s",
        height: "50%",
        top: "calc(50% - (50%) / 2)",
        transform: "translateX(-50%)",
        position: "absolute",
        left: "50%"
      },
      "&:hover, &:focus-visible": {
        outline: "none",
        "&::before": {
          opacity: 1
        },
        "&::after": {
          backgroundColor: theme.colors.primary.main
        }
      }
    }),
    handleHorizontal: css.css({
      cursor: "row-resize",
      "&::before": {
        left: "inherit",
        transform: "translateY(-50%)",
        top: "50%",
        height: "1px",
        width: "100%"
      },
      "&::after": {
        width: "50%",
        height: "4px",
        top: "50%",
        transform: "translateY(-50%)",
        left: "calc(50% - (50%) / 2)"
      }
    }),
    container: css.css({
      display: "flex",
      width: "100%",
      flexGrow: 1,
      overflow: "hidden"
    }),
    panel: css.css({ display: "flex", position: "relative", flexBasis: 0 })
  };
}
function measureElement(ref) {
  if (ref === null) {
    return void 0;
  }
  const savedBodyOverflow = document.body.style.overflow;
  const savedWidth = ref.style.width;
  const savedHeight = ref.style.height;
  const savedFlex = ref.style.flexGrow;
  document.body.style.overflow = "hidden";
  ref.style.flexGrow = "0";
  const { width: minWidth, height: minHeight } = ref.getBoundingClientRect();
  ref.style.flexGrow = "100";
  const { width: maxWidth, height: maxHeight } = ref.getBoundingClientRect();
  document.body.style.overflow = savedBodyOverflow;
  ref.style.width = savedWidth;
  ref.style.height = savedHeight;
  ref.style.flexGrow = savedFlex;
  return { minWidth, maxWidth, minHeight, maxHeight };
}
function useResizeObserver(target, cb, throttleWait = 0, deps) {
  const throttledCallback = lodash.throttle(cb, throttleWait);
  React.useLayoutEffect(() => {
    if (!target) {
      return;
    }
    const resizeObserver = new ResizeObserver(throttledCallback);
    resizeObserver.observe(target, { box: "device-pixel-content-box" });
    return () => resizeObserver.disconnect();
  }, deps);
}

function SplitLayoutRenderer({ model }) {
  const { primary, secondary, direction, isHidden, initialSize, primaryPaneStyles, secondaryPaneStyles } = model.useState();
  if (isHidden) {
    return null;
  }
  const Prim = primary.Component;
  const Sec = secondary == null ? void 0 : secondary.Component;
  let startSize = secondary ? initialSize : 1;
  return /* @__PURE__ */ React__default.default.createElement(
    Splitter,
    {
      direction,
      initialSize: startSize != null ? startSize : 0.5,
      primaryPaneStyles,
      secondaryPaneStyles
    },
    /* @__PURE__ */ React__default.default.createElement(Prim, { key: primary.state.key, model: primary, parentState: model.state }),
    Sec && secondary && /* @__PURE__ */ React__default.default.createElement(Sec, { key: secondary.state.key, model: secondary, parentState: model.state })
  );
}

class SplitLayout extends SceneObjectBase {
  toggleDirection() {
    this.setState({
      direction: this.state.direction === "row" ? "column" : "row"
    });
  }
  isDraggable() {
    return false;
  }
}
SplitLayout.Component = SplitLayoutRenderer;

class SceneApp extends SceneObjectBase {
  constructor() {
    super(...arguments);
    this._renderBeforeActivation = true;
  }
  enrichDataRequest() {
    return {
      app: this.state.name || "app"
    };
  }
}
SceneApp.Component = ({ model }) => {
  const { pages } = model.useState();
  return /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, /* @__PURE__ */ React__default.default.createElement(SceneAppContext.Provider, { value: model }, /* @__PURE__ */ React__default.default.createElement(reactRouterDom.Routes, null, pages.map((page) => /* @__PURE__ */ React__default.default.createElement(reactRouterDom.Route, { key: page.state.url, path: page.state.routePath, element: /* @__PURE__ */ React__default.default.createElement(page.Component, { model: page }) })))));
};
const SceneAppContext = React.createContext(null);
const sceneAppCache = /* @__PURE__ */ new Map();
function useSceneApp(factory) {
  const cachedApp = sceneAppCache.get(factory);
  if (cachedApp) {
    return cachedApp;
  }
  const newApp = factory();
  sceneAppCache.set(factory, newApp);
  return newApp;
}

class SceneReactObject extends SceneObjectBase {
}
SceneReactObject.Component = ({ model }) => {
  const { component: Component, props, reactNode } = model.useState();
  if (Component) {
    return /* @__PURE__ */ React__default.default.createElement(Component, { ...props });
  }
  if (reactNode) {
    return reactNode;
  }
  return null;
};

function DebugDetails({ node }) {
  const state = node.useState();
  const styles = ui.useStyles2(getStyles$2);
  return /* @__PURE__ */ React__default.default.createElement("div", { className: styles.container }, Object.keys(state).map((key) => /* @__PURE__ */ React__default.default.createElement("div", { className: styles.row, key }, /* @__PURE__ */ React__default.default.createElement("div", { className: styles.keyName }, key), /* @__PURE__ */ React__default.default.createElement("div", { className: styles.value }, renderValue(key, state[key], node)))));
}
function renderValue(key, value, node) {
  if (value === null) {
    return "null";
  }
  switch (typeof value) {
    case "number":
      return /* @__PURE__ */ React__default.default.createElement(
        ui.Input,
        {
          type: "number",
          defaultValue: value,
          onBlur: (evt) => node.setState({ [key]: evt.currentTarget.valueAsNumber })
        }
      );
    case "string":
      return /* @__PURE__ */ React__default.default.createElement(ui.Input, { type: "text", defaultValue: value, onBlur: (evt) => node.setState({ [key]: evt.currentTarget.value }) });
    case "object":
      if (isSceneObject(value)) {
        return value.constructor.name;
      }
      if (lodash.isPlainObject(value) || lodash.isArray(value)) {
        return /* @__PURE__ */ React__default.default.createElement(ui.JSONFormatter, { json: value, open: 0 });
      }
      return String(value);
    default:
      return typeof value;
  }
}
function getStyles$2(theme) {
  return {
    container: css.css({
      flexGrow: 1,
      display: "flex",
      gap: theme.spacing(0.5),
      flexDirection: "column"
    }),
    row: css.css({
      display: "flex",
      gap: theme.spacing(2)
    }),
    keyName: css.css({
      display: "flex",
      flexGrow: "0",
      width: 120,
      alignItems: "center",
      height: theme.spacing(theme.components.height.md)
    }),
    value: css.css({
      flexGrow: 1,
      minHeight: theme.spacing(theme.components.height.md),
      display: "flex",
      alignItems: "center"
    })
  };
}

function DebugTreeNode({ node, selectedObject, onSelect }) {
  const styles = ui.useStyles2(getStyles$1);
  const children = [];
  const isSelected = node === selectedObject;
  node.forEachChild((child) => {
    children.push(
      /* @__PURE__ */ React__default.default.createElement(DebugTreeNode, { node: child, key: child.state.key, selectedObject, onSelect })
    );
  });
  return /* @__PURE__ */ React__default.default.createElement("div", { className: styles.container }, /* @__PURE__ */ React__default.default.createElement("div", { className: css.cx(styles.name, isSelected && styles.selected), onClick: () => onSelect(node) }, node.constructor.name), /* @__PURE__ */ React__default.default.createElement("div", { className: styles.children }, children));
}
function getStyles$1(theme) {
  return {
    container: css.css({
      flexGrow: 1,
      display: "flex",
      gap: theme.spacing(0.5),
      flexDirection: "column"
    }),
    name: css.css({
      flexGrow: 1,
      display: "flex",
      gap: theme.spacing(1),
      fontSize: theme.typography.bodySmall.fontSize,
      cursor: "pointer",
      padding: theme.spacing(0, 1),
      borderRadius: theme.shape.borderRadius(2),
      position: "relative",
      "&:hover": {
        background: theme.colors.background.secondary
      }
    }),
    selected: css.css({
      "&::before": {
        display: "block",
        content: "' '",
        position: "absolute",
        left: 0,
        width: 4,
        bottom: 2,
        top: 2,
        borderRadius: theme.shape.radius.default,
        backgroundImage: theme.colors.gradients.brandVertical
      }
    }),
    children: css.css({
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      paddingLeft: theme.spacing(1)
    })
  };
}

function SceneDebugger({ scene }) {
  const styles = ui.useStyles2(getStyles);
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedObject, setSelectedObject] = React.useState();
  return /* @__PURE__ */ React__default.default.createElement(React__default.default.Fragment, null, /* @__PURE__ */ React__default.default.createElement(ui.ToolbarButton, { variant: "canvas", icon: "bug", onClick: () => setIsOpen(true) }), isOpen && /* @__PURE__ */ React__default.default.createElement(
    ui.Drawer,
    {
      title: i18n.t("grafana-scenes.components.scene-debugger.title-scene-debugger", "Scene debugger"),
      onClose: () => setIsOpen(false),
      size: "lg"
    },
    /* @__PURE__ */ React__default.default.createElement("div", { className: styles.panes }, /* @__PURE__ */ React__default.default.createElement("div", { className: styles.pane1 }, /* @__PURE__ */ React__default.default.createElement("div", { className: styles.paneHeading }, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.components.scene-debugger.scene-graph" }, "Scene graph")), /* @__PURE__ */ React__default.default.createElement(ui.CustomScrollbar, { autoHeightMin: "100%" }, /* @__PURE__ */ React__default.default.createElement("div", { className: styles.treeWrapper }, /* @__PURE__ */ React__default.default.createElement(DebugTreeNode, { node: scene, selectedObject, onSelect: setSelectedObject })))), /* @__PURE__ */ React__default.default.createElement("div", { className: styles.pane2 }, /* @__PURE__ */ React__default.default.createElement("div", { className: styles.paneHeading }, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.components.scene-debugger.object-details" }, "Object details")), selectedObject && /* @__PURE__ */ React__default.default.createElement(DebugDetails, { node: selectedObject })))
  ));
}
function getStyles(theme) {
  return {
    panes: css.css({
      flexGrow: 1,
      display: "flex",
      height: "100%",
      flexDirection: "row",
      marginTop: theme.spacing(-2)
    }),
    pane1: css.css({
      flexGrow: 0,
      display: "flex",
      height: "100%",
      flexDirection: "column",
      borderRight: `1px solid ${theme.colors.border.weak}`
    }),
    pane2: css.css({
      flexGrow: 1,
      display: "flex",
      minHeight: "100%",
      flexDirection: "column",
      paddingLeft: theme.spacing(2)
    }),
    treeWrapper: css.css({
      paddingRight: theme.spacing(2),
      height: "100%",
      marginLeft: theme.spacing(-1)
    }),
    paneHeading: css.css({
      padding: theme.spacing(1, 0),
      fontWeight: theme.typography.fontWeightMedium
    })
  };
}

function SceneAppPageView({ page }) {
  const routeMatch = useSceneRouteMatch(page.state.url);
  const containerPage = getParentPageIfTab(page);
  const containerState = containerPage.useState();
  const params = useAppQueryParams();
  const scene = page.getScene(routeMatch);
  const appContext = React.useContext(SceneAppContext);
  const isInitialized = containerState.initializedScene === scene;
  const { layout } = page.state;
  const locationService = useLocationServiceSafe();
  React.useLayoutEffect(() => {
    if (!isInitialized) {
      containerPage.initializeScene(scene);
    }
  }, [scene, containerPage, isInitialized]);
  React.useEffect(() => {
    return () => containerPage.setState({ initializedScene: void 0 });
  }, [containerPage]);
  const urlSyncInitialized = useUrlSync(containerPage, appContext == null ? void 0 : appContext.state.urlSyncOptions);
  if (!isInitialized && !urlSyncInitialized) {
    return null;
  }
  const pageNav = {
    text: containerState.title,
    img: containerState.titleImg,
    icon: containerState.titleIcon,
    url: getUrlWithAppState(containerState.url, locationService.getSearchObject(), containerState.preserveUrlKeys),
    hideFromBreadcrumbs: containerState.hideFromBreadcrumbs,
    parentItem: getParentBreadcrumbs(
      containerState.getParentPage ? containerState.getParentPage() : containerPage.parent,
      params,
      locationService.getSearchObject()
    )
  };
  if (containerState.tabs) {
    pageNav.children = containerState.tabs.map((tab) => {
      return {
        text: tab.state.title,
        icon: tab.state.titleIcon,
        tabSuffix: tab.state.tabSuffix,
        active: page === tab,
        url: getUrlWithAppState(tab.state.url, locationService.getSearchObject(), tab.state.preserveUrlKeys),
        parentItem: pageNav
      };
    });
  }
  let pageActions = [];
  if (containerState.controls) {
    pageActions = containerState.controls.map((control) => /* @__PURE__ */ React__default.default.createElement(control.Component, { model: control, key: control.state.key }));
  }
  if (params["scene-debugger"]) {
    pageActions.push(/* @__PURE__ */ React__default.default.createElement(SceneDebugger, { scene: containerPage, key: "scene-debugger" }));
  }
  return /* @__PURE__ */ React__default.default.createElement(
    runtime.PluginPage,
    {
      layout,
      pageNav,
      actions: pageActions,
      renderTitle: containerState.renderTitle,
      subTitle: containerState.subTitle
    },
    /* @__PURE__ */ React__default.default.createElement(scene.Component, { model: scene })
  );
}
function getParentPageIfTab(page) {
  if (page.parent instanceof SceneAppPage) {
    return page.parent;
  }
  return page;
}
function getParentBreadcrumbs(parent, params, searchObject) {
  if (parent instanceof SceneAppPage) {
    return {
      text: parent.state.title,
      url: getUrlWithAppState(parent.state.url, searchObject, parent.state.preserveUrlKeys),
      hideFromBreadcrumbs: parent.state.hideFromBreadcrumbs,
      parentItem: getParentBreadcrumbs(
        parent.state.getParentPage ? parent.state.getParentPage() : parent.parent,
        params,
        searchObject
      )
    };
  }
  return void 0;
}
function SceneAppDrilldownViewRender({ drilldown, parent }) {
  const routeMatch = useSceneRouteMatch(drilldown.routePath);
  const page = parent.getDrilldownPage(drilldown, routeMatch);
  return /* @__PURE__ */ React__default.default.createElement(page.Component, { model: page });
}

class SceneAppPage extends SceneObjectBase {
  constructor() {
    super(...arguments);
    this._sceneCache = /* @__PURE__ */ new Map();
    this._drilldownCache = /* @__PURE__ */ new Map();
  }
  initializeScene(scene) {
    this.setState({ initializedScene: scene });
  }
  getScene(routeMatch) {
    let scene = this._sceneCache.get(routeMatch.url);
    if (scene) {
      return scene;
    }
    if (!this.state.getScene) {
      throw new Error("Missing getScene on SceneAppPage " + this.state.title);
    }
    scene = this.state.getScene(routeMatch);
    this._sceneCache.set(routeMatch.url, scene);
    return scene;
  }
  getDrilldownPage(drilldown, routeMatch) {
    let page = this._drilldownCache.get(routeMatch.url);
    if (page) {
      return page;
    }
    page = drilldown.getPage(routeMatch, this);
    this._drilldownCache.set(routeMatch.url, page);
    return page;
  }
  enrichDataRequest(source) {
    if (this.state.getParentPage) {
      return this.state.getParentPage().enrichDataRequest(source);
    }
    if (!this.parent) {
      return null;
    }
    const root = this.getRoot();
    if (isDataRequestEnricher(root)) {
      return root.enrichDataRequest(source);
    }
    return null;
  }
}
SceneAppPage.Component = SceneAppPageRenderer;
function SceneAppPageRenderer({ model }) {
  const { tabs, drilldowns } = model.useState();
  const routes = [];
  routes.push(getFallbackRoute(model));
  if (tabs && tabs.length > 0) {
    for (let tabIndex = 0; tabIndex < tabs.length; tabIndex++) {
      const tab = tabs[tabIndex];
      if (tabIndex === 0) {
        routes.push(/* @__PURE__ */ React__default.default.createElement(reactRouterDom.Route, { key: model.state.routePath, path: "", element: /* @__PURE__ */ React__default.default.createElement(tab.Component, { model: tab }) }));
      }
      routes.push(
        /* @__PURE__ */ React__default.default.createElement(reactRouterDom.Route, { key: tab.state.url, path: tab.state.routePath, element: /* @__PURE__ */ React__default.default.createElement(tab.Component, { model: tab }) })
      );
      if (tab.state.drilldowns) {
        for (const drilldown of tab.state.drilldowns) {
          routes.push(
            /* @__PURE__ */ React__default.default.createElement(
              reactRouterDom.Route,
              {
                key: drilldown.routePath,
                path: drilldown.routePath,
                element: /* @__PURE__ */ React__default.default.createElement(SceneAppDrilldownViewRender, { drilldown, parent: tab })
              }
            )
          );
        }
      }
    }
  }
  if (drilldowns) {
    for (const drilldown of drilldowns) {
      routes.push(
        /* @__PURE__ */ React__default.default.createElement(
          reactRouterDom.Route,
          {
            key: drilldown.routePath,
            path: drilldown.routePath,
            Component: () => /* @__PURE__ */ React__default.default.createElement(SceneAppDrilldownViewRender, { drilldown, parent: model })
          }
        )
      );
    }
  }
  if (!tabs) {
    routes.push(/* @__PURE__ */ React__default.default.createElement(reactRouterDom.Route, { key: "home route", path: "/", element: /* @__PURE__ */ React__default.default.createElement(SceneAppPageView, { page: model }) }));
  }
  return /* @__PURE__ */ React__default.default.createElement(reactRouterDom.Routes, null, routes);
}
function getFallbackRoute(page) {
  var _a, _b, _c;
  return /* @__PURE__ */ React__default.default.createElement(
    reactRouterDom.Route,
    {
      key: "fallback route",
      path: "*",
      element: /* @__PURE__ */ React__default.default.createElement(SceneAppPageView, { page: (_c = (_b = (_a = page.state).getFallbackPage) == null ? void 0 : _b.call(_a)) != null ? _c : getDefaultFallbackPage() })
    }
  );
}
function getDefaultFallbackPage() {
  return new SceneAppPage({
    url: "",
    title: i18n.t("grafana-scenes.components.fallback-page.title", "Not found"),
    subTitle: i18n.t("grafana-scenes.components.fallback-page.subTitle", "The url did not match any page"),
    routePath: "*",
    getScene: () => {
      return new EmbeddedScene({
        body: new SceneFlexLayout({
          direction: "column",
          children: [
            new SceneFlexItem({
              body: new SceneReactObject({
                component: () => {
                  return /* @__PURE__ */ React__default.default.createElement("div", { "data-testid": "default-fallback-content" }, /* @__PURE__ */ React__default.default.createElement(i18n.Trans, { i18nKey: "grafana-scenes.components.fallback-page.content" }, "If you found your way here using a link then there might be a bug in this application."));
                }
              })
            })
          ]
        })
      });
    }
  });
}

class StandardFieldConfigOverridesBuilder {
  constructor() {
    this._overrides = [];
  }
  overrideColor(value) {
    this._overrides[this._overrides.length - 1].properties.push({ id: "color", value });
    return this;
  }
  overrideDecimals(value) {
    this._overrides[this._overrides.length - 1].properties.push({ id: "decimals", value });
    return this;
  }
  overrideDisplayName(value) {
    this._overrides[this._overrides.length - 1].properties.push({ id: "displayName", value });
    return this;
  }
  overrideFilterable(value) {
    this._overrides[this._overrides.length - 1].properties.push({ id: "filterable", value });
    return this;
  }
  overrideLinks(value) {
    this._overrides[this._overrides.length - 1].properties.push({ id: "links", value });
    return this;
  }
  overrideMappings(value) {
    this._overrides[this._overrides.length - 1].properties.push({ id: "mappings", value });
    return this;
  }
  overrideMax(value) {
    this._overrides[this._overrides.length - 1].properties.push({ id: "max", value });
    return this;
  }
  overrideMin(value) {
    this._overrides[this._overrides.length - 1].properties.push({ id: "min", value });
    return this;
  }
  overrideNoValue(value) {
    this._overrides[this._overrides.length - 1].properties.push({ id: "noValue", value });
    return this;
  }
  overrideThresholds(value) {
    this._overrides[this._overrides.length - 1].properties.push({ id: "thresholds", value });
    return this;
  }
  overrideUnit(value) {
    this._overrides[this._overrides.length - 1].properties.push({ id: "unit", value });
    return this;
  }
}

class FieldConfigOverridesBuilder extends StandardFieldConfigOverridesBuilder {
  match(matcher) {
    this._overrides.push({ matcher, properties: [] });
    return this;
  }
  matchFieldsWithName(name) {
    this._overrides.push({
      matcher: {
        id: data.FieldMatcherID.byName,
        options: name
      },
      properties: []
    });
    return this;
  }
  matchFieldsWithNameByRegex(regex) {
    this._overrides.push({
      matcher: {
        id: data.FieldMatcherID.byRegexp,
        options: regex
      },
      properties: []
    });
    return this;
  }
  matchFieldsByType(fieldType) {
    this._overrides.push({
      matcher: {
        id: data.FieldMatcherID.byType,
        options: fieldType
      },
      properties: []
    });
    return this;
  }
  matchFieldsByQuery(refId) {
    this._overrides.push({
      matcher: {
        id: data.FieldMatcherID.byFrameRefID,
        options: refId
      },
      properties: []
    });
    return this;
  }
  matchFieldsByValue(options) {
    this._overrides.push({
      matcher: {
        id: data.FieldMatcherID.byValue,
        options
      },
      properties: []
    });
    return this;
  }
  matchComparisonQuery(refId) {
    return this.matchFieldsByQuery(getCompareSeriesRefId(refId));
  }
  overrideCustomFieldConfig(id, value) {
    const _id = `custom.${String(id)}`;
    const last = this._overrides[this._overrides.length - 1];
    last.properties.push({ id: _id, value });
    return this;
  }
  build() {
    return this._overrides;
  }
}

class FieldConfigBuilder {
  constructor(defaultFieldConfig) {
    this.defaultFieldConfig = defaultFieldConfig;
    this._fieldConfig = {
      defaults: {},
      overrides: []
    };
    this._overridesBuilder = new FieldConfigOverridesBuilder();
    this.setDefaults();
  }
  setDefaults() {
    const fieldConfig = {
      defaults: {
        custom: this.defaultFieldConfig ? lodash.cloneDeep(this.defaultFieldConfig()) : {}
      },
      // use field config factory that will provide default field config
      overrides: []
    };
    this._fieldConfig = fieldConfig;
  }
  /**
   * Set color.
   */
  setColor(color) {
    return this.setFieldConfigDefaults("color", color);
  }
  /**
   * Set number of decimals to show.
   */
  setDecimals(decimals) {
    return this.setFieldConfigDefaults("decimals", decimals);
  }
  /**
   * Set field display name.
   */
  setDisplayName(displayName) {
    return this.setFieldConfigDefaults("displayName", displayName);
  }
  /**
   * Set the standard field config property filterable.
   */
  setFilterable(filterable) {
    return this.setFieldConfigDefaults("filterable", filterable);
  }
  /**
   * Set data links.
   */
  setLinks(links) {
    return this.setFieldConfigDefaults("links", links);
  }
  /**
   * Set value mappings.
   */
  setMappings(mappings) {
    return this.setFieldConfigDefaults("mappings", mappings);
  }
  /**
   * Set the standard field config property max.
   */
  setMax(max) {
    return this.setFieldConfigDefaults("max", max);
  }
  /**
   * Set the standard field config property min.
   */
  setMin(min) {
    return this.setFieldConfigDefaults("min", min);
  }
  /**
   * Set the standard field config property noValue.
   */
  setNoValue(noValue) {
    return this.setFieldConfigDefaults("noValue", noValue);
  }
  /**
   * Set the standard field config property thresholds.
   */
  setThresholds(thresholds) {
    return this.setFieldConfigDefaults("thresholds", thresholds);
  }
  /**
   * Set the standard field config property unit.
   */
  setUnit(unit) {
    return this.setFieldConfigDefaults("unit", unit);
  }
  /**
   * Set an individual custom field config value. This will merge the value with the existing custom field config.
   */
  setCustomFieldConfig(id, value) {
    this._fieldConfig.defaults = {
      ...this._fieldConfig.defaults,
      custom: lodash.merge(this._fieldConfig.defaults.custom, { [id]: value })
    };
    return this;
  }
  /**
   * Configure overrides for the field config. This will merge the overrides with the existing overrides.
   */
  setOverrides(builder) {
    builder(this._overridesBuilder);
    return this;
  }
  setFieldConfigDefaults(key, value) {
    this._fieldConfig.defaults = {
      ...this._fieldConfig.defaults,
      [key]: value
    };
    return this;
  }
  build() {
    return {
      defaults: this._fieldConfig.defaults,
      overrides: this._overridesBuilder.build()
    };
  }
}

class PanelOptionsBuilder {
  constructor(defaultOptions) {
    this.defaultOptions = defaultOptions;
    this._options = {};
    this.setDefaults();
  }
  setDefaults() {
    this._options = this.defaultOptions ? lodash.cloneDeep(this.defaultOptions()) : {};
  }
  /**
   * Set an individual panel option. This will merge the value with the existing options.
   */
  setOption(id, value) {
    this._options = lodash.merge(this._options, { [id]: value });
    return this;
  }
  build() {
    return this._options;
  }
}

class VizPanelBuilder {
  constructor(pluginId, pluginVersion, defaultOptions, defaultFieldConfig) {
    this._state = {};
    this._state.title = "";
    this._state.description = "";
    this._state.displayMode = "default";
    this._state.hoverHeader = false;
    this._state.pluginId = pluginId;
    this._state.pluginVersion = pluginVersion;
    this._fieldConfigBuilder = new FieldConfigBuilder(defaultFieldConfig);
    this._panelOptionsBuilder = new PanelOptionsBuilder(defaultOptions);
  }
  /**
   * Set panel title.
   */
  setTitle(title) {
    this._state.title = title;
    return this;
  }
  /**
   * Set panel description.
   */
  setDescription(description) {
    this._state.description = description;
    return this;
  }
  /**
   * Set panel display mode.
   */
  setDisplayMode(displayMode) {
    this._state.displayMode = displayMode;
    return this;
  }
  /**
   * Set if panel header should be shown on hover.
   */
  setHoverHeader(hoverHeader) {
    this._state.hoverHeader = hoverHeader;
    return this;
  }
  /**
   * Set if VizPanelMenu "kebab" icon is shown on panel hover for desktop devices. Set true to always show menu icon.
   * @param showMenuAlways
   */
  setShowMenuAlways(showMenuAlways) {
    this._state.showMenuAlways = showMenuAlways;
    return this;
  }
  /**
   * Set panel menu scene object.
   */
  setMenu(menu) {
    this._state.menu = menu;
    return this;
  }
  /**
   * Set scene object or react component to use as panel header actions.
   */
  setHeaderActions(headerActions) {
    this._state.headerActions = headerActions;
    return this;
  }
  setCollapsible(collapsible) {
    this._state.collapsible = collapsible;
    return this;
  }
  setCollapsed(collapsed) {
    this._state.collapsed = collapsed;
    return this;
  }
  /**
   * Set color.
   */
  setColor(color) {
    this._fieldConfigBuilder.setColor(color);
    return this;
  }
  /**
   * Set number of decimals to show.
   */
  setDecimals(decimals) {
    this._fieldConfigBuilder.setDecimals(decimals);
    return this;
  }
  /**
   * Set field display name.
   */
  setDisplayName(displayName) {
    this._fieldConfigBuilder.setDisplayName(displayName);
    return this;
  }
  /**
   * Set the standard field config property filterable.
   */
  setFilterable(filterable) {
    this._fieldConfigBuilder.setFilterable(filterable);
    return this;
  }
  /**
   * Set data links.
   */
  setLinks(links) {
    this._fieldConfigBuilder.setLinks(links);
    return this;
  }
  /**
   * Set value mappings.
   */
  setMappings(mappings) {
    this._fieldConfigBuilder.setMappings(mappings);
    return this;
  }
  /**
   * Set the standard field config property max.
   */
  setMax(max) {
    this._fieldConfigBuilder.setMax(max);
    return this;
  }
  /**
   * Set the standard field config property min.
   */
  setMin(min) {
    this._fieldConfigBuilder.setMin(min);
    return this;
  }
  /**
   * Set the standard field config property noValue.
   */
  setNoValue(noValue) {
    this._fieldConfigBuilder.setNoValue(noValue);
    return this;
  }
  /**
   * Set the standard field config property thresholds.
   */
  setThresholds(thresholds) {
    this._fieldConfigBuilder.setThresholds(thresholds);
    return this;
  }
  /**
   * Set the standard field config property unit.
   */
  setUnit(unit) {
    this._fieldConfigBuilder.setUnit(unit);
    return this;
  }
  setCustomFieldConfig(id, value) {
    this._fieldConfigBuilder.setCustomFieldConfig(id, value);
    return this;
  }
  setOverrides(builder) {
    this._fieldConfigBuilder.setOverrides(builder);
    return this;
  }
  /**
   * Set an individual panel option. This will merge the value with the existing options.
   */
  setOption(id, value) {
    this._panelOptionsBuilder.setOption(id, value);
    return this;
  }
  /**
   * Set data provider for the panel.
   */
  setData(data) {
    this._state.$data = data;
    return this;
  }
  /**
   * Set time range for the panel.
   */
  setTimeRange(timeRange) {
    this._state.$timeRange = timeRange;
    return this;
  }
  /**
   * Set variables for the panel.
   */
  setVariables(variables) {
    this._state.$variables = variables;
    return this;
  }
  /**
   * Set behaviors for the panel.
   */
  setBehaviors(behaviors) {
    this._state.$behaviors = behaviors;
    return this;
  }
  /**
   * Sets the default series limit for the panel.
   */
  setSeriesLimit(seriesLimit) {
    this._state.seriesLimit = seriesLimit;
    return this;
  }
  /**
   * Makes it possible to shared config between different builders
   */
  applyMixin(mixin) {
    mixin(this);
    return this;
  }
  /**
   * Build the panel.
   */
  build() {
    const panel = new VizPanel({
      ...this._state,
      options: this._panelOptionsBuilder.build(),
      fieldConfig: this._fieldConfigBuilder.build()
    });
    return panel;
  }
}

const PanelOptionsBuilders = {
  barchart() {
    return new PanelOptionsBuilder(() => BarChartPanelCfg_types_gen.defaultOptions);
  },
  bargauge() {
    return new PanelOptionsBuilder(() => BarGaugePanelCfg_types_gen.defaultOptions);
  },
  datagrid() {
    return new PanelOptionsBuilder(() => DatagridPanelCfg_types_gen.defaultOptions);
  },
  flamegraph() {
    return new PanelOptionsBuilder();
  },
  gauge() {
    return new PanelOptionsBuilder(() => GaugePanelCfg_types_gen.defaultOptions);
  },
  geomap() {
    return new PanelOptionsBuilder(() => GeomapPanelCfg_types_gen.defaultOptions);
  },
  heatmap() {
    return new PanelOptionsBuilder(() => HeatmapPanelCfg_types_gen.defaultOptions);
  },
  histogram() {
    return new PanelOptionsBuilder(() => HistogramPanelCfg_types_gen.defaultOptions);
  },
  logs() {
    return new PanelOptionsBuilder();
  },
  news() {
    return new PanelOptionsBuilder(() => NewsPanelCfg_types_gen.defaultOptions);
  },
  nodegraph() {
    return new PanelOptionsBuilder();
  },
  piechart() {
    return new PanelOptionsBuilder(() => PieChartPanelCfg_types_gen.defaultOptions);
  },
  stat() {
    return new PanelOptionsBuilder(() => StatPanelCfg_types_gen.defaultOptions);
  },
  statetimeline() {
    return new PanelOptionsBuilder(() => StateTimelinePanelCfg_types_gen.defaultOptions);
  },
  statushistory() {
    return new PanelOptionsBuilder(() => StatusHistoryPanelCfg_types_gen.defaultOptions);
  },
  table() {
    return new PanelOptionsBuilder(() => TablePanelCfg_types_gen.defaultOptions);
  },
  text() {
    return new PanelOptionsBuilder(() => TextPanelCfg_types_gen.defaultOptions);
  },
  timeseries() {
    return new PanelOptionsBuilder();
  },
  trend() {
    return new PanelOptionsBuilder();
  },
  traces() {
    return new PanelOptionsBuilder();
  },
  xychart() {
    return new PanelOptionsBuilder(() => XYChartPanelCfg_types_gen.defaultOptions);
  }
};

const FieldConfigBuilders = {
  barchart() {
    return new FieldConfigBuilder(() => BarChartPanelCfg_types_gen.defaultFieldConfig);
  },
  bargauge() {
    return new FieldConfigBuilder();
  },
  datagrid() {
    return new FieldConfigBuilder();
  },
  flamegraph() {
    return new FieldConfigBuilder();
  },
  gauge() {
    return new FieldConfigBuilder();
  },
  geomap() {
    return new FieldConfigBuilder();
  },
  heatmap() {
    return new FieldConfigBuilder();
  },
  histogram() {
    return new FieldConfigBuilder(() => HistogramPanelCfg_types_gen.defaultFieldConfig);
  },
  logs() {
    return new FieldConfigBuilder();
  },
  news() {
    return new FieldConfigBuilder();
  },
  nodegraph() {
    return new FieldConfigBuilder();
  },
  piechart() {
    return new FieldConfigBuilder();
  },
  stat() {
    return new FieldConfigBuilder();
  },
  statetimeline() {
    return new FieldConfigBuilder(() => StateTimelinePanelCfg_types_gen.defaultFieldConfig);
  },
  statushistory() {
    return new FieldConfigBuilder(() => StatusHistoryPanelCfg_types_gen.defaultFieldConfig);
  },
  table() {
    return new FieldConfigBuilder();
  },
  text() {
    return new FieldConfigBuilder();
  },
  timeseries() {
    return new FieldConfigBuilder();
  },
  trend() {
    return new FieldConfigBuilder();
  },
  traces() {
    return new FieldConfigBuilder();
  },
  xychart() {
    return new FieldConfigBuilder(() => XYChartPanelCfg_types_gen.defaultFieldConfig);
  }
};

const PanelBuilders = {
  barchart() {
    return new VizPanelBuilder(
      "barchart",
      "10.0.0",
      () => BarChartPanelCfg_types_gen.defaultOptions,
      () => BarChartPanelCfg_types_gen.defaultFieldConfig
    );
  },
  bargauge() {
    return new VizPanelBuilder("bargauge", "10.0.0", () => BarGaugePanelCfg_types_gen.defaultOptions);
  },
  datagrid() {
    return new VizPanelBuilder("datagrid", "10.0.0", () => DatagridPanelCfg_types_gen.defaultOptions);
  },
  flamegraph() {
    return new VizPanelBuilder("flamegraph", "10.0.0");
  },
  gauge() {
    return new VizPanelBuilder("gauge", "10.0.0", () => GaugePanelCfg_types_gen.defaultOptions);
  },
  geomap() {
    return new VizPanelBuilder("geomap", "10.0.0", () => GeomapPanelCfg_types_gen.defaultOptions);
  },
  heatmap() {
    return new VizPanelBuilder("heatmap", "10.0.0", () => HeatmapPanelCfg_types_gen.defaultOptions);
  },
  histogram() {
    return new VizPanelBuilder(
      "histogram",
      "10.0.0",
      () => HistogramPanelCfg_types_gen.defaultOptions,
      () => HistogramPanelCfg_types_gen.defaultFieldConfig
    );
  },
  logs() {
    return new VizPanelBuilder("logs", "10.0.0");
  },
  news() {
    return new VizPanelBuilder("news", "10.0.0", () => NewsPanelCfg_types_gen.defaultOptions);
  },
  nodegraph() {
    return new VizPanelBuilder("nodeGraph", "10.0.0");
  },
  piechart() {
    return new VizPanelBuilder(
      "piechart",
      "10.0.0",
      () => PieChartPanelCfg_types_gen.defaultOptions
    );
  },
  stat() {
    return new VizPanelBuilder("stat", "10.0.0", () => StatPanelCfg_types_gen.defaultOptions);
  },
  statetimeline() {
    return new VizPanelBuilder(
      "state-timeline",
      "10.0.0",
      () => StateTimelinePanelCfg_types_gen.defaultOptions,
      () => StateTimelinePanelCfg_types_gen.defaultFieldConfig
    );
  },
  statushistory() {
    return new VizPanelBuilder(
      "status-history",
      "10.0.0",
      () => StatusHistoryPanelCfg_types_gen.defaultOptions,
      () => StatusHistoryPanelCfg_types_gen.defaultFieldConfig
    );
  },
  table() {
    return new VizPanelBuilder("table", "10.0.0", () => TablePanelCfg_types_gen.defaultOptions);
  },
  text() {
    return new VizPanelBuilder("text", "10.0.0", () => TextPanelCfg_types_gen.defaultOptions);
  },
  timeseries() {
    return new VizPanelBuilder("timeseries", "10.0.0");
  },
  trend() {
    return new VizPanelBuilder("trend", "10.0.0");
  },
  traces() {
    return new VizPanelBuilder("traces", "10.0.0");
  },
  xychart() {
    return new VizPanelBuilder(
      "xychart",
      "10.0.0",
      () => XYChartPanelCfg_types_gen.defaultOptions,
      () => XYChartPanelCfg_types_gen.defaultFieldConfig
    );
  }
};

class VizConfigBuilder {
  constructor(pluginId, pluginVersion, defaultOptions, defaultFieldConfig) {
    this._pluginId = pluginId;
    this._pluginVersion = pluginVersion;
    this._fieldConfigBuilder = new FieldConfigBuilder(defaultFieldConfig);
    this._panelOptionsBuilder = new PanelOptionsBuilder(defaultOptions);
  }
  /**
   * Set color.
   */
  setColor(color) {
    this._fieldConfigBuilder.setColor(color);
    return this;
  }
  /**
   * Set number of decimals to show.
   */
  setDecimals(decimals) {
    this._fieldConfigBuilder.setDecimals(decimals);
    return this;
  }
  /**
   * Set field display name.
   */
  setDisplayName(displayName) {
    this._fieldConfigBuilder.setDisplayName(displayName);
    return this;
  }
  /**
   * Set the standard field config property filterable.
   */
  setFilterable(filterable) {
    this._fieldConfigBuilder.setFilterable(filterable);
    return this;
  }
  /**
   * Set data links.
   */
  setLinks(links) {
    this._fieldConfigBuilder.setLinks(links);
    return this;
  }
  /**
   * Set value mappings.
   */
  setMappings(mappings) {
    this._fieldConfigBuilder.setMappings(mappings);
    return this;
  }
  /**
   * Set the standard field config property max.
   */
  setMax(max) {
    this._fieldConfigBuilder.setMax(max);
    return this;
  }
  /**
   * Set the standard field config property min.
   */
  setMin(min) {
    this._fieldConfigBuilder.setMin(min);
    return this;
  }
  /**
   * Set the standard field config property noValue.
   */
  setNoValue(noValue) {
    this._fieldConfigBuilder.setNoValue(noValue);
    return this;
  }
  /**
   * Set the standard field config property thresholds.
   */
  setThresholds(thresholds) {
    this._fieldConfigBuilder.setThresholds(thresholds);
    return this;
  }
  /**
   * Set the standard field config property unit.
   */
  setUnit(unit) {
    this._fieldConfigBuilder.setUnit(unit);
    return this;
  }
  setCustomFieldConfig(id, value) {
    this._fieldConfigBuilder.setCustomFieldConfig(id, value);
    return this;
  }
  setOverrides(builder) {
    this._fieldConfigBuilder.setOverrides(builder);
    return this;
  }
  /**
   * Set an individual panel option. This will merge the value with the existing options.
   */
  setOption(id, value) {
    this._panelOptionsBuilder.setOption(id, value);
    return this;
  }
  /**
   * Build the panel.
   */
  build() {
    return {
      pluginId: this._pluginId,
      pluginVersion: this._pluginVersion,
      options: this._panelOptionsBuilder.build(),
      fieldConfig: this._fieldConfigBuilder.build()
    };
  }
}

const VizConfigBuilders = {
  barchart() {
    return new VizConfigBuilder(
      "barchart",
      "10.0.0",
      () => BarChartPanelCfg_types_gen.defaultOptions,
      () => BarChartPanelCfg_types_gen.defaultFieldConfig
    );
  },
  bargauge() {
    return new VizConfigBuilder("bargauge", "10.0.0", () => BarGaugePanelCfg_types_gen.defaultOptions);
  },
  datagrid() {
    return new VizConfigBuilder("datagrid", "10.0.0", () => DatagridPanelCfg_types_gen.defaultOptions);
  },
  flamegraph() {
    return new VizConfigBuilder("flamegraph", "10.0.0");
  },
  gauge() {
    return new VizConfigBuilder("gauge", "10.0.0", () => GaugePanelCfg_types_gen.defaultOptions);
  },
  geomap() {
    return new VizConfigBuilder("geomap", "10.0.0", () => GeomapPanelCfg_types_gen.defaultOptions);
  },
  heatmap() {
    return new VizConfigBuilder("heatmap", "10.0.0", () => HeatmapPanelCfg_types_gen.defaultOptions);
  },
  histogram() {
    return new VizConfigBuilder(
      "histogram",
      "10.0.0",
      () => HistogramPanelCfg_types_gen.defaultOptions,
      () => HistogramPanelCfg_types_gen.defaultFieldConfig
    );
  },
  logs() {
    return new VizConfigBuilder("logs", "10.0.0");
  },
  news() {
    return new VizConfigBuilder("news", "10.0.0", () => NewsPanelCfg_types_gen.defaultOptions);
  },
  nodegraph() {
    return new VizConfigBuilder("nodeGraph", "10.0.0");
  },
  piechart() {
    return new VizConfigBuilder(
      "piechart",
      "10.0.0",
      () => PieChartPanelCfg_types_gen.defaultOptions
    );
  },
  stat() {
    return new VizConfigBuilder("stat", "10.0.0", () => StatPanelCfg_types_gen.defaultOptions);
  },
  statetimeline() {
    return new VizConfigBuilder(
      "state-timeline",
      "10.0.0",
      () => StateTimelinePanelCfg_types_gen.defaultOptions,
      () => StateTimelinePanelCfg_types_gen.defaultFieldConfig
    );
  },
  statushistory() {
    return new VizConfigBuilder(
      "status-history",
      "10.0.0",
      () => StatusHistoryPanelCfg_types_gen.defaultOptions,
      () => StatusHistoryPanelCfg_types_gen.defaultFieldConfig
    );
  },
  table() {
    return new VizConfigBuilder("table", "10.0.0", () => TablePanelCfg_types_gen.defaultOptions);
  },
  text() {
    return new VizConfigBuilder("text", "10.0.0", () => TextPanelCfg_types_gen.defaultOptions);
  },
  timeseries() {
    return new VizConfigBuilder("timeseries", "10.0.0");
  },
  trend() {
    return new VizConfigBuilder("trend", "10.0.0");
  },
  traces() {
    return new VizConfigBuilder("traces", "10.0.0");
  },
  xychart() {
    return new VizConfigBuilder(
      "xychart",
      "10.0.0",
      () => XYChartPanelCfg_types_gen.defaultOptions,
      () => XYChartPanelCfg_types_gen.defaultFieldConfig
    );
  }
};

function __variableDynamicImportRuntime0__(path) {
  switch (path) {
    case '../locales/cs-CZ/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-DPdlSPjz.js'); });
    case '../locales/de-DE/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-BHIE4ld0.js'); });
    case '../locales/en-US/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-DrGXYYn6.js'); });
    case '../locales/es-ES/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-D4tq59Dc.js'); });
    case '../locales/fr-FR/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-Ce77KCbO.js'); });
    case '../locales/hu-HU/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-DMYCnFop.js'); });
    case '../locales/id-ID/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-DHpGBx0P.js'); });
    case '../locales/it-IT/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-BZj2ZETs.js'); });
    case '../locales/ja-JP/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-ByblbWyE.js'); });
    case '../locales/ko-KR/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-BUP4DNLu.js'); });
    case '../locales/nl-NL/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-BQOG4-hf.js'); });
    case '../locales/pl-PL/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-f39AM_op.js'); });
    case '../locales/pt-BR/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-CsPh4lyF.js'); });
    case '../locales/pt-PT/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-D0ZeSjr4.js'); });
    case '../locales/ru-RU/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-Ce6rkTUB.js'); });
    case '../locales/sv-SE/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-BWSRLKS6.js'); });
    case '../locales/tr-TR/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-CkznchTe.js'); });
    case '../locales/zh-Hans/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-fENyYMom.js'); });
    case '../locales/zh-Hant/grafana-scenes.json': return Promise.resolve().then(function () { return require('./grafana-scenes-D2C1ii8d.js'); });
    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }
const resources = i18n.LANGUAGES.reduce((acc, lang) => {
  acc[lang.code] = async () => await __variableDynamicImportRuntime0__(`../locales/${lang.code}/grafana-scenes.json`);
  return acc;
}, {});
const loadResources = async (resolvedLanguage) => {
  const translation = await resources[resolvedLanguage]();
  return translation.default;
};

const sceneUtils = {
  getUrlWithAppState,
  registerRuntimePanelPlugin,
  registerRuntimeDataSource,
  registerVariableMacro,
  cloneSceneObjectState,
  syncStateFromSearchParams,
  getUrlState,
  renderPrometheusLabelFilters,
  escapeLabelValueInRegexSelector,
  escapeLabelValueInExactSelector,
  escapeURLDelimiters,
  // Variable guards
  isAdHocVariable,
  isConstantVariable,
  isCustomVariable,
  isDataSourceVariable,
  isIntervalVariable,
  isQueryVariable,
  isTextBoxVariable,
  isGroupByVariable,
  isSwitchVariable,
  isRepeatCloneOrChildOf,
  buildPathIdFor
};

exports.AdHocFiltersComboboxRenderer = AdHocFiltersComboboxRenderer;
exports.AdHocFiltersVariable = AdHocFiltersVariable;
exports.AdHocFiltersVariableController = AdHocFiltersVariableController;
exports.ConstantVariable = ConstantVariable;
exports.ControlsLabel = ControlsLabel;
exports.CustomVariable = CustomVariable;
exports.DataProviderProxy = DataProviderProxy;
exports.DataSourceVariable = DataSourceVariable;
exports.EmbeddedScene = EmbeddedScene;
exports.FieldConfigBuilder = FieldConfigBuilder;
exports.FieldConfigBuilders = FieldConfigBuilders;
exports.FieldConfigOverridesBuilder = FieldConfigOverridesBuilder;
exports.GroupByVariable = GroupByVariable;
exports.IntervalVariable = IntervalVariable;
exports.LazyLoader = LazyLoader;
exports.LocalValueVariable = LocalValueVariable;
exports.MultiOrSingleValueSelect = MultiOrSingleValueSelect;
exports.MultiValueVariable = MultiValueVariable;
exports.NestedScene = NestedScene;
exports.NewSceneObjectAddedEvent = NewSceneObjectAddedEvent;
exports.OPERATORS = OPERATORS;
exports.PATH_ID_SEPARATOR = PATH_ID_SEPARATOR;
exports.PanelBuilders = PanelBuilders;
exports.PanelOptionsBuilders = PanelOptionsBuilders;
exports.QueryVariable = QueryVariable;
exports.RuntimeDataSource = RuntimeDataSource;
exports.SafeSerializableSceneObject = SafeSerializableSceneObject;
exports.SceneApp = SceneApp;
exports.SceneAppPage = SceneAppPage;
exports.SceneByFrameRepeater = SceneByFrameRepeater;
exports.SceneByVariableRepeater = SceneByVariableRepeater;
exports.SceneCSSGridItem = SceneCSSGridItem;
exports.SceneCSSGridLayout = SceneCSSGridLayout;
exports.SceneCanvasText = SceneCanvasText;
exports.SceneControlsSpacer = SceneControlsSpacer;
exports.SceneDataLayerBase = SceneDataLayerBase;
exports.SceneDataLayerControls = SceneDataLayerControls;
exports.SceneDataLayerSet = SceneDataLayerSet;
exports.SceneDataLayerSetBase = SceneDataLayerSetBase;
exports.SceneDataNode = SceneDataNode;
exports.SceneDataTransformer = SceneDataTransformer;
exports.SceneDebugger = SceneDebugger;
exports.SceneFlexItem = SceneFlexItem;
exports.SceneFlexLayout = SceneFlexLayout;
exports.SceneGridItem = SceneGridItem;
exports.SceneGridLayout = SceneGridLayout;
exports.SceneGridLayoutDragStartEvent = SceneGridLayoutDragStartEvent;
exports.SceneGridRow = SceneGridRow;
exports.SceneObjectBase = SceneObjectBase;
exports.SceneObjectRef = SceneObjectRef;
exports.SceneObjectStateChangedEvent = SceneObjectStateChangedEvent;
exports.SceneObjectUrlSyncConfig = SceneObjectUrlSyncConfig;
exports.SceneQueryRunner = SceneQueryRunner;
exports.SceneReactObject = SceneReactObject;
exports.SceneRefreshPicker = SceneRefreshPicker;
exports.SceneTimePicker = SceneTimePicker;
exports.SceneTimeRange = SceneTimeRange;
exports.SceneTimeRangeCompare = SceneTimeRangeCompare;
exports.SceneTimeRangeTransformerBase = SceneTimeRangeTransformerBase;
exports.SceneTimeZoneOverride = SceneTimeZoneOverride;
exports.SceneToolbarButton = SceneToolbarButton;
exports.SceneToolbarInput = SceneToolbarInput;
exports.SceneVariableSet = SceneVariableSet;
exports.SceneVariableValueChangedEvent = SceneVariableValueChangedEvent;
exports.ScopesVariable = ScopesVariable;
exports.SplitLayout = SplitLayout;
exports.SwitchVariable = SwitchVariable;
exports.TestVariable = TestVariable;
exports.TextBoxVariable = TextBoxVariable;
exports.UrlSyncContextProvider = UrlSyncContextProvider;
exports.UrlSyncManager = UrlSyncManager;
exports.UserActionEvent = UserActionEvent;
exports.VariableDependencyConfig = VariableDependencyConfig;
exports.VariableValueControl = VariableValueControl;
exports.VariableValueSelectWrapper = VariableValueSelectWrapper;
exports.VariableValueSelectors = VariableValueSelectors;
exports.VizConfigBuilder = VizConfigBuilder;
exports.VizConfigBuilders = VizConfigBuilders;
exports.VizPanel = VizPanel;
exports.VizPanelBuilder = VizPanelBuilder;
exports.VizPanelExploreButton = VizPanelExploreButton;
exports.VizPanelMenu = VizPanelMenu;
exports.behaviors = index$2;
exports.dataLayers = index;
exports.escapeUrlPipeDelimiters = escapeUrlPipeDelimiters;
exports.formatRegistry = formatRegistry;
exports.getExploreURL = getExploreURL;
exports.getQueriesForVariables = getQueriesForVariables;
exports.isCustomVariableValue = isCustomVariableValue;
exports.isDataLayer = isDataLayer;
exports.isDataRequestEnricher = isDataRequestEnricher;
exports.isFiltersRequestEnricher = isFiltersRequestEnricher;
exports.isSceneObject = isSceneObject;
exports.loadResources = loadResources;
exports.performanceUtils = index$1;
exports.registerQueryWithController = registerQueryWithController;
exports.registerRuntimeDataSource = registerRuntimeDataSource;
exports.sceneGraph = sceneGraph;
exports.sceneUtils = sceneUtils;
exports.useSceneApp = useSceneApp;
exports.useSceneObjectState = useSceneObjectState;
exports.useUrlSync = useUrlSync;
exports.writePerformanceLog = writePerformanceLog;
//# sourceMappingURL=index.js.map
